/*! Skills Lab — © School House Learning Centre (shlc-tutor.co.uk). All rights reserved.
    Not licensed for reuse, redistribution, resale or derivative works.
    Enquiries: info@shlc-tutor.co.uk  ·  build SHLC-SL-7Q4M2 */
/* ============================================================
   SKILLS LAB · core
   Registry for skill modules, the full-screen shell and its four
   screens (library, practise, teach, board), progress in
   localStorage, dark/light theme. Skill modules register with
   SL.register({...}) and provide make(level, ctx) + teach(host, q, api).
   RULE for teach renderers: all() paints the FINISHED state in one go, no
   replayed animation at speed. Answer only must never flicker through steps.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- host lock ----------
     The lab only starts on our own hostnames. Anywhere else it returns before
     anything is defined, so window.SL never exists; every engine opens with
     `var SL = window.SL; if (!SL) return;` and so no-ops in silence too.
     No thrown error and no message: a lifted copy simply does nothing.
     Allowed: shlc-tutor.co.uk and its subdomains, the store's own myshopify
     host (theme previews), localhost/127.0.0.1 and file:// (empty hostname,
     the local harness). */
  try {
    var _host = String(location.hostname || '').toLowerCase();
    if (!(/(^|\.)shlc-tutor\.co\.uk$/.test(_host)
          || _host === 'c44a55-2.myshopify.com'
          || _host === 'localhost' || _host === '127.0.0.1'
          || _host === '')) return;
  } catch (e) { return; }

  /* Build fingerprint. Deliberately distinctive and carried by any wholesale
     copy of this file: it is what identifies our code in a takedown notice.
     Do not change it without a note in project_shlc_skills_lab_code_protection. */
  var SL_BUILD = 'SHLC-SL-7Q4M2';
  try { window.SL_BUILD = SL_BUILD; } catch (e) {}

  var MINUS = '−';
  function ri(a, b) { return a + Math.floor(Math.random() * (b - a + 1)); }
  function pick(a) { return a[Math.floor(Math.random() * a.length)]; }
  function chance(p) { return Math.random() < p; }
  function shuffle(a) { var i, j, t; for (i = a.length - 1; i > 0; i--) { j = Math.floor(Math.random() * (i + 1)); t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function lsGet(k, d) { try { var v = localStorage.getItem(k); return v === null ? d : JSON.parse(v); } catch (e) { return d; } }
  function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function narrow() { try { return window.innerWidth <= 640; } catch (e) { return false; } }
  /* the badge, from the CDN copy the rest of the storefront already uses, so it
     costs the page nothing and cannot drift from the site logo. It never renders
     below 40px: the ring text turns to mush and a mushy badge is worse than none. */
  var LOGO_SRC = 'https://shlc-tutor.co.uk/cdn/shop/files/Maths_Online_Tutor_Logo.png?v=1771190336&width=200';
  function logoHTML(cls) { return '<img class="sl-logo' + (cls ? ' ' + cls : '') + '" src="' + LOGO_SRC + '" width="200" height="200" alt="School House Learning Centre">'; }
  function $(id) { return document.getElementById(id); }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html !== undefined) e.innerHTML = html; return e; }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  var reduceMotion = false, motionMQ = null;
  try { motionMQ = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)'); reduceMotion = !!(motionMQ && motionMQ.matches); } catch (e) {}
  /* the preference can change while the page is open, so it is read live */
  try { if (motionMQ && motionMQ.addEventListener) motionMQ.addEventListener('change', function (ev) { reduceMotion = !!ev.matches; if (window.SL) window.SL.reduceMotion = reduceMotion; }); } catch (e) {}

  /* ---------- icons: stroke SVG on a 24 grid, one style ---------- */
  function svg(paths) { return '<svg class="ico" viewBox="0 0 24 24" aria-hidden="true">' + paths + '</svg>'; }
  /* The sticker icons (GPT image gen, Aadam 2026-09-15: "yes use these, much better"). One sprite, a cell
     per key, in the order of skill-lab/icons/lab-c-v1/. The element keeps class "ico" so every place that
     sizes an icon sizes the sticker too; skills-lab.css (STICKER ICONS) draws the cell. Anything with no
     cell here keeps its line icon, so a new skill is never iconless. */
  var STK = { teach: 0, practise: 1, speed: 2, board: 3, turn: 4, 'count-together': 5,
    'counting-in-steps': 6, 'place-value': 7, 'more-or-less': 8, 'reading-writing-numbers': 9,
    'comparing-ordering-numbers': 10, 'multiply-divide-by-10-100-1000': 11, 'roman-numerals': 12, 'negative-numbers': 13,
    'expanding-single-brackets': 14, 'expanding-double-brackets': 15, 'expanding-triple-brackets': 16, 'expanding-surd-brackets': 17,
    'completing-the-square': 18, 'factorising-quadratics': 19, 'quadratic-formula': 20,
    'linear-nth-term': 21, 'quadratic-sequences': 22,
    /* sprite v5 (2026-09-25): a sticker for every skill that had none, and the GCSE past papers row */
    'times-tables': 23, 'grid-multiplication': 24, 'column-multiplication': 25, 'short-division': 26,
    'mult-div-decimals': 27, 'recurring-decimals': 28, 'simplifying-surds': 29, 'rationalising': 30,
    'simplifying-algebraic-fractions': 31, 'mult-div-algebraic-fractions': 32, 'add-sub-algebraic-fractions': 33,
    'algebraic-fraction-equations': 34, 'solving-quadratics-factorising': 35, 'rearranging-formulae': 36,
    'algebraic-proof': 37, papers: 38 };
  /* A skill added after 2026-09-25 names its own cell (`sticker: 39` on its register object, carried
     by the manifest), so a new sticker never needs a core push: the sprite and its row count live in
     the stickers css block, which ship.py splices like any other. */
  function stk(key, fallback, cell) {
    var i = STK[key]; if (i === undefined) i = cell;
    if (typeof i !== 'number' || i < 0) return fallback || '';
    return '<i class="ico sl-stk" style="--sx:' + (i % 5) + ';--sy:' + Math.floor(i / 5) + '" aria-hidden="true"></i>';
  }
  var ICON = {
    cross: svg('<path d="M6 6l12 12M18 6L6 18"/>'),
    refresh: svg('<path d="M20 12a8 8 0 1 1-2.4-5.7"/><path d="M20 4v5h-5"/>'),
    dice: svg('<rect x="4" y="4" width="16" height="16" rx="3.5"/><circle cx="9" cy="9" r="1.1" fill="currentColor" stroke="none"/><circle cx="15" cy="9" r="1.1" fill="currentColor" stroke="none"/><circle cx="9" cy="15" r="1.1" fill="currentColor" stroke="none"/><circle cx="15" cy="15" r="1.1" fill="currentColor" stroke="none"/>'),
    tick: svg('<path d="M5 12.5l4.5 4.5L19 7.5"/>'),
    sun: svg('<circle cx="12" cy="12" r="4"/><path d="M12 2.5v2.5M12 19v2.5M2.5 12H5M19 12h2.5M5.3 5.3l1.8 1.8M16.9 16.9l1.8 1.8M5.3 18.7l1.8-1.8M16.9 7.1l1.8-1.8"/>'),
    moon: svg('<path d="M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5z"/>'),
    search: svg('<circle cx="11" cy="11" r="6.5"/><path d="M16 16l4.5 4.5"/>'),
    plus: svg('<path d="M12 5v14M5 12h14"/>'),
    minus: svg('<path d="M5 12h14"/>'),
    chevR: svg('<path d="M9 6l6 6-6 6"/>'),
    chevL: svg('<path d="M15 6l-6 6 6 6"/>'),
    chevD: svg('<path d="M6 9l6 6 6-6"/>'),
    print: svg('<path d="M7 8V4h10v4"/><rect x="4" y="8" width="16" height="9" rx="2"/><path d="M7 13h10v7H7z"/>'),
    expand: svg('<path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/>'),
    link: svg('<path d="M10.5 13.5a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1.4 1.4"/><path d="M13.5 10.5a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1.4-1.4"/>'),
    eye: svg('<path d="M2.5 12s3.5-6.5 9.5-6.5 9.5 6.5 9.5 6.5-3.5 6.5-9.5 6.5S2.5 12 2.5 12z"/><circle cx="12" cy="12" r="2.8"/>'),
    eyeOff: svg('<path d="M3 3l18 18"/><path d="M10 5.8A10 10 0 0 1 12 5.5c6 0 9.5 6.5 9.5 6.5a17 17 0 0 1-3.2 3.9M6.6 6.6C4 8.4 2.5 12 2.5 12s3.5 6.5 9.5 6.5c1.6 0 3-.4 4.2-1"/>'),
    steps: svg('<path d="M4 18h5v-4h5v-4h5V6"/>'),
    board: svg('<rect x="3" y="4" width="18" height="12" rx="2"/><path d="M12 16v4M8 20h8"/>'),
    list: svg('<path d="M8 6h12M8 12h12M8 18h12"/><circle cx="4.5" cy="6" r="1" fill="currentColor" stroke="none"/><circle cx="4.5" cy="12" r="1" fill="currentColor" stroke="none"/><circle cx="4.5" cy="18" r="1" fill="currentColor" stroke="none"/>'),
    play: svg('<path d="M7.5 4.5l12 7.5-12 7.5z"/>'),
    pause: svg('<path d="M9 5v14M15 5v14"/>'),
    sliders: svg('<path d="M4 7h10M18 7h2M4 17h4M12 17h8M4 12h16"/><circle cx="16" cy="7" r="2"/><circle cx="10" cy="17" r="2"/>'),
    trophy: svg('<path d="M7.5 4h9v5a4.5 4.5 0 0 1-9 0V4z"/><path d="M7.5 6H4.5a3 3 0 0 0 3 4"/><path d="M16.5 6h3a3 3 0 0 1-3 4"/><path d="M12 13.5V17"/><path d="M8.5 20h7"/>'),
    /* the favourite star, hollow and filled from the same path so the two
       states sit on exactly the same outline and nothing shifts on a tap */
    star: svg('<path d="M12 3.6l2.55 5.17 5.7.83-4.13 4.02.98 5.68L12 16.62l-5.1 2.68.98-5.68L3.75 9.6l5.7-.83z"/>'),
    starOn: svg('<path d="M12 3.6l2.55 5.17 5.7.83-4.13 4.02.98 5.68L12 16.62l-5.1 2.68.98-5.68L3.75 9.6l5.7-.83z" fill="currentColor"/>'),
    /* Negatives: a minus in a circle. A number line was tried three ways and
       none of them survived 16px - an arrowhead and ticks fused into a blob, and
       a zero tick crossing the axis drew a plus sign, the one thing this icon
       must not say. One shape, unmistakable at every size. */
    /* counting: a line with two EQUAL hops - the same jump made again, which is
       what repeated addition is. One hop and three beads read as a blob at 16px. */
    count: svg('<path d="M2.5 18.5h19"/><path d="M5 18.5q4-9 8 0"/><path d="M13 18.5q4-9 8 0"/><path d="M5 16.5v4M13 16.5v4M21 16.5v4"/>'),
    numberline: svg('<circle cx="12" cy="12" r="8.5"/><path d="M7.8 12h8.4"/>'),
    arcs: svg('<path d="M4 16c2-8 8-8 10 0"/><path d="M10 16c2-8 8-8 10 0"/>'),
    /* One icon per bracket skill: one pair of brackets, and a countable dot for
       each bracket in the question. Drawing the pairs side by side was the first
       try and it failed - two adjacent parentheses close into a lens, so ()()
       read as an X and ()()() as a row of Xs. Each parenthesis is a single
       circular arc (A command), so the halves mirror exactly at 16px and 22px. */
    bracket1: svg('<path d="M7.5 4.5A17 17 0 0 0 7.5 19.5"/><path d="M16.5 4.5A17 17 0 0 1 16.5 19.5"/><circle cx="12" cy="12" r="1.9" fill="currentColor" stroke="none"/>'),
    bracket2: svg('<path d="M7.5 4.5A17 17 0 0 0 7.5 19.5"/><path d="M16.5 4.5A17 17 0 0 1 16.5 19.5"/><circle cx="10.2" cy="12" r="1.7" fill="currentColor" stroke="none"/><circle cx="13.8" cy="12" r="1.7" fill="currentColor" stroke="none"/>'),
    bracket3: svg('<path d="M7.5 4.5A17 17 0 0 0 7.5 19.5"/><path d="M16.5 4.5A17 17 0 0 1 16.5 19.5"/><circle cx="9" cy="12" r="1.5" fill="currentColor" stroke="none"/><circle cx="12" cy="12" r="1.5" fill="currentColor" stroke="none"/><circle cx="15" cy="12" r="1.5" fill="currentColor" stroke="none"/>'),
    wand: svg('<path d="M4 20L15 9"/><path d="M14 4l.9 2.1L17 7l-2.1.9L14 10l-.9-2.1L11 7l2.1-.9z"/>'),
    clock: svg('<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/>'),
    flag: svg('<path d="M5 21V4"/><path d="M5 4h13l-3 4.5 3 4.5H5"/>'),
    /* Speed: the sound toggle and the pad's delete key */
    sound: svg('<path d="M4 9.5h3.5L12 5.5v13L7.5 14.5H4z"/><path d="M15.5 9.5a4 4 0 0 1 0 5"/><path d="M18 7a7.5 7.5 0 0 1 0 10"/>'),
    mute: svg('<path d="M4 9.5h3.5L12 5.5v13L7.5 14.5H4z"/><path d="M16 10l4.5 4.5M20.5 10L16 14.5"/>'),
    del: svg('<path d="M9 5.5h9.5a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H9L3.5 12z"/><path d="M12.5 9.5l5 5M17.5 9.5l-5 5"/>'),
    arrowR: svg('<path d="M4 12h15"/><path d="M13 6l6 6-6 6"/>'),
    book: svg('<path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H20v15H6.5A2.5 2.5 0 0 0 4 20.5z"/><path d="M4 18.5A2.5 2.5 0 0 1 6.5 16H20"/>'),
    root: svg('<path d="M2.5 13.2L5.6 12.1L9.1 19.5L14.4 4.5H21.5"/>'),
    grid: svg('<rect x="4" y="4" width="6.5" height="6.5" rx="1.5"/><rect x="13.5" y="4" width="6.5" height="6.5" rx="1.5"/><rect x="4" y="13.5" width="6.5" height="6.5" rx="1.5"/><rect x="13.5" y="13.5" width="6.5" height="6.5" rx="1.5"/>'),
    /* compare: a less-than and a greater-than side by side; shift: three digit cards with an arrow one place left; roman: XII */
    compare: svg('<path d="M10 6L4 12l6 6"/><path d="M14 6l6 6-6 6"/>'),
    shift: svg('<rect x="3" y="12" width="5" height="7" rx="1.2"/><rect x="9.5" y="12" width="5" height="7" rx="1.2"/><rect x="16" y="12" width="5" height="7" rx="1.2"/><path d="M17 6H7"/><path d="M10 3L7 6l3 3"/>'),
    roman: svg('<path d="M4 6l6 12M10 6L4 18"/><path d="M14 6v12"/><path d="M19 6v12"/>')
  };

  /* the old hand-picked palette. Still here as the fallback for a skill that
     is in no family yet - see FAMILIES below, which is where colour comes from. */
  var COLOURS = {
    blue: { col: 'var(--brand-lite)', tint: 'var(--brand-tint)' },
    orange: { col: 'var(--accent-text)', tint: 'var(--accent-tint)' },
    violet: { col: 'var(--left)', tint: 'var(--left-d)' },
    green: { col: 'var(--ok-text)', tint: 'var(--ok-d)' },
    gold: { col: 'var(--gold)', tint: 'var(--gold-d)' }
  };

  /* ============================================================
     COLOUR: ONE HUE PER FAMILY
     A skill's colour used to be typed into its module by hand, which meant
     nothing: seven of the first twelve skills were the same blue and the
     colour told a pupil nothing at all. It is DERIVED now. Each FAMILY takes
     the next hue in HUES, and the skills inside a family share that hue at
     different shades. So a mixed board says at a glance which columns are the
     same kind of thing, a new skill never needs a colour decision, and two
     neighbours cannot clash by accident.

     THE ORDER OF THIS LIST IS THE HUE ORDER. Moving a family repaints it
     everywhere - tiles, board heads, mix chips, question card edges - so add
     new families at the END unless you mean to repaint. The order of the
     skills INSIDE a family is its shade order: the first member is the hue
     itself, and later members are mixed towards --shade-to (white on the dark
     theme, near-black on the light one) so they stay readable in both.
     ============================================================ */
  var FAMILIES = [
    { id: 'counting', skills: ['counting-in-steps'] },
    /* what the digits mean, and what happens when they move */
    { id: 'place-value', skills: ['place-value', 'more-or-less', 'multiply-divide-by-10-100-1000'] },
    /* writing a number down, in words or in someone else's numerals */
    { id: 'numerals', skills: ['reading-writing-numbers', 'roman-numerals'] },
    { id: 'comparing', skills: ['comparing-ordering-numbers'] },
    { id: 'negatives', skills: ['negative-numbers'] },
    { id: 'brackets', skills: ['expanding-single-brackets', 'expanding-double-brackets', 'expanding-triple-brackets', 'expanding-surd-brackets'] },
    { id: 'completing-the-square', skills: ['factorising-quadratics', 'completing-the-square', 'quadratic-formula', 'solving-quadratics-factorising'] },
    { id: 'sequences', skills: ['linear-nth-term', 'quadratic-sequences'] },
    { id: 'simplifying-surds', skills: ['simplifying-surds', 'rationalising'] },
    { id: 'simplifying-algebraic-fractions', skills: ['simplifying-algebraic-fractions', 'mult-div-algebraic-fractions', 'add-sub-algebraic-fractions'] },
    { id: 'equations', skills: ['algebraic-fraction-equations', 'rearranging-formulae'] },
    { id: 'proof', skills: ['algebraic-proof'] },
    { id: 'recurring-decimals', skills: ['recurring-decimals'] },
    { id: 'written-methods', skills: ['times-tables', 'grid-multiplication', 'column-multiplication', 'short-division'] },
    { id: 'decimals-calc', skills: ['mult-div-decimals'] },
    /* WIRE: new families go above this line */
  ];
  /* eight hues, ordered so consecutive families sit far apart on the wheel */
  var HUES = ['--t2', '--t1', '--t3', '--t4', '--t5', '--t7', '--t6', '--t8'];
  /* How much of the hue each member keeps; the rest is --shade-to. The first
     ramp tried was gentle (100/82/68/56) and four brackets read as four
     identical teal cards - the whole point of a shade is that you can SEE it,
     and mixing towards white on the dark theme (or towards near-black on the
     light one) only ever adds contrast, never takes it away. The band's tint
     steps down with it, so the ladder is legible even at a glance. */
  var SHADES = [100, 80, 62, 48];
  var TINTS = [19, 16, 14, 12];
  var FAMILY_COLOUR = (function () {
    var out = {};
    FAMILIES.forEach(function (f, i) {
      var hue = 'var(' + HUES[i % HUES.length] + ')';
      f.skills.forEach(function (id, j) {
        var k = Math.min(j, SHADES.length - 1), pct = SHADES[k];
        var col = pct >= 100 ? hue : 'color-mix(in oklab, ' + hue + ' ' + pct + '%, var(--shade-to))';
        out[id] = { col: col, tint: 'color-mix(in srgb, ' + col + ' ' + TINTS[k] + '%, transparent)' };
      });
    });
    return out;
  })();

  /* ---------- registry ---------- */
  /* The registry starts from the MANIFEST: one light entry per skill (name,
     strand, stage, colour, icon, levels with names and examples, aliases,
     blurb, which asset holds its engine and which kits that asset needs),
     written by build.py from the modules themselves. Those entries are STUBS:
     they carry everything the library and the skill screen show and none of
     the engine. The engine (make, teach, fields, chorus) arrives when the
     module's asset is loaded, and SL.register then replaces the stub in place,
     keeping the library order. A page that loads every module up front (the
     harness with ?eager=1) simply never has stubs. */
  var registry = {}, order = [], loading = {}, loaded = {};
  (window.SL_MANIFEST || []).forEach(function (m) { m.stub = true; if (!registry[m.id]) order.push(m.id); registry[m.id] = m; });
  function loadAsset(file) {
    if (loaded[file]) return Promise.resolve();
    if (loading[file]) return loading[file];
    var url = (window.SL_ASSETS || {})[file];
    if (!url) return Promise.reject(new Error('no asset for ' + file));
    loading[file] = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = url; s.async = true;
      s.onload = function () { loaded[file] = 1; delete loading[file]; resolve(); };
      s.onerror = function () { delete loading[file]; try { s.parentNode.removeChild(s); } catch (e) {} reject(new Error('failed ' + file)); };
      document.head.appendChild(s);
    });
    return loading[file];
  }
  /* A board does not have its final width the moment it is mounted: the shell is
     still animating in and the fonts are still loading. A drawing that measures
     the box then is laid out into a fraction of it and STAYS there, because
     nothing after that fires a resize. Every engine used to guess at a 30ms
     timer; this watches the box instead and lays out again whenever its width
     really moves. Returns the stop function to call from destroy. */
  function watchWidth(el, fn) {
    var last = el.clientWidth, ro;
    if (window.ResizeObserver) {
      ro = new ResizeObserver(function () {
        var w = el.clientWidth;
        if (!w || Math.abs(w - last) < 2) return;
        last = w; fn(w);
      });
      ro.observe(el);
      return function () { ro.disconnect(); };
    }
    var t = setTimeout(function () { fn(el.clientWidth); }, 30);
    return function () { clearTimeout(t); };
  }
  var SL = window.SL = {
    MINUS: MINUS, ri: ri, pick: pick, chance: chance, shuffle: shuffle, esc: esc, el: el, lsGet: lsGet, lsSet: lsSet,
    watchWidth: watchWidth,
    ICON: ICON, reduceMotion: reduceMotion,
    register: function (skill) { if (!registry[skill.id]) order.push(skill.id); registry[skill.id] = skill; },
    skills: function () { return order.map(function (id) { return registry[id]; }); },
    get: function (id) { return registry[id]; },
    ready: function (id) { var m = registry[id]; return !!(m && !m.stub); },
    /* load the engines for these skills, kits first, one fetch per asset however
       many skills share it; resolves once every one of them has registered */
    ensure: function (ids) {
      return Promise.all(ids.map(function (id) {
        var m = registry[id];
        if (!m) return Promise.reject(new Error('unknown skill ' + id));
        if (!m.stub) return Promise.resolve(m);
        return Promise.all((m.needs || []).map(loadAsset)).then(function () { return loadAsset(m.file); }).then(function () {
          if (registry[id].stub) throw new Error('module did not register ' + id);
          return registry[id];
        });
      }));
    }
  };

  var STRANDS = {
    secondary: [
      { id: 'number', name: 'Number' }, { id: 'algebra', name: 'Algebra' }, { id: 'ratio', name: 'Ratio & proportion' },
      { id: 'geometry', name: 'Geometry' }, { id: 'statistics', name: 'Statistics & probability' }
    ],
    primary: [
      { id: 'p-number', name: 'Number & place value' }, { id: 'p-calc', name: 'Calculation' },
      { id: 'p-fdp', name: 'Fractions, decimals & percentages' }, { id: 'p-measure', name: 'Measure' }, { id: 'p-shape', name: 'Shape & position' }
    ]
  };

  /* ============================================================
     THE LEARNING ORDER
     A shelf listed itself in whatever order the modules happened to be
     wired in, which is not an order anybody learns in. One list per
     strand, written as the order a pupil should MEET the skills, and the
     library sorts by it everywhere: the shelf, the search results and the
     mix. A skill that is not named here still shows - it falls to the end
     of its strand - and `build.py` prints a warning naming it, so a new
     skill is never quietly left at the bottom.
     WHEN YOU ADD A SKILL: put its id in the list, next to the skill it
     builds on, not at the end.
     ============================================================ */
  var LEARN_ORDER = {
    /* Primary number: count, then read what the digits mean, then move
       around the number line, then read and compare, then shift the digits.
       Roman numerals are a side branch, so they come last. */
    'p-number': [
      'counting-in-steps',
      'place-value',
      'more-or-less',
      'reading-writing-numbers',
      'comparing-ordering-numbers',
      'multiply-divide-by-10-100-1000',
      'linear-nth-term',
      'roman-numerals'
    ],
    /* Primary calculation: the four written methods in teaching order. Tables first,
       because every one of them is a table fact repeated. */
    'p-calc': [
      'times-tables',
      'grid-multiplication',
      'column-multiplication',
      'short-division'
    ],
    'p-fdp': [
      'mult-div-decimals'
    ],
    'p-measure': [],
    'p-shape': [],
    /* Secondary number: what the digits mean, then the four written methods in the
       order they are taught (tables, the grid that explains multiplication, the column
       that does it quickly, division, then the same two methods with decimals), then
       the line carried past zero and the harder number work. The written methods sit
       here and not at the end: they stand on place value and on multiplying by powers
       of ten, and everything below them stands on the written methods. */
    'number': [
      'place-value',
      'more-or-less',
      'reading-writing-numbers',
      'comparing-ordering-numbers',
      'multiply-divide-by-10-100-1000',
      'times-tables',
      'grid-multiplication',
      'column-multiplication',
      'short-division',
      'mult-div-decimals',
      'negative-numbers',
      'recurring-decimals',
      'simplifying-surds',
      'rationalising'
    ],
    /* Algebra: one bracket, two, three, then the same expansion with surds. */
    'algebra': [
      'expanding-single-brackets',
      'expanding-double-brackets',
      'expanding-triple-brackets',
      'expanding-surd-brackets',
      'rearranging-formulae',
      'linear-nth-term',
      'quadratic-sequences',
      'factorising-quadratics',
      'solving-quadratics-factorising',
      'completing-the-square',
      'quadratic-formula',
      'simplifying-algebraic-fractions',
      'mult-div-algebraic-fractions',
      'add-sub-algebraic-fractions',
      'algebraic-fraction-equations',
      'algebraic-proof'
    ],
    'ratio': [],
    'geometry': [],
    'statistics': []
  };

  /* ============================================================
     THE APP
     A skill is a destination: Skills → skill → level → activity.
     Mixed practice is the only place with a basket.
     ============================================================ */
  function boot() {
    var root = $('slRoot');
    if (!root) return;
    var shell = $('slShell');
    var PLANNED = window.SL_PLANNED || {};
    var K = 'shlc_sl_v2';

    var S = {
      theme: 'dark', stage: 'secondary', strand: 'algebra', search: '', showPlanned: false, libZoom: 3,
      view: 'skills', skill: null, mix: [], levels: {}, sel: {}, prog: {},
      screen: 'library', from: 'skills', set: [], setN: 10, prOne: -1, typed: false,
      /* the question drawer starts open on a laptop and CLOSED on a phone: under
         640px it is a 40vh block stacked above the board, and on a 390 wide
         screen it pushed the model right off the bottom of the page */
      teach: { i: 0, r: null, mode: 'step', done: false, listOpen: !narrow(), back: null, opts: {} },
      /* Your turn: one question at a time, answered on the model. cp is the
         current question's checkpoints, marks what the pupil did with each on
         the FIRST try, and log the whole run, which is what the results read. */
      turn: { i: 0, r: null, phase: 'play', cp: [], marks: [], at: 0, log: [], t0: 0, ms: 0, ended: false },
      board: { cols: [], ans: false, layout: 'mix', mixLayout: 'skill', n: 16, tab: 0 },
      /* Speed: the shape of a run, and the sound that goes with it */
      speed: { shape: 'race', n: 10, secs: 120 }, sound: true,
      strandPicked: false, libMore: false,
      /* first open only: who is here, what for, what they want first, and
         how far through the walkthrough they are */
      intro: { done: false, who: null, goal: null, first: null, step: 0 },
      /* the skills saved to Favourites, newest first, by id */
      fav: [],
      /* GCSE past papers: the questions already walked through (by id) and the strand chip picked */
      pwSeen: {}, pwStrand: ''
    };

    /* ---------- storage ---------- */
    function save() {
      syncHash(false);
      lsSet(K, { theme: S.theme, stage: S.stage, strand: S.strand, skill: S.skill, mix: S.mix, fav: S.fav, levels: S.levels, sel: S.sel, prog: S.prog, typed: S.typed, libZoom: S.libZoom, teachOpts: S.teach.opts, chorus: S.chorus, sound: S.sound, speed: S.speed, pwSeen: S.pwSeen, intro: { done: S.intro.done, who: S.intro.who, goal: S.intro.goal, first: S.intro.first }, board: { layout: S.board.layout, mixLayout: S.board.mixLayout, n: S.board.n } });
    }
    (function load() {
      var d = lsGet(K, null) || lsGet('shlc_sl_v1', null);
      if (!d) return;
      if (d.theme === 'light' || d.theme === 'dark') S.theme = d.theme;
      if (d.stage === 'primary' || d.stage === 'secondary') S.stage = d.stage;
      if (typeof d.strand === 'string') S.strand = d.strand;
      if (d.skill && SL.get(d.skill)) S.skill = d.skill;
      if (Array.isArray(d.mix)) S.mix = d.mix.filter(function (m) { return m && SL.get(m.id); });
      /* favourites keep their raw ids: a skill module can register after this
         runs, and filtering here would quietly throw the saved skill away */
      if (Array.isArray(d.fav)) S.fav = d.fav.filter(function (id) { return typeof id === 'string'; });
      if (d.levels && typeof d.levels === 'object') S.levels = d.levels;
      if (d.sel && typeof d.sel === 'object') S.sel = d.sel;
      if (d.prog && typeof d.prog === 'object') S.prog = d.prog;
      S.typed = d.typed === true;
      if (d.teachOpts && typeof d.teachOpts === 'object') S.teach.opts = d.teachOpts;
      /* 0..6, see LIB_ZOOMS (a literal here: this runs before that list is assigned) */
      if (typeof d.libZoom === 'number' && d.libZoom >= 0 && d.libZoom <= 6) S.libZoom = Math.round(d.libZoom);
      S.chorus = d.chorus && typeof d.chorus === 'object' ? d.chorus : {};
      if (d.sound === false) S.sound = false;
      if (d.pwSeen && typeof d.pwSeen === 'object') S.pwSeen = d.pwSeen;
      if (d.speed && typeof d.speed === 'object') {
        if (d.speed.shape === 'race' || d.speed.shape === 'clock') S.speed.shape = d.speed.shape;
        /* SPEED SLIDERS (2026-09-21): a length saved before the sliders (5 questions, 30 seconds,
           1½ minutes) snaps to the nearest stop in range. spSnap is a declaration further down. */
        var sN = spSnap('race', d.speed.n), sS = spSnap('clock', d.speed.secs);
        if (sN) S.speed.n = sN;
        if (sS) S.speed.secs = sS;
      }
      if (d.intro && typeof d.intro === 'object') {
        S.intro.done = d.intro.done === true;
        ['who', 'goal', 'first'].forEach(function (k) { if (typeof d.intro[k] === 'string') S.intro[k] = d.intro[k]; });
      }
      /* someone who used the lab before the walkthrough existed has already
         found their way round: progress or a saved skill counts as done */
      else if (d.skill || (d.fav && d.fav.length) || (d.prog && Object.keys(d.prog).length)) S.intro.done = true;
      if (d.board) { if (d.board.layout === 'diff' || d.board.layout === 'mix') S.board.layout = d.board.layout; if (d.board.mixLayout === 'mixed' || d.board.mixLayout === 'skill') S.board.mixLayout = d.board.mixLayout; if ([8, 16, 24].indexOf(d.board.n) >= 0) S.board.n = d.board.n; }
    })();

    /* ============================================================
       GA4
       The Shopify Google & YouTube pixel puts gtag on the page itself
       (window.gtag, dataLayer), so an event here lands in G-42RVT4XQGJ with
       no tag of our own and no extra bytes. Nothing about a pupil goes with
       it: a skill id, a level number, a count. If gtag is missing, as it is
       in the harness, every call is a no-op that still writes to
       window.__SL_TRACK_LOG, which is how a flow is checked without GA4.
       Custom parameters need registering as custom dimensions in GA4 admin
       before they show up in reports - the events themselves arrive anyway.
       ============================================================ */
    var TRACK_LOG_MAX = 80;
    function track(name, params) {
      var p = {}, k, v;
      for (k in (params || {})) {
        v = params[k];
        if (v === null || v === undefined || v === '') continue;
        p[k] = typeof v === 'string' ? v.slice(0, 100) : v;
      }
      try {
        var log = window.__SL_TRACK_LOG = window.__SL_TRACK_LOG || [];
        log.push({ e: name, p: p, t: Date.now() });
        if (log.length > TRACK_LOG_MAX) log.shift();
      } catch (err) {}
      /* belt and braces on the theme's internal-traffic marker: the layout sets
         traffic_type globally for a marked browser, and this stamps the lab's
         own events too, so they are dropped by the GA4 filter either way */
      if (window.__shlcInternal) p.traffic_type = 'internal';
      /* send_to names GA4 alone. Without it the event also goes to the Ads and
         Merchant Center containers the Shopify pixel configures on the same
         gtag, which have no use for a level number and list it as a conversion
         candidate. */
      p.send_to = 'G-42RVT4XQGJ';
      try { if (typeof window.gtag === 'function') window.gtag('event', name, p); } catch (err) {}
    }
    /* one per skill and level for the life of the page, and one per dealt set */
    var trackedSecure = {}, trackedSet = null, trackedTour = false, trackedWait = false;
    function levelsOf(sk) { try { return selLevels(sk).join(','); } catch (err) { return ''; } }

    /* ---------- helpers on skills ---------- */
    /* the levels a skill is set to: one or several, never none. skillLevel is the lowest */
    function selLevels(sk) {
      var a = S.sel[sk.id];
      if (!Array.isArray(a) || !a.length) { var n = S.levels[sk.id]; a = [(typeof n === 'number' && n >= 1 && n <= sk.levels.length) ? n : 1]; }
      a = a.filter(function (x) { return typeof x === 'number' && x >= 1 && x <= sk.levels.length; }).sort(function (x, y) { return x - y; });
      return a.length ? a : [1];
    }
    function skillLevel(sk) { return selLevels(sk)[0]; }
    function setSel(sk, arr) { var a = arr.filter(function (x, i, xs) { return xs.indexOf(x) === i; }).sort(function (x, y) { return x - y; }); if (!a.length) return; S.sel[sk.id] = a; S.levels[sk.id] = a[0]; save(); }
    function setLevel(sk, n) { setSel(sk, [Math.max(1, Math.min(sk.levels.length, n))]); }
    function toggleSel(sk, n) { var a = selLevels(sk); if (a.indexOf(n) >= 0) { if (a.length === 1) return; a = a.filter(function (x) { return x !== n; }); } else a.push(n); setSel(sk, a); }
    function levelWord(sk) { var a = selLevels(sk); if (a.length === 1) return 'Level ' + a[0] + ': ' + levelName(sk, a[0]); return 'Levels ' + (a.length === 2 ? a.join(' and ') : a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1]); }
    /* the family's hue and shade; the module's own `colour:` is only the
       fallback for a skill nobody has put in a family yet */
    function colourOf(sk) { return (sk && FAMILY_COLOUR[sk.id]) || COLOURS[sk && sk.colour] || COLOURS.blue; }
    function skIcon(sk) { return sk ? stk(sk.id, ICON[sk.icon] || '', sk.sticker) : ''; }
    function tagHTML(sk) { var c = colourOf(sk); return '<span class="sl-tag" style="color:' + c.col + ';background:' + c.tint + '">' + skIcon(sk) + esc(sk.short || sk.name) + '</span>'; }
    function levelName(sk, n) { var L = sk.levels[n - 1]; return L ? L.name : ''; }
    /* The level that deals from all the others. Aadam, 2026-09-15: "remove all mixed levels from
       teaching mode as not needed", and "in practice always show the Mixed level as 'Mixed' so you
       can see clearly". Known by its id or by "mixed" in its name (Everything mixed, Mixed and checked). */
    function isMixLevel(sk, n) { var L = sk && sk.levels && sk.levels[n - 1]; return !!L && (L.levelId === 'mixed' || /\bmixed\b/i.test(L.name || '')); }
    /* MIXED LEVEL CHIP FITS ITS WORD (2026-09-21): the chip builders add sl-chip--mix so the CSS can let it grow */
    function chipText(sk, n) { return isMixLevel(sk, n) ? 'Mixed' : String(n); }
    /* Teach deals from the chosen levels without the mixed one; if that was the only one chosen,
       the level below it. True when anything changed. */
    function stripMixForTeach() {
      var changed = false;
      activeSkills().forEach(function (sk) {
        var a = selLevels(sk), b = a.filter(function (k) { return !isMixLevel(sk, k); }), k;
        if (b.length === a.length) return;
        if (!b.length) for (k = sk.levels.length; k >= 1; k--) if (!isMixLevel(sk, k)) { b = [k]; break; }
        if (b.length) { setSel(sk, b); changed = true; }
      });
      return changed;
    }
    /* what a level chip says on hover: its name and a question like the ones it deals */
    /* the attributes that drive the pill: what the level is, and one question from it */
    /* ONE example, never two. Levels written with a second example after a
       double space get cut back here, so nothing has to be trusted to stay short. */
    function oneEg(eg) { return String(eg || '').split(/,\s\s+/)[0].trim(); }
    function tipAttrs(sk, n) {
      var L = sk.levels[n - 1]; if (!L) return '';
      return ' data-tip="' + esc('Level ' + n + ': ' + L.name) + '"' + (L.eg ? ' data-tipeg="' + esc(oneEg(L.eg)) + '"' : '');
    }
    function levelEg(sk, n) { var L = sk.levels[n - 1]; return L ? oneEg(L.eg) : ''; }
    /* a skill can span both stages (stage: 'both'): it lists under its secondary strand
       and under `pstrand` in the primary list, same name in both (Aadam, 2026-09-09) */
    function strandOf(sk, stage) { return (stage === 'primary' && sk.pstrand) ? sk.pstrand : sk.strand; }
    function inStage(sk, stage) { var s = sk.stage || 'secondary'; return !stage || s === stage || (s === 'both' && (stage === 'secondary' || !!sk.pstrand)); }
    /* where a skill sits in its strand's learning order; unlisted skills go
       to the end, in the order they registered, never dropped */
    function learnIndex(sk, stage) {
      var list = LEARN_ORDER[strandOf(sk, stage)] || [], i = list.indexOf(sk.id);
      return i < 0 ? 900 : i;
    }
    function strandRank(sk, stage) {
      var st = strandOf(sk, stage), list = STRANDS[stage] || STRANDS.secondary, i;
      for (i = 0; i < list.length; i++) if (list[i].id === st) return i;
      return 90;
    }
    /* indexed once per registry size: the library asks every strand for its count on every render */
    var readyMemo = {}, readyMemoN = -1;
    function readySkills(strand, stage) {
      var all = SL.skills(), k = (strand || '') + '|' + (stage || '');
      if (readyMemoN !== all.length) { readyMemo = {}; readyMemoN = all.length; }
      if (!readyMemo[k]) {
        var reg = {}; all.forEach(function (sk, i) { reg[sk.id] = i; });
        readyMemo[k] = all.filter(function (sk) { return inStage(sk, stage) && (!strand || strandOf(sk, stage) === strand); })
          .sort(function (a, b) {
            return (strandRank(a, stage) - strandRank(b, stage)) || (learnIndex(a, stage) - learnIndex(b, stage)) || (reg[a.id] - reg[b.id]);
          });
      }
      return readyMemo[k];
    }
    /* The planned list is the Mr Carter crawl, and it still holds the names of
       skills that have since been BUILT - so "Negative numbers" showed as a tile
       AND as planned. Every skill added from here would have done the same, so
       the planned list is filtered against what is registered: the skill's name,
       its short name and its aliases, loosely matched. */
    function plainName(x) { return String(x || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim(); }
    var builtNames = null;
    function isBuilt(name) {
      if (!builtNames) {
        builtNames = {};
        SL.skills().forEach(function (sk) {
          [sk.name, sk.short].concat(sk.aliases || []).forEach(function (n) { if (n) builtNames[plainName(n)] = 1; });
        });
      }
      return !!builtNames[plainName(name)];
    }
    var planMemo = {};
    function plannedFor(strand) { if (!planMemo[strand]) planMemo[strand] = (PLANNED[strand] || []).filter(function (n) { return !isBuilt(n); }); return planMemo[strand]; }
    function curSkill() { return S.skill ? SL.get(S.skill) : null; }
    function mixSkills() { return S.mix.map(function (m) { return SL.get(m.id); }).filter(Boolean); }
    function inMix(sk) { return S.mix.some(function (m) { return m.id === sk.id; }); }
    /* Favourites: one list, kept across both stages, newest first. It is the
       pupil's own shelf, so a skill saved in Secondary still shows when the
       switch is on Primary - the list is theirs, not the stage's. */
    function isFav(sk) { return sk && S.fav.indexOf(sk.id) >= 0; }
    function toggleFav(sk) { var i = S.fav.indexOf(sk.id); if (i >= 0) S.fav.splice(i, 1); else S.fav.unshift(sk.id); save(); }
    function favSkills() { return S.fav.map(function (id) { return SL.get(id); }).filter(Boolean); }
    /* the skills a set or a board is dealt from: the one skill, or the mixed basket */
    function activeSkills() { return S.from === 'mixed' ? mixSkills() : (curSkill() ? [curSkill()] : []); }
    /* A skill whose answer can only be REVEALED cannot be raced. An algebraic proof is a page
       of working, not something a child types on a keypad against a clock (Aadam, 2026-09-24,
       "keep algebraic proof out of speed"). `speed: false` on the register object says so, and
       it is JSON-clean, so a manifest STUB carries it and the Speed card is gone before the
       engine has loaded - the same rule as gating Your turn on `turnName` and never on `turn`.
       Gate on this, never on what make() happens to deal: sampling a stub has no make(). */
    function canRace(sk) { return !!sk && sk.speed !== false; }
    function raceSkills() { return activeSkills().filter(canRace); }
    function matches(q, name, aliases) { q = q.trim().toLowerCase(); if (!q) return true; if (name.toLowerCase().indexOf(q) >= 0) return true; return (aliases || []).some(function (a) { return a.toLowerCase().indexOf(q) >= 0; }); }

    /* ---------- theme ---------- */
    /* A theme switch used to snap. For the third of a second after the toggle
       every colour on the page may transition (the is-theming class, see the
       MOTION block in the CSS) and the sun or moon turns in. The class comes
       off again so nothing else is slowed by it. */
    var themeFx = false, themeT = null;
    function applyTheme() {
      root.setAttribute('data-theme', S.theme);
      document.documentElement.classList.toggle('sl-dark', S.theme === 'dark');
      document.documentElement.classList.toggle('sl-light', S.theme === 'light');
      each(document.querySelectorAll('[data-sl-theme]'), function (b) {
        b.innerHTML = S.theme === 'dark' ? ICON.sun : ICON.moon;
        b.classList.toggle('is-spin', themeFx);
        b.setAttribute('aria-label', S.theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode');
        b.removeAttribute('title');
        b.setAttribute('data-tip', S.theme === 'dark' ? 'Light mode' : 'Dark mode');
        b.setAttribute('data-tipsub', S.theme === 'dark' ? 'A white page, for a bright room or for printing.' : 'A dark page, easier on the eyes on a screen.');
      });
      if (themeFx) {
        themeFx = false;
        root.classList.add('is-theming'); document.documentElement.classList.add('sl-theming');
        clearTimeout(themeT);
        themeT = setTimeout(function () { root.classList.remove('is-theming'); document.documentElement.classList.remove('sl-theming'); }, 420);
      }
    }
    function toggleTheme() { S.theme = S.theme === 'dark' ? 'light' : 'dark'; save(); themeFx = !reduceMotion; applyTheme(); }
    function themeBtn() { return '<button type="button" class="sl-iconbtn" data-sl-theme></button>'; }

    /* ---------- scroll lock + inert page ---------- */
    var lockY = 0, isLocked = false, inerted = [];
    function lockScroll() {
      if (isLocked) return;
      lockY = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.documentElement.classList.add('sl-lock');
      var b = document.body.style; b.position = 'fixed'; b.top = (-lockY) + 'px'; b.left = '0'; b.right = '0'; b.width = '100%';
      isLocked = true;
    }
    function unlockScroll() {
      if (!isLocked) return;
      var b = document.body.style; b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = '';
      document.documentElement.classList.remove('sl-lock');
      isLocked = false;
      window.scrollTo(0, lockY);
      setTimeout(function () { window.scrollTo(0, lockY); }, 0);
    }
    /* everything that is not on the path from body to the shell goes inert while it is open */
    function setInert(on) {
      if (!on) { inerted.forEach(function (e) { e.inert = false; e.removeAttribute('aria-hidden'); }); inerted = []; return; }
      var node = shell;
      while (node && node !== document.body) {
        var parent = node.parentNode;
        if (!parent) break;
        Array.prototype.forEach.call(parent.children, function (sib) {
          if (sib !== node && sib.tagName !== 'SCRIPT' && sib.tagName !== 'STYLE') { sib.inert = true; sib.setAttribute('aria-hidden', 'true'); inerted.push(sib); }
        });
        node = parent;
      }
    }

    /* ============================================================
       SHELL
       ============================================================ */
    shell.setAttribute('role', 'dialog'); shell.setAttribute('aria-modal', 'true'); shell.setAttribute('aria-label', 'Skills Lab'); shell.setAttribute('tabindex', '-1');
    shell.innerHTML =
      '<div class="sl-top" id="slTop"></div>' +
      '<div class="sl-body">' +
        ['slWelcome', 'slLibrary', 'slMixed', 'slSkill', 'slBoardSetup', 'slSpeedSetup', 'slPractise', 'slTeach', 'slTurn', 'slBoard', 'slSpeed', 'slPapers'].map(function (id) { return '<div class="sl-screen" id="' + id + '"></div>'; }).join('') +
      '</div>';
    var elTop = $('slTop'), elBody = shell.querySelector('.sl-body');
    var SCREEN_ID = { welcome: 'slWelcome', library: 'slLibrary', mixed: 'slMixed', skill: 'slSkill', boardsetup: 'slBoardSetup', speedsetup: 'slSpeedSetup', practise: 'slPractise', teach: 'slTeach', turn: 'slTurn', board: 'slBoard', speed: 'slSpeed', papers: 'slPapers' };

    /* ============================================================
       MOTION
       Every screen is rebuilt with innerHTML, so a CSS transition on a
       selected control never fires: the old button is gone and the new one
       is born already selected. So a render is bracketed. Before it, the
       selected controls are measured; after it, each fresh one is told where
       its predecessor was. A single-choice control (a segmented pill, the
       strand list, the teach list, the board tabs) slides from there. A
       multi-choice control (level chips and rows, tiles in a mix, switches)
       that has just come on pops, and one that has just gone off is told so.
       The MOTION block at the foot of skills-lab.css does the drawing.
       FX carries one-shot notes from a click to the next render (which card
       was just revealed, marked or swapped) and is wiped once used.
       ============================================================ */
    var MO = (function () {
      var SLIDE = '.sl-seg, .sl-strand, .sl-rrow[data-tq], .sl-btabs .sl-chip';
      var POP = '.sl-chip--lvl, .sl-chip--alllvl, .sl-lvlrow, .sl-tile[data-skill], .sl-toggle';
      var NEW = '.sl-mixchip';
      /* a control is measured against the box it slides inside (its segwrap,
         its rail, its list), never the viewport: a teach model can move the
         whole mode switch after it mounts, and the pill must still travel one
         slot along its track, not across the screen */
      var GROUPBOX = '.sl-segwrap, .sl-teach-rail-q, .sl-btabs, .sl-rail';
      var ON = /(^|\s)(is-on|is-now|sl-chip--now)(\s|$)/;
      function isOn(e) { return ON.test(e.className); }
      function skip(name) { return name.indexOf('data-') !== 0 || name === 'data-tip' || name === 'data-tipeg' || name === 'data-tipsub'; }
      function dataKey(e) { var out = [], a = e.attributes, i; for (i = 0; i < a.length; i++) if (!skip(a[i].name)) out.push(a[i].name + '=' + a[i].value); return out.join('|'); }
      /* the track a single-choice control slides along: named on the wrapper
         where there is one (data-mo-group), else the control's first data
         attribute, scoped to the topic or mix chip it sits in */
      function groupOf(e) {
        var g = e.closest('[data-mo-group]'), name = g ? g.getAttribute('data-mo-group') : null, a = e.attributes, i;
        if (!name) for (i = 0; i < a.length; i++) if (!skip(a[i].name)) { name = a[i].name; break; }
        return (name || e.id || '') + '@' + scopeOf(e);
      }
      function scopeOf(e) { var s = e.closest('[data-topic],[data-mix]'); return s ? (s.getAttribute('data-topic') || s.getAttribute('data-mix')) : ''; }
      function keyOf(e) { return (e.id ? '#' + e.id : e.className.split(' ')[0]) + '@' + scopeOf(e) + '|' + dataKey(e); }
      function rect(e) {
        var r = e.getBoundingClientRect(); if (!r.width) return null;
        var g = e.closest(GROUPBOX), b = g ? g.getBoundingClientRect() : { left: 0, top: 0 };
        return { left: r.left - b.left, top: r.top - b.top, width: r.width, height: r.height };
      }
      function snap(root) {
        if (reduceMotion) return;
        var s = { slide: {}, on: {}, had: {} };
        each(root.querySelectorAll(SLIDE), function (e) { var r; if (isOn(e) && (r = rect(e))) s.slide[groupOf(e)] = { key: keyOf(e), r: r }; });
        each(root.querySelectorAll(POP), function (e) { s.on[keyOf(e)] = isOn(e); });
        each(root.querySelectorAll(NEW), function (e) { s.had[keyOf(e)] = 1; });
        root.__mo = s;
      }
      function play(root) {
        var s = root.__mo; root.__mo = null; if (!s) return;
        each(root.querySelectorAll(SLIDE), function (e) {
          if (!isOn(e)) return;
          var old = s.slide[groupOf(e)], r;
          if (!old || old.key === keyOf(e) || !(r = rect(e))) return;
          e.style.setProperty('--fx', (old.r.left - r.left).toFixed(1) + 'px');
          e.style.setProperty('--fy', (old.r.top - r.top).toFixed(1) + 'px');
          e.style.setProperty('--fw', (old.r.width / r.width).toFixed(3));
          e.style.setProperty('--fh', (old.r.height / r.height).toFixed(3));
          e.classList.add('is-slide');
        });
        each(root.querySelectorAll(POP), function (e) {
          var was = s.on[keyOf(e)], now = isOn(e);
          if (was === undefined || was === now) return;
          e.classList.add(now ? 'is-pop' : 'is-unpop');
        });
        each(root.querySelectorAll(NEW), function (e) { if (!s.had[keyOf(e)]) e.classList.add('is-new'); });
      }
      return { snap: snap, play: play, keyOf: keyOf };
    })();
    /* render through here and the selected controls carry their motion over.
       `after` runs before the measuring pass: anything that changes the layout
       once the markup is in (mounting a teach model fills the step bar and
       shifts the mode switch) has to happen first, or the pill measures a
       position it is about to leave. */
    var SCROLLERS = '.sl-scroll, .sl-rail, .sl-teach-rail-q, .sl-strands', lastPaint = 0;
    /* a render puts the keyboard back where it was by calling focus(), which
       fires focusin. That is not a pupil reaching a control, so no tooltip. */
    var focusRestore = false;
    function focusKey(e) { return e && e !== document.body && e !== shell ? { tag: e.tagName, key: MO.keyOf(e) } : null; }
    function paint(host, html, after) {
      /* a render must not throw a pupil back to the top of the list, nor drop
         the keyboard's place: the scrollers' positions and the focused control
         are found again in the new markup */
      var t0 = (window.performance && performance.now) ? performance.now() : 0;
      var ae = document.activeElement, fk = (ae && host.contains(ae)) ? focusKey(ae) : null, saved = [];
      each(host.querySelectorAll(SCROLLERS), function (sc, i) { if (sc.scrollTop || sc.scrollLeft) saved.push({ i: i, top: sc.scrollTop, left: sc.scrollLeft }); });
      MO.snap(host);
      host.innerHTML = html;
      if (after) after();
      /* PHONE LIBRARY + MIXED TRAY + LEVEL TICK SCROLL (2026-09-21): the scrollers are scroll-behavior:smooth, so writing the old
         position back started a glide from 0 on the NEW list, and the scrollLeft write straight
         after it cancelled the glide: a phone ticking a level row was thrown back to the top.
         Put the position back instantly. */
      if (saved.length) { var scs = host.querySelectorAll(SCROLLERS); saved.forEach(function (s) { var sc = scs[s.i]; if (!sc) return; var sb = sc.style.scrollBehavior; sc.style.scrollBehavior = 'auto'; sc.scrollTop = s.top; sc.scrollLeft = s.left; sc.style.scrollBehavior = sb; }); }
      if (fk && !host.contains(document.activeElement)) {
        var hit = null; each(host.querySelectorAll(fk.tag), function (c) { if (!hit && MO.keyOf(c) === fk.key) hit = c; });
        if (hit) { focusRestore = true; try { hit.focus({ preventScroll: true }); } catch (e) { try { hit.focus(); } catch (e2) {} } focusRestore = false; }
      }
      MO.play(host);
      if (t0) lastPaint = performance.now() - t0;
    }
    /* restart a one-shot animation on a node that is patched in place */
    function refresh(node) { if (reduceMotion || !node) return; node.classList.remove('is-fresh'); void node.offsetWidth; node.classList.add('is-fresh'); }
    function diffCount(a, b) { if (a.length !== b.length) return Math.max(a.length, b.length); var n = 0, i; for (i = 0; i < a.length; i++) if (a[i] !== b[i]) n++; return n; }
    var FX = {};
    /* how deep each screen sits: going deeper slides in from the right, coming back from the left */
    var DEPTH = { welcome: 0, library: 0, mixed: 1, skill: 2, boardsetup: 3, speedsetup: 3, practise: 3, teach: 4, turn: 4, board: 4, speed: 4, papers: 3 };
    var entering = false, opening = false;

    /* ---------- loading a skill's engine ----------
       The library and the skill screen run on the manifest alone. The first
       time an activity needs a skill's engine (Practise, Teach, Board, a deep
       link) its asset is fetched: the control that was pressed goes busy, and
       the screen only changes once every needed module has registered. A load
       that fails says so in a toast with a retry; a load overtaken by another
       navigation is dropped. */
    var loadTok = 0, lastLoad = null;
    function busy(btn, on, label) {
      if (!btn) return;
      btn.classList.toggle('is-busy', !!on); btn.setAttribute('aria-busy', on ? 'true' : 'false');
      if (on) { btn.disabled = true; if (label) { btn.setAttribute('data-label', btn.innerHTML); btn.innerHTML = ICON.refresh + esc(label); } }
      else { btn.disabled = false; if (btn.hasAttribute('data-label')) { btn.innerHTML = btn.getAttribute('data-label'); btn.removeAttribute('data-label'); } }
    }
    function withSkills(ids, btn, go, labelled) {
      ids = ids.filter(Boolean);
      if (ids.every(SL.ready)) { go(); return; }
      var tok = ++loadTok, n = ids.filter(function (id) { return !SL.ready(id); }).length;
      lastLoad = { ids: ids, go: go };
      busy(btn, true, labelled ? (n > 1 ? 'Preparing ' + n + ' skills' : 'Loading') : null);
      SL.ensure(ids).then(function () {
        if (tok !== loadTok) return;
        busy(btn, false); go();
      }, function () {
        if (tok !== loadTok) return;
        busy(btn, false);
        toast('That skill did not load. Check the connection and try again.', 'Try again', function () { var L = lastLoad; if (L) withSkills(L.ids, null, L.go); });
      });
    }
    var toastEl = null, toastT = null;
    function toast(msg, action, fn) {
      if (!toastEl) { toastEl = el('div', 'sl-toast'); toastEl.setAttribute('role', 'status'); shell.appendChild(toastEl); }
      toastEl.innerHTML = '<span>' + esc(msg) + '</span>' + (action ? '<button type="button" class="sl-btn sl-btn--sm" id="slToastGo">' + esc(action) + '</button>' : '');
      toastEl.classList.add('is-on');
      var go = $('slToastGo'); if (go) go.onclick = function () { hideToast(); if (fn) fn(); };
      clearTimeout(toastT); toastT = setTimeout(hideToast, action ? 8000 : 3500);
    }
    function hideToast() { if (toastEl) toastEl.classList.remove('is-on'); clearTimeout(toastT); }

    /* Keys. One handler, per screen, and it stands down whenever the focus is in
       a field or on a button so Space and Enter still do the obvious thing. */
    /* SHORTER SHORTCUTS (2026-09-21). Aadam: "more concise - repetitive ones don't have to appear so many
       times". A key that does the same job on every screen is listed once, under Everywhere; a screen lists
       only what is its own. R gives new questions on the board as well (N still works there), and / opens
       this list as well as ?. A row's keys can be a list: one kbd each. */
    var KEYS = [
      /* SMARTBOARD KEYS (Aadam, 2026-09-21): N gives new questions on every screen, C marks a card
         correct and X marks it missed (Y and N used to), so copying a link moved from C to L */
      ['Everywhere', [['Space', 'Next card, step or question'], ['A', 'Show the answers'], ['N', 'New questions'],
                      ['Esc', 'Back'], ['F', 'Full screen'], ['L', 'Copy a link to this'], [['?', '/'], 'This list']]],
      ['Practise',   [[['←', '→'], 'Previous or next card'], [['C', '1'], 'Mark it correct'], [['X', '2'], 'Mark it missed'],
                      ['H', 'Hide the answers'], ['S', 'Show the steps']]],
      ['Teach',      [[['←', '→'], 'Back or forward a step'], [['↑', '↓'], 'Previous or next question'], ['R', 'A new one for this question']]],
      ['Board',      [['Space', 'Show or hide the answers'], ['T', 'Start or stop the timer']]],
      ['Your turn',  [[['1', '2'], 'Pick the left or right choice']]],
      ['Speed',      [[['0-9', '.', '-'], 'Type your answer'], ['⌫', 'Rub one out'], ['1-6', 'Pick an option'],
                      ['M', 'Sound on or off'], ['Esc', 'Pause']]]
    ];
    var keysOpen = false;
    function keysHTML() {
      return '<div class="sl-keys-card" role="dialog" aria-label="Keyboard shortcuts"><div class="sl-keys-head"><b>Keyboard shortcuts</b>' +
        '<button type="button" class="sl-iconbtn" id="slKeysX" aria-label="Close">' + ICON.cross + '</button></div>' +
        '<div class="sl-keys-cols">' + KEYS.map(function (g) {
          return '<div class="sl-keys-grp"><div class="sl-sect">' + g[0] + '</div>' + g[1].map(function (r) {
            return '<div class="sl-keys-row"><span class="sl-keys-k">' + [].concat(r[0]).map(function (x) { return '<kbd>' + x + '</kbd>'; }).join('') + '</span><span>' + r[1] + '</span></div>';
          }).join('') + '</div>';
        }).join('') + '</div></div>';
    }
    function toggleKeys(on) {
      keysOpen = (on === undefined) ? !keysOpen : !!on;
      var w = $('slKeys');
      if (!w) { w = el('div', 'sl-keys'); w.id = 'slKeys'; shell.appendChild(w); }
      w.innerHTML = keysOpen ? keysHTML() : '';
      w.classList.toggle('is-on', keysOpen);
    }

    /* The browser's own tooltip is grey OS chrome, shows one line of plain text
       and takes a second to appear. A level chip has to say what the questions
       ARE, so it gets a proper pill: the plain-English name, then an example. */
    var tipEl = null, tipFor = null;
    function tipNode() {
      if (tipEl) return tipEl;
      tipEl = el('div', 'sl-tip');
      tipEl.setAttribute('role', 'tooltip');
      shell.appendChild(tipEl);
      return tipEl;
    }
    function showTip(t) {
      var name = t.getAttribute('data-tip'); if (!name) return;
      var eg = t.getAttribute('data-tipeg') || '', sub = t.getAttribute('data-tipsub') || '';
      var n = tipNode();
      /* Aadam, 2026-09-15: hover states "easier to understand and not overly complicated". One
         line: what it is, and its key when it has one. The sentence under it has gone, except where
         the tip IS the information (a bar on the Speed chart says which question it was). */
      var key = (sub.match(/Key:\s*(\S+)\s*$/) || [])[1] || '', keep = t.hasAttribute('data-tipkeep');
      n.classList.toggle('is-row', !eg && !keep);
      n.innerHTML = '<b>' + esc(name) + '</b>' + (eg ? '<span class="sl-expr">' + eg + '</span>' : '') +
        (keep && sub ? '<span class="sl-tipsub">' + esc(sub) + '</span>' : '') +
        (key ? '<kbd class="sl-tipkey">' + esc(key) + '</kbd>' : '');
      n.classList.add('is-on');
      var r = (SL.rawRect || function (x) { return x.getBoundingClientRect(); })(t), w = n.offsetWidth, h = n.offsetHeight;
      var left = Math.round(r.left + r.width / 2 - w / 2);
      left = Math.max(8, Math.min(left, window.innerWidth - w - 8));
      var top = Math.round(r.bottom + 8);
      if (top + h > window.innerHeight - 8) top = Math.round(r.top - h - 8);
      n.style.left = left + 'px'; n.style.top = top + 'px';
      tipFor = t;
    }
    function hideTip() { if (tipEl) tipEl.classList.remove('is-on'); tipFor = null; }
    shell.addEventListener('mouseover', function (e) {
      var t = e.target.closest ? e.target.closest('[data-tip]') : null;
      if (t && t !== tipFor) showTip(t); else if (!t && tipFor) hideTip();
    });
    shell.addEventListener('mouseout', function (e) {
      var t = e.target.closest ? e.target.closest('[data-tip]') : null;
      if (t && t === tipFor && !t.contains(e.relatedTarget)) hideTip();
    });
    /* a pill on FOCUS is for the keyboard. The shell focuses its first control
       the moment it opens, and a tooltip hanging open over the rail on load
       reads as a stuck panel, so a mouse focus does not raise one.
       A deep link opens the shell before anything has been pressed, and with no
       input yet :focus-visible MATCHES a scripted focus, so "Back to board setup"
       hung over the first column head on every board link. A tab opened in the
       background gets that focusin late, when it is first shown, so a flag round
       the call is not enough: after the shell opens, no pill on focus until a key
       is pressed (a modifier alone, as in cmd-tab, does not count). */
    var openQuiet = false;
    document.addEventListener('keydown', function (e) {
      if (!/^(Shift|Meta|Control|Alt|AltGraph|OS|CapsLock)$/.test(e.key || '')) openQuiet = false;
    }, true);
    shell.addEventListener('focusin', function (e) {
      if (focusRestore || openQuiet) return;
      var t = e.target.closest ? e.target.closest('[data-tip]') : null;
      if (!t) { hideTip(); return; }
      var kb = true; try { kb = t.matches(':focus-visible'); } catch (err) {}
      if (kb) showTip(t); else hideTip();
    });
    shell.addEventListener('focusout', hideTip);
    shell.addEventListener('click', hideTip, true);
    shell.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('button') : null;
      if (t && t.id === 'slKeysX') { toggleKeys(false); return; }
      /* the button that OPENED the panel is not an outside click: the top bar
         handler runs first, so by the time this one sees the same click the
         panel is already open and closing it here made the button look dead */
      if (t && t.id === 'slKeysBtn') return;
      if (keysOpen && !(e.target.closest && e.target.closest('.sl-keys-card'))) toggleKeys(false);
    });
    window.addEventListener('scroll', hideTip, true);

    /* Paper: the shell sits deep inside the theme's wrappers, and a print rule
       cannot say "hide everything except this element's ancestors". So the chain
       from the shell up to <body> is tagged while the app is open, and the print
       sheet hides every sibling of that chain. */
    function markPrintPath(on) {
      var e = shell.parentElement;
      while (e && e !== document.body) { e.classList.toggle('sl-printpath', !!on); e = e.parentElement; }
    }
    var closing = null;
    function openShell(screen) {
      if (closing) { clearTimeout(closing); closing = null; shell.classList.remove('is-closing'); shell.inert = false; }
      shell.classList.add('is-on'); shell.setAttribute('aria-hidden', 'false');
      root.classList.add('app-open');
      lockScroll(); setInert(true); markPrintPath(true);
      opening = true;
      track('lab_open', {
        entry: /^#(play|library|skills|mixed|skill|practise|teach|turn|board|speed)/.test(location.hash || '') ? 'deep_link' : 'button',
        returning: S.intro.done ? 'yes' : 'no',
        who: S.intro.who, goal: S.intro.goal
      });
      /* a deep link opens what it names; only the plain Open button, which
         asks for the library, ever meets the walkthrough */
      show((!screen || screen === 'library') && !S.intro.done ? 'welcome' : (screen || 'library'));
      setTimeout(function () { openQuiet = true; var f = elTop.querySelector('button'); if (f) f.focus(); else shell.focus(); }, 30);
    }
    /* the shell settles out over a sixth of a second, then really closes */
    function closeShell() {
      if (closing) return;
      loadTok++; hideToast(); clearTimeout(cascadeT); clearTimeout(searchTimer);
      if (reduceMotion) { closeNow(); return; }
      /* nothing may act on the app while it settles out */
      shell.classList.add('is-closing'); shell.inert = true;
      closing = setTimeout(closeNow, 170);
    }
    function closeNow() {
      closing = null; shell.classList.remove('is-closing'); shell.inert = false;
      destroyTeach();
      shell.classList.remove('is-on'); shell.setAttribute('aria-hidden', 'true');
      root.classList.remove('app-open');
      setInert(false); unlockScroll(); markPrintPath(false); toggleKeys(false); stopTimer(); destroyChorus(); destroyTurn(); spReset(); clearOut(); welFormRestore();
      if (window.history && history.replaceState && location.hash) {
        try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
      }
      var o = $('slOpen'); if (o) o.focus();
    }
    function destroyTeach() { if (S.teach.r) { try { S.teach.r.destroy(); } catch (e) {} S.teach.r = null; } }
    function destroyTurn() { if (S.turn.r) { try { S.turn.r.destroy(); } catch (e) {} S.turn.r = null; } }
    /* The screen that is LEAVING goes with the one arriving: it is held over
       the body for a fifth of a second, pushed the other way and faded, so a
       skill slides in over the library instead of replacing it in one frame.
       Only the still screens do this. A board, a run or a teach model carries
       measuring rigs that must not be asked to lay out twice, and a second copy
       of one on the stage would refit the live one underneath it. */
    var OUT_OK = { welcome: 1, library: 1, mixed: 1, skill: 1, boardsetup: 1, speedsetup: 1 };
    var outEl = null, outT = null;
    function clearOut() {
      if (!outEl) return;
      outEl.classList.remove('is-out', 'is-on'); outEl.removeAttribute('data-out'); outEl = null;
      clearTimeout(outT);
    }
    /* The leaving screen KEEPS is-on while it goes, and is-out takes it out of
       the flow instead. Dropping is-on first put it through display: none in
       the same style pass, and the animation Chrome then made on it stayed
       play-pending for ever: the class was right, the screen never moved. */
    function screenOut(prev, dir) {
      clearOut();
      var e = prev ? $(SCREEN_ID[prev]) : null;
      if (reduceMotion || !e || !OUT_OK[prev] || dir === 'none') { if (e) e.classList.remove('is-on'); return; }
      outEl = e; e.classList.add('is-out'); e.setAttribute('data-out', dir);
      outT = setTimeout(clearOut, 300);
    }
    function show(name) {
      if (S.screen === 'teach' && name !== 'teach') { destroyTeach(); destroyChorus(); }
      if (S.screen === 'papers' && name !== 'papers') destroyPapers();
      if (S.screen === 'turn' && name !== 'turn') destroyTurn();
      if (S.screen === 'board' && name !== 'board') stopTimer();
      if (S.screen === 'speed' && name !== 'speed') spReset();
      var prev = S.screen;
      hideTip();
      if (prev === 'welcome' && name !== 'welcome') welFormRestore();
      S.screen = name; loadTok++;
      var dir = (opening || reduceMotion || name === prev) ? 'none' : (DEPTH[name] >= DEPTH[prev] ? 'fwd' : 'back');
      elBody.setAttribute('data-dir', dir);
      opening = false; entering = true;
      syncHash(prev !== name);
      Object.keys(SCREEN_ID).forEach(function (k) { if (k !== prev) $(SCREEN_ID[k]).classList.remove('is-on'); });
      $(SCREEN_ID[name]).classList.add('is-on');
      screenOut(prev === name ? null : prev, dir);
      var r = { welcome: renderWelcome, library: renderLibrary, mixed: renderMixed, skill: renderSkill, boardsetup: renderBoardSetup, speedsetup: renderSpeedSetup, practise: renderPractise, teach: renderTeach, turn: renderTurn, board: renderBoard, speed: renderSpeed, papers: renderPapers }[name];
      r();
      renderTop();
      entering = false;
      var sc = $(SCREEN_ID[name]).querySelector('.sl-scroll'); if (sc) sc.scrollTop = 0;
      if (name !== prev) trackScreen(name);
    }
    /* what someone actually chose to do, named once per arrival */
    var ACTIVITY = { practise: 1, teach: 1, board: 1, speed: 1, turn: 1 };
    function trackScreen(name) {
      var sk = curSkill();
      if (name === 'skill' && sk) { track('skill_open', { skill: sk.id, strand: strandOf(sk, S.stage), stage: S.stage, levels: levelsOf(sk) }); return; }
      if (name === 'mixed') { track('mix_open', { mix_size: S.mix.length }); return; }
      if (!ACTIVITY[name]) return;
      track('activity_start', {
        activity: name, skill: S.from === 'mixed' ? 'mixed' : (sk ? sk.id : ''),
        levels: S.from === 'mixed' ? '' : (sk ? levelsOf(sk) : ''),
        mix_size: S.from === 'mixed' ? mixSkills().length : 1,
        stage: S.stage
      });
    }
    /* where "back" and "Change skill" go from an activity */
    function backTarget() { return S.from === 'mixed' ? 'mixed' : 'skill'; }
    /* the steps screen returns to whatever opened it: practise, or the skill */
    function backFromTeach() { return S.teach.back === 'practise' && S.set.length ? 'practise' : backTarget(); }
    function changeSkill() { S.from = 'skills'; show('library'); }

    /* ---------- top bar ---------- */
    function titleHTML() {
      var sk = curSkill();
      if (S.from === 'mixed') return '<span class="sl-title"><b>Mixed practice</b><span>' + mixSkills().length + ' skills</span></span>';
      if (!sk) return '';
      var it = S.screen === 'teach' && S.set[S.teach.i];
      var sub = it ? 'Level ' + it.level + ': ' + levelName(it.skill, it.level) : levelWord(sk);
      return '<span class="sl-title"><b>' + esc(it ? it.skill.name : sk.name) + '</b><span>' + esc(sub) + '</span></span>';
    }
    function renderTop() {
      var h = '';
      /* The tooltip pill, not the browser's own: title= is grey OS chrome that
         takes a second to show and cannot say a second line. Every control in
         this bar is an icon, so every one of them says what it does and what
         key does the same thing. A control with data-tip must NOT also carry a
         title, or the OS tooltip turns up underneath it. */
      var full = '<button type="button" class="sl-iconbtn" id="slCopyLink" aria-label="Copy a link to this" data-tip="Copy a link" data-tipsub="A link that opens this skill at these levels. Key: L">' + ICON.link + '</button>' +
        '<button type="button" class="sl-iconbtn hide-sm" id="slKeysBtn" aria-label="Keyboard shortcuts" data-tip="Keyboard shortcuts" data-tipsub="Every key the app listens for. Key: ? or /"><span class="sl-kbd">?</span></button>' +
        '<button type="button" class="sl-iconbtn" id="slFull" aria-label="Full screen" data-tip="Full screen" data-tipsub="Fill the whole screen, for the front of a class. Key: F">' + ICON.expand + '</button>';
      var back = function (id, label) { return '<button type="button" class="sl-iconbtn" id="' + id + '" aria-label="' + label + '" data-tip="' + label + '" data-tipsub="Key: Esc">' + ICON.chevL + '</button>'; };
      var TIP = function (name, sub) { return ' data-tip="' + name + '" data-tipsub="' + sub + '"'; };
      if (S.screen === 'welcome') {
        h = '<button type="button" class="sl-iconbtn" id="slClose" aria-label="Close Skills Lab" data-tip="Close" data-tipsub="Leave the Skills Lab and go back to the page. Key: Esc">' + ICON.cross + '</button>' +
          '<h1 class="sl-wordmark">Maths Skills <span>Lab</span></h1>' +
          '<div class="sl-spacer"></div>' +
          '<button type="button" class="sl-btn sl-btn--sm sl-btn--ghost" id="slWelSkip"' + TIP('Skip', 'Straight to the skills. You can start the walkthrough again from the library.') + '>Skip</button>' + themeBtn();
      } else if (S.screen === 'library' || S.screen === 'mixed') {
        h = '<button type="button" class="sl-iconbtn" id="slClose" aria-label="Close Skills Lab" data-tip="Close" data-tipsub="Leave the Skills Lab and go back to the page. Key: Esc">' + ICON.cross + '</button>' +
          '<h1 class="sl-wordmark">Maths Skills <span>Lab</span></h1><div class="sl-vbar"></div>' +
          '<div class="sl-segwrap" role="tablist" data-mo-group="view"><button type="button" role="tab" class="sl-seg' + (S.screen === 'library' ? ' is-on' : '') + '" data-view="skills">' + ICON.book + 'Skills</button>' +
          '<button type="button" role="tab" class="sl-seg' + (S.screen === 'mixed' ? ' is-on' : '') + '" data-view="mixed">' + ICON.grid + 'Mixed practice</button></div>' +
          '<div class="sl-spacer"></div>' + searchTopHTML() + zoomHTML() + '<div class="sl-vbar hide-sm"></div>' + full + themeBtn();
      } else if (S.screen === 'papers') {
        h = back('slBackLib', 'Back to skills') + '<h1 class="sl-wordmark hide-sm">Maths Skills <span>Lab</span></h1><span class="sl-title show-sm"><b>Past papers</b></span><div class="sl-spacer"></div>' + full + themeBtn();
      } else if (S.screen === 'skill') {
        h = back('slBackLib', 'Back to skills') + '<h1 class="sl-wordmark hide-sm">Maths Skills <span>Lab</span></h1><div class="sl-spacer"></div>' +
          '<button type="button" class="sl-btn sl-btn--sm" id="slChange"' + TIP('Change skill', 'Back to the library to pick a different one.') + '>' + ICON.book + 'Change skill</button>' + full + themeBtn();
      } else if (S.screen === 'boardsetup') {
        h = back('slBackSkill', 'Back to the skill') + titleHTML() + '<div class="sl-spacer"></div>' + full + themeBtn();
      } else if (S.screen === 'practise') {
        var marked = S.set.filter(function (it) { return it.state === 'ok' || it.state === 'miss'; }).length;
        var ok = S.set.filter(function (it) { return it.state === 'ok'; }).length;
        var done = S.set.filter(function (it) { return it.state !== 'hid'; }).length;
        /* ONE BAR (Aadam, 2026-09-16): the level chips and Type the answer used to sit in a strip of
           their own under this bar, saying what the title already says. They live here now, Print and
           Change skill are icons, and Hide answers is an icon beside Show all answers. */
        h = back('slBackSkill', S.prOne >= 0 ? 'Back to all cards' : 'Back') + titleHTML() +
          '<div class="sl-prchips">' + activeSkills().map(function (sk) { return topicHTML(sk, 0); }).join('') + '</div>' +
          '<button type="button" class="sl-toggle' + (S.typed ? ' is-on' : '') + '" id="slTyped" aria-pressed="' + (S.typed ? 'true' : 'false') + '"' + TIP('Type the answer', 'Type it in instead of turning the card over.') + '><i></i>Type the answer</button>' +
          '<div class="sl-spacer"></div>' +
          '<span class="sl-mini' + (FX.count ? ' is-pop' : '') + '"' + TIP('Your marking', 'How many you have marked right, out of the ones you have marked.') + '><span class="num lg">' + ok + ' correct · ' + marked + ' marked</span><span class="num sm" aria-hidden="true">' + ICON.tick + ok + '/' + marked + '</span></span>' +
          '<span class="sl-mini hide-sm"' + TIP('How far through', 'How many of the ' + S.set.length + ' you have looked at.') + '><span class="num">' + done + ' of ' + S.set.length + ' done</span></span>' +
          (anyHidden() ? '<button type="button" class="sl-btn sl-btn--sm" id="slRevealAll"' + TIP('Show all answers', 'Turns every card over at once. Marking you have already done stays.') + '>' + ICON.eye + 'Show all answers</button>' : '') +
          (anyShown() ? '<button type="button" class="sl-iconbtn" id="slHideAll" aria-label="Hide answers"' + TIP('Hide answers', 'Puts every answer back. Your ticks stay.') + '>' + ICON.eyeOff + '</button>' : '') +
          '<button type="button" class="sl-iconbtn hide-sm" id="slPrintSet" aria-label="Print"' + TIP('Print', 'An A4 sheet of these questions with room to work.') + '>' + ICON.print + '</button>' +
          '<button type="button" class="sl-btn sl-btn--sm" id="slNewSet"' + TIP('New ' + S.setN, S.setN + ' fresh questions at the same levels. Your marking is cleared. Key: N') + '>' + ICON.refresh + 'New ' + S.setN + '</button>' +
          '<button type="button" class="sl-iconbtn hide-sm" id="slChange" aria-label="' + (S.from === 'mixed' ? 'Change mix' : 'Change skill') + '"' + TIP(S.from === 'mixed' ? 'Change mix' : 'Change skill', 'Back to the library to pick again.') + '>' + ICON.book + '</button>' + full + themeBtn();
      } else if (S.screen === 'teach') {
        h = back('slBackSkill', 'Back') + titleHTML() + '<div class="sl-spacer"></div>' +
          (chorusOK() ? '<button type="button" class="sl-toggle' + (S.teach.chorus ? ' is-on' : '') + '" id="slChorusBtn" aria-pressed="' + (S.teach.chorus ? 'true' : 'false') + '"' + TIP(esc(curSkill().chorusName || 'Count together'), '') + '><i></i>' + esc(curSkill().chorusName || 'Count together') + '</button><div class="sl-vbar"></div>' : '') +
          '<div class="sl-segwrap hide-sm"><button type="button" class="sl-seg is-on">' + ICON.steps + 'Teach</button><button type="button" class="sl-seg" id="slTeachPractise"' + TIP('Practise', 'The same questions as a set to work through and mark.') + '>' + ICON.list + 'Practise</button></div>' +
          '<button type="button" class="sl-btn sl-btn--sm hide-sm" id="slChange"' + TIP('Change skill', 'Back to the library to pick a different one.') + '>' + ICON.book + 'Change skill</button>' + full + themeBtn();
      } else if (S.screen === 'speedsetup') {
        h = back('slBackSkill', 'Back to the skill') + titleHTML() + '<div class="sl-spacer"></div>' + full + themeBtn();
      } else if (S.screen === 'speed') {
        var running = SP.phase !== 'done';
        h = back('slSpQuit', running ? 'End the run' : 'Back') + titleHTML() + '<div class="sl-spacer"></div>' +
          (running ? spRunTopHTML() +
            '<button type="button" class="sl-iconbtn hide-sm" id="slFull" aria-label="Full screen" data-tip="Full screen" data-tipsub="Key: F">' + ICON.expand + '</button>'
            : full) + themeBtn();
      } else if (S.screen === 'turn') {
        var uOK = S.turn.log.filter(function (x) { return x.ok; }).length;
        h = back('slBackSkill', 'Back') + titleHTML() + '<div class="sl-spacer"></div>' +
          /* the pips in the rail already say what happened to each question, so
             the phone drops the chip rather than wrapping the bar to two rows */
          (S.turn.phase === 'play' ? '<span class="sl-mini hide-sm' + (FX.count ? ' is-pop' : '') + '"' + TIP('Right first time', 'Questions where every decision was right on the first try.') + '><span class="num">' + uOK + ' right first time</span></span>' +
            '<span class="sl-mini hide-sm"' + TIP('How far through', 'Which question you are on.') + '><span class="num">' + Math.min(S.turn.i + 1, S.set.length) + ' of ' + S.set.length + '</span></span>' : '') +
          '<button type="button" class="sl-btn sl-btn--sm sl-ulabel" id="slUAgain"' + TIP('Start again', 'Ten fresh questions at the same levels. Key: N') + '>' + ICON.refresh + '<span>Start again</span></button>' +
          '<button type="button" class="sl-btn sl-btn--sm hide-sm" id="slChange"' + TIP('Change skill', 'Back to the library to pick a different one.') + '>' + ICON.book + 'Change skill</button>' + full + themeBtn();
      } else if (S.screen === 'board') {
        /* Show answers moved to the right-hand end, as a button that says what it will do
           (Aadam, 2026-09-15: "move the show answers button to more clear place on the right") */
        h = back('slBackSetup', 'Back to board setup') + titleHTML() + '<div class="sl-spacer"></div>' +
          '<span id="slTimerWrap"></span><div class="sl-vbar"></div>' +
          '<button type="button" class="sl-btn sl-btn--sm" id="slBoardNew"' + TIP('New set', 'Key: N') + '>' + ICON.refresh + 'New set</button>' +
          '<button type="button" class="sl-btn sl-btn--sm hide-sm" id="slBoardPrintQ"' + TIP('Print questions', '') + '>' + ICON.print + 'Print questions</button>' +
          '<button type="button" class="sl-btn sl-btn--sm hide-sm" id="slBoardPrintA"' + TIP('Print with answers', '') + '>' + ICON.print + 'With answers</button>' +
          '<div class="sl-vbar"></div>' +
          '<button type="button" class="sl-btn sl-btn--sm sl-bansbtn' + (S.board.ans ? ' is-on' : '') + '" id="slBoardAns" aria-pressed="' + (S.board.ans ? 'true' : 'false') + '"' + TIP(S.board.ans ? 'Hide answers' : 'Show answers', 'Key: Space') + '>' + (S.board.ans ? ICON.eyeOff + 'Hide answers' : ICON.eye + 'Show answers') + '</button>' +
          full + themeBtn();
      }
      elTop.classList.toggle('is-enter', entering);
      elTop.classList.toggle('is-run', S.screen === 'speed' && SP.phase !== 'done');
      elTop.classList.toggle('is-pr', S.screen === 'practise');
      elTop.classList.toggle('is-lib', S.screen === 'library' || S.screen === 'mixed');
      paint(elTop, h); FX.count = false;
      if (S.screen === 'board') paintTimer();
      applyTheme();
      fitTop();
    }
    /* one row or not: offsetTop ignores the slide-in transform, so an entering bar does not read as wrapped */
    function topWraps() {
      var tops = [], kids = elTop.children, i, k;
      for (i = 0; i < kids.length; i++) { k = kids[i]; if (k.offsetParent !== null && k.offsetWidth) tops.push(k.offsetTop + k.offsetHeight / 2); }
      return tops.length > 1 && Math.max.apply(null, tops) - Math.min.apply(null, tops) > 20;
    }
    function fitTop() {
      if (!elTop) return;
      elTop.classList.remove('is-tight');
      if (window.innerWidth <= 860) return;
      if (topWraps()) elTop.classList.add('is-tight');
    }
    var fitTopT = null;
    window.addEventListener('resize', function () { clearTimeout(fitTopT); fitTopT = setTimeout(fitTop, 120); });
    try { document.fonts.ready.then(function () { fitTop(); }); document.fonts.addEventListener('loadingdone', function () { fitTop(); }); } catch (err) {}
    function toggleFull() { try { if (document.fullscreenElement) document.exitFullscreen(); else shell.requestFullscreen(); } catch (err) {} }
    elTop.addEventListener('keydown', function (e) {
      if (!e.target || e.target.id !== 'slTimerIn') return;
      if (e.key === 'Enter') { e.preventDefault(); commitTimer(e.target.value); }
      if (e.key === 'Escape') { e.preventDefault(); TM.editing = false; paintTimer(); }
    });
    elTop.addEventListener('focusout', function (e) {
      if (e.target && e.target.id === 'slTimerIn') commitTimer(e.target.value);
    });
    elTop.addEventListener('input', function (e) {
      var t = e.target; if (!t) return;
      if (t.id === 'slSearch') { onSearch(e, rerenderLib); return; }
      if (t.getAttribute && t.getAttribute('data-slider') === 'libzoom') setLibZoom(Number(t.value), false);
    });
    elTop.addEventListener('change', function (e) {
      var t = e.target; if (t && t.getAttribute && t.getAttribute('data-slider') === 'libzoom') setLibZoom(Number(t.value), true);
    });
    elTop.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('button') : null;
      if (!t) return;
      if (t.hasAttribute('data-clearsearch')) { S.search = ''; S.libMore = false; rerenderLib(); syncSearchBox(); var si = $('slSearch'); if (si) si.focus(); return; }
      if (t.hasAttribute('data-libzoom')) { setLibZoom(libZoomAt() + Number(t.getAttribute('data-libzoom')), true); return; }
      if (t.hasAttribute('data-sl-theme')) { toggleTheme(); return; }
      if (t.id === 'slClose') { closeShell(); return; }
      if (t.getAttribute('data-view')) { show(t.getAttribute('data-view') === 'mixed' ? 'mixed' : 'library'); return; }
      if (t.id === 'slWelSkip') { welDone(false); return; }
      if (t.id === 'slBackLib') { show('library'); return; }
      if (t.id === 'slBackSkill' && S.screen === 'practise' && S.prOne >= 0) { toWall(); return; }
      if (t.id === 'slBackSkill') { show(S.screen === 'teach' ? backFromTeach() : backTarget()); return; }
      if (t.id === 'slBackSetup') { show(S.from === 'mixed' ? 'mixed' : 'boardsetup'); return; }
      /* Back out of a run that has answers in it goes to the RESULTS, not to
         nothing: the seconds are the point, and throwing them away silently
         because someone reached for the arrow is a bad trade. */
      if (t.id === 'slSpQuit') { if (SP.phase === 'play' && SP.log.length) spFinish(true); else { spReset(); show('speedsetup'); } return; }
      if (t.id === 'slSpSnd') { toggleSound(); renderTop(); return; }
      if (t.id === 'slSpPause') { spPause(true); return; }
      if (t.id === 'slChange') { if (S.from === 'mixed') show('mixed'); else changeSkill(); return; }
      var prTopic = t.closest ? t.closest('.sl-prchips .sl-topic') : null;
      if (prTopic && t.getAttribute('data-togglelvl')) {
        var psk = SL.get(prTopic.getAttribute('data-topic'));
        if (partlyMarked() && !window.confirm('Change the levels and deal fresh questions? The marks on this set will go.')) return;
        toggleSel(psk, Number(t.getAttribute('data-togglelvl')));
        redealSkill(psk); renderPractise(); renderTop(); return;
      }
      if (t.id === 'slTyped') { S.typed = !S.typed; save(); renderPractise(); renderTop(); return; }
      if (t.id === 'slRevealAll') { revealAll(); return; }
      if (t.id === 'slPrintSet') { printSet(); return; }
      if (t.id === 'slHideAll') { hideAll(); return; }
      if (t.id === 'slNewSet') { if (partlyMarked() && !window.confirm('Start a fresh ' + S.setN + '? The marks on this set will go.')) return; buildSet(); renderPractise(); renderTop(); return; }
      if (t.id === 'slTeachPractise') { S.teach.back = 'practise'; show('practise'); return; }
      if (t.id === 'slUAgain') { startTurn(); renderTurn(); renderTop(); return; }
      if (t.id === 'slCopyLink') { copyLink(); return; }
      if (t.id === 'slFull') { toggleFull(); return; }
      if (t.id === 'slKeysBtn') { toggleKeys(true); return; }
      if (t.id === 'slTimerFace') { TM.editing = true; paintTimer(); return; }
      if (t.id === 'slTimerGo') { toggleTimer(); return; }
      if (t.id === 'slTimerRe') { resetTimer(); return; }
      if (t.id === 'slChorusBtn') { S.teach.chorus = !S.teach.chorus; save(); renderTeach(); renderTop(); return; }
      if (t.id === 'slBoardAns') { setAllAns(!S.board.ans); paintAns(); renderTop(); return; }
      if (t.id === 'slBoardNew') { buildBoard(); renderBoard(); renderTop(); return; }
      if (t.id === 'slBoardPrintQ') { printBoard(false); return; }
      if (t.id === 'slBoardPrintA') { printBoard(true); return; }
    });
    /* the practise set as a worksheet: questions only, with room to write */
    function printSet() {
      var skP = curSkill();
      track('practise_print', { skill: S.from === 'mixed' ? 'mixed' : (skP ? skP.id : ''), question_count: S.set.length });
      document.documentElement.classList.add('sl-printing');
      elPr.classList.add('is-printing');
      setTimeout(function () {
        window.print();
        document.documentElement.classList.remove('sl-printing');
        elPr.classList.remove('is-printing');
      }, 80);
    }
    function printBoard(withAnswers) {
      var sk0 = curSkill();
      track('board_print', { with_answers: withAnswers ? 'yes' : 'no', skill: S.from === 'mixed' ? 'mixed' : (sk0 ? sk0.id : ''), question_count: S.board.n });
      var was = S.board.ans; setAllAns(withAnswers);
      document.documentElement.classList.add('sl-printing');
      renderBoard();
      setTimeout(function () {
        window.print();
        document.documentElement.classList.remove('sl-printing');
        setAllAns(was); renderBoard(); renderTop();
      }, 80);
    }

    /* ============================================================
       WELCOME
       The first open only. Three questions (who, what for, what first),
       then a starting point, then three cards about the activities those
       answers point at. Skippable at every step from the bar, from Escape
       and from the last question; re-openable from the rail foot. A deep
       link never meets it: a shared link opens what it names.
       ============================================================ */
    var elWel = $('slWelcome');
    /* The walkthrough, redesigned 2026-09-15 from the onboarding canvas: big
       tiles that move on by themselves, one short line a screen, and a working
       demo on every activity card. Three questions -> three cards for the role
       (the first names the first skill) -> the waitlist. */
    var WL_SVG = {
      family: svg('<circle cx="8.5" cy="7" r="3"/><path d="M3.5 20v-1.5a5 5 0 0 1 10 0V20"/><circle cx="17" cy="10.5" r="2.2"/><path d="M14.5 20v-1a3 3 0 0 1 6 0v1"/>'),
      pencil: svg('<path d="M4 20l1.2-4.6L15.8 4.8a2 2 0 0 1 2.8 0l.6.6a2 2 0 0 1 0 2.8L8.6 18.8z"/><path d="M13.5 7l3.5 3.5"/>'),
      checks: svg('<path d="M9.5 6H20M9.5 12H20M9.5 18H20"/><path d="M3.5 6l1.5 1.5L7 4.8M3.5 12l1.5 1.5L7 10.8"/><path d="M4.5 18h.01"/>'),
      mail: svg('<rect x="3" y="5" width="18" height="14" rx="2.5"/><path d="M4 7l8 6 8-6"/>'),
      arrowL: svg('<path d="M20 12H5M11 6l-6 6 6 6"/>'),
      arrowD: svg('<path d="M12 4v15M6 13l6 6 6-6"/>')
    };
    var WEL_OPTS = {
      who: [
        { id: 'parent', icon: WL_SVG.family, name: 'Parent or carer', hue: 'gold' },
        { id: 'tutor', icon: ICON.board, name: 'Tutor or teacher', hue: '' },
        { id: 'pupil', icon: WL_SVG.pencil, name: 'Student', hue: 'green' }
      ],
      goal: [
        { id: '11plus', big: '11+', sub: 'Entrance exam', hue: 'gold', stage: 'primary' },
        { id: 'sats', big: 'SATs', sub: 'Year 6', hue: 'purple', stage: 'primary' },
        { id: 'gcse', big: 'GCSE', sub: 'Years 10 and 11', hue: '', stage: 'secondary' },
        { id: 'general', icon: ICON.book, name: 'Practice', sub: 'No exam', hue: '', stage: 'primary' }
      ],
      /* what they can pick first is the role's own three cards, so the tour
         always keeps all three of them */
      first: [
        { id: 'teach', icon: ICON.steps, name: 'Show me how', hue: '' },
        { id: 'practise', icon: WL_SVG.checks, name: 'Try questions', hue: 'green' },
        { id: 'levels', icon: ICON.trophy, name: 'See progress', hue: 'gold' },
        { id: 'board', icon: ICON.board, name: 'Teach a group', hue: 'purple' },
        { id: 'mixed', icon: ICON.grid, name: 'Mix skills', hue: 'green' },
        { id: 'speed', icon: ICON.clock, name: 'Beat the clock', hue: 'gold' }
      ]
    };
    var WEL_Q = [
      { key: 'who', title: 'Who\'s using it?' },
      { key: 'goal', title: 'Choose a goal' },
      { key: 'first', title: 'Pick one to try' }
    ];
    var TOUR = {
      teach: { icon: ICON.steps, name: 'Show me how', hue: '' },
      practise: { icon: WL_SVG.checks, name: 'Try questions', hue: 'green', line: 'See the answer, then mark yourself' },
      speed: { icon: ICON.clock, name: 'Beat the clock', hue: 'gold', line: 'Beat your time on 4 questions' },
      board: { icon: ICON.board, name: 'Teach a group', hue: 'purple', line: 'Questions for a group, answers on tap' },
      mixed: { icon: ICON.grid, name: 'Mix skills', hue: '', line: 'Keep 2 or more skills ticked' },
      levels: { icon: ICON.trophy, name: 'See progress', hue: 'gold', line: 'Get 8 right to secure a level' }
    };
    var TOUR_FOR = { parent: ['teach', 'practise', 'levels'], tutor: ['board', 'teach', 'mixed'], pupil: ['practise', 'speed', 'teach'] };
    var WL_M = '−';
    /* the demos are written by hand, checked, and chosen by stage: they show
       how an activity works, so they never wait on an engine to load */
    var WSETS = {
      count: {
        teach: { expr: '5 + 5 + 5 + 5', ans: '20', lo: 0, hi: 20, every: 5, line: 'Start at 5, then add 5', hopLabel: '+5', steps: [
          { cap: 'Start at 5', btn: 'Start at 5', pill: '5', at: 5, hops: [] },
          { cap: '5 + 5 = 10', btn: 'Add 5', pill: '10', at: 10, hops: [[5, 10]] },
          { cap: '10 + 5 = 15', btn: 'Add 5', pill: '15', at: 15, hops: [[5, 10], [10, 15]] },
          { cap: '15 + 5 = 20', btn: 'Add 5', pill: '20', at: 20, hops: [[5, 10], [10, 15], [15, 20]], done: true }
        ] },
        practise: [['5 + 5 + 5', '15'], ['3 + 3 + 3 + 3', '12'], ['40 ' + WL_M + ' 10 ' + WL_M + ' 10', '20']],
        speed: [
          { q: '2 + 2 + 2', a: '6', ch: ['4', '6', '8'] },
          { q: '10 + 10 + 10 + 10', a: '40', ch: ['30', '40', '50'] },
          { q: '4 + 4 + 4', a: '12', ch: ['12', '16', '8'] },
          { q: '25 ' + WL_M + ' 5 ' + WL_M + ' 5', a: '15', ch: ['20', '15', '10'] }
        ],
        board: [
          ['Level 1', [['2 + 2 + 2 + 2', '8'], ['10 + 10 + 10', '30'], ['5 + 5 + 5', '15']]],
          ['Level 2', [['3 + 3 + 3', '9'], ['4 + 4 + 4 + 4', '16'], ['3 + 3 + 3 + 3', '12']]],
          ['Level 3', [['7 + 7 + 7', '21'], ['6 + 6 + 6 + 6', '24'], ['9 + 9 + 9', '27']]]
        ],
        mixed: [
          { id: 'counting-in-steps', name: 'Counting', qs: [['5 + 5 + 5', '15'], ['4 + 4 + 4', '12']] },
          { id: 'place-value', name: 'Place value', qs: [['Value of the 4 in 47', '40'], ['Value of the 3 in 356', '300']] },
          { id: 'more-or-less', name: 'More or less', qs: [['10 more than 356', '366'], ['100 less than 725', '625']] }
        ],
        levelNames: ['Up in 2s, 5s and 10s', 'Up in 3s and 4s', 'Up in 6s, 7s, 8s and 9s', 'Down in 2s, 5s and 10s', 'Missing starting number']
      },
      neg: {
        teach: { expr: '1 ' + WL_M + ' 6', ans: WL_M + '5', lo: -7, hi: 3, every: 1, line: 'Start at 1, then subtract 6', hopLabel: '', steps: [
          { cap: 'Subtract, so move left', btn: 'Start at 1', pill: '1', at: 1, hops: [], arrow: true },
          { cap: '6 jumps left lands on ' + WL_M + '5', btn: 'Jump 6', pill: WL_M + '5', at: -5, hops: [[1, 0], [0, -1], [-1, -2], [-2, -3], [-3, -4], [-4, -5]], done: true, stagger: true }
        ] },
        practise: [['2 ' + WL_M + ' 7', WL_M + '5'], [WL_M + '3 + 8', '5'], [WL_M + '4 ' + WL_M + ' 5', WL_M + '9']],
        speed: [
          { q: '3 ' + WL_M + ' 5', a: WL_M + '2', ch: ['2', WL_M + '2', WL_M + '8'] },
          { q: WL_M + '1 ' + WL_M + ' 4', a: WL_M + '5', ch: [WL_M + '3', WL_M + '5', '5'] },
          { q: WL_M + '6 + 2', a: WL_M + '4', ch: [WL_M + '4', WL_M + '8', '4'] },
          { q: '0 ' + WL_M + ' 7', a: WL_M + '7', ch: ['7', WL_M + '6', WL_M + '7'] }
        ],
        board: [
          ['Level 1', [['8 ' + WL_M + ' 15', WL_M + '7'], ['3 ' + WL_M + ' 9', WL_M + '6'], ['6 ' + WL_M + ' 10', WL_M + '4']]],
          ['Level 2', [[WL_M + '5 ' + WL_M + ' 9', WL_M + '14'], [WL_M + '16 + 4', WL_M + '12'], [WL_M + '3 + 11', '8']]],
          ['Level 3', [['5 + (' + WL_M + '12)', WL_M + '7'], [WL_M + '9 + (' + WL_M + '7)', WL_M + '16'], ['4 + (' + WL_M + '3)', '1']]]
        ],
        mixed: [
          { id: 'negative-numbers', name: 'Negatives', qs: [[WL_M + '4 ' + WL_M + ' 5', WL_M + '9'], ['2 ' + WL_M + ' 8', WL_M + '6']] },
          { id: 'place-value', name: 'Place value', qs: [['Value of the 3 in 3,074', '3,000'], ['Value of the 7 in 2.47', '0.07']] },
          { id: 'multiply-divide-by-10-100-1000', name: '× and ÷ by 10', qs: [['3.2 × 10', '32'], ['450 ÷ 10', '45']] }
        ],
        levelNames: ['Subtract past zero', 'Start on a negative number', 'Add a negative number', 'Subtract a negative number', 'Add and subtract, all kinds']
      }
    };
    function welWho() { return S.intro.who || 'parent'; }
    function welOpt(key, id) { return WEL_OPTS[key].filter(function (o) { return o.id === (id || S.intro[key]); })[0] || null; }
    /* the goal picks the stage (Practice, with no exam, counts as primary) */
    function welStage() { var g = welOpt('goal'); return (g && g.stage) || S.stage; }
    /* what they get dropped into at the end: the first ready skill of that
       stage in learning order, or anything ready if the stage has nothing yet */
    function welRec() {
      var list = readySkills(null, welStage());
      /* most of the library is primary number, and "both" skills sort first, so
         a GCSE answer landed on place value. Prefer a skill that is secondary
         and nothing else, and only fall back to the head of the list. */
      if (welStage() === 'secondary') {
        var only = list.filter(function (sk) { return (sk.stage || 'secondary') === 'secondary'; });
        if (only.length) list = only;
      }
      if (!list.length) list = readySkills(null, S.stage);
      if (!list.length) list = SL.skills().filter(function (sk) { return !sk.stub; });
      /* readySkills is memoised and a stub is replaced IN PLACE when its engine
         registers, so the list holds the stale object: read the skill back from
         the registry */
      return (list[0] && SL.get(list[0].id)) || null;
    }
    function welSet() { return WSETS[welStage() === 'secondary' ? 'neg' : 'count']; }
    /* the level ladder shows the recommended skill's own first five levels */
    function welLevelNames() {
      var sk = welRec();
      return (sk && sk.levels && sk.levels.length >= 5) ? sk.levels.slice(0, 5).map(function (L) { return L.name; }) : welSet().levelNames;
    }
    /* three cards: what they said they wanted first, then the rest of the set
       for whoever they said they are */
    function tourKeys() {
      var set = TOUR_FOR[welWho()] || TOUR_FOR.parent, want = S.intro.first;
      var out = (want && set.indexOf(want) >= 0) ? [want] : [];
      set.forEach(function (k) { if (out.indexOf(k) < 0) out.push(k); });
      return out.slice(0, 3);
    }
    /* the questions, the three cards (the first one names the first skill), and the waitlist last */
    function welSteps() { return 4 + tourKeys().length; }
    function welStep() { return Math.max(0, Math.min(welSteps() - 1, S.intro.step || 0)); }

    /* demo state lives for the page, not in storage: it is a toy, not progress */
    var WD = null, welPT = null, welST = null, welLT = null, welIV = null, welLast = -1, welLoading = false;
    function wdFresh() {
      return { fx: {}, tStep: 0, markAt: null, pr: [0, 0, 0], sp: 'ready', spI: 0, spT0: 0, spEnd: 0, spFinal: 0, spMiss: [false, false, false, false],
        spBest: 0, spIsBest: false, spPick: '', spOk: '', spLock: false, bdAll: false, bdOpen: [], bdLevel: 0, mx: [true, true, false], lv: 2, lvFill: false, lvTouched: false };
    }
    function wd() { if (!WD) WD = wdFresh(); return WD; }
    /* every timer the walkthrough owns, stopped whenever the screen moves on */
    function welClear() {
      clearTimeout(welPT); clearTimeout(welST); clearTimeout(welLT);
      if (welIV) { clearInterval(welIV); welIV = null; }
      if (WD) { if (WD.sp === 'run') WD.sp = 'ready'; WD.spLock = false; WD.spOk = ''; WD.spPick = ''; WD.lvFill = false; }
    }
    function wlFmt(v) { return v < 0 ? WL_M + Math.abs(v) : String(v); }
    function welClockText() {
      var d = wd(), el = d.sp === 'run' ? (d.spFinal || Date.now() - d.spT0) : d.sp === 'end' ? d.spEnd : 0;
      return (el / 1000).toFixed(1);
    }

    function welTileHTML(key, o) {
      var on = S.intro[key] === o.id;
      return '<button type="button" class="wl-tile' + (o.hue ? ' hue-' + o.hue : '') + (on ? ' is-on' : '') + '" data-welpick="' + key + ':' + o.id + '" aria-pressed="' + (on ? 'true' : 'false') + '">' +
        (o.big ? '<span class="wl-big">' + esc(o.big) + '</span>' : '<span class="wl-ico">' + o.icon + '</span>') +
        '<span class="wl-t">' + (o.name ? '<span class="wl-name">' + esc(o.name) + '</span>' : '') + (o.sub ? '<span class="wl-sub">' + esc(o.sub) + '</span>' : '') + '</span>' +
        '<span class="wl-go" aria-hidden="true"><span class="go-a">' + ICON.chevR + '</span><span class="go-t">' + ICON.tick + '</span></span></button>';
    }
    function welQuestionHTML(i) {
      var Q = WEL_Q[i], opts = WEL_OPTS[Q.key];
      if (Q.key === 'first') opts = (TOUR_FOR[welWho()] || TOUR_FOR.parent).map(function (id) { return welOpt('first', id); });
      return '<h2 class="wl-h">' + esc(Q.title) + '</h2>' +
        '<div class="wl-tiles wl-tiles--' + opts.length + '">' + opts.map(function (o) { return welTileHTML(Q.key, o); }).join('') + '</div>';
    }
    /* the first card names the skill that Start will open, above its demo */
    function welSkillHTML() {
      var sk = welRec(); if (!sk) return '';
      var col = colourOf(sk);
      return '<div class="wl-skill"><span class="wl-skill-ico" style="color:' + col.col + ';background:' + col.tint + '">' + skIcon(sk) + '</span>' +
        '<span class="wl-skill-t">Your first skill: <b>' + esc(sk.name) + '</b></span><span class="wl-skill-n">' + sk.levels.length + ' levels</span></div>';
    }
    function welCardHTML(k, first) {
      var T = TOUR[k], line = k === 'teach' ? welSet().teach.line : T.line;
      return (first ? welSkillHTML() : '') + '<div class="wl-head' + (T.hue ? ' hue-' + T.hue : '') + '"><span class="wl-badge">' + T.icon + '</span><h2 class="wl-h">' + esc(T.name) + '</h2></div>' +
        '<p class="wl-line">' + esc(line) + '</p>' +
        '<div class="wl-demo' + (k === 'levels' ? ' wl-demo--narrow' : '') + '" id="slWelDemo" data-kind="' + k + '">' + welDemoHTML(k) + '</div>';
    }

    /* ---------- the demos: each one is a few taps, and it is the explanation ---------- */
    function welDemoHTML(k) {
      var D = welSet(), d = wd();
      if (k === 'teach') {
        var T = D.teach, tk = Math.min(d.tStep, T.steps.length), st = tk > 0 ? T.steps[tk - 1] : null, prevN = tk > 1 ? T.steps[tk - 2].hops.length : 0;
        var X = function (v) { return 4 + ((v - T.lo) / (T.hi - T.lo)) * 92; };
        var ticks = '', v;
        for (v = T.lo; v <= T.hi; v++) {
          var lab = v % T.every === 0 ? wlFmt(v) : '';
          ticks += '<div class="wl-tick' + (v === 0 ? ' is-zero' : '') + (lab ? ' is-maj' : '') + (st && st.at === v ? ' is-at' : '') + (tk === 0 && v === T.steps[0].at ? ' is-start' : '') + '" style="left:' + X(v) + '%"><span>' + lab + '</span></div>';
        }
        var hops = st ? st.hops.map(function (h, i) {
          var a = Math.min(h[0], h[1]), b = Math.max(h[0], h[1]), isNew = i >= prevN;
          return '<div class="wl-hop' + (isNew ? ' is-new' : '') + '" style="left:' + X(a) + '%;width:' + (X(b) - X(a)) + '%;animation-delay:' + (isNew && st.stagger ? (i - prevN) * 130 : 0) + 'ms"><b>' + T.hopLabel + '</b></div>';
        }).join('') : '';
        var pills = T.steps.map(function (s, i) { return '<span class="wl-pill' + ((st && st.done) || i < tk - 1 ? ' is-done' : i === tk - 1 ? ' is-now' : '') + '">' + s.pill + '</span>'; }).join('');
        var marker = '';
        if (st) {
          var to = X(st.at), from = d.markAt === null ? to : d.markAt;
          marker = '<div class="wl-marker" style="left:' + from + '%;transition-delay:' + (st.stagger ? (st.hops.length - prevN) * 130 : 0) + 'ms" data-to="' + to + '%">' +
            '<span class="wl-dot' + (d.markAt === null ? ' is-new' : '') + '"></span>' + (st.arrow ? '<span class="wl-arrow">' + WL_SVG.arrowL + '</span>' : '') + '</div>';
          d.markAt = to;
        } else d.markAt = null;
        var btn = !st ? T.steps[0].btn : st.done ? 'Start again' : T.steps[tk].btn;
        return '<div class="wl-nl-top"><div class="wl-expr">' + T.expr + (st && st.done ? '<span class="wl-ans">&nbsp;= ' + T.ans + '</span>' : '') + '</div><div class="wl-pills">' + pills + '</div></div>' +
          '<div class="wl-nl"><div class="wl-axis"></div>' + ticks + hops + marker + '</div>' +
          '<div class="wl-nl-foot"><div class="wl-cap" aria-live="polite">' + (st ? st.cap : '') + '</div>' +
          '<button type="button" class="sl-btn wl-dbtn wl-dbtn--now' + (tk === 0 ? ' is-hint' : '') + '" data-wd="step">' + btn + '</button></div>';
      }
      if (k === 'practise') {
        var rights = 7, marked = 0, openPr = d.pr.indexOf(1), nextPr = openPr >= 0 ? openPr : d.pr.indexOf(0), pips = '', j;
        d.pr.forEach(function (x) { if (x >= 2) marked++; if (x === 2) rights++; });
        var toGo = 3 - marked;
        for (j = 0; j < 10; j++) {
          var pv = j < 7 ? 2 : d.pr[j - 7];
          pips += '<i class="wl-pip' + (pv === 2 ? ' is-ok' : pv === 3 ? ' is-bad' : '') + (j >= 7 && d.fx.prPop === j - 7 ? ' is-pop' : '') + '"></i>';
        }
        var cards = D.practise.map(function (q, i) {
          var s = d.pr[i], body;
          if (s === 0) body = '<button type="button" class="wl-check" data-wd="pr-open" data-i="' + i + '">Show answer</button>';
          else if (s === 1) body = '<div class="wl-a' + (d.fx.open === i ? ' is-new' : '') + '">' + q[1] + '</div><div class="wl-marks' + (d.fx.open === i ? ' is-new' : '') + '">' +
            '<button type="button" class="wl-mark wl-mark--ok" data-wd="pr-ok" data-i="' + i + '" aria-label="I got it right">' + ICON.tick + '</button>' +
            '<button type="button" class="wl-mark wl-mark--bad" data-wd="pr-bad" data-i="' + i + '" aria-label="I got it wrong">' + ICON.cross + '</button></div>';
          else body = '<div class="wl-a">' + q[1] + '</div><button type="button" class="wl-res ' + (s === 2 ? 'wl-res--ok' : 'wl-res--bad') + (d.fx.prPop === i ? ' is-new' : '') + '" data-wd="pr-open" data-i="' + i + '" aria-label="Change mark">' + (s === 2 ? ICON.tick : ICON.cross) + '</button>';
          return '<div class="wl-card' + ['', '', ' is-right', ' is-wrong'][s] + (i === nextPr ? ' is-next' : '') + '"><div class="wl-q">' + q[0] + '</div>' + body + '</div>';
        }).join('');
        return '<div class="wl-cards">' + cards + '</div>' +
          '<div class="wl-pr-foot"><div class="wl-pips">' + pips + '</div><div class="wl-score">' + (toGo > 0 ? rights + ' right, ' + toGo + ' to mark' : rights + ' of 10 right') + '</div>' +
          (rights >= 8 ? '<span class="wl-gold' + (d.fx.prPop !== undefined ? ' is-new' : '') + '">' + ICON.trophy + 'Secure</span>' : '') +
          (toGo === 0 ? '<button type="button" class="sl-btn sl-btn--ghost wl-dbtn" data-wd="pr-reset">Try again</button>' : '') + '</div>';
      }
      if (k === 'speed') {
        var SQ = D.speed, sq = SQ[Math.min(d.spI, SQ.length - 1)];
        var spp = SQ.map(function (q, i) {
          return '<i class="wl-sppip' + (d.sp === 'ready' ? '' : (d.sp === 'end' || i < d.spI) ? (d.spMiss[i] ? ' is-bad' : ' is-ok') : i === d.spI ? (d.spOk ? (d.spMiss[i] ? ' is-bad' : ' is-ok') : (d.spMiss[i] ? ' is-bad' : ' is-now')) : '') + '"></i>';
        }).join('');
        var mid;
        if (d.sp === 'ready') mid = '<button type="button" class="sl-btn wl-dbtn wl-dbtn--now wl-gobtn" data-wd="sp-go">Go</button>' + (d.spBest ? '<span class="wl-chip">Best ' + (d.spBest / 1000).toFixed(1) + ' s</span>' : '');
        else if (d.sp === 'run') mid = '<div class="wl-spq' + (d.fx.shake ? ' wl-shake' : '') + '">' + sq.q + '</div><div class="wl-choices">' +
          sq.ch.map(function (v, i) { return '<button type="button" class="wl-choice' + (d.spOk === v ? ' is-ok' : d.spPick === v ? ' is-miss' : '') + '" data-wd="sp-pick" data-i="' + i + '">' + v + '</button>'; }).join('') + '</div>';
        else mid = '<div class="wl-bigtime">' + (d.spEnd / 1000).toFixed(1) + ' s</div>' +
          (d.spIsBest ? '<span class="wl-gold is-new">' + ICON.star + 'New best</span>'
            : d.spMiss.indexOf(true) >= 0 ? '<span class="wl-chip">' + d.spMiss.filter(function (x) { return !x; }).length + ' of ' + SQ.length + ' right first time</span>'
            : '<span class="wl-chip">Best ' + (d.spBest / 1000).toFixed(1) + ' s</span>') +
          '<button type="button" class="sl-btn wl-dbtn wl-dbtn--now" data-wd="sp-go">Try again</button>';
        return '<div class="wl-sp-top"><div class="wl-clock">' + ICON.clock + '<b><span id="slWelClock">' + welClockText() + '</span><span class="wl-unit"> s</span></b></div>' +
          '<div class="wl-sppips' + (d.sp === 'ready' ? ' is-ready' : '') + '">' + spp + '</div></div><div class="wl-sp-mid">' + mid + '</div>';
      }
      if (k === 'board') {
        var any = d.bdAll || d.bdOpen.length > 0;
        var tabs = '<div class="wl-bd-tabs">' + D.board.map(function (col, ci) {
          return '<button type="button" class="wl-bd-tab' + (ci === d.bdLevel ? ' is-on' : '') + '" data-wd="bd-tab" data-i="' + ci + '">' + col[0] + '</button>';
        }).join('') + '</div>';
        var cols = D.board.map(function (col, ci) {
          return '<div class="wl-bd-col' + (ci === d.bdLevel ? ' is-sel' : '') + '"><div class="wl-bd-h">' + col[0] + '</div>' + col[1].map(function (it, ii) {
            var idx = ci * 3 + ii, open = d.bdAll || d.bdOpen.indexOf(idx) >= 0;
            return '<button type="button" class="wl-bd-q' + (open ? ' is-open' : '') + (!any && ii === 0 && ci === d.bdLevel ? ' is-hint' : '') + ((d.fx.bd === idx || (d.fx.bdAll && open)) ? ' is-new' : '') + '" data-wd="bd-q" data-i="' + idx + '" aria-expanded="' + (open ? 'true' : 'false') + '">' +
              '<span>' + it[0] + '</span><span class="wl-bd-r"><span class="wl-eye">' + ICON.eye + '</span><span class="wl-bd-a">' + it[1] + '</span></span></button>';
          }).join('') + '</div>';
        }).join('');
        return tabs + '<div class="wl-bd-cols">' + cols + '</div><div class="wl-bd-foot"><button type="button" class="sl-btn wl-dbtn' + (d.bdAll ? ' sl-btn--ghost' : ' sl-btn--on') + '" data-wd="bd-all">' + ICON.eye + (d.bdAll ? 'Hide all answers' : 'Show all answers') + '</button></div>';
      }
      if (k === 'mixed') {
        var M = D.mixed, sel = M.filter(function (m, i) { return d.mx[i]; }), rows = '', r;
        var colOf = function (m) { return colourOf(SL.get(m.id) || { colour: 'blue' }); };
        for (r = 0; r < 4; r++) {
          var mm = sel[r % sel.length], mq = mm.qs[Math.floor(r / sel.length) % mm.qs.length], mc = colOf(mm);
          rows += '<div class="wl-mx-row' + (d.fx.mx ? ' is-new' : '') + '" style="border-left-color:' + mc.col + '"><span class="wl-mx-q">' + mq[0] + '</span><span class="wl-mx-tag" style="color:' + mc.col + ';background:' + mc.tint + '">' + esc(mm.name) + '</span></div>';
        }
        return '<div class="wl-mx-chips">' + M.map(function (m, i) {
          return '<button type="button" class="wl-mx-chip' + (d.mx[i] ? ' is-on' : '') + (d.fx.mxBlock === i ? ' wl-shake' : '') + '" style="color:' + colOf(m).col + '" aria-pressed="' + (d.mx[i] ? 'true' : 'false') + '" data-wd="mx" data-i="' + i + '">' +
            '<span class="wl-mx-box">' + ICON.tick + '</span><span class="wl-mx-name">' + esc(m.name) + '</span></button>';
        }).join('') + '</div><div class="wl-mx-flow" aria-hidden="true">' + WL_SVG.arrowD + '</div><div class="wl-mx-rows">' + rows + '</div>';
      }
      if (k === 'levels') {
        var LN = welLevelNames(), lp = '', q2;
        for (q2 = 0; q2 < 8; q2++) lp += '<i class="wl-lvpip' + (q2 < 7 ? ' is-ok' : q2 === 7 ? (d.lvFill ? ' is-ok is-pop' : ' is-next') : '') + '"></i>';
        return '<div class="wl-lv-list">' + LN.map(function (name, i) {
          return '<div class="wl-lv-row' + (i < d.lv ? ' is-done' : i === d.lv ? ' is-now' : ' is-later') + (i === d.fx.lvPop ? ' is-pop' : '') + '"><span class="wl-lv-n">' + (i + 1) + '</span><span class="wl-lv-name">' + esc(name) + '</span>' +
            (i === d.lv ? '<span class="wl-lv-next">Up next</span>' : '') + (i < d.lv ? '<span class="wl-lv-ok">' + ICON.tick + '</span>' : '') + '</div>';
        }).join('') + '</div>' +
          '<div class="wl-lv-foot"><div class="wl-lv-status"><div class="wl-lv-count">' + d.lv + ' of ' + LN.length + ' secure</div>' + (d.lv < LN.length ? '<div class="wl-lvpips">' + lp + '</div>' : '') + '</div>' +
          '<button type="button" class="sl-btn wl-dbtn wl-dbtn--now' + (d.lv === 2 && !d.lvTouched ? ' is-hint' : '') + '" data-wd="lv"' + (d.lvFill ? ' disabled aria-busy="true"' : '') + '>' + (d.lv >= LN.length ? 'Start again' : 'Get the 8th right') + '</button></div>';
      }
      return '';
    }
    /* the marker is drawn where it was and then sent to where it goes, so a
       rebuilt line still shows the jump */
    function welAfterDemo(host) {
      var mk = host && host.querySelector('.wl-marker[data-to]');
      if (mk) { void mk.offsetWidth; mk.style.left = mk.getAttribute('data-to'); }
      if (WD) WD.fx = {};
    }
    function welPaintDemo() {
      var host = $('slWelDemo'); if (!host || !WD) return;
      var ae = document.activeElement, fa = (ae && host.contains(ae)) ? ae.getAttribute('data-wd') : null, fi = fa ? ae.getAttribute('data-i') : null;
      host.innerHTML = welDemoHTML(host.getAttribute('data-kind'));
      welAfterDemo(host);
      if (fa) {
        var hit = host.querySelector('[data-wd="' + fa + '"]' + (fi !== null ? '[data-i="' + fi + '"]' : '')) || (fi !== null ? host.querySelector('[data-i="' + fi + '"]') : null) || host.querySelector('[data-wd]');
        if (hit) { try { hit.focus({ preventScroll: true }); } catch (e) {} }
      }
    }
    function welDemo(t) {
      var act = t.getAttribute('data-wd'), i = +t.getAttribute('data-i'), d = wd(), D = welSet();
      if (act === 'step') { d.tStep = d.tStep >= D.teach.steps.length ? 0 : d.tStep + 1; }
      else if (act === 'pr-open') { d.pr[i] = 1; d.fx.open = i; }
      else if (act === 'pr-ok' || act === 'pr-bad') { d.pr[i] = act === 'pr-ok' ? 2 : 3; d.fx.prPop = i; }
      else if (act === 'pr-reset') { d.pr = [0, 0, 0]; }
      else if (act === 'sp-go') {
        welClear();
        d.sp = 'run'; d.spI = 0; d.spT0 = Date.now(); d.spFinal = 0; d.spMiss = [false, false, false, false]; d.spIsBest = false; d.spPick = ''; d.spOk = ''; d.spLock = false;
        welIV = setInterval(function () { var el = $('slWelClock'); if (el && WD && WD.sp === 'run') el.textContent = welClockText(); else { clearInterval(welIV); welIV = null; } }, 100);
      }
      else if (act === 'sp-pick') {
        if (d.sp !== 'run' || d.spLock) return;
        var SQ = D.speed, q = SQ[d.spI], v = q.ch[i];
        if (v !== q.a) { d.spMiss[d.spI] = true; d.spPick = v; d.fx.shake = true; }
        else {
          var last = d.spI >= SQ.length - 1, el = Date.now() - d.spT0;
          if (last && welIV) { clearInterval(welIV); welIV = null; }
          d.spOk = v; d.spPick = ''; d.spLock = true; d.spFinal = last ? el : 0;
          clearTimeout(welST);
          welST = setTimeout(function () {
            d.spOk = ''; d.spLock = false;
            /* only a round with no misses can set a best time */
            if (last) { var clean = d.spMiss.indexOf(true) < 0; d.spIsBest = clean && (!d.spBest || el < d.spBest); if (d.spIsBest) d.spBest = el; d.spEnd = el; d.sp = 'end'; d.spFinal = 0; }
            else d.spI++;
            welPaintDemo();
          }, 240);
        }
      }
      else if (act === 'bd-q') {
        if (d.bdAll) { d.bdAll = false; d.bdOpen = [0, 1, 2, 3, 4, 5, 6, 7, 8].filter(function (x) { return x !== i; }); }
        else { var at = d.bdOpen.indexOf(i); if (at >= 0) d.bdOpen.splice(at, 1); else { d.bdOpen.push(i); d.fx.bd = i; } }
      }
      else if (act === 'bd-all') { d.bdAll = !d.bdAll; d.bdOpen = []; d.fx.bdAll = d.bdAll; }
      else if (act === 'bd-tab') { d.bdLevel = i; }
      else if (act === 'mx') {
        if (d.mx[i] && d.mx.filter(Boolean).length <= 2) d.fx.mxBlock = i;
        else { d.mx[i] = !d.mx[i]; d.fx.mx = true; }
      }
      else if (act === 'lv') {
        if (d.lvFill) return;
        d.lvTouched = true;
        if (d.lv >= welLevelNames().length) d.lv = 0;
        else {
          d.lvFill = true;
          clearTimeout(welLT);
          welLT = setTimeout(function () { d.fx.lvPop = d.lv; d.lv++; d.lvFill = false; welPaintDemo(); }, 550);
        }
      }
      welPaintDemo();
    }

    /* The waitlist form is the REAL Shopify customer form from the page, moved
       into the card and moved back afterwards. A clone would lose the listener
       the storefront captcha script attached to it, and the post would die on a
       missing token (see the contact-form note in memory). */
    var ntForm = null, ntHome = null;
    function welFormMount() {
      var host = $('slWelForm'); if (!host) return;
      if (!ntForm) {
        ntForm = root.querySelector('.nt-form');
        if (!ntForm) { host.innerHTML = '<p class="wl-note">The sign-up is on the page behind this.</p>'; return; }
        ntHome = ntForm.parentNode;
      }
      if (ntForm.parentNode !== host) host.appendChild(ntForm);
      /* the submit reloads the page, so the event has to go on the way out */
      if (!ntForm.__slTracked) {
        ntForm.__slTracked = 1;
        ntForm.addEventListener('submit', function () { S.intro.done = true; S.intro.step = 0; save(); try { sessionStorage.setItem('sl_wel_posted', '1'); } catch (e) {} track('tour_waitlist_submit', { who: S.intro.who, goal: S.intro.goal }); });
      }
    }
    function welFormHome() { if (ntForm && ntHome && ntForm.parentNode !== ntHome) ntHome.appendChild(ntForm); }
    /* called whenever the walkthrough is left or the shell closes */
    function welFormRestore() { welFormHome(); welClear(); clearTimeout(welIdleT); elTop.classList.remove('is-wel'); }
    /* Next asks for attention when nobody moves on: a few quiet seconds and it
       bounces (on a question, the tiles do). Any tap or key starts the wait again,
       and a speed run in progress is never interrupted. */
    var welIdleT = null;
    function welIdleArm() {
      clearTimeout(welIdleT);
      var m = elWel.querySelector('.wl-main');
      if (m) m.classList.remove('is-nudge');
      if (S.screen !== 'welcome') return;
      welIdleT = setTimeout(function nudge() {
        if (S.screen !== 'welcome') return;
        if (WD && WD.sp === 'run') { welIdleT = setTimeout(nudge, 2000); return; }
        var mm = elWel.querySelector('.wl-main');
        if (mm) mm.classList.add('is-nudge');
      }, welStep() < 3 ? 6000 : 4000);
    }
    function welNotifyHTML() {
      if (welPosted) return '<span class="wl-mailico is-done">' + ICON.tick + '</span><h2 class="wl-h">You\'re on the list</h2>' +
        '<p class="wl-line">' + (S.intro.who === 'pupil' ? 'We\'ll tell them when it\'s ready' : 'We\'ll tell you when the full lab is ready') + '</p>';
      return '<span class="wl-mailico">' + WL_SVG.mail + '</span><h2 class="wl-h">Want more skills?</h2>' +
        '<p class="wl-line">' + (S.intro.who === 'pupil' ? 'Ask an adult to add their email, and we\'ll tell them when it\'s ready' : 'Add your email and we\'ll tell you when the full lab is ready') + '</p>' +
        '<div class="wl-form" id="slWelForm"></div>';
    }
    function renderWelcome() {
      var step = welStep(), keys = tourKeys(), n = welSteps(), sk = welRec();
      var body, last = step === n - 1, i;
      /* the form is inside the card, so a repaint would tear the real node out
         of the page: it goes home before every paint and comes back after */
      welFormHome();
      wd();
      if (step < 3) body = welQuestionHTML(step);
      else if (last) body = welNotifyHTML();
      else body = welCardHTML(keys[step - 3], step === 3);
      /* done is recorded by Start, Skip, Escape or the waitlist submit, never by
         merely arriving: someone who closes on the last step sees it again */
      if (!trackedTour) { trackedTour = true; track('tour_start', { returning: S.intro.who ? 'yes' : 'no' }); }
      if (last && !trackedWait) { trackedWait = true; track('tour_waitlist_view', { who: S.intro.who, goal: S.intro.goal }); }
      var same = step === welLast;
      var wdir = (welLast < 0 || reduceMotion || same) ? '' : (step > welLast ? ' is-fwd' : ' is-back');
      welLast = step;
      /* a new step starts at the top; paint would otherwise put the old scroll back */
      if (!same) { var sc0 = elWel.querySelector('.wl-scroll'); if (sc0) sc0.scrollTop = 0; }
      var segs = '';
      for (i = 0; i < n; i++) segs += '<i class="' + (i === step ? 'is-now' : (i < step ? 'is-done' : '')) + '"></i>';
      /* a question moves on by itself, so it never shows Next: tapping the chosen tile again moves on after Back */
      var showNext = step >= 3;
      var longLabel = last ? (sk ? 'Start with ' + esc(sk.short || sk.name) : 'Open the skills') : 'Next', shortLabel = last ? (sk ? 'Start ' + esc(sk.short || sk.name) : 'Start') : 'Next';
      /* the recommended skill's engine is fetched quietly while they look round,
         so Start opens it without a wait */
      if (step >= 3 && sk && !SL.ready(sk.id) && !welLoading) {
        welLoading = true;
        SL.ensure([sk.id]).then(function () { welLoading = false; }, function () { welLoading = false; });
      }
      return paint(elWel, '<div class="sl-main wl-main"><div class="sl-scroll wl-scroll"><div class="wl-stage' + (entering ? ' is-enter' : '') + '">' +
        '<section class="wl-screen' + wdir + (same ? ' is-still' : '') + '">' + body + '</section></div></div>' +
        '<div class="wl-nav">' +
          '<div class="wl-nav-l">' + (step ? '<button type="button" class="sl-btn sl-btn--ghost wl-nbtn" data-wel="back">' + ICON.chevL + 'Back</button>' : '') + '</div>' +
          '<div class="wl-bar" role="img" aria-label="Step ' + (step + 1) + ' of ' + n + '">' + segs + '</div>' +
          '<div class="wl-nav-r">' + (showNext ? '<button type="button" class="sl-btn sl-btn--cta wl-cta" data-wel="' + (last ? 'done' : 'next') + '"><span class="wl-long">' + longLabel + '</span><span class="wl-short">' + shortLabel + '</span>' + ICON.chevR + '</button>' : '') + '</div>' +
        '</div></div>', function () { if (last && !welPosted) welFormMount(); welAfterDemo($('slWelDemo')); welIdleArm(); elTop.classList.add('is-wel'); });
    }
    /* A waitlist sign-up posts the page, and Shopify reloads it with its thank-you
       line (.nt-ok) in the form. The submit left a flag in this tab: open the lab
       again on the last step and say it worked, rather than dropping them on the
       page. No flag, or no thank-you line (a failed post), and nothing happens. */
    var welPosted = false;
    try {
      if (sessionStorage.getItem('sl_wel_posted') && root.querySelector('.nt-ok')) {
        welPosted = true; trackedTour = true; trackedWait = true;
        setTimeout(function () { S.intro.step = welSteps() - 1; openShell('welcome'); }, 0);
      }
      sessionStorage.removeItem('sl_wel_posted');
    } catch (e) {}
    function welGo(step) { welClear(); S.intro.step = Math.max(0, Math.min(welSteps() - 1, step)); save(); renderWelcome(); }
    /* an answer shows as chosen for a moment, then moves on by itself */
    function welPick(pair) {
      var bits = String(pair).split(':'), key = bits[0], val = bits[1];
      if (!WEL_OPTS[key]) return;
      var was = S.intro[key], at = welStep();
      S.intro[key] = val;
      track('tour_answer', { question: key, answer: val });
      if (key === 'who' && was !== val) S.intro.first = null;
      if (key === 'goal') {
        var g = welOpt('goal', val);
        if (g && g.stage) { S.stage = g.stage; S.strand = ''; S.strandPicked = false; S.libMore = false; }
        if (was !== val) WD = null;
      }
      save();
      renderWelcome();
      clearTimeout(welPT);
      welPT = setTimeout(function () { if (S.screen === 'welcome' && welStep() === at) welGo(at + 1); }, 650);
    }
    /* the end of the walkthrough, and the Skip that stands in for it: the
       questions already answered are kept either way, and it never runs again */
    function welDone(start) {
      var wasStep = welStep();
      welClear();
      track('tour_finish', {
        outcome: start ? 'complete' : 'skip', step: wasStep,
        who: S.intro.who, goal: S.intro.goal, first: S.intro.first
      });
      S.intro.done = true; S.intro.step = 0; welLast = -1; WD = null;
      var sk = start ? welRec() : null;
      if (sk) {
        S.skill = sk.id; S.from = 'skills'; S.strand = strandOf(sk, S.stage); S.strandPicked = true;
        save(); show('skill'); return;
      }
      save(); show('library');
    }
    elWel.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('button') : null; if (!t) return;
      var pick = t.getAttribute('data-welpick');
      if (pick) { welPick(pick); return; }
      if (t.hasAttribute('data-wd')) { welDemo(t); return; }
      var act = t.getAttribute('data-wel');
      if (act === 'back') { welGo(welStep() - 1); return; }
      if (act === 'next') { welGo(welStep() + 1); return; }
      if (act === 'done') { welDone(true); return; }
    });
    ['pointerdown', 'keydown', 'input'].forEach(function (ev) { elWel.addEventListener(ev, welIdleArm, true); });

    /* ============================================================
       LIBRARY (Skills): stage, search, strands, single-choice cards
       ============================================================ */
    var elLib = $('slLibrary');
    /* The example on a card is dealt by the skill's own generator, not a string
       written by hand that can drift from what the engine actually produces. One
       per skill and level, held for the session so it does not flicker on every
       render, with the authored eg as the fallback if a generator throws. */
    var EG = {};
    /* THE LINE ON A CARD. Not a question the engine dealt: the one line that
       says what the skill IS at a glance (Aadam 2026-09-16: "show answers or
       the main thing from the skill, something that shows exactly what the
       skill is, easily recognisable, each one different"). Mostly the ANSWER -
       the thing the skill produces - except where a bare answer says nothing:
       expanding is the bracket you are handed, and a skill whose answer is a
       plain number keeps the statement it belongs to. A skill with no line here
       falls back to a real question. Level 1 only: once a level is picked the
       card shows a specimen of THAT level. */
    function cardRad(n) { return '<span class="eb-srd"><svg class="eb-rad" viewBox="0 0 24 40" aria-hidden="true"><path d="M2 23 L7 21 L12 36 L22.4 2.4"/></svg><span>' + n + '</span></span>'; }
    function cardRt(inner) { return '<span class="cs-rt"><svg viewBox="0 0 24 40" preserveAspectRatio="none" aria-hidden="true"><path d="M2 23 L7 21 L12 37 L22.4 2"/></svg><span class="cs-rin">' + inner + '</span></span>'; }
    /* .cs-fr sets .66em for a fraction inside a line of working; on a card the
       formula IS the line, so it comes back up to nearly full size */
    function cardFr(top, bot) { return '<span class="cs-fr" style="font-size:.84em"><span>' + top + '</span><span>' + bot + '</span></span>'; }
    /* A card line that is too long for one line breaks at the = or the → that
       joins its two halves, and nowhere else: '(x + 2)(x + 5)' over
       '= x² + 7x + 10'. Inside a half the space AFTER an operator is nailed
       shut, so if a half has to wrap as well it still breaks in front of the
       operator, never behind it. */
    function nbOps(s) { return s.replace(/([+−=×<>→])\s/g, '$1 '); }
    function cardLine(s) {
      var i = s.indexOf(' = '); if (i < 0) i = s.indexOf(' → ');
      return i < 0 || s.length <= 22 ? nbOps(s) : nbOps(s.slice(0, i)) + '<br>' + nbOps(s.slice(i + 1));
    }
    var CARD_EG = {
      /* the answer */
      'factorising-quadratics': cardLine('(x + 3)(x + 4)'),
      'completing-the-square': cardLine('(x + 4)² − 13'),
      'linear-nth-term': cardLine('3n + 2'),
      'quadratic-sequences': cardLine('n² + 2n + 3'),
      /* the formula itself, as it is written */
      'quadratic-formula': nbOps('x = ') + cardFr(nbOps('−b ± ') + cardRt(nbOps('b² − 4ac')), '2a'),
      /* expanding: the bracket you are handed IS the skill */
      'expanding-single-brackets': cardLine('3(x + 4)'),
      'expanding-double-brackets': cardLine('(x + 2)(x + 5)'),
      'expanding-triple-brackets': cardLine('(x + 1)(x + 2)(x + 3)'),
      'expanding-surd-brackets': cardLine('R(R + 3)').split('R').join(cardRad(2)),
      /* a plain number on its own says nothing, so these keep the statement */
      'negative-numbers': cardLine('8 − 15 = −7'),
      'counting-in-steps': cardLine('0, 5, 10, 15, 20'),
      'place-value': cardLine('the 7 in 3,724 = 700'),
      'more-or-less': cardLine('10 more than 246 = 256'),
      'multiply-divide-by-10-100-1000': cardLine('46 × 10 = 460'),
      'reading-writing-numbers': cardLine('47 = forty-seven'),
      'comparing-ordering-numbers': cardLine('0.5 > 0.455'),
      'roman-numerals': cardLine('XIV = 14')
    };
    function egFor(sk, level) {
      if ((level || 1) === 1 && CARD_EG[sk.id]) return CARD_EG[sk.id];
      if (typeof sk.make !== 'function') return firstEg(levelEg(sk, level || 1) || sk.eg);
      var key = sk.id + '|' + (level || 1);
      if (EG[key]) return EG[key];
      var html = null;
      try { html = sk.make(level || 1, { seen: {}, shapeSeen: {}, last: null }).html; } catch (err) { html = null; }
      EG[key] = html || firstEg(sk.eg);
      return EG[key];
    }
    /* one example, not the whole list: the fallback shows a single specimen.
       Examples in an eg are separated by a comma AND spaces ('3(x + 4),  x(2x
       − 5)'); a plain comma belongs INSIDE the example - a sequence, a list of
       steps - so splitting on it cut '5, 8, 11, 14, …' down to '5' on the
       sequences cards. Only split on a separator that is not inside a tag. */
    function firstEg(html) {
      var parts = String(html || '').split(/,\s\s+/);
      if (parts.length < 2) return html;
      var head = parts[0];
      if ((head.split('<').length - 1) !== (head.split('>').length - 1)) return html;
      return head.trim();
    }
    /* The library tile: the topic colour takes the head of the card with the
       skill's own icon, and one real question sits on the panel underneath. The
       name reserves two lines whether it needs them or not, so the bands, the
       panels and the card edges line up across a row. */
    function cardHTML(sk, pick, i) {
      var on = pick && inMix(sk), c = colourOf(sk);
      var right = pick
        ? '<span class="sl-check' + (on ? ' is-on' : '') + '">' + ICON.tick + '</span>'
        : '<span class="tgo">' + ICON.chevR + '</span>';
      /* the star cannot live INSIDE the tile - a button inside a button is not
         valid and the click would have nowhere to go - so the pair sits in a
         wrapper and the star is laid over the card's corner */
      return '<div class="sl-tilewrap" style="--c:' + c.col + ';--ct:' + c.tint + ';--i:' + (i || 0) + '">' +
        '<button type="button" class="sl-tile sl-tile--card' + (on ? ' is-on' : '') + '" data-skill="' + sk.id + '"' + (pick ? ' aria-pressed="' + (on ? 'true' : 'false') + '"' : '') + '>' +
        '<div class="tband tband--title">' + skIcon(sk) + '<span class="tname">' + esc(sk.name) + '</span>' + right + '</div>' +
        '<div class="tbody"><div class="tspec"><span class="sl-expr">' + egFor(sk, 1) + '</span></div></div></button>' +
        favBtn(sk) + '</div>';
    }
    /* one control, two places: the corner of a library tile and the head of the
       skill card. It says what it does in the pill, because a star on its own
       is only obvious once you have used it. */
    function favBtn(sk, big) {
      var f = isFav(sk);
      return '<button type="button" class="sl-fav' + (big ? ' sl-fav--big' : '') + (f ? ' is-on' : '') + '" data-fav="' + sk.id +
        '" aria-pressed="' + (f ? 'true' : 'false') + '" aria-label="' + (f ? 'Remove ' + esc(sk.name) + ' from favourites' : 'Save ' + esc(sk.name) + ' to favourites') + '">' +
        (f ? ICON.starOn : ICON.star) + '</button>';
    }
    function libraryBody(pick) {
      var strands = STRANDS[S.stage], q = S.search;
      var strand = (S.strand === FAVID || S.strand === ALLID || strands.some(function (s) { return s.id === S.strand; })) ? S.strand : strands[0].id;
      if (strand !== FAVID && strand !== ALLID && !readySkills(strand, S.stage).length && !S.strandPicked) { var first = strands.filter(function (s) { return readySkills(s.id, S.stage).length; })[0]; if (first) strand = first.id; }
      S.strand = strand;
      var searching = !!q.trim();
      var favView = strand === FAVID && !searching, allView = strand === ALLID && !searching;
      var ready = (favView ? favSkills() : (searching || allView ? readySkills(null, S.stage) : readySkills(strand, S.stage))).filter(function (sk) { return matches(q, sk.name, sk.aliases); });
      var planned = favView ? [] : (searching || allView
        ? [].concat.apply([], strands.map(function (s) { return plannedFor(s.id).filter(function (n) { return matches(q, n); }); }))
        : plannedFor(strand));
      var strandName = searching ? 'Search: ' + q.trim() : favView ? 'Favourites' : allView ? 'All skills' : strands.filter(function (s) { return s.id === strand; })[0].name;
      /* the tiles deal in only when the shelf itself changes (stage, strand,
         search), never when a tile is ticked or the planned list is opened */
      var sig = S.stage + '|' + strand + '|' + (pick ? 1 : 0), enter = entering || (!searching && libSig[pick ? 1 : 0] !== sig);
      libSig[pick ? 1 : 0] = sig;

      var stage = '<div class="sl-segwrap" role="tablist" aria-label="Stage" data-mo-group="stage"><button type="button" role="tab" class="sl-seg' + (S.stage === 'primary' ? ' is-on' : '') + '" data-stage="primary">Primary</button>' +
        '<button type="button" role="tab" class="sl-seg' + (S.stage === 'secondary' ? ' is-on' : '') + '" data-stage="secondary">Secondary</button></div>';
      /* the search box lives in the top bar now (searchTopHTML) */
      var nfav = favSkills().length;
      var favRow = '<button type="button" class="sl-rrow sl-strand sl-strand--fav' + (favView ? ' is-now' : '') + (nfav ? '' : ' is-quiet') + '" data-strand="' + FAVID + '">' +
        (nfav ? ICON.starOn : ICON.star) + '<span class="rq">Favourites</span><span class="rside">' + (nfav ? nfav + ' saved' : 'none yet') + '</span>' + (favView ? '' : ICON.chevR) + '</button>';
      var nAll = readySkills(null, S.stage).length;
      var allRow = '<button type="button" class="sl-rrow sl-strand sl-strand--all' + (allView ? ' is-now' : '') + '" data-strand="' + ALLID + '">' +
        '<span class="rq">All skills</span><span class="rcount">' + nAll + '</span>' + (allView ? '' : ICON.chevR) + '</button>';
      var rail = '<div class="sl-rail-top">' + stage + favRow + papersRow() + '</div><div class="sl-rail-title">Strands</div><div class="sl-strands">' + allRow + strands.map(function (s) {
        var r = readySkills(s.id, S.stage).length, p = plannedFor(s.id).length;
        var now = s.id === strand && !searching;
        return '<button type="button" class="sl-rrow sl-strand' + (now ? ' is-now' : '') + (r ? '' : ' is-quiet') + '" data-strand="' + s.id + '">' +
          '<span class="rq">' + esc(s.name) + '</span>' +
          (r ? '<span class="rcount">' + r + '</span>' : '<span class="rside">soon</span>') +
          (now || !r ? '' : ICON.chevR) + '</button>';
      }).join('') + '</div>' + railFootHTML();

      var cont = '';
      /* a big shelf is paged: two dozen tiles, then one chip for the rest, so a
         fifty-skill strand never mounts or animates fifty cards at once */
      var PAGE = 24, shown = S.libMore || allView ? ready : ready.slice(0, PAGE);
      var grid = allView ? allShelfHTML(strands, pick) : shown.map(function (sk, i) { return cardHTML(sk, pick, i); }).join('');
      if (ready.length > shown.length) grid += '<button type="button" class="sl-chip sl-chip--more" id="slLibMore" style="grid-column:1/-1;justify-self:center">' + ICON.chevD + 'Show the other ' + (ready.length - shown.length) + '</button>';
      if (!grid) {
        var where = strands.filter(function (s) { return readySkills(s.id, S.stage).length; }).map(function (s) { return s.name + ' (' + readySkills(s.id, S.stage).length + ')'; }).join(', ');
        grid = '<div class="sl-empty" style="grid-column:1/-1">' + (favView ? 'Nothing saved yet. Tap the star in the corner of any skill and it lands here.' : (searching ? 'No ready skill matches.' : 'Nothing in ' + esc(strandName) + ' yet.') + (where ? ' Ready now: ' + esc(where) + '.' : '')) + '</div>';
      }
      var plannedLine = planned.length
        ? '<div class="sl-planned"><button type="button" class="sl-chip" id="slTogglePlanned" aria-expanded="' + (S.showPlanned ? 'true' : 'false') + '">' + ICON.clock + (S.showPlanned || searching ? (searching ? planned.length + ' planned match' + (planned.length === 1 ? '' : 'es') : 'Hide the ' + planned.length + ' planned') : planned.length + ' more planned') + '</button>' +
          (S.showPlanned || searching ? '<div class="sl-planned-list">' + planned.map(function (n) { return '<span class="sl-chip" style="cursor:default">' + esc(n) + '</span>'; }).join('') + '</div>' : '') + '</div>'
        : '';
      var sub = favView ? 'The skills you have saved. Tap a star to take one out.'
        : allView && !pick ? 'Every skill that is ready, strand by strand, in the order they are learnt.'
        : pick ? 'Choose 2 to 6 skills. Ten questions, taken from each in turn at the levels you pick.'
        : 'Pick a skill, choose its level, then teach it, practise it or put it on the board.';
      return '<div class="sl-rail">' + rail + '</div><div class="sl-main"><div class="sl-scroll"><div class="sl-lib-main">' + cont +
        '<div class="sl-lib-head"><div><h2>' + esc(strandName) + '</h2><div class="sub">' + sub + '</div></div></div>' +
        '<div class="sl-grid' + (enter ? ' is-enter' : '') + '" style="--lz:' + LIB_ZOOMS[libZoomAt()] + '">' + grid + '</div>' + plannedLine + '</div></div>' + (pick ? mixedTray() : '') + '</div>';
    }
    /* the foot of the rail. The column is taller than five strands on any
       laptop, and an empty third of it says nothing; this says what is in the
       Lab today and that it is still growing. */
    function railFootHTML() {
      var here = readySkills(null, S.stage), n = here.length;
      var other = readySkills(null, S.stage === 'primary' ? 'secondary' : 'primary').filter(function (sk) { return here.indexOf(sk) < 0; }).length;
      return '<div class="sl-rail-foot">' +
        '<b>' + n + ' skill' + (n === 1 ? '' : 's') + ' ready</b>' +
        '<span>' + (other ? other + ' more in ' + (S.stage === 'primary' ? 'Secondary' : 'Primary') + '. ' : '') + 'New ones land every week.</span>' +
        '<button type="button" class="sl-linkbtn" data-welopen="1">Show me around</button></div>';
    }
    var libSig = {}, FAVID = '_fav', ALLID = '_all';
    /* ALL SKILLS (2026-09-25): every strand's ready skills under its own heading, in learning order. The
       headings sit in the same grid (full width), so the tile zoom and the deal-in stagger carry on across
       them. A big lab caps each strand at 8 with a chip into the strand itself. */
    function allShelfHTML(strands, pick) {
      var total = readySkills(null, S.stage).length, cap = total > 48 ? 8 : 0, k = 0;
      return strands.map(function (s) {
        var list = readySkills(s.id, S.stage); if (!list.length) return '';
        var show = cap ? list.slice(0, cap) : list;
        var cards = show.map(function (sk) { return cardHTML(sk, pick, k++); }).join('');
        if (list.length > show.length) cards += '<button type="button" class="sl-chip sl-chip--more" data-strand="' + s.id + '" style="grid-column:1/-1;justify-self:center">' + ICON.chevR + 'All ' + list.length + ' in ' + esc(s.name) + '</button>';
        return '<h3 class="sl-libsec"><button type="button" class="sl-libsec-go" data-strand="' + s.id + '">' + esc(s.name) + ICON.chevR + '</button><span class="rcount">' + list.length + '</span></h3>' + cards;
      }).join('');
    }
    /* Zoom for the skill tiles: a step scales the whole tile (type, icon, example) and so how many fit in a
       row. 1 is the size the shelf was designed at; smaller fits more in a row, bigger fewer. */
    var LIB_ZOOMS = [0.7, 0.8, 0.9, 1, 1.15, 1.3, 1.5];
    function libZoomAt() { var z = Math.round(S.libZoom); return z >= 0 && z < LIB_ZOOMS.length ? z : 3; }
    function searchTopHTML() {
      var q = S.search || '', live = !!q.trim();
      return '<label class="sl-input sl-search sl-topsearch' + (live ? ' is-live' : '') + '">' + ICON.search +
        '<input type="search" id="slSearch" placeholder="Search skills" value="' + esc(q) + '" aria-label="Search skills">' +
        '<button type="button" class="sl-searchx" data-clearsearch="1" aria-label="Clear the search" data-tip="Clear search">' + ICON.cross + '</button></label>';
    }
    function zoomHTML() {
      var z = libZoomAt(), n = LIB_ZOOMS.length - 1;
      return '<div class="sl-zoom hide-sm" style="--p:' + (z / n) + '">' +
        '<button type="button" class="sl-iconbtn sl-zoombtn" data-libzoom="-1" aria-label="Smaller tiles, more in a row" data-tip="Smaller tiles"' + (z === 0 ? ' disabled' : '') + '>' + ICON.minus + '</button>' +
        '<input type="range" class="sl-range" min="0" max="' + n + '" step="1" value="' + z + '" data-slider="libzoom" aria-label="Tile size">' +
        '<button type="button" class="sl-iconbtn sl-zoombtn" data-libzoom="1" aria-label="Bigger tiles, fewer in a row" data-tip="Bigger tiles"' + (z === n ? ' disabled' : '') + '>' + ICON.plus + '</button></div>';
    }
    /* the box is in the top bar, which a shelf re-render does not repaint, so it is brought in line by hand */
    function syncSearchBox() {
      var inp = $('slSearch'); if (!inp) return;
      if (inp.value !== (S.search || '')) inp.value = S.search || '';
      var lab = inp.closest('.sl-topsearch'); if (lab) lab.classList.toggle('is-live', !!(S.search || '').trim());
    }
    function rerenderLib() { if (S.screen === 'mixed') renderMixed(); else if (S.screen === 'library') renderLibrary(); }
    function setLibZoom(z, repaintTop) {
      S.libZoom = Math.max(0, Math.min(LIB_ZOOMS.length - 1, z));
      Array.prototype.forEach.call(document.querySelectorAll('#slShell .sl-grid'), function (g) { g.style.setProperty('--lz', LIB_ZOOMS[S.libZoom]); });
      var w = document.querySelector('#slShell .sl-zoom');
      if (w) {
        w.style.setProperty('--p', S.libZoom / (LIB_ZOOMS.length - 1));
        var r = w.querySelector('input'); if (r && Number(r.value) !== S.libZoom) r.value = S.libZoom;
        var b = w.querySelectorAll('.sl-zoombtn'); if (b.length === 2) { b[0].disabled = S.libZoom === 0; b[1].disabled = S.libZoom === LIB_ZOOMS.length - 1; }
      }
      if (repaintTop) save();
    }
    /* PHONE (2026-09-25): under 861px the rail is one sideways row, and the strand on show could sit off
       its right edge with nothing to say it was there: bring it into view whenever the shelf changes */
    function railToNow(host) {
      if (window.innerWidth > 860) return;
      var r = host.querySelector('.sl-rail'), n = r && r.querySelector('.sl-strand.is-now');
      if (!r || !n) return;
      var rb = r.getBoundingClientRect(), nb = n.getBoundingClientRect();
      if (nb.left >= rb.left && nb.right <= rb.right - 40) return;
      var sb = r.style.scrollBehavior; r.style.scrollBehavior = 'auto';
      r.scrollLeft += nb.left - rb.left - Math.max(12, (rb.width - nb.width) / 2);
      r.style.scrollBehavior = sb;
    }
    function renderLibrary() { var was = libSig[0]; paint(elLib, libraryBody(false)); if (was !== libSig[0]) { shelfTop(elLib); railToNow(elLib); } pwPrefetch(); }
    /* PHONE LIBRARY + MIXED TRAY + LEVEL TICK SCROLL (2026-09-21): a different shelf starts at its top */
    function shelfTop(host) { var sc = host.querySelector('.sl-main > .sl-scroll'); if (!sc || !sc.scrollTop) return; var sb = sc.style.scrollBehavior; sc.style.scrollBehavior = 'auto'; sc.scrollTop = 0; sc.style.scrollBehavior = sb; }
    function libClick(e, pick) {
      var t = e.target.closest ? e.target.closest('button') : null;
      if (!t) return false;
      if (t.getAttribute('data-stage')) { S.stage = t.getAttribute('data-stage'); S.strandPicked = false; S.strand = ''; S.libMore = false; save(); return true; }
      if (t.getAttribute('data-papers')) { S.papersQ = ''; save(); show('papers'); return false; }
      if (t.getAttribute('data-strand')) { S.strand = t.getAttribute('data-strand'); S.strandPicked = true; S.search = ''; S.libMore = false; save(); return true; }
      if (t.getAttribute('data-fav')) { toggleFav(SL.get(t.getAttribute('data-fav'))); return true; }
      if (t.getAttribute('data-clearsearch')) { S.search = ''; S.libMore = false; return true; }
      if (t.id === 'slLibMore') { S.libMore = true; return true; }
      if (t.id === 'slTogglePlanned') { S.showPlanned = !S.showPlanned; return true; }
      if (t.getAttribute('data-skill')) {
        var sk = SL.get(t.getAttribute('data-skill'));
        if (pick) { toggleMix(sk); return true; }
        S.skill = sk.id; S.from = 'skills'; save(); show('skill'); return false;
      }
      return false;
    }
    elLib.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('button') : null;
      if (b && b.getAttribute('data-welopen')) { S.intro.step = 0; show('welcome'); return; }
      if (libClick(e, false)) { renderLibrary(); syncSearchBox(); }
    });
    var searchTimer = null;
    function onSearch(e, rerender) {
      if (!e.target || e.target.id !== 'slSearch' || e.isComposing) return;
      S.search = e.target.value; S.libMore = false;
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function () {
        var pos = e.target.selectionStart;
        rerender(); syncSearchBox();
        var inp = $('slSearch'); if (inp) { inp.focus(); try { inp.setSelectionRange(pos, pos); } catch (err) {} }
      }, 120);
    }
    elLib.addEventListener('input', function (e) { onSearch(e, renderLibrary); });

    /* ============================================================
       MIXED PRACTICE: the basket
       ============================================================ */
/* SLPW: GCSE past papers */
    /* ============================================================
       GCSE PAST PAPERS: the hardest questions
       A real paper's last questions, taught the way a skill is taught: one
       press is one idea, the inputs light before the result, and the question
       itself lights up so a pupil sees where every number came from. The
       walkthroughs live in the papers kit, which is fetched the first time
       this screen is opened; the engine owns its own stage inside the screen.
       ============================================================ */
    var elPapers = $('slPapers'), pwApi = null;
    function destroyPapers() { if (pwApi) { try { pwApi.destroy(); } catch (e) {} pwApi = null; } }
    function papersKit() { return (window.SL && SL.kits && SL.kits.papers) || null; }
    /* the count is the kit's own list, never a number typed here (it said 10 while 15 were live); until the
       kit has loaded the row shows a chevron instead, and on a laptop the kit is fetched once the shelf is idle */
    function papersRow() {
      if (S.stage !== 'secondary') return '';
      var k = papersKit(), n = k ? k.list().length : 0;
      return '<button type="button" class="sl-rrow sl-strand sl-pwrow' + (S.screen === 'papers' ? ' is-now' : '') +
        '" data-papers="1">' + stk('papers', '') + '<span class="rq">GCSE past papers</span>' + (n ? '<span class="rcount">' + n + '</span>' : ICON.chevR) + '</button>';
    }
    var pwPre = false, pwEnter = true;
    function pwPrefetch() {
      if (pwPre || papersKit() || S.stage !== 'secondary' || narrow()) return;
      pwPre = true;
      var go = function () {
        loadAsset('skills-lab-kit-papers.js').then(function () {
          if (S.screen !== 'library' && S.screen !== 'mixed') return;
          each(document.querySelectorAll('#slShell .sl-pwrow'), function (r) { r.outerHTML = papersRow(); });
        }, function () { pwPre = false; });
      };
      if (window.requestIdleCallback) window.requestIdleCallback(go, { timeout: 5000 }); else setTimeout(go, 2500);
    }
    var PW_STRANDS = [['number', 'Number'], ['algebra', 'Algebra'], ['ratio', 'Ratio & proportion'], ['geometry', 'Geometry'], ['statistics', 'Probability & statistics']];
    var PW_HUE = { number: '--t2', algebra: '--t1', ratio: '--t3', geometry: '--t4', statistics: '--t5' };
    /* a question's strand: the kit's own when a row carries one, else read from the topic. Algebra is tried
       before geometry so a tangent's EQUATION and a transformed GRAPH land in algebra, as the spec puts them. */
    function pwStrand(r) {
      if (r.strand && PW_HUE[r.strand]) return r.strand;
      var t = String(r.topic || '').toLowerCase();
      if (/probab|colour|dice|spinner|coin|tree diagram|venn|mean|median|histogram|cumulative|frequency/.test(t)) return 'statistics';
      if (/ratio|proportion|percent|speed|density|pressure|compound|growth|decay|interest/.test(t)) return 'ratio';
      if (/tangent|graph|function|equation|inequalit|algebra|sequence|quadratic|simultaneous|formula|iteration|expression|factoris|expand|proof/.test(t)) return 'algebra';
      if (/vector|angle|circle|trig|triangle|area|volume|similar|congruen|shape|polygon|octagon|hexagon|bearing|pythag|sine|cosine|arc|sector|cone|sphere|prism|pyramid|cylinder|transformation|loci|construct/.test(t)) return 'geometry';
      return 'number';
    }
    function pwStrandName(id) { for (var i = 0; i < PW_STRANDS.length; i++) if (PW_STRANDS[i][0] === id) return PW_STRANDS[i][1]; return ''; }
    function cap1(s) { s = String(s || '').trim(); return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }
    function papersListHTML() {
      var k = papersKit();
      if (!k) return '<div class="sl-scroll"><div class="sl-pwload">Opening the past paper questions...</div></div>';
      /* one block per paper: the question numbers repeat between papers, so the
         paper has to be on screen above them, and the id carries it. The strand
         chips (All first) only thin the cards out; the papers stay in order.
         Built to grow (2026-09-25): a calculator filter appears once there are
         both kinds, a search box once there are more than 24 questions, and a
         paper's heading folds its cards away (every paper starts folded once
         there are more than four). Tiers are never named (house rule 3). */
      var rows = k.list(), papers = k.papers ? k.papers() : [k.paper], body = '', idx = 0;
      var calcOf = function (r) { var p = paperById(r.paperId); return /non.?calc/i.test(p && p.sub || '') ? 'non' : 'calc'; };
      var paperById = function (id) { for (var i = 0; i < papers.length; i++) if (papers[i].id === id) return papers[i]; return null; };
      var want = S.pwStrand && rows.some(function (r) { return pwStrand(r) === S.pwStrand; }) ? S.pwStrand : '';
      var kinds = { calc: 0, non: 0 }; rows.forEach(function (r) { kinds[calcOf(r)]++; });
      var calcWant = kinds.calc && kinds.non && (S.pwCalc === 'calc' || S.pwCalc === 'non') ? S.pwCalc : '';
      var qq = rows.length > 24 ? String(S.pwFind || '').trim().toLowerCase() : '';
      var keep = function (r) { return (!want || pwStrand(r) === want) && (!calcWant || calcOf(r) === calcWant) && (!qq || String(r.topic).toLowerCase().indexOf(qq) >= 0); };
      var seen = S.pwSeen || {}, nSeen = rows.filter(function (r) { return seen[r.q]; }).length;
      var chip = function (id, label, n) {
        var on = want === id;
        return '<button type="button" role="tab" class="sl-chip sl-pwchip' + (on ? ' sl-chip--now' : '') + '" data-pwstrand="' + id + '" aria-selected="' + (on ? 'true' : 'false') + '"' +
          (id ? ' style="--c:var(' + PW_HUE[id] + ')"><i></i>' : '>') + label + '<b class="num">' + n + '</b></button>';
      };
      var cchip = function (id, label) {
        var on = calcWant === id;
        return '<button type="button" class="sl-chip sl-pwchip sl-pwcalc' + (on ? ' sl-chip--now' : '') + '" data-pwcalc="' + id + '" aria-pressed="' + (on ? 'true' : 'false') + '">' + label + '</button>';
      };
      var chips = '<div class="sl-pwchips" role="tablist" aria-label="Strand">' + chip('', 'All', rows.length) +
        PW_STRANDS.map(function (s) { var n = rows.filter(function (r) { return pwStrand(r) === s[0]; }).length; return n ? chip(s[0], s[1], n) : ''; }).join('') + '</div>';
      /* the calculator filter is its own row: on a phone the strand row scrolls, and this must never hide off its edge */
      var calcs = kinds.calc && kinds.non ? '<div class="sl-pwchips sl-pwcalcs" aria-label="Calculator">' + cchip('non', 'Non‑calculator') + cchip('calc', 'Calculator') + '</div>' : '';
      var find = rows.length > 24 ? '<label class="sl-input sl-search sl-pwfind">' + ICON.search + '<input type="search" id="slPwFind" placeholder="Find a topic" value="' + esc(S.pwFind || '') + '" aria-label="Find a topic"></label>' : '';
      var fold = S.pwFold || (S.pwFold = {}), many = papers.length > 4, shown = 0;
      papers.forEach(function (p) {
        var mine = rows.filter(function (r) { return r.paperId === p.id && keep(r); });
        if (!mine.length) return;
        shown += mine.length;
        var m = /^(.*?),\s*(Paper\s.+)$/.exec(p.name || ''), meta = [m ? m[1] : ''].concat(String(p.sub || '').split(/,\s*/))
          .filter(function (s) { return s && !/\btier\b/i.test(s); }).map(function (s) { return cap1(s).replace(/-/g, '‑'); });
        var closed = fold[p.id] === undefined ? many && !qq : fold[p.id];
        var pSeen = mine.filter(function (r) { return seen[r.q]; }).length;
        var cards = closed ? '' : mine.map(function (r) {
          var st = pwStrand(r), done = !!seen[r.q];
          return '<button type="button" class="sl-pwcard' + (done ? ' is-seen' : '') + '" data-pwopen="' + esc(r.q) + '" style="--c:var(' + PW_HUE[st] + ');--i:' + (idx++) + '">' +
            '<span class="pwc-top"><span class="sl-pwq">Q' + esc(r.num || r.q) + '</span><span class="pwc-marks">' + esc(r.marks) + '</span></span>' +
            '<span class="sl-pwtopic">' + esc(r.topic) + '</span>' +
            '<span class="pwc-strand"><i></i>' + esc(pwStrandName(st)) + '</span>' +
            '<span class="pwc-foot"><span class="sl-pwgo">' + (done ? ICON.tick + 'Walked through' : ICON.play + 'Walk through it') + '</span><span class="sl-pwmeta">' + r.steps + ' steps</span></span></button>';
        }).join('');
        body += '<section class="sl-pwsec' + (closed ? ' is-folded' : '') + '"><button type="button" class="sl-pwpaper" data-pwfold="' + esc(p.id) + '" aria-expanded="' + (closed ? 'false' : 'true') + '">' +
          '<h3>' + esc(m ? m[2] : p.name) + '</h3><span class="pwp-meta">' + esc(meta.join(' · ')) + '</span>' +
          '<span class="pwp-count">' + mine.length + ' question' + (mine.length === 1 ? '' : 's') + (pSeen ? ' · ' + pSeen + ' done' : '') + '</span>' + ICON.chevD + '</button>' +
          (closed ? '' : '<div class="sl-pwgrid">' + cards + '</div>') + '</section>';
      });
      if (!shown) body = '<div class="sl-empty">No question matches. <button type="button" class="sl-linkbtn" data-pwreset="1">Show them all</button></div>';
      var prog = nSeen ? '<div class="sl-pwprog" style="--p:' + (nSeen / rows.length) + '"><span><i></i></span>' + nSeen + ' of ' + rows.length + ' walked through</div>' : '';
      var enter = pwEnter; pwEnter = false;
      return '<div class="sl-scroll"><div class="sl-pwlist' + (enter ? ' is-enter' : '') + '"><div class="sl-pwhead"><h2>GCSE past papers</h2>' +
        '<p>The hardest questions from real papers, taught one press at a time. Every one can be rerolled with new numbers.</p>' + prog + find + '<div class="sl-pwfilters">' + chips + calcs + '</div></div>' +
        body + '</div></div>';
    }
    function papersFail() { destroyPapers(); paint(elPapers, '<div class="sl-scroll"><div class="sl-pwload">That did not load. Check the connection and try again.</div></div>'); }
    function renderPapers() {
      var want = S.papersQ || '';
      if (!want) {
        destroyPapers(); pwEnter = true;
        paint(elPapers, papersListHTML());
        if (!papersKit()) loadAsset('skills-lab-kit-papers.js').then(function () {
          if (S.screen === 'papers' && !S.papersQ) paint(elPapers, papersListHTML());
        }, papersFail);
        return;
      }
      paint(elPapers, '<div class="sl-pwhost" id="slPwHost"></div>');
      loadAsset('skills-lab-kit-papers.js').then(function () {
        if (S.screen !== 'papers' || (S.papersQ || '') !== want) return;
        var k = papersKit(), host = $('slPwHost');
        if (!k || !host) return papersFail();
        destroyPapers();
        var got = k.has(want) ? want : k.list()[0].q;
        if (!S.pwSeen) S.pwSeen = {};
        if (!S.pwSeen[got]) { S.pwSeen[got] = 1; save(); }
        pwApi = k.mount(host, { q: k.has(want) ? want : k.list()[0].q, onList: function () { S.papersQ = ''; save(); renderPapers(); renderTop(); } });
      }, papersFail);
    }
    elPapers.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('button') : null;
      if (b && b.hasAttribute('data-pwstrand')) { S.pwStrand = b.getAttribute('data-pwstrand'); pwEnter = true; paint(elPapers, papersListHTML()); return; }
      if (b && b.hasAttribute('data-pwcalc')) { var cv = b.getAttribute('data-pwcalc'); S.pwCalc = S.pwCalc === cv ? '' : cv; pwEnter = true; paint(elPapers, papersListHTML()); return; }
      if (b && b.getAttribute('data-pwfold')) { var fid = b.getAttribute('data-pwfold'), sec = b.closest('.sl-pwsec'); S.pwFold = S.pwFold || {}; S.pwFold[fid] = !(sec && sec.classList.contains('is-folded')); paint(elPapers, papersListHTML()); return; }
      if (b && b.getAttribute('data-pwreset')) { S.pwStrand = ''; S.pwCalc = ''; S.pwFind = ''; paint(elPapers, papersListHTML()); return; }
      if (b && b.getAttribute('data-pwopen')) { S.papersQ = b.getAttribute('data-pwopen'); save(); renderPapers(); renderTop(); }
    });

    var pwFindT = null;
    elPapers.addEventListener('input', function (e) {
      if (!e.target || e.target.id !== 'slPwFind' || e.isComposing) return;
      S.pwFind = e.target.value; clearTimeout(pwFindT);
      pwFindT = setTimeout(function () {
        var pos = e.target.selectionStart; paint(elPapers, papersListHTML());
        var i = $('slPwFind'); if (i) { i.focus(); try { i.setSelectionRange(pos, pos); } catch (er) {} }
      }, 140);
    });
    var elMix = $('slMixed');
    function toggleMix(sk) {
      if (inMix(sk)) S.mix = S.mix.filter(function (m) { return m.id !== sk.id; });
      else if (S.mix.length < 6) S.mix.push({ id: sk.id });
      save();
    }
    /* every level as its own chip, the way the practise rail does it. The old
       minus/plus stepper moved the whole selection up and down, which is not how
       anyone picks levels, and it broke when the level arrows were removed. */
    function lvlChipsHTML(sk, extra) {
      var sel = selLevels(sk), all = sel.length === sk.levels.length;
      var chips = sk.levels.map(function (L, i) {
        var k = i + 1, on = sel.indexOf(k) >= 0;
        return '<button type="button" class="sl-chip sl-chip--lvl num' + (isMixLevel(sk, k) ? ' sl-chip--mix' : '') + (on ? ' sl-chip--now' : '') +
          '" data-togglelvl="' + k + '" aria-pressed="' + (on ? 'true' : 'false') + '"' + tipAttrs(sk, k) + '>' + chipText(sk, k) + '</button>';
      }).join('');
      return '<div class="sl-lvlchips">' + chips +
        (extra ? '<button type="button" class="sl-chip sl-chip--alllvl' + (all ? ' sl-chip--now' : '') + '" data-alllvl="1" title="' +
          (all ? 'Back to level 1 only' : 'Use every level') + '">All</button>' : '') + '</div>';
    }
    function mixChipHTML(sk, i) {
      var c = colourOf(sk), n = mixSkills().length;
      /* the exact share this skill gets, not an approximation: the set is dealt
         round robin, so the first few skills carry the remainder */
      var base = n ? Math.floor(S.setN / n) : 0, per = base + ((i || 0) < S.setN - base * n ? 1 : 0);
      return '<div class="sl-mixchip" data-mix="' + sk.id + '" style="--c:' + c.col + ';--ct:' + c.tint + '"><span class="mico">' + skIcon(sk) + '</span><span class="mname">' + esc(sk.name) + '</span>' +
        lvlChipsHTML(sk, true) +
        '<span class="rside hide-sm" title="How many of the ' + S.setN + ' questions come from this skill"><b class="num">' + per + '</b> question' + (per === 1 ? '' : 's') + '</span>' +
        '<button type="button" class="sl-iconbtn rm" data-rm="1" aria-label="Remove ' + esc(sk.name) + '">' + ICON.cross + '</button></div>';
    }
    function mixedTray() {
      var n = S.mix.length, okN = n >= 2;
      return '<div class="sl-tray"><div class="sl-tray-head"><span class="sl-sect">Your selection</span>' +
        '<span class="sub">' + (n ? n + ' of 6 skills' + (okN ? ' · ' + S.setN + ' questions, taken from each in turn' : ' · pick at least 2') : 'Tick 2 to 6 skills above') + '</span>' +
        '<div class="sl-tray-ctas"><div class="sl-segwrap sl-mixlay" data-mo-group="mixlay" title="How the board deals these skills"><button type="button" class="sl-seg' + (S.board.mixLayout === 'skill' ? ' is-on' : '') + '" data-mixlay="skill">One skill per column</button>' +
        '<button type="button" class="sl-seg' + (S.board.mixLayout === 'mixed' ? ' is-on' : '') + '" data-mixlay="mixed">All mixed</button></div>' +
        '<button type="button" class="sl-btn" id="slMixBoard"' + (okN ? '' : ' disabled') + '>' + ICON.board + 'Board</button>' +
        '<button type="button" class="sl-btn" id="slMixSpeed"' + (okN ? '' : ' disabled') + '>' + ICON.clock + 'Speed</button>' +
        '<button type="button" class="sl-btn sl-btn--cta" id="slMixPractise" style="padding:13px 20px;font-size:16px"' + (okN ? '' : ' disabled') + '>' + ICON.play + 'Mixed practise</button></div></div>' +
        (n ? '<div class="sl-tray-chips">' + mixSkills().map(mixChipHTML).join('') + '</div>' : '') + '</div>';
    }
    function renderMixed() { var was = libSig[1]; paint(elMix, libraryBody(true)); if (was !== libSig[1]) { shelfTop(elMix); railToNow(elMix); } }
    elMix.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('button') : null;
      if (!t) return;
      var chip = t.closest('.sl-mixchip');
      if (chip) {
        var sk = SL.get(chip.getAttribute('data-mix'));
        if (t.getAttribute('data-rm')) { toggleMix(sk); renderMixed(); return; }
        if (levelClick(t, sk)) { renderMixed(); return; }
        return;
      }
      if (t.getAttribute('data-mixlay')) { S.board.mixLayout = t.getAttribute('data-mixlay'); save(); renderMixed(); return; }
      if (t.id === 'slMixPractise') { withSkills(S.mix.map(function (m) { return m.id; }), t, function () { S.from = 'mixed'; buildSet(); show('practise'); }, true); return; }
      if (t.id === 'slMixBoard') { withSkills(S.mix.map(function (m) { return m.id; }), t, function () { S.from = 'mixed'; buildBoard(); show('board'); }, true); return; }
      if (t.id === 'slMixSpeed') { S.from = 'mixed'; show('speedsetup'); return; }
      if (libClick(e, true)) { renderMixed(); syncSearchBox(); }
    });
    elMix.addEventListener('input', function (e) { onSearch(e, renderMixed); });

    /* ============================================================
       LEVEL PICKER, shared by the skill screen, board setup and practise
       ============================================================ */
    /* max: the most levels that may be ticked at once (the board fits three columns) */
    function levelCap(sk, max) { return max ? Math.min(max, sk.levels.length) : sk.levels.length; }
    function levelListHTML(sk, compact, max) {
      var sel = selLevels(sk), full = max && sel.length >= max;
      var cap = levelCap(sk, max), allOn = sel.length >= cap;
      var bar = '<div class="sl-lvlbar"><button type="button" class="sl-chip sl-chip--alllvl' + (allOn ? ' sl-chip--now' : '') + '" data-alllvl="1">' +
        (allOn ? 'Clear, back to level 1' : 'Select all ' + cap) + '</button></div>';
      return bar + '<div class="sl-lvllist' + (compact ? ' sl-lvllist--compact' : '') + '" role="group" aria-label="Levels">' + sk.levels.map(function (L, i) {
        var k = i + 1, on = sel.indexOf(k) >= 0, off = full && !on;
        return '<button type="button" class="sl-rrow sl-lvlrow' + (on ? ' is-now' : '') + (off ? ' is-off' : '') + '" style="--i:' + (k - 1) + '" data-togglelvl="' + k + '" aria-pressed="' + (on ? 'true' : 'false') + '"' + (off ? ' disabled' : '') + '><span class="sl-check' + (on ? ' is-on' : '') + '">' + ICON.tick + '</span><span class="rq"><span class="lname">' + k + '. ' + esc(L.name) + '</span><span class="leg sl-expr">' + oneEg(L.eg) + '</span></span>' + '</button>';
      }).join('') + '</div>';
    }
    function levelNowHTML(sk) {
      var sel = selLevels(sk), n = sk.levels.length, lo = sel[0];
      var body = sel.length === 1
        ? '<b class="num">Level ' + lo + ' of ' + n + '</b><span>' + esc(levelName(sk, lo)) + '</span><span class="sl-expr leg">Questions such as ' + levelEg(sk, lo) + '</span>'
        : '<b class="num">' + sel.length + ' levels of ' + n + '</b><span>' + esc(levelWord(sk).replace('Levels ', 'Levels ')) + '</span><span class="leg">Questions from each, taken in turn. Tap a level below to add or remove it.</span>';
      return '<div class="sl-lvlnow"><div class="lvbody">' + body + '</div></div>';
    }
    function levelClick(t, sk, max) {
      if (t.getAttribute('data-alllvl')) {
        var cap = levelCap(sk, max), every = [], i;
        for (i = 1; i <= cap; i++) every.push(i);
        setSel(sk, selLevels(sk).length >= cap ? [1] : every);
        return true;
      }
      if (t.getAttribute('data-togglelvl')) {
        var k = Number(t.getAttribute('data-togglelvl'));
        if (max && selLevels(sk).indexOf(k) < 0 && selLevels(sk).length >= max) return true;
        toggleSel(sk, k); return true;
      }
      return false;
    }

    /* ============================================================
       SKILL: name → level → activity
       ============================================================ */
    var elSk = $('slSkill');
    function renderSkill() {
      var sk = curSkill(); if (!sk) { show('library'); return; }
      var n = sk.levels.length, c = colourOf(sk), sel = selLevels(sk);
      paint(elSk, '<div class="sl-main"><div class="sl-scroll"><div class="sl-skill' + (entering ? ' is-enter' : '') + '">' +
        '<div class="sl-skill-info">' +
          '<div class="sl-skill-card" style="--c:' + c.col + ';--ct:' + c.tint + '">' +
            '<div class="tband tband--title">' + skIcon(sk) + '<h2 class="tname">' + esc(sk.name) + '</h2>' + favBtn(sk, true) +
'</div>' +
            '<div class="sl-skill-body"><p>' + esc(sk.blurb || '') + '</p>' +
            '<div class="tspec"><span class="sl-expr">' + egFor(sk, sel[0]) + '</span></div></div></div>' +
          '<div class="sl-lvlpick"><div class="sl-sect">Level</div>' + levelNowHTML(sk) +
            '<div class="sl-lvlnote">Tick more than one level to practise them together.</div>' +
            levelListHTML(sk, false) + '</div>' +
        '</div>' +
        '<div class="sl-skill-do"><div class="sl-sect">What would you like to do?</div>' +
          '<button type="button" class="sl-act" data-act="teach" style="--c:' + c.col + '">' + stk('teach', ICON.steps) + '<b>Teach</b><span>Work through one model step by step.</span></button>' +
          '<button type="button" class="sl-act" data-act="practise" style="--c:' + c.col + '">' + stk('practise', ICON.list) + '<b>Practise</b><span>Ten questions to work out and mark.</span></button>' +
          /* only a skill whose model can be ANSWERED offers this one */
          (sk.turnName ? '<button type="button" class="sl-act" data-act="turn" style="--c:' + c.col + '">' + stk('turn', ICON.flag) + '<b>' + esc(sk.turnName || 'Your turn') + '</b><span>' + esc(sk.turnBlurb || 'Answer on the model itself, step by step.') + '</span></button>' : '') +
          /* only a skill whose answer can be TYPED or TAPPED offers this one */
          (canRace(sk) ? '<button type="button" class="sl-act" data-act="speed" style="--c:' + c.col + '">' + stk('speed', ICON.clock) + '<b>Speed</b><span>Questions against the clock, timed one by one.</span></button>' : '') +
          '<button type="button" class="sl-act" data-act="board" style="--c:' + c.col + '">' + stk('board', ICON.board) + '<b>Board</b><span>A set of questions on the screen for a class.</span></button>' +
        '</div></div></div></div>');
    }
    elSk.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('button') : null; if (!t) return;
      var sk = curSkill(); if (!sk) return;
      if (t.getAttribute('data-fav')) { toggleFav(SL.get(t.getAttribute('data-fav'))); renderSkill(); return; }
      if (levelClick(t, sk)) { renderSkill(); return; }
      var act = t.getAttribute('data-act');
      if (act === 'practise') withSkills([sk.id], t, function () { S.from = 'skills'; buildSet(); show('practise'); });
      if (act === 'teach') withSkills([sk.id], t, function () { S.from = 'skills'; buildSet(); S.teach.i = 0; S.teach.back = null; show('teach'); });
      if (act === 'speed') { if (!canRace(sk)) return; S.from = 'skills'; show('speedsetup'); }
      if (act === 'turn') withSkills([sk.id], t, function () { S.from = 'skills'; startTurn(); show('turn'); });
      if (act === 'board') { S.from = 'skills'; show('boardsetup'); }
    });

    /* ============================================================
       BOARD SETUP
       ============================================================ */
    var elBs = $('slBoardSetup');
    /* Choosing how many, or how long, is a slider (Aadam, 2026-09-15), but only onto stops that make
       sense: no 27 questions, no 3 minutes 32. The readout sits over the track and every stop is
       named under it, and a stop can be clicked. The choice is taken when the thumb is let go. */
    function sliderHTML(key, stops, cur, big, small) {
      var i = stops.indexOf(cur), n = stops.length - 1;
      if (i < 0) i = 0;
      return '<div class="sl-slider" style="--p:' + (n ? i / n : 0) + '">' +
        '<output class="sl-slval num">' + big(stops[i]) + '</output>' +
        '<input type="range" class="sl-range" min="0" max="' + n + '" step="1" value="' + i + '" data-slider="' + key + '" aria-valuetext="' + esc(big(stops[i])) + '">' +
        '<div class="sl-slticks">' + stops.map(function (v, k) {
          return '<button type="button" class="sl-slstop num' + (k === i ? ' is-on' : '') + '" style="--k:' + (n ? k / n : 0) + '" data-slstop="' + k + '" tabindex="-1">' + small(v) + '</button>';
        }).join('') + '</div></div>';
    }
    /* while the thumb moves, the readout and the fill follow it */
    function sliderMove(inp, stops, big) {
      var wrap = inp.closest('.sl-slider'), k = Number(inp.value), n = stops.length - 1;
      if (!wrap) return;
      wrap.style.setProperty('--p', n ? k / n : 0);
      var o = wrap.querySelector('.sl-slval'); if (o) o.textContent = big(stops[k]);
      inp.setAttribute('aria-valuetext', big(stops[k]));
      Array.prototype.forEach.call(wrap.querySelectorAll('.sl-slstop'), function (b, j) { b.classList.toggle('is-on', j === k); });
    }
    var BOARD_N = [8, 16, 24];
    function boardNWords(v) { return v + ' questions'; }
    /* BOARD SETUP (2026-09-16, Aadam's pick): levels, layout and how many on the left; on the right
       the board itself, dealt, fitted at full size and scaled down, so what is on the setup is what
       the class gets. Show the board opens those questions; Deal again deals them afresh. */
    function boardSigFor(sk) { return [sk.id, selLevels(sk).join(','), S.board.layout, S.board.n].join('|'); }
    function bsMini(per) {
      var W = [78, 56, 88, 64, 72, 50];
      return '<span class="sl-mb" aria-hidden="true">' + [0, 1, 2].map(function (c) {
        return '<span class="mb-col"><i class="mb-h' + (per ? '' : ' is-plain') + '" style="--d:var(--t' + (c + 1) + ')"></i>' + [0, 1, 2, 3].map(function (r) {
          return '<i class="mb-l" style="--w:' + W[(r * 3 + c) % 6] + '%;--d:var(--t' + ((per ? c : r + c) % 3 + 1) + ')"></i>';
        }).join('') + '</span>';
      }).join('') + '</span>';
    }
    function renderBoardSetup() {
      var sk = curSkill(); if (!sk) { show('library'); return; }
      var sel = selLevels(sk), n = sk.levels.length, diff = S.board.layout === 'diff';
      var cols = diff ? diffLevels(sk) : [];
      var chosen = sel.length === 1 ? 'Level ' + sel[0] : (sel.length === n ? 'All ' + n + ' chosen' : sel.length + ' chosen');
      var lay = function (key, name, sub, per) {
        var on = S.board.layout === key;
        return '<button type="button" class="sl-bslay' + (on ? ' is-on' : '') + '" data-layout="' + key + '" aria-pressed="' + (on ? 'true' : 'false') + '">' + bsMini(per) + '<b>' + name + '</b><span>' + sub + '</span></button>';
      };
      var countRow = diff
        ? '<span class="sl-lvlnote">Eight questions in each column, up to three levels.' + (sel.length === 1 ? ' One level chosen, so the two above it fill the other columns.' : '') + '</span>'
        : '<span class="sl-bsh sl-bsh--sm">Questions</span><div class="sl-segwrap sl-bsn" data-mo-group="bcount">' + BOARD_N.map(function (v) {
            return '<button type="button" class="sl-seg num' + (v === S.board.n ? ' is-on' : '') + '" data-bn="' + v + '">' + v + '</button>';
          }).join('') + '</div>';
      var prevSub = diff ? 'Levels ' + cols.join(', ') : (sel.length === 1 ? 'Level ' + sel[0] : 'Levels ' + sel.join(', ') + ', taken in turn');
      paint(elBs, '<div class="sl-main"><div class="sl-scroll"><div class="sl-bsetup' + (entering ? ' is-enter' : '') + (n > 9 ? ' is-many' : '') + '">' +
        '<div class="sl-bsleft">' +
          '<div class="sl-bshead"><h2 class="sl-bsh">Levels</h2><span class="sl-bssub">' + chosen + '</span></div>' +
          levelListHTML(sk, true, diff ? 3 : 0) +
          '<div class="sl-bshead"><h2 class="sl-bsh">Layout</h2></div>' +
          '<div class="sl-bslays">' + lay('mix', 'Mixed', 'Levels taken in turn', false) + lay('diff', 'One column per level', 'A column for each level', true) + '</div>' +
          '<div class="sl-bsrow">' + countRow + '</div>' +
        '</div>' +
        '<div class="sl-bsright">' +
          '<div class="sl-bshead"><h2 class="sl-bsh">Preview</h2><span class="sl-bssub">' + prevSub + '</span><span class="sl-bs-sp"></span>' +
            '<button type="button" class="sl-btn sl-btn--sm" id="slBsDeal">' + ICON.refresh + 'Deal again</button></div>' +
          '<div class="sl-bprev" id="slBsPrev"><span class="sl-bprev-wait">Dealing the board</span></div>' +
          '<div class="sl-bsgo"><span class="sl-lvlnote">Answers start hidden.</span><span class="sl-bs-sp"></span>' +
            '<button type="button" class="sl-btn sl-btn--cta" id="slBoardGo">' + ICON.board + 'Show the board</button></div>' +
        '</div>' +
      '</div></div></div>');
      bsPreview(false);
    }
    var bsTok = 0;
    /* deals when the board on hand was not dealt for these settings, then draws; loads the engine
       itself (not withSkills), so a Show the board press while it loads keeps its own token */
    function bsPreview(redeal) {
      var host = $('slBsPrev'), sk = curSkill(); if (!host || !sk) return;
      var tok = ++bsTok;
      var draw = function () {
        if (tok !== bsTok || S.screen !== 'boardsetup' || !host.isConnected) return;
        var s2 = curSkill(); if (!s2 || !s2.make) return;
        if (redeal || S.from !== 'skills' || !S.board.cols.length || S.board.cols.bsSig !== boardSigFor(s2)) { S.from = 'skills'; buildBoard(); }
        bsDraw(host);
      };
      if (SL.ready(sk.id)) draw();
      else SL.ensure([sk.id]).then(draw, function () { if (tok === bsTok && host.isConnected) host.innerHTML = '<span class="sl-bprev-wait">The preview did not load. Show the board still works.</span>'; });
    }
    /* the real board at the size the board screen will have, fitted there, then scaled into the box */
    function bsDraw(host) {
      var cols = S.board.cols;
      if (!host.clientWidth || !host.clientHeight || !cols.length) return;
      var diffBoard = S.board.layout === 'diff', headChips = !diffBoard && !cols.some(function (c) { return c.mixed; });
      var W = Math.max(720, elBody.clientWidth), H = Math.max(420, elBody.clientHeight - (headChips ? 0 : 54));
      host.innerHTML = '<div class="sl-bprev-fit"><div class="sl-bprev-stage" inert aria-hidden="true" style="width:' + W + 'px;height:' + H + 'px"><div class="sl-board-main">' +
        '<div class="sl-board-cols n' + Math.min(6, cols.length) + '">' + boardColsHTML(cols, undefined, headChips) + '</div>' + boardFootHTML(cols) + '</div></div></div>';
      var stage = host.querySelector('.sl-bprev-stage'), fit = host.firstChild;
      fitBoard(stage);
      var k = Math.min(host.clientWidth / W, host.clientHeight / H);
      stage.style.transform = 'scale(' + k.toFixed(4) + ')';
      fit.style.width = Math.floor(W * k) + 'px'; fit.style.height = Math.floor(H * k) + 'px';
    }
    /* the columns of a differentiated board: the chosen levels, or the chosen one and the two above it */
    function diffLevels(sk) {
      var sel = selLevels(sk), n = sk.levels.length;
      if (sel.length > 1) return sel.slice(0, 3);
      var levels = [];
      for (var m = sel[0]; m <= n && levels.length < 3; m++) levels.push(m);
      while (levels.length < 3 && levels[0] > 1) levels.unshift(levels[0] - 1);
      return levels;
    }
    elBs.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('button') : null; if (!t) return;
      var sk = curSkill(); if (!sk) return;
      if (t.getAttribute('data-layout')) {
        S.board.layout = t.getAttribute('data-layout');
        /* one column per level shows three at most, so trim the choice to match */
        if (S.board.layout === 'diff' && selLevels(sk).length > 3) setSel(sk, selLevels(sk).slice(0, 3));
        save(); renderBoardSetup(); return;
      }
      if (t.hasAttribute('data-bn')) { S.board.n = Number(t.getAttribute('data-bn')) || S.board.n; save(); renderBoardSetup(); return; }
      if (levelClick(t, sk, S.board.layout === 'diff' ? 3 : 0)) { renderBoardSetup(); return; }
      if (t.id === 'slBsDeal') { bsPreview(true); return; }
      if (t.id === 'slBoardGo') withSkills([sk.id], t, function () {
        S.from = 'skills';
        if (!S.board.cols.length || S.board.cols.bsSig !== boardSigFor(curSkill())) buildBoard();
        else { setAllAns(false); S.board.tab = 0; }
        show('board');
      }, true);
    });

    /* ============================================================
       SETS
       ============================================================ */
    function makeItem(sk, lvl, ctx) { return { skill: sk, level: lvl, q: sk.make(lvl, ctx), state: 'hid' }; }
    /* where a question sits among the earlier questions of its skill and level, so a skill whose sets
       climb in a fixed order (quadratic formula) re-deals the SAME step when one question is refreshed (2026-09-15) */
    function slotIn(list, i) {
      var it = list[i], n = 0;
      for (var j = 0; j < i; j++) if (list[j] && list[j].skill === it.skill && list[j].level === it.level) n++;
      return n;
    }
    /* count questions for one skill, its chosen levels taken in turn */
    function dealFor(sk, count, ctx) {
      var levels = selLevels(sk), out = [];
      ctx = ctx || { seen: {}, shapeSeen: {}, last: null };
      for (var k = 0; k < count; k++) out.push(makeItem(sk, levels[k % levels.length], ctx));
      return out;
    }
    function buildSet() {
      var sks = activeSkills(), n = S.setN, queues = [], items = [];
      if (!sks.length) { S.set = []; return; }
      var per = Math.floor(n / sks.length), rem = n - per * sks.length;
      sks.forEach(function (sk, i) { queues.push(dealFor(sk, per + (i < rem ? 1 : 0))); });
      /* taken in turn: skill 1, skill 2, skill 1, skill 2 ... */
      for (var k = 0; items.length < n; k++) { var q = queues[k % queues.length]; if (q.length) items.push(q.shift()); else if (queues.every(function (x) { return !x.length; })) break; }
      S.set = items; S.prOne = -1;
    }
    function redealSkill(sk) {
      var count = S.set.filter(function (it) { return it.skill === sk; }).length, fresh = dealFor(sk, count), i = 0;
      S.set = S.set.map(function (it) { return it.skill === sk ? fresh[i++] : it; });
      S.prOne = -1;
    }
    function partlyMarked() { return S.set.some(function (it) { return it.state === 'ok' || it.state === 'miss'; }) && S.set.some(function (it) { return it.state !== 'ok' && it.state !== 'miss'; }); }
    function mark(it, got) {
      if (it.state === 'ok' || it.state === 'miss') return;
      it.state = got ? 'ok' : 'miss';
      var p = S.prog[it.skill.id] = S.prog[it.skill.id] || {};
      var r = p[it.level] = p[it.level] || { n: 0, ok: 0 };
      r.n++; if (got) r.ok++;
      FX.mark = S.set.indexOf(it); FX.count = true;
      trackSecure(it.skill, it.level, r);
      trackSet();
      save();
    }
    /* the rule the app tells people: ten marked at eight out of ten */
    function trackSecure(sk, level, r) {
      if (!sk || !r || r.n < 10 || r.ok / r.n < 0.8) return;
      var k = sk.id + '|' + level;
      if (trackedSecure[k]) return;
      trackedSecure[k] = 1;
      track('level_secure', { skill: sk.id, level: level, marked: r.n, correct: r.ok });
    }
    /* every question in the dealt set marked, once per deal */
    function trackSet() {
      if (!S.set.length || S.set.some(function (x) { return x.state !== 'ok' && x.state !== 'miss'; })) return;
      var sig = S.set.length + '|' + (S.set[0].key || S.set[0].q && S.set[0].q.key || '');
      if (trackedSet === sig) return;
      trackedSet = sig;
      track('set_marked', {
        skill: S.from === 'mixed' ? 'mixed' : (S.set[0].skill ? S.set[0].skill.id : ''),
        correct: S.set.filter(function (x) { return x.state === 'ok'; }).length,
        question_count: S.set.length
      });
    }

    /* ============================================================
       PRACTISE
       ============================================================ */
    var elPr = $('slPractise');
    function topicHTML(sk, max) {
      var c = colourOf(sk), sel = selLevels(sk), count = S.set.filter(function (it) { return it.skill === sk; }).length;
      var cap = max ? Math.min(max, sk.levels.length) : 0;
      var chips = sk.levels.map(function (L, i) {
        var k = i + 1, on = sel.indexOf(k) >= 0;
        if (S.screen === 'teach' && isMixLevel(sk, k)) return '';
        /* one column per level fits three, so a fourth is shown but not takeable */
        var off = cap && !on && sel.length >= cap;
        return '<button type="button" class="sl-chip sl-chip--lvl num' + (isMixLevel(sk, k) ? ' sl-chip--mix' : '') + (on ? ' sl-chip--now' : '') + (off ? ' is-off' : '') + '" data-togglelvl="' + k + '" aria-pressed="' + (on ? 'true' : 'false') + '"' + tipAttrs(sk, k) + '>' + chipText(sk, k) + '</button>';
      }).join('');
      return '<div class="sl-topic" data-topic="' + sk.id + '"><div class="thead"><span style="color:' + c.col + ';display:grid">' + skIcon(sk) + '</span><span class="tname">' + esc(sk.name) + '</span>' + (S.screen === 'practise' && S.from === 'mixed' ? '<span class="tcount">' + count + ' of ' + S.set.length + '</span>' : '') + '</div>' +
        '<div class="sl-lvlchips">' + chips + '</div>' +
        '<span class="tlname">' + esc(levelWord(sk)) + (sel.length > 1 ? ', in turn' : '') + '</span></div>';
    }
    /* On the board the strip was a whole band of chrome across the top - two
       rows of it with four skills - saying the same thing every column head
       already said. The chips move INTO the head, so the control sits on the
       thing it changes and the questions get the height back. It only works
       when a column IS one skill: a differentiated board is one skill at three
       levels, and a mixed column has no single skill, so those keep the strip. */
    function headChipsHTML(sk) {
      var sel = selLevels(sk);
      return '<div class="sl-topic sl-topic--bhead" data-topic="' + sk.id + '"><div class="sl-lvlchips">' + sk.levels.map(function (L, i) {
        var k = i + 1, on = sel.indexOf(k) >= 0;
        return '<button type="button" class="sl-chip sl-chip--lvl num' + (isMixLevel(sk, k) ? ' sl-chip--mix' : '') + (on ? ' sl-chip--now' : '') + '" data-togglelvl="' + k + '" aria-pressed="' + (on ? 'true' : 'false') + '"' + tipAttrs(sk, k) + '>' + chipText(sk, k) + '</button>';
      }).join('') + '</div></div>';
    }
    /* the level strip practise carries, reused by teach and by the board so a
       level can be changed where the questions are, not two screens back */
    function lvlStripHTML(tail, max) {
      return '<div class="sl-prbar">' + activeSkills().map(function (sk) { return topicHTML(sk, max); }).join('') +
        '<div class="sl-prbar-sp"></div>' + (tail || '') + '</div>';
    }
    /* Typing an answer. A plain number is one box. Anything else used to fall
       straight through - the toggle went on and every algebra card stayed
       tap-to-reveal, which read as the feature being broken - so a skill can now
       say how its answer splits with fields(q): the brackets skills hand back one
       box per COEFFICIENT with the x term printed beside it, so the pupil types
       the numbers and the shape of the answer is given to them. */
    function typeFields(it) {
      var sk = it.skill, fs = null;
      if (sk && typeof sk.fields === 'function') { try { fs = sk.fields(it.q); } catch (err) { fs = null; } }
      if (fs && fs.length) return fs;
      if (/^[\u2212-]?\d+(?:\.\d+)?$/.test(String(it.q.ansText || '').trim())) return [{ ans: String(it.q.ansText).trim(), w: 5 }];
      return null;
    }
    function canType(it) { return !!typeFields(it); }
    /* what counts as the same answer: numbers by VALUE (commas, spaces, a leading
       point, trailing decimal zeros and the minus glyph all forgiven), text by
       letters (case, spaces and hyphens forgiven), plus any string the skill lists
       in accepted, plus a skill's own norm() on the field (2026-09-09) */
    function canon(x) {
      var s = String(x === null || x === undefined ? '' : x).trim().toLowerCase().replace(/[\u2212\u2013\u2014]/g, '-').replace(/[,\s]/g, '').replace(/^\+/, '');
      if (/^-?(?:\d+\.?\d*|\.\d+)$/.test(s)) {
        var neg = s.charAt(0) === '-'; if (neg) s = s.slice(1);
        var parts = s.split('.'), ip = (parts[0] || '').replace(/^0+(?=\d)/, '') || '0', fp = (parts[1] || '').replace(/0+$/, '');
        return (neg && (ip !== '0' || fp) ? '-' : '') + ip + (fp ? '.' + fp : '');
      }
      return s.replace(/-/g, '');
    }
    function sameAnswer(a, b, accepted, norm) {
      if (typeof norm === 'function') { try { var na = norm(String(a || '')); if (na === '') return false; if (na === norm(String(b || ''))) return true; return (accepted || []).some(function (x) { return norm(String(x)) === na; }); } catch (err) {} }
      var ca = canon(a); if (ca === '') return false;
      if (ca === canon(b)) return true;
      return (accepted || []).some(function (x) { return canon(x) === ca; });
    }
    /* a skill can judge the whole typed answer itself with checkFields(q, vals) -> true/false
       (factorising: the two brackets may come in either order, so their boxes swap
       together, which box-by-box marking cannot see) (2026-09-15) */
    function fieldsRight(it, fs, vals, acc) {
      var sk = it && it.skill;
      if (sk && typeof sk.checkFields === 'function') { try { var r = sk.checkFields(it.q, vals); if (r === true || r === false) return r; } catch (err) {} }
      return fs.every(function (f, j) { return sameAnswer(vals[j], f.ans, f.accepted || acc || null, f.norm); });
    }
    /* PHONE ROUND: TYPE-IN + WALL FIT (2026-09-23). A phone's number pad has no minus key, so a box whose answer may be
       negative used to force the alphabet keyboard on the child and hide half the question behind it.
       A field marked sign: true prints the operator as a BUTTON instead - it starts at + and a tap
       (or typing - into the box) turns it into a minus - so the box only ever holds the size of the
       number and the keyboard can stay numeric. Aadam, 2026-09-23, on the sequences skills: "the +
       should already be there and it changes to a minus if they choose it". */
    function signHTML(i, j, lead) {
      return '<button type="button" class="af-sign' + (lead ? ' is-lead' : '') + '" data-sign="' + i + ':' + j + '" data-v="+"' +
        ' aria-label="Plus or minus for box ' + (j + 1) + ', tap to change" aria-pressed="false">+</button>';
    }
    /* FRACTION FIELDS (2026-09-25, Aadam: "use the actual divide symbol not forward slash"). A module marks
       a denominator with op '/': that field and every field after it are the denominator, and the
       numerator is the field before it, or the bracketed group that field closes. The pair is drawn
       STACKED, numerator over a bar over denominator, never "[ ] / [ ]". The brackets that only grouped a
       side for the slash go (a product of brackets keeps its own), and the words in front of the
       numerator ("x =") and a plain lead (the space after a mixed number's whole part) stay outside.
       The algebraic fraction skills stack their boxes with their own grid (asf-fb / afr-m markers) and
       are left as they are. DOM order, and so tab order and data-af, never changes. */
    var FF_OPEN = /\(\s*$/, FF_CLOSE = /\)\s*$/;
    function fracView(fs) {
      var d = -1, j, n0, opens = 0, v;
      if (!fs || fs.length < 2 || fs.some(function (f) { return /asf-fb|afr-m/.test(f.pre || ''); })) return null;
      for (j = 1; j < fs.length; j++) if (fs[j].op === '/') { d = j; break; }
      if (d < 0) return null;
      n0 = d - 1;
      if (FF_CLOSE.test(fs[d - 1].after || '')) for (j = d - 1; j >= 0; j--) if (FF_OPEN.test(fs[j].pre || '')) { n0 = j; break; }
      /* a coefficient and its surd are ONE numerator term: [3] root[5] over [5], not 3 beside root 5 over 5 */
      if (n0 === d - 1 && n0 > 0 && fs[n0].op === ' ' && /cs-radtick|<svg/.test(fs[n0].pre || '')) n0--;
      v = fs.map(function (f) { return { pre: f.pre || '', after: f.after || '', out: '' }; });
      if (FF_OPEN.test(v[n0].pre) && FF_CLOSE.test(v[d - 1].after)) { v[n0].pre = v[n0].pre.replace(FF_OPEN, ''); v[d - 1].after = v[d - 1].after.replace(FF_CLOSE, ''); }
      for (j = d; j < fs.length; j++) if (FF_OPEN.test(v[j].pre)) opens++;
      if (opens === 1 && FF_OPEN.test(v[d].pre) && FF_CLOSE.test(v[fs.length - 1].after)) { v[d].pre = v[d].pre.replace(FF_OPEN, ''); v[fs.length - 1].after = v[fs.length - 1].after.replace(FF_CLOSE, ''); }
      if (v[n0].pre && !/<svg|class="[^"]*(rt|rad)/.test(v[n0].pre)) { v[n0].out = v[n0].pre; v[n0].pre = ''; }
      return { n0: n0, d: d, v: v };
    }
    /* piece(f, j, view) -> { lead, body }: the renderer's own markup for one box, handed the view's pre/after;
       outer(html) wraps the words moved out in front of the fraction in that renderer's own class */
    function stackFields(fs, piece, outer) {
      var fv = fracView(fs), j, p, out = '', num = '', den = '';
      if (!fv) return fs.map(function (f, j) { var q = piece(f, j, { pre: f.pre || '', after: f.after || '' }); return q.lead + q.body; }).join('');
      for (j = 0; j < fs.length; j++) {
        p = piece(fs[j], j, fv.v[j]);
        if (j < fv.n0) out += p.lead + p.body;
        else if (j === fv.n0) { out += (fs[j].sign ? '' : p.lead) + (fv.v[j].out ? (outer ? outer(fv.v[j].out) : fv.v[j].out) : ''); num += (fs[j].sign ? p.lead : '') + p.body; }
        else if (j < fv.d) num += p.lead + p.body;
        else if (j === fv.d) den += (fs[j].sign ? p.lead : '') + p.body;
        else den += p.lead + p.body;
      }
      return out + '<span class="sl-ffr"><span class="sl-ffr-n">' + num + '</span><span class="sl-ffr-d">' + den + '</span></span>';
    }
    function fieldsHTML(fs, i) {
      return '<span class="sl-ansfields">' + stackFields(fs, function (f, j, vw) {
        return { lead: f.sign ? signHTML(i, j, !j) : j ? '<span class="af-op">' + (f.op || '+') + '</span>' : '', body:
          (vw.pre ? '<span class="af-t af-pre">' + vw.pre + '</span>' : '') +
          '<input type="text" class="sl-ansin num" data-ans="' + i + '" data-af="' + j + '" style="width:' + ((f.w || 4) + 2) + 'ch"' +
          (f.sign ? ' data-signed="1" inputmode="decimal"' : ' inputmode="text"') + ' autocomplete="off" spellcheck="false" placeholder="?" aria-label="' +
          esc(fs.length > 1 ? 'Question ' + (i + 1) + ', box ' + (j + 1) + ' of ' + fs.length : 'Your answer for question ' + (i + 1)) + '">' +
          (vw.after ? '<span class="af-t">' + vw.after + '</span>' : '') };
      }, function (h) { return '<span class="af-t af-pre">' + h + '</span>'; }) + '</span>';
    }
    /* the sign button that belongs to a box, and the box's answer with that sign on the front */
    function signBtn(box) {
      if (!box || !box.getAttribute('data-signed')) return null;
      var root = box.closest ? box.closest('.sl-ansfields') : null;
      return root ? root.querySelector('.af-sign[data-sign="' + box.getAttribute('data-ans') + ':' + box.getAttribute('data-af') + '"]') : null;
    }
    function signOf(box) { var b = signBtn(box); return b ? (b.getAttribute('data-v') || '+') : ''; }
    function setSign(btn, v) {
      btn.setAttribute('data-v', v);
      btn.textContent = v === '-' ? MINUS_CH : '+';
      btn.classList.toggle('is-neg', v === '-');
      btn.setAttribute('aria-pressed', v === '-' ? 'true' : 'false');
    }
    function boxVal(box) {
      var v = String(box.value).trim();
      return v && signOf(box) === '-' ? '-' + v : v;
    }
    var MINUS_CH = '\u2212';
    function boxesFor(i) { return elPr.querySelectorAll('[data-ans="' + i + '"]'); }
    /* Enter walks to the next empty box, and only marks once they are all filled */
    /* a field with blank: true may be left empty (a coefficient of 1, no x term, a denominator
       of 1): the skill's checkFields reads the empty box. Enter walks past it; at least one
       box must be filled before the answer is marked. */
    function mustFill(fs, k) { return !(fs && fs[k] && fs[k].blank); }
    function typedNext(i, from) {
      var boxes = boxesFor(i), fs = S.set[i] ? typeFields(S.set[i]) : null, k, any = false;
      for (k = 0; k < boxes.length; k++) if (String(boxes[k].value).trim()) any = true;
      for (k = from + 1; k < boxes.length; k++) if (!String(boxes[k].value).trim() && (mustFill(fs, k) || !any)) { boxes[k].focus(); return true; }
      for (k = 0; k < boxes.length; k++) if (!String(boxes[k].value).trim() && (mustFill(fs, k) || !any)) { boxes[k].focus(); return true; }
      return false;
    }
    function checkTyped(i) {
      var it = S.set[i]; if (!it || it.state !== 'hid') return;
      var fs = typeFields(it); if (!fs) return;
      var boxes = boxesFor(i); if (!boxes.length) return;
      var vals = [], k;
      for (k = 0; k < boxes.length; k++) vals.push(boxVal(boxes[k]));
      for (k = 0; k < boxes.length; k++) if (!String(vals[k]).trim() && mustFill(fs, k)) { boxes[k].focus(); return; }
      if (!vals.some(function (v) { return String(v).trim(); })) { boxes[0].focus(); return; }
      var acc1 = fs.length === 1 && it.q.data && it.q.data.accepted;
      var got = fieldsRight(it, fs, vals, acc1);
      it.typed = vals.join(', ');
      it.typedHTML = stackFields(fs, function (f, j, vw) {
        /* PHONE ROUND: TYPE-IN + WALL FIT (2026-09-23): a signed box shows the sign it was given, not a printed + */
        var v = String(vals[j]).trim(), neg = v.charAt(0) === '-';
        if (f.sign && neg) v = v.slice(1);
        return { lead: f.sign ? (j || neg ? '<span class="eb-op">' + (neg ? MINUS_CH : '+') + '</span>' : '')
          : j ? '<span class="eb-op">' + (f.op || '+') + '</span>' : '',
          body: (vw.pre ? '<span class="eb-op">' + vw.pre + '</span>' : '') + '<span class="eb-tm">' + esc(v) + vw.after + '</span>' };
      }, function (h) { return '<span class="eb-op">' + h + '</span>'; });
      mark(it, got); if (!got) FX.shake = i;
      renderPractise(); renderTop();
      var nx = nextHidden();
      if (nx >= 0) { var el2 = elPr.querySelector('[data-ans="' + nx + '"]'); if (el2) el2.focus(); }
    }
    /* one question swapped for another, the rest of the set left alone */
    function freshQuestion(i) {
      var it = S.set[i]; if (!it) return;
      var ctx = { seen: {}, shapeSeen: {}, last: null };
      S.set.forEach(function (x, n) { if (n !== i && x.skill === it.skill && x.q && x.q.key) ctx.seen[x.q.key] = 1; });
      ctx.slot = slotIn(S.set, i);
      S.set[i] = makeItem(it.skill, it.level, ctx);
      FX.swap = i;
      renderPractise(); renderTop();
    }
    function choicesHTML(ch, i, picked, done) {
      var sym = ch.options.every(function (o) { return el('div', null, String(o)).textContent.trim().length <= 2; });
      return '<span class="sl-choices' + (done ? ' is-done' : '') + (sym ? ' is-sym' : '') + '">' + ch.options.map(function (o, k) {
        var cls = 'sl-choice' + (done && k === ch.answer ? ' is-right' : '') + (done && picked === k && k !== ch.answer ? ' is-wrong' : '');
        return '<button type="button" class="' + cls + '" data-choice="' + i + '" data-opt="' + k + '"' + (done ? ' disabled' : '') + '><b>' + 'ABCDEF'.charAt(k) + '</b><span>' + o + '</span></button>';
      }).join('') + '</span>';
    }
    function qcardHTML(it, i) {
      var hid = it.state === 'hid';
      var qn = it.state === 'ok' ? '<span class="sl-qn ok" aria-label="Right">' + ICON.tick + '</span>' : it.state === 'miss' ? '<span class="sl-qn miss" aria-label="Missed">' + ICON.cross + '</span>' : '<span class="sl-qn num">' + (i + 1) + '</span>';
      var stepBtn = '<button type="button" class="sl-qsteps" data-steps="' + i + '" aria-label="Steps for question ' + (i + 1) + '" data-tip="Show the steps">' + ICON.steps + '</button>' +
        '<button type="button" class="sl-qsteps sl-qfresh" data-fresh="' + i + '" aria-label="A different question ' + (i + 1) + '" data-tip="New question">' + ICON.refresh + '</button>';
      var ch = it.q.choice || null;
      var fs = hid && S.typed && !ch ? typeFields(it) : null;
      var side, typeIt = !!fs;
      /* a choice question: the options are the answer box. Tap one to mark; shown
         (Show all answers) lights the right one and offers Got it / Missed it. */
      if (ch && hid) side = choicesHTML(ch, i, null, false);
      else if (ch && it.state === 'shown') side = choicesHTML(ch, i, null, true) + '<div class="sl-vbar"></div><button type="button" class="sl-btn sl-btn--sm sl-btn--on" data-mark="1" data-i="' + i + '">' + ICON.tick + 'Got it</button><button type="button" class="sl-btn sl-btn--sm sl-btn--bad" data-mark="0" data-i="' + i + '">' + ICON.cross + 'Missed it</button>';
      else if (ch) side = choicesHTML(ch, i, it.picked, true);
      else if (typeIt) side = fieldsHTML(fs, i) +
        '<button type="button" class="sl-btn sl-btn--sm" data-check="' + i + '">' + ICON.tick + 'Check</button>';
      else if (hid) side = '<span class="sl-tapq">Tap to see the answer</span>';
      else if (it.state === 'shown') side = '<span class="sl-expr sl-ans">' + it.q.ansHTML + '</span><div class="sl-vbar"></div><button type="button" class="sl-btn sl-btn--sm sl-btn--on" data-mark="1" data-i="' + i + '">' + ICON.tick + 'Got it</button><button type="button" class="sl-btn sl-btn--sm sl-btn--bad" data-mark="0" data-i="' + i + '">' + ICON.cross + 'Missed it</button>';
      else side = (it.typed && it.state === 'miss' ? '<span class="sl-expr sl-ans bad sl-yours">' + (it.typedHTML || esc(it.typed)) + '</span>' : '') +
        '<span class="sl-expr sl-ans' + (it.state === 'miss' && !it.typed ? ' bad' : '') + '">' + it.q.ansHTML + '</span>';
      /* one-shot notes from the click that caused this render: --i places the
         card in a deal, --d places a reveal in a Show-all cascade */
      var newly = FX.newly && FX.newly[i] !== undefined;
      var fx = (FX.reveal === i || newly ? ' is-reveal' : '') + (FX.mark === i ? ' is-marked' : '') + (FX.swap === i ? ' is-swap' : '') +
        (FX.shake === i ? ' is-shake' : '') + (FX.hidden && FX.hidden[i] ? ' is-hide' : '');
      return '<div class="sl-qcard' + (hid ? ' is-hid' : '') + (typeIt ? ' is-typing' : '') + (it.state === 'shown' ? ' is-mark' : '') + fx + '" style="--c:' + colourOf(it.skill).col + ';--i:' + i + ';--d:' + (newly ? FX.newly[i] : 0) + '"' +
        (hid && !typeIt && !ch ? ' data-reveal="' + i + '" role="button" tabindex="0" aria-label="Question ' + (i + 1) + ', tap to see the answer"' : '') + '>' + qn + stepBtn +
        '<div class="sl-qmain">' + (S.from === 'mixed' ? tagHTML(it.skill) : '') + '<span class="sl-expr">' + it.q.html + '</span></div><div class="sl-qside">' + side + '</div></div>';
    }
    /* NOT practise any more (one bar, 2026-09-16): teach and the board still carry a strip */
    function prBarHTML() {
      return lvlStripHTML(
        '<button type="button" class="sl-toggle' + (S.typed ? ' is-on' : '') + '" id="slTyped" aria-pressed="' + (S.typed ? 'true' : 'false') + '" title="Type the answer instead of revealing it"><i></i>Type the answer</button>' +
        '<button type="button" class="sl-btn sl-btn--sm sl-btn--ghost" id="slChangeR">' + ICON.book + (S.from === 'mixed' ? 'Change mix' : 'Change skill') + '</button>');
    }
    /* ============================================================
       PRACTISE CARDS + BOARD SETUP PREVIEW (2026-09-16)
       Aadam picked cards that open into one question. The wall is the set as
       clean cards: the number, the question, and the answer once it is marked.
       A tap opens that card as one big question with Show answer (or the
       typing boxes, or the choices), marking, the steps, a new question, and a
       strip along the foot to move between them. S.prOne is the open card,
       -1 the wall.
       ============================================================ */
    function qnHTML(it, i) {
      return it.state === 'ok' ? '<span class="sl-qn ok" aria-label="Right">' + ICON.tick + '</span>' : it.state === 'miss' ? '<span class="sl-qn miss" aria-label="Missed">' + ICON.cross + '</span>' : '<span class="sl-qn num">' + (i + 1) + '</span>';
    }
    function prFx(i) {
      var newly = FX.newly && FX.newly[i] !== undefined;
      return (FX.reveal === i || newly ? ' is-reveal' : '') + (FX.mark === i ? ' is-marked' : '') + (FX.swap === i ? ' is-swap' : '') + (FX.shake === i ? ' is-shake' : '');
    }
    function printRowHTML(it, i) {
      if (it.off) return '';
      return '<div class="sl-qcard"><span class="sl-qn num">' + (i + 1) + '</span><div class="sl-qmain">' + (S.from === 'mixed' ? tagHTML(it.skill) : '') + '<span class="sl-expr">' + it.q.html + '</span></div></div>';
    }
    /* CARD TAP + CARD TOOLS (2026-09-16). Aadam: the card is the button again, tap it to turn the
       answer over, tap it again to put it away. The three things you might do to a question sit in
       the top corner and only appear when the pointer is on the card (always, on a touch screen),
       so ten cards read as ten questions and nothing else. Hiding is about the QUESTION, not the
       answer: a hidden card is blank, so a class never sees it until it is shown again. */
    function pcardHTML(it, i) {
      var st = it.state, done = st === 'ok' || st === 'miss', newly = FX.newly && FX.newly[i] !== undefined;
      var off = !!it.off, n = i + 1;
      var tool = function (attr, label, tip, sub, icon) {
        return '<span class="wc-tool" ' + attr + ' role="button" tabindex="0" aria-label="' + label + '" data-tip="' + tip + '"' + (sub ? ' data-tipsub="' + sub + '"' : '') + '>' + icon + '</span>';
      };
      var tools = '<span class="wc-tools">' +
        (off ? '' :
          tool('data-openq="' + i + '"', 'Open question ' + n, 'Open this question', 'The question on its own, with the steps and marking.', ICON.expand) +
          tool('data-fresh="' + i + '"', 'A different question ' + n, 'New question', 'Swaps this one for another at the same level.', ICON.refresh)) +
        tool('data-off="' + i + '"', (off ? 'Show question ' : 'Hide question ') + n, off ? 'Show this question' : 'Hide this question',
             off ? '' : 'Blanks the card, so the class does not see it.', off ? ICON.eye : ICON.eyeOff) +
        '</span>';
      var body = off
        ? '<span class="wc-q wc-blank"><span class="wc-hlab">' + ICON.eyeOff + 'Hidden</span></span><span class="wc-foot"></span>'
        : '<span class="wc-q"><span class="sl-expr">' + it.q.html + '</span></span>' +
          '<span class="wc-foot">' + (done || st === 'shown' ? '<span class="sl-expr sl-ans">' + it.q.ansHTML + '</span>' : '') + '</span>';
      var says = off ? 'Question ' + n + ', hidden. Show it'
        : st === 'ok' ? 'Question ' + n + ', right'
        : st === 'miss' ? 'Question ' + n + ', missed'
        : st === 'shown' ? 'Question ' + n + ', put the answer away'
        : 'Question ' + n + ', show the answer';
      return '<button type="button" class="sl-wallcard is-' + st + (off ? ' is-blank' : '') + prFx(i) + '" data-cardtap="' + i + '" style="--c:' + colourOf(it.skill).col + ';--i:' + i + ';--d:' + (newly ? FX.newly[i] : 0) + '" aria-label="' + says + '">' +
        '<span class="wc-top">' + qnHTML(it, i) + (S.from === 'mixed' && !off ? tagHTML(it.skill) : '') + tools + '</span>' +
        body + '</button>';
    }
    /* hidden is the tutor's own doing, so it survives a reveal or a mark; a fresh deal clears it
       because the item itself is new */
    function toggleOff(i) {
      var it = S.set[i]; if (!it) return;
      it.off = !it.off;
      renderPractise(); renderTop();
    }
    function wallHTML(enter) {
      var n = S.set.length, cols = Math.min(5, n);
      return '<div class="sl-pwall' + (enter ? ' is-enter' : '') + '" style="--cols:' + cols + ';--rows:' + Math.ceil(n / cols) + '">' + S.set.map(pcardHTML).join('') + '</div>';
    }
    function markBtnsHTML(i) {
      return '<span class="po-mark"><button type="button" class="sl-btn sl-btn--on" data-mark="1" data-i="' + i + '" data-tip="Got it" data-tipsub="Key: C">' + ICON.tick + 'Got it</button>' +
        '<button type="button" class="sl-btn sl-btn--bad" data-mark="0" data-i="' + i + '" data-tip="Missed it" data-tipsub="Key: X">' + ICON.cross + 'Missed it</button></span>';
    }
    function oneHTML(i, opened) {
      var it = S.set[i], n = S.set.length, st = it.state, ch = it.q.choice || null, done = st === 'ok' || st === 'miss';
      var fs = st === 'hid' && S.typed && !ch ? typeFields(it) : null, act;
      if (ch && st === 'hid') act = choicesHTML(ch, i, null, false);
      else if (ch && st === 'shown') act = choicesHTML(ch, i, null, true) + markBtnsHTML(i) + '<button type="button" class="sl-btn sl-btn--ghost po-hide" data-hide="' + i + '" aria-label="Hide this answer">' + ICON.eyeOff + '<span class="po-lbl">Hide</span></button>';
      else if (ch) act = choicesHTML(ch, i, it.picked, true);
      else if (fs) act = fieldsHTML(fs, i) + '<button type="button" class="sl-btn sl-btn--on po-check" data-check="' + i + '">' + ICON.tick + 'Check</button>';
      else if (st === 'hid') act = '<button type="button" class="po-show" data-reveal="' + i + '">' + ICON.eye + 'Show answer</button>';
      else if (st === 'shown') act = '<span class="sl-expr sl-ans">' + it.q.ansHTML + '</span>' + markBtnsHTML(i) + '<button type="button" class="sl-btn sl-btn--ghost po-hide" data-hide="' + i + '" aria-label="Hide this answer">' + ICON.eyeOff + '<span class="po-lbl">Hide</span></button>';
      else act = (it.typed && st === 'miss' ? '<span class="sl-expr sl-ans bad sl-yours">' + (it.typedHTML || esc(it.typed)) + '</span>' : '') +
        '<span class="sl-expr sl-ans' + (st === 'miss' ? ' bad' : ' ok') + '">' + it.q.ansHTML + '</span>';
      if (done) act += i < n - 1
        ? '<button type="button" class="sl-btn sl-btn--cta po-next" data-goto="' + (i + 1) + '">Next question' + ICON.chevR + '</button>'
        : '<button type="button" class="sl-btn sl-btn--cta po-next" data-wall="1">' + ICON.grid + 'All cards</button>';
      var tile = function (x, k) {
        var s = x.state;
        return '<button type="button" class="po-tile num' + (k === i ? ' is-now' : '') + (x.off ? ' is-blank' : '') + (s === 'ok' ? ' is-ok' : s === 'miss' ? ' is-miss' : s === 'shown' ? ' is-shown' : '') + '" data-goto="' + k + '" aria-label="Question ' + (k + 1) + (s === 'ok' ? ', right' : s === 'miss' ? ', missed' : '') + '"' + (k === i ? ' aria-current="true"' : '') + '>' +
          (s === 'ok' ? ICON.tick : s === 'miss' ? ICON.cross : '') + (k + 1) + '</button>';
      };
      return '<div class="sl-pone' + (opened ? ' is-cardopen' : '') + '">' +
        '<div class="po-meta"><span class="po-count num">Question <b>' + (i + 1) + '</b> of ' + n + '</span>' +
          (S.from === 'mixed' ? tagHTML(it.skill) : '') + '<span class="po-lvl">Level ' + it.level + ' · ' + esc(levelName(it.skill, it.level)) + '</span><span class="sl-bs-sp"></span>' +
          '<button type="button" class="sl-btn sl-btn--sm" data-steps="' + i + '">' + ICON.steps + '<span class="po-lbl">Show the steps</span></button>' +
          '<button type="button" class="sl-btn sl-btn--sm" data-fresh="' + i + '">' + ICON.refresh + '<span class="po-lbl">New question</span></button></div>' +
        '<div class="po-stage"><div class="po-card is-' + st + prFx(i) + '" style="--c:' + colourOf(it.skill).col + '">' +
          '<div class="po-q"><span class="sl-expr">' + it.q.html + '</span></div>' +
          '<div class="po-act">' + act + '</div></div></div>' +
        '<div class="po-dock"><span class="po-dl"><button type="button" class="sl-btn po-all" data-wall="1">' + ICON.grid + '<span class="po-lbl">All cards</span></button></span>' +
          '<span class="po-nav"><button type="button" class="sl-iconbtn sl-iconbtn--sq po-arrow" data-goto="' + (i - 1) + '" aria-label="Previous question"' + (i ? '' : ' disabled') + '>' + ICON.chevL + '</button>' +
          /* PHONE ROUND 2: OPEN QUESTION FILLS THE SCREEN (2026-09-23): ten numbered tiles need about 460px, so on a phone half of
             them sat off the side behind the arrow. There the strip says where you are instead. */
          '<span class="po-pos num" aria-hidden="true"><b>' + (i + 1) + '</b> of ' + n + '</span>' +
          '<span class="po-tiles">' + S.set.map(tile).join('') + '</span>' +
          '<button type="button" class="sl-iconbtn sl-iconbtn--sq po-arrow" data-goto="' + (i + 1) + '" aria-label="Next question"' + (i < n - 1 ? '' : ' disabled') + '>' + ICON.chevR + '</button></span><span class="po-dr"></span></div>' +
        '</div>';
    }
    /* PHONE ROUND: TYPE-IN + WALL FIT (2026-09-23). The on-screen keyboard takes half a phone's screen, and the browser only
       scrolls a focused field into view when the PAGE scrolls - every Skills Lab screen scrolls inside
       a box, so a box low on the screen ended up behind the keyboard with nothing to do about it.
       On focus, once the keyboard has settled, the box is brought back above it. Does nothing where
       there is no keyboard (visualViewport unchanged), so a laptop is untouched. */
    function keepAbove(box) {
      if (!box || !window.visualViewport) return;
      setTimeout(function () {
        var vv = window.visualViewport, r = box.getBoundingClientRect(), over = r.bottom + 18 - (vv.offsetTop + vv.height), sc, sb;
        if (!(over > 0)) return;
        sc = box.closest ? box.closest('.po-stage, .sl-scroll, .sl-prscroll') : null;
        if (sc && sc.scrollHeight > sc.clientHeight + 2) { sb = sc.style.scrollBehavior; sc.style.scrollBehavior = 'auto'; sc.scrollTop += over; sc.style.scrollBehavior = sb; }
        else if (box.scrollIntoView) { try { box.scrollIntoView({ block: 'center' }); } catch (err) {} }
      }, 320);
    }
    elPr.addEventListener('focusin', function (e) {
      var b = e.target; if (b && b.classList && b.classList.contains('sl-ansin')) keepAbove(b);
    });
    function openCard(i) {
      if (!(i >= 0 && i < S.set.length)) return;
      S.prOne = i; renderPractise(); renderTop();
      /* the keyboard lands where the next press is: the typing box, or Show answer */
      var f = elPr.querySelector('.po-act [data-ans], .po-show');
      if (f) { try { f.focus({ preventScroll: true }); } catch (err) {} }
    }
    function toWall() {
      var was = S.prOne; S.prOne = -1; renderPractise(); renderTop();
      var c = elPr.querySelector('.sl-wallcard[data-cardtap="' + was + '"]');
      if (c) { try { c.focus({ preventScroll: true }); } catch (err) {} }
    }
    /* The type on a card, and on the open question, is as big as its box lets it be. A sum or an
       expression stays on one line down to 60% and only then wraps (a chain broken before a "+" is
       harder to add up); words wrap from the start. Every box searches at once, seven halvings a
       pass, so a pass costs seven layouts. A box that grows to fit (a phone's cards) is only held
       to its width. */
    var PFIT_MIN = 0.34;
    /* SMARTBOARD PRACTISE CARDS (2026-09-21): a board's answer strip is taller, so its answer can be read from the
       back. On a wall of tall questions (tables, long sentences) that height is worth more to the questions: when three
       or more cards' questions have had to shrink to their height, the strip goes back to its old height and the wall
       is fitted again. */
    /* PHONE ROUND: TYPE-IN + WALL FIT (2026-09-23). Aadam, 2026-09-23: "some of the place value ordering questions can't be
       seen properly - need to fix their layouts so they work with mobiles of different sizes".
       Two (or three) cards to a row is right for a sum and wrong for a table: a five-column table
       in a 170px card fitted its labels at 7px, and every skill with a note, a word problem or a
       chart under the question did the same. A card is measured, not guessed at: if its question's
       own type falls under 15px, or ANY text inside it under 10px, the card takes the whole row and
       is fitted again at that width; if it is still under, the card grows downwards, which a
       scrolling wall can afford and a fixed grid cannot. Nothing changes above 860px. */
    var PW_MAIN = 15, PW_LEAF = 10;
    function flowWall() { try { return window.innerWidth <= 860; } catch (e) { return false; } }
    /* a superscript index is a mark, not text to read: the 2 in x² is 0.6em by design and would
       otherwise drag every algebra card under the floor on its own */
    function isMark(e) {
      if (e.tagName === 'SUP' || e.tagName === 'SUB') return true;
      var va = window.getComputedStyle(e).verticalAlign;
      return va === 'super' || va === 'sub';
    }
    function leafMin(box) {
      var min = 99;
      each(box.querySelectorAll('*'), function (e) {
        if (e.children.length || !(e.textContent || '').trim()) return;
        if (!e.offsetWidth && !e.offsetHeight) return;
        var cs = window.getComputedStyle(e), f;
        if (cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return;
        if (isMark(e) || (e.parentNode && e.parentNode.nodeType === 1 && isMark(e.parentNode))) return;
        f = parseFloat(cs.fontSize); if (f && f < min) min = f;
      });
      return min;
    }
    /* 0 when the card reads, else how far under the floor it is (0.5 = half the size it needs) */
    function underFloor(q) {
      var ex = q.querySelector('.sl-expr'); if (!ex) return 0;
      var r = Math.min((parseFloat(window.getComputedStyle(ex).fontSize) || 99) / PW_MAIN, leafMin(q) / PW_LEAF);
      /* 0.999, not 0.995: a question at 14.94px sat inside the old half-percent slack, was never widened, and
         read 14.9px on a 390 phone (completing the square L10, "Solve 3x2 + 24x = -18" and longer, 2026-09-26) */
      return r < 0.999 ? Math.max(r, 0.2) : 0;
    }
    function phoneWall(wall) {
      var again = false;
      each(wall.querySelectorAll('.sl-wallcard'), function (c) {
        if (c.classList.contains('is-blank')) return;
        var q = c.querySelector('.wc-q'), ex = q && q.querySelector('.sl-expr'), r = q ? underFloor(q) : 0, k, need;
        if (!ex || !r) return;
        if (!c.classList.contains('is-wide')) { c.classList.add('is-wide'); again = true; return; }
        if (ex.classList.contains('is-sumline') && !c.classList.contains('is-wrapsum')) { c.classList.add('is-wrapsum'); again = true; return; }
        k = parseFloat(ex.style.getPropertyValue('--k')) || 1;
        /* a tenth over what it needs, so a card 0.1px under the floor still buys the room to
           clear it and the second fit is not a no-op */
        ex.style.setProperty('--k', (k * Math.min(2.4, 1.1 / r)).toFixed(3));
        need = Math.ceil(Math.max(ex.offsetHeight, ex.scrollHeight)) + 6;
        ex.style.setProperty('--k', k.toFixed(3));
        need = Math.min(Math.max(need, Math.ceil(q.clientHeight * 1.06)), Math.round((window.innerHeight || 700) * 0.62));
        if (need > q.clientHeight) { q.style.minHeight = need + 'px'; again = true; }
      });
      return again;
    }
    function fitPractise() {
      var wall = elPr.querySelector('.sl-pwall'), tall = 0, pass;
      if (wall) wall.classList.remove('is-tallq');
      if (wall && flowWall()) each(wall.querySelectorAll('.sl-wallcard'), function (c) {
        c.classList.remove('is-wide', 'is-wrapsum');
        var q = c.querySelector('.wc-q'); if (q) q.style.removeProperty('min-height');
      });
      fitCards();
      if (wall && flowWall()) {
        for (pass = 0; pass < 3 && phoneWall(wall); pass++) fitCards();
        /* the height was bought against the size the card WANTED; once it has been fitted at that
           height, give back whatever the question did not use, so a card is never mostly air */
        each(wall.querySelectorAll('.sl-wallcard.is-wide'), function (c) {
          var q = c.querySelector('.wc-q'), ex = q && q.querySelector('.sl-expr'), had, want;
          if (!q || !ex || !q.style.minHeight) return;
          had = parseFloat(q.style.minHeight) || 0;
          want = Math.ceil(Math.max(ex.offsetHeight, ex.scrollHeight)) + 8;
          if (want < had) q.style.minHeight = want + 'px';
        });
      }
      floorType(elPr);
      if (wall && window.innerWidth > 860) {
        each(wall.querySelectorAll('.wc-q'), function (b) {
          var ex = b.querySelector('.sl-expr'), k = ex ? parseFloat(ex.style.getPropertyValue('--k')) || 1 : 1;
          if (ex && k < 0.97 && ex.offsetHeight >= b.clientHeight * 0.85) tall++;
        });
        if (tall >= 3) { wall.classList.add('is-tallq'); fitCards(); }
      }
      watchPoQ();
    }
    /* the open question's box is what is left after its answer row, and that row can change after the fit (a web font
       landing re-wraps long choices), so the box is watched and the question fitted again when its height moves */
    var poRO = null, poH = 0;
    function watchPoQ() {
      if (!window.ResizeObserver) return;
      var q = elPr.querySelector('.po-q');
      if (!poRO) poRO = new ResizeObserver(function () {
        var q2 = elPr.querySelector('.po-q');
        if (q2 && Math.abs(q2.clientHeight - poH) > 2) { poH = q2.clientHeight; refitCards(); }
      });
      poRO.disconnect();
      if (q) { poH = q.clientHeight; poRO.observe(q); }
    }
    function fitCards() {
      var todo = [];
      /* SMARTBOARD PRACTISE CARDS (2026-09-21): kind = wq/wa (a card's question/answer), pq/pa (the open question's);
         a question drawn as patterns (matchsticks) is a picture, not a sentence, so it gets is-pics and no word sizing */
      function add(box, ex, useH, tight, kind) {
        if (!box || !ex) return;
        ex.style.removeProperty('--k'); ex.classList.remove('is-sumline', 'is-cswrap');
        if (tight || kind === 'pa') box.classList.remove('is-ans2');
        var pics = !!ex.querySelector('.sq-pats');
        var words = !pics && (!!ex.querySelector('.ct-words, .pt-words, .pv-w, .pv-two') || /[a-z]{3,}/i.test(ex.textContent.replace(/\b(?:sqrt|surd)\b/gi, '')));
        ex.classList.toggle('is-wordq', words); ex.classList.toggle('is-pics', pics);
        /* PHONE ROUND 3: TEACH + BOARD ON A PHONE (2026-09-23): a card marked is-wrapsum has already been given the whole row
           and its height and is STILL under the floor, so its sum is allowed to wrap between terms */
        if (!words && !(box.parentNode && box.parentNode.classList && box.parentNode.classList.contains('is-wrapsum'))) ex.classList.add('is-sumline');
        todo.push({ box: box, ex: ex, h: useH, words: words, pics: pics, tight: !!tight, kind: kind });
      }
      each(elPr.querySelectorAll('.sl-wallcard'), function (c) {
        add(c.querySelector('.wc-q'), c.querySelector('.wc-q > .sl-expr'), true, false, 'wq');
        add(c.querySelector('.wc-foot'), c.querySelector('.wc-foot > .sl-ans'), false, true, 'wa');
      });
      var po = elPr.querySelector('.po-card');
      if (po) {
        add(po.querySelector('.po-q'), po.querySelector('.po-q > .sl-expr'), true, false, 'pq');
        each(po.querySelectorAll('.po-act > .sl-ans'), function (a) { add(po.querySelector('.po-act'), a, false, false, 'pa'); });
      }
      todo = todo.filter(function (t) { return t.box.clientWidth > 0; });
      if (!todo.length) return;
      /* clientWidth counts the padding, and a tight row (the card's answer strip) also shares its
         width with the hide button, so both come off before anything is measured against it */
      function avail(t) {
        var cs = window.getComputedStyle(t.box), w = t.box.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
        if (t.tight) {
          var gap = parseFloat(cs.columnGap) || parseFloat(cs.gap) || 0, ch = t.box.children, k;
          for (k = 0; k < ch.length; k++) if (ch[k] !== t.ex) w -= ch[k].offsetWidth + gap;
        }
        return Math.max(40, w);
      }
      /* SMARTBOARD PRACTISE CARDS: the content's own rectangle is measured too, since offsetHeight and scrollWidth
         round to whole pixels (a six-line question 1.6px taller than its card read as fitting) */
      function fits(t) {
        if (t.ex.scrollWidth > avail(t) + 1) return false;
        var rg = document.createRange(), r;
        rg.selectNodeContents(t.ex); r = rg.getBoundingClientRect();
        if (r.width > avail(t) + 0.5) return false;
        return !t.h || Math.max(t.ex.offsetHeight, r.height) <= innerH(t) + 0.5;
      }
      /* a wrapped answer on a card's strip: as wide as the strip, and at most t.lines lines (the strip grows) */
      function fitsLines(t) {
        if (t.ex.scrollWidth > avail(t) + 1) return false;
        var cs = window.getComputedStyle(t.ex), bs = window.getComputedStyle(t.box);
        var lh = parseFloat(cs.lineHeight) || (parseFloat(cs.fontSize) || 16) * 1.15;
        var inner = t.box.clientHeight - (parseFloat(bs.paddingTop) || 0) - (parseFloat(bs.paddingBottom) || 0);
        return t.ex.offsetHeight <= Math.min(inner, lh * t.lines) + 1;
      }
      /* a verb question wrapped (is-cswrap): fits as before, and every term after the verb is on one row */
      function fitsCsWrap(t) {
        if (!fits(t)) return false;
        var kids = t.ex.firstElementChild.children, a = null, r, k;
        for (k = 1; k < kids.length; k++) {
          r = kids[k].getBoundingClientRect(); if (!r.width) continue;
          if (!a) { a = r; continue; }
          if (r.top >= a.bottom - 1 || r.bottom <= a.top + 1) return false;
        }
        return true;
      }
      function search(list, floor, test, ceil) {
        list.forEach(function (t) { t.lo = floor(t); t.hi = ceil ? ceil(t) : 1; });
        for (var r = 0; r < 7; r++) {
          list.forEach(function (t) { t.k = (t.lo + t.hi) / 2; t.ex.style.setProperty('--k', t.k.toFixed(3)); });
          list.forEach(function (t) { if ((test || fits)(t)) t.lo = t.k; else t.hi = t.k; });
        }
        list.forEach(function (t) { t.ex.style.setProperty('--k', t.lo.toFixed(3)); });
      }
      /* SMARTBOARD PRACTISE CARDS (2026-09-21). Aadam: "imagine it will be on a smartboard ... if you can make it larger
         without obstructing do so". Type used to stop at its CSS size, so a short sum sat small in a big card. Whatever
         fits now GROWS until its box is nearly full (the box's side padding and a tenth of its height kept as air), up to
         a ceiling tied to the screen height, so "7 + 5" is big but not absurd; sentences stop sooner than sums. A box
         that grows with its content (the scrolling wall under 861px, the open card on a phone) keeps its CSS size. */
      var vh = window.innerHeight || 800, flow = !!(window.matchMedia && window.matchMedia('(max-width: 860px)').matches), phone = narrow();
      function innerH(t) {
        var bs = window.getComputedStyle(t.box);
        return t.box.getBoundingClientRect().height - (parseFloat(bs.borderTopWidth) || 0) - (parseFloat(bs.borderBottomWidth) || 0) -
          (parseFloat(bs.paddingTop) || 0) - (parseFloat(bs.paddingBottom) || 0);
      }
      function capOf(t) {
        /* PHONE ROUND 2: OPEN QUESTION FILLS THE SCREEN (2026-09-23): the open card now fills a phone's screen, so the
           question is allowed to grow into it - it is the one thing being looked at. The wall's
           cards still keep their CSS size when they flow, since there the space is the next card's. */
        var ih = innerH(t), c = t.kind === 'wq' ? (flow ? 0 : Math.min(vh * 0.1, ih * 0.34))
          : t.kind === 'wa' ? (flow ? 0 : ih * 0.64)
          : t.kind === 'pq' ? (phone ? Math.min(vh * 0.12, ih * 0.34) : Math.min(vh * 0.13, ih * 0.3))
          : t.kind === 'pa' ? (phone ? vh * 0.075 : vh * 0.092) : 0;
        return t.words ? c * 0.74 : c;
      }
      /* fits, with air: a question keeps a tenth of its box's height free and a one-line sum keeps off the card's
         sides (a sentence or a picture wraps, so it is only held to fitting); an answer stays off its strip's edges */
      function roomy(t) {
        if (!fits(t)) return false;
        var rg = document.createRange(), r, h;
        rg.selectNodeContents(t.ex); r = rg.getBoundingClientRect(); h = Math.max(t.ex.offsetHeight, r.height);
        if (t.h) return (t.words || t.pics || r.width <= avail(t) * 0.93) && h <= innerH(t) * 0.9;
        if (r.width > avail(t) * 0.94 + 1) return false;
        return t.kind !== 'wa' || h <= innerH(t) * 0.9 + 1;
      }
      function grow(list) {
        list = list.filter(function (t) {
          t.b = parseFloat(window.getComputedStyle(t.ex).fontSize) || 16; t.kmax = capOf(t) / t.b;
          return t.kmax > 1.03 && roomy(t);
        });
        if (list.length) search(list, function () { return 1; }, roomy, function (t) { return t.kmax; });
        list.forEach(function (t) { t.gf = t.b * t.lo; });
      }
      /* LONG ANSWERS ON TWO LINES (2026-09-21). Aadam: "if the answer is v long - fit onto two lines and make
         the text larger". A card's answer strip was one line, so a number in words shrank to the floor and was
         still cut off. A words answer that would have to shrink wraps instead: two lines, a third only when two
         would be under 15px, and more (up to six, on a phone's narrow card) only while it is under 13px (a
         263px card's twelve-word number is 10px on two lines). The strip grows to hold it, and this runs before the questions are fitted, so each
         question is sized to the space that is left. */
      function fitLong(t) {
        var k1, f1, fit1, base, room = innerH(t) - 12, lift;
        search([t], function () { return PFIT_MIN; });
        k1 = t.lo; fit1 = fits(t); base = (parseFloat(window.getComputedStyle(t.ex).fontSize) || 16) / k1;
        /* SMARTBOARD PRACTISE CARDS: n lines may be as big as n lines fill the strip's own height, so on a board the
           strip holds two big lines rather than one small one, and does not grow */
        lift = function (n) { return (t.kind === 'pa' ? phone : flow) ? 1 : Math.max(1, room / (n * 1.16) / base); };
        if (fit1 && k1 >= 0.8 && lift(2) <= k1 * 1.08) return;
        f1 = base * k1;
        t.box.classList.add('is-ans2');
        for (var n = 2; n <= 6; n++) {
          t.lines = n; search([t], function () { return PFIT_MIN; }, fitsLines, function () { return lift(n); });
          if (fitsLines(t) && base * t.lo >= (n === 2 ? 15 : 13)) break;
        }
        if (fit1 && base * t.lo <= f1 * 1.08) { t.box.classList.remove('is-ans2'); t.ex.style.setProperty('--k', k1.toFixed(3)); }
      }
      /* SMARTBOARD PRACTISE CARDS: a list of numbers ("980,000, 98,000, 9,800") wraps between its numbers like words do */
      var longs = todo.filter(function (t) { return (t.tight || t.kind === 'pa') && (t.words || /\d, /.test(t.ex.textContent)) && !fits(t); });
      longs.forEach(fitLong);
      todo = todo.filter(function (t) { return longs.indexOf(t) < 0; });
      /* answers first, because the open question's answer takes its room from the question */
      grow(todo.filter(function (t) { return !t.h; }));
      grow(todo.filter(function (t) { return t.h; }));
      /* ten cards read as one set: on the wall a short question stops at 1.2 times the middle size of its sort */
      ['s', 'w', 'p'].forEach(function (y) {
        var g = todo.filter(function (t) { return t.kind === 'wq' && (t.pics ? 'p' : t.words ? 'w' : 's') === y; }), fs, top;
        if (g.length < 3) return;
        fs = g.map(function (t) { return t.gf || t.b || 0; }).sort(function (a, b) { return a - b; });
        top = fs[Math.floor((fs.length - 1) / 2)] * 1.2;
        g.forEach(function (t) { if (t.gf && t.gf > top) t.ex.style.setProperty('--k', (t.lo * top / t.gf).toFixed(3)); });
      });
      var over = todo.filter(function (t) { return !fits(t); });
      if (!over.length) return;
      search(over, function (t) { return t.words ? PFIT_MIN : 0.6; });
      /* a sum that still does not fit at 60% on one line may wrap, and comes down again from there */
      var wrap = over.filter(function (t) { return !t.words && !fits(t); });
      wrap.forEach(function (t) { t.ex.classList.remove('is-sumline'); t.ex.style.removeProperty('--k'); });
      wrap = wrap.filter(function (t) { return !fits(t); });
      if (wrap.length) search(wrap, function () { return PFIT_MIN; });
      /* VERB QUESTIONS WRAP (2026-09-21). A cs-q question that opens with its verb ("Second difference and coefficient of
         n²", "nth term", "Which term of") and had to shrink hard, or never fitted, tries the verb on its own line
         with the terms under it, and keeps that when the type comes out bigger or one line never fitted. */
      var csw = over.filter(function (t) {
        var q = t.h && t.words ? t.ex.firstElementChild : null;
        return q && q.classList.contains('cs-q') && q.firstElementChild && q.firstElementChild.classList.contains('cs-verb') && (t.lo < 0.8 || !fits(t));
      });
      if (!csw.length) return;
      csw.forEach(function (t) { t.k1 = t.lo; t.fit1 = fits(t); t.ex.classList.add('is-cswrap'); });
      search(csw, function () { return PFIT_MIN; }, fitsCsWrap);
      csw.forEach(function (t) {
        if (!t.fit1 || t.lo > t.k1 * 1.08) return;
        t.ex.classList.remove('is-cswrap'); t.ex.style.setProperty('--k', t.k1.toFixed(3));
      });
    }
    var cardFitT = null, prRO = null;
    function refitCards() {
      if (!shell.classList.contains('is-on')) return;
      clearTimeout(cardFitT);
      cardFitT = setTimeout(function () {
        if (S.screen === 'practise') fitPractise();
        else if (S.screen === 'boardsetup') { var h = $('slBsPrev'); if (h && S.board.cols.length) bsDraw(h); }
      }, 120);
    }
    /* the top bar wraps once its font lands, which takes height off the cards: watch the screen */
    function watchPractise() {
      if (prRO || !window.ResizeObserver) return;
      var lw = 0, lh = 0;
      prRO = new ResizeObserver(function () {
        var w = elPr.clientWidth, h = elPr.clientHeight;
        if (!w || (Math.abs(w - lw) < 2 && Math.abs(h - lh) < 2)) return;
        lw = w; lh = h; refitCards();
      });
      prRO.observe(elPr);
    }
    var prKeys = [], prWas = -2;
    function renderPractise() {
      if (!S.set.length) buildSet();
      /* a fresh deal (New 10, a level change) rises in; one swapped question, a
         reveal or a mark leaves the list where it is */
      var keys = S.set.map(function (it) { return it.q && it.q.key; }), enter = entering || diffCount(prKeys, keys) > 1;
      prKeys = keys;
      if (!(S.prOne < S.set.length)) S.prOne = -1;
      var switched = prWas !== S.prOne; prWas = S.prOne;
      /* the print sheet reads a plain list, rendered under the view and hidden on screen */
      var print = S.set.length ? '<div class="sl-qlist sl-prprint" aria-hidden="true">' + S.set.map(printRowHTML).join('') + '</div>' : '';
      var view = !S.set.length ? '<div class="sl-empty">Pick a skill first.</div>' : S.prOne >= 0 ? oneHTML(S.prOne, switched && !entering) : wallHTML(enter || switched);
      var sk0 = curSkill(), pT = S.from === 'mixed' ? 'Mixed practice' : esc(sk0 ? sk0.name : 'Skills Lab');
      var pS = S.from === 'mixed' ? mixSkills().map(function (x) { return esc(x.short || x.name); }).join(' · ') : esc(levelWord(sk0));
      var head = '<div class="sl-print-head">' + logoHTML('sl-logo--sheet') + '<div class="ph-l"><b>' + pT + '</b><span>' + pS + '</span></div>' +
        '<div class="ph-r"><span>Name</span><i></i><span>Date</span><i class="sm"></i></div></div>';
      paint(elPr, '<div class="sl-main"><div class="sl-scroll sl-prscroll">' + head + print + view + '</div></div>');
      if (narrow()) prPhoneFit();
      fitPractise(); watchPractise();
      FX.reveal = FX.mark = FX.swap = FX.shake = undefined; FX.newly = FX.hidden = null;
    }
    /* On a phone: bring the level in use into the chip row's view, and fit each
       card's sum on one line (shrinking to 70% at most, then it may wrap). A
       chain broken with a "+" at the start of its second line is harder to
       add up than a slightly smaller one. Sentences are left to wrap. */
    function prPhoneFit() {
      var row = elTop.querySelector('.sl-prchips .sl-lvlchips'), now = row && row.querySelector('.sl-chip--now');
      if (row && now) row.scrollLeft = Math.max(0, now.offsetLeft - row.offsetLeft - row.clientWidth / 2 + now.offsetWidth / 2);
      each(elPr.querySelectorAll('.sl-qcard .sl-qmain > .sl-expr'), function (ex) {
        ex.style.fontSize = ''; ex.classList.remove('is-wrap', 'is-fit');
        if (ex.querySelector('.ct-words') || /[a-z]{3,}/i.test(ex.textContent.replace(/\b(?:sqrt|surd)\b/gi, ''))) return;
        ex.classList.add('is-fit');
        var room = ex.parentNode.clientWidth - 4, need = ex.scrollWidth;
        if (!room || need <= room) return;
        var f = Math.max(0.7, room / need);
        ex.style.fontSize = (parseFloat(getComputedStyle(ex).fontSize) * f).toFixed(1) + 'px';
        if (ex.scrollWidth > room + 1) ex.classList.add('is-wrap');
      });
    }
    function lastLive() {
      var i, hit = -1;
      for (i = 0; i < S.set.length; i++) if (S.set[i].state === 'shown') hit = i;
      if (hit < 0) for (i = 0; i < S.set.length; i++) if (S.set[i].state !== 'hid') hit = i;
      return hit;
    }
    function nextHidden() { for (var i = 0; i < S.set.length; i++) if (S.set[i].state === 'hid') return i; return -1; }
    function revealOne(i) {
      var it = S.set[i]; if (!it || it.state !== 'hid') return;
      it.state = 'shown'; FX.reveal = i;
      renderPractise(); renderTop();
    }
    function revealAll() {
      var d = 0; FX.newly = {};
      S.set.forEach(function (it, i) { if (it.state === 'hid') { it.state = 'shown'; FX.newly[i] = d++; } });
      renderPractise(); renderTop();
    }
    /* PRACTISE HIDE ONE + ONE BAR (2026-09-16)
       ONE question's answer put away again, the rest of the set left as it is (Aadam).
       Marked questions are not offered it: the tick is the record, and re-hiding one would leave a
       card that cannot be answered again. */
    function hideOne(i) {
      var it = S.set[i]; if (!it || it.state !== 'shown') return;
      it.state = 'hid'; FX.hidden = {}; FX.hidden[i] = 1;
      renderPractise(); renderTop();
    }
    /* put the answers away again. A question already marked keeps its answer and its tick. */
    function hideAll() {
      FX.hidden = {};
      S.set.forEach(function (it, i) { if (it.state === 'shown') { it.state = 'hid'; FX.hidden[i] = 1; } });
      renderPractise(); renderTop();
    }
    function anyHidden() { return S.set.some(function (it) { return it.state === 'hid'; }); }
    function anyShown() { return S.set.some(function (it) { return it.state === 'shown'; }); }
    elPr.addEventListener('click', function (e) {
      var tool = e.target.closest ? e.target.closest('[data-hide],[data-off],[data-openq],[data-fresh]') : null;
      if (tool) {
        e.preventDefault(); e.stopPropagation();
        if (tool.hasAttribute('data-hide')) hideOne(Number(tool.getAttribute('data-hide')));
        else if (tool.hasAttribute('data-off')) toggleOff(Number(tool.getAttribute('data-off')));
        else if (tool.hasAttribute('data-openq')) openCard(Number(tool.getAttribute('data-openq')));
        else freshQuestion(Number(tool.getAttribute('data-fresh')));
        return;
      }
      /* the card itself: the answer over, and back again */
      var tap = e.target.closest ? e.target.closest('[data-cardtap]') : null;
      if (tap) {
        var ti = Number(tap.getAttribute('data-cardtap')), tit = S.set[ti];
        if (!tit) return;
        if (tit.off) toggleOff(ti);
        /* PHONE ROUND: TYPE-IN + WALL FIT (2026-09-23). Aadam, 2026-09-23: "can't see it on the phone app". With typing on,
           the box lives on the open question, and the only way in was a hover-only tool - so on a
           phone Type the answer looked broken. A tap on a card that can be typed now OPENS it. */
        else if (tit.state === 'hid' && S.typed && canType(tit)) openCard(ti);
        else if (tit.state === 'hid') revealOne(ti);
        else if (tit.state === 'shown') hideOne(ti);
        else openCard(ti);
        return;
      }
      var t = e.target.closest ? e.target.closest('button') : null;
      if (!t) {
        var card = e.target.closest ? e.target.closest('.sl-qcard[data-reveal]') : null;
        if (card) revealOne(Number(card.getAttribute('data-reveal')));
        return;
      }
      if (t.hasAttribute('data-wall')) { toWall(); return; }
      if (t.hasAttribute('data-goto')) { openCard(Number(t.getAttribute('data-goto'))); return; }
      if (t.hasAttribute('data-reveal')) { revealOne(Number(t.getAttribute('data-reveal'))); return; }
      var topic = t.closest('.sl-topic');
      if (topic && t.getAttribute('data-togglelvl')) {
        var sk = SL.get(topic.getAttribute('data-topic'));
        if (partlyMarked() && !window.confirm('Change the levels and deal fresh questions? The marks on this set will go.')) return;
        toggleSel(sk, Number(t.getAttribute('data-togglelvl')));
        redealSkill(sk); renderPractise(); renderTop(); return;
      }
      if (t.id === 'slTyped') { S.typed = !S.typed; save(); renderPractise(); renderTop(); return; }
      if (t.hasAttribute('data-check')) { checkTyped(Number(t.getAttribute('data-check'))); return; }
      /* PHONE ROUND: TYPE-IN + WALL FIT (2026-09-23) */
      if (t.hasAttribute('data-sign')) {
        setSign(t, t.getAttribute('data-v') === '-' ? '+' : '-');
        var sb = t.parentNode.querySelector('.sl-ansin[data-af="' + t.getAttribute('data-sign').split(':')[1] + '"]');
        if (sb) { try { sb.focus({ preventScroll: true }); } catch (err) {} }
        return;
      }
      if (t.hasAttribute('data-choice')) {
        var ci = Number(t.getAttribute('data-choice')), ck = Number(t.getAttribute('data-opt')), cit = S.set[ci];
        if (cit && cit.state === 'hid' && cit.q.choice) { cit.picked = ck; var right = ck === cit.q.choice.answer; mark(cit, right); if (!right) FX.shake = ci; renderPractise(); renderTop(); }
        return;
      }
      if (t.hasAttribute('data-fresh')) { freshQuestion(Number(t.getAttribute('data-fresh'))); return; }
      if (t.id === 'slChangeR') { if (S.from === 'mixed') show('mixed'); else changeSkill(); return; }
      if (t.hasAttribute('data-mark')) { mark(S.set[Number(t.getAttribute('data-i'))], t.getAttribute('data-mark') === '1'); renderPractise(); renderTop(); return; }
      if (t.hasAttribute('data-steps')) { S.teach.i = Number(t.getAttribute('data-steps')); S.teach.back = 'practise'; show('teach'); return; }
    });
    elPr.addEventListener('keydown', function (e) {
      var hk = e.target.closest ? e.target.closest('[data-hide],[data-off],[data-openq],[data-fresh]') : null;
      if (hk && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault(); e.stopPropagation();
        if (hk.hasAttribute('data-hide')) hideOne(Number(hk.getAttribute('data-hide')));
        else if (hk.hasAttribute('data-off')) toggleOff(Number(hk.getAttribute('data-off')));
        else if (hk.hasAttribute('data-openq')) openCard(Number(hk.getAttribute('data-openq')));
        else freshQuestion(Number(hk.getAttribute('data-fresh')));
        return;
      }
      if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-ans')) {
        if (e.key === 'Enter') {
          e.preventDefault();
          var qi = Number(e.target.getAttribute('data-ans')), fi = Number(e.target.getAttribute('data-af') || 0);
          if (!typedNext(qi, fi)) checkTyped(qi);
        }
        /* PHONE ROUND: TYPE-IN + WALL FIT (2026-09-23): a minus typed into a signed box moves the button, it is never
           typed into the box (so "-" and a - button can never both be counted) */
        else if ((e.key === '-' || e.key === '\u2212' || e.key === '+') && signBtn(e.target)) {
          e.preventDefault(); setSign(signBtn(e.target), e.key === '+' ? '+' : '-');
        }
        return;
      }
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var card = e.target.closest ? e.target.closest('.sl-qcard[data-reveal]') : null;
      if (!card || e.target.tagName === 'BUTTON') return;
      e.preventDefault(); revealOne(Number(card.getAttribute('data-reveal')));
    });

    /* ============================================================
       TEACH
       ============================================================ */
    var elTe = $('slTeach'), teachHost = null;
    /* Practise deals the set in turn: skill A, skill B, skill A... Teaching wants
       the opposite - work up the levels, easiest first - so teach walks its own
       order over the same set. Only the order changes, never the questions. */
    function teachOrder() {
      var idx = S.set.map(function (x, i) { return i; });
      var levels = {}, skills = {};
      S.set.forEach(function (x) { levels[x.level] = 1; skills[x.skill.id] = 1; });
      if (Object.keys(levels).length < 2 && Object.keys(skills).length < 2) return idx;
      return idx.sort(function (a, b) {
        var x = S.set[a], y = S.set[b];
        return (x.level - y.level) || x.skill.name.localeCompare(y.skill.name) || (a - b);
      });
    }
    function teachPos(order) { var p = order.indexOf(S.teach.i); return p < 0 ? 0 : p; }
    function renderTeach() {
      destroyChorus();
      /* Count together lives in Teach now, not Board (Aadam, 2026-09-15): the whole screen becomes the count */
      if (S.teach.chorus && chorusOK()) {
        destroyTeach();
        paint(elTe, '<div class="sl-main sl-teach-chorus"><div class="sl-chorus-host" id="slChorusHost"></div></div>', mountChorus);
        return;
      }
      /* the mixed level is not taught: Teach deals from the chosen levels without it */
      if (S.teach.back !== 'practise' && stripMixForTeach()) { buildSet(); S.teach.i = 0; }
      if (!S.set.length) buildSet();
      if (!S.set.length) { elTe.innerHTML = '<div class="sl-main"><div class="sl-empty">Pick a skill first.</div></div>'; return; }
      S.teach.i = Math.max(0, Math.min(S.set.length - 1, S.teach.i));
      var order = teachOrder(), pos = teachPos(order);
      var it = S.set[S.teach.i], sk = it.skill, lv = it.level, last = pos >= order.length - 1;
      var list = order.map(function (i) {
        var x = S.set[i];
        var tick = x.state === 'ok' ? '<span class="rtick">' + ICON.tick + '</span>' : x.state === 'miss' ? '<span class="rtick miss">' + ICON.cross + '</span>' : '';
        return '<div class="sl-rrowwrap"><button type="button" class="sl-rrow' + (i === S.teach.i ? ' is-now' : '') + '" data-tq="' + i + '"' + tipAttrs(x.skill, x.level) + '><span class="rnum num">' + (order.indexOf(i) + 1) + '</span><span class="rq sl-expr" style="font-weight:700">' + x.q.html + '</span>' + tick + '</button>' +
          '<button type="button" class="sl-qrefresh" data-refresh="' + i + '" aria-label="New question ' + (i + 1) + '" data-tip="New question">' + ICON.refresh + '</button></div>';
      }).join('');
      var rail = '<button type="button" class="sl-rail-title sl-drawer" id="slListToggle" aria-expanded="' + (S.teach.listOpen ? 'true' : 'false') + '">Questions 1 to ' + S.set.length + ' ' + ICON.chevD + '</button>' +
        '<div class="sl-teach-rail-q' + (S.teach.listOpen ? '' : ' is-closed') + '">' + list +
          '<button type="button" class="sl-btn sl-btn--ghost sl-btn--sm" id="slTeachNewAll" style="margin-top:6px" data-tip="Refresh all questions" data-tipsub="Key: N">' + ICON.refresh + 'Refresh all questions</button></div>' +
        '<div class="navrow"><button type="button" class="sl-iconbtn sl-iconbtn--sq" id="slTPrev" aria-label="Previous question" title="Previous question"' + (pos === 0 ? ' disabled' : '') + '>' + ICON.chevL + '</button>' +
        '<button type="button" class="sl-btn" id="slTNext">' + (last ? 'New set' : 'Next in this set') + ICON.chevR + '</button></div>';
      var mode = '<div class="sl-segwrap" data-mo-group="tmode"><button type="button" class="sl-seg' + (S.teach.mode === 'step' ? ' is-on' : '') + '" data-tmode="step">' + ICON.steps + 'Step by step</button><button type="button" class="sl-seg' + (S.teach.mode === 'answer' ? ' is-on' : '') + '" data-tmode="answer">' + ICON.eye + 'Answer only</button></div>';
      var main = '<div class="sl-teach-main">' +
        '<div class="sl-teach-head show-sm"><b>' + esc(sk.name) + '</b><span>Level ' + lv + ': ' + esc(levelName(sk, lv)) + '</span>' +
          (S.teach.back === 'practise' ? '<button type="button" class="sl-btn sl-btn--sm sl-btn--ghost" id="slBackPr">' + ICON.list + 'Back to practise</button>' : '<button type="button" class="sl-btn sl-btn--sm sl-btn--ghost" id="slChangeT">' + ICON.book + 'Change skill</button>') + '</div>' +
        lvlStripHTML() +
        '<div class="sl-teach-bar">' + mode + teachOptsHTML(sk, lv) + '<div class="sl-steps" id="slTSteps"></div></div>' +
        /* the question itself, big, over the model: which one you are on was
           only readable in the list down the left, and on a phone the list is
           shut. It sits with the model, not in the chrome, so nobody has to
           look away from the thing they are working on. */
        '<div class="sl-teach-q' + (entering ? '' : ' is-fresh') + (String(it.q.text || '').length > 60 ? ' is-long' : '') + '"><span class="tqn num">' + (pos + 1) + ' of ' + order.length + '</span>' +
          '<span class="sl-expr tqx">' + it.q.html + '</span></div>' +
        '<div class="sl-teach-board is-enter" id="slTBoard"></div>' +
        '<div class="sl-teach-actions"><div class="row"><button type="button" class="sl-btn sl-btn--cta" id="slTCta">Next</button><button type="button" class="sl-btn" id="slTAll">' + ICON.eye + 'Show it all</button></div>' +
        '<div class="sl-hint" id="slTHint"></div></div></div>';
      paint(elTe, '<div class="sl-rail sl-teach-rail">' + rail + '</div><div class="sl-main">' + main + '</div>', mountTeach);
    }
    /* A skill can offer switches for its own model (brackets: Grid method), shown beside
       Step by step | Answer only. One saved setting per id, shared by every skill offering it. */
    /* a switch may name the levels it belongs to (place value's Blocks: levels 1 to 3, PLACE VALUE BLOCKS (2026-09-21)) */
    function teachOptsHTML(sk, lv) {
      return (sk.teachOpts || []).filter(function (o) { return !o.levels || o.levels.indexOf(lv) >= 0; }).map(function (o) {
        var on = !!S.teach.opts[o.id];
        return '<button type="button" class="sl-toggle sl-topt' + (on ? ' is-on' : '') + '" data-topt="' + esc(o.id) + '" aria-pressed="' + on + '"><i></i>' + esc(o.label) + '</button>';
      }).join('');
    }
    /* flipping one rebuilds the model in place and walks it back to where it was */
    function toggleTeachOpt(btn) {
      var id = btn.getAttribute('data-topt'), on = !S.teach.opts[id], r = S.teach.r;
      var at = r && r.where ? r.where() : null, wasDone = S.teach.done;
      S.teach.opts[id] = on; save();
      btn.classList.toggle('is-on', on); btn.setAttribute('aria-pressed', String(on));
      mountTeach();
      if (S.teach.fitting) { S.teach.afterMount = function () { var r2 = S.teach.r; if (!r2 || S.teach.mode === 'answer') return; if (wasDone) r2.all(); else if (at && r2.seek) r2.seek(at); }; return; }
      r = S.teach.r; if (!r || S.teach.mode === 'answer') return;
      if (wasDone) r.all(); else if (at && r.seek) r.seek(at);
    }

    /* ============================================================
       SMARTBOARD TEACH ZOOM (2026-09-21)
       Aadam: "check every teach and make them all as large as possible so it's clear and
       easy to see". The model is drawn at its own size inside a board that is zoomed up to
       fill the space. The zoom is found before the model shows: the model is mounted in its
       finished state (Show it all, no motion), measured, and the zoom is cut until the whole
       of it fits. Then the real model mounts at that zoom. A model that grows past the board
       later in its steps makes the zoom smaller, never bigger, so nothing jumps.
       Rects: inside a zoomed board getBoundingClientRect returns the UNZOOMED rect about the
       board's corner, because the engines draw arrows from rect differences and set them
       with unzoomed lengths. rawRect() is the real one.
       ============================================================ */
    var TZ = { host: null, z: 1, token: 0, qz: {}, qy: {}, lz: {}, ign: {}, mo: null, moT: null, zmax: 2.6 };
    /* TEACH CENTRED: set the board's working down by a share of its inside (0 = where the model puts it) */
    function tzDown(host, frac) {
      var on = frac > 0 && TZ.host === host && tzOn(host);
      if (!on) { host.style.removeProperty('--ty'); host.classList.remove('is-ty'); return; }
      var cs = getComputedStyle(host), z = TZ.z || 1, hr = rawRect(host);
      var pad = ((parseFloat(cs.borderTopWidth) || 0) + (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.borderBottomWidth) || 0) + (parseFloat(cs.paddingBottom) || 0)) * z;
      host.style.setProperty('--ty', (frac * (hr.height - pad) / z).toFixed(1) + 'px'); host.classList.add('is-ty');
    }
    var RAW_RECT = Element.prototype.getBoundingClientRect.__slRaw || Element.prototype.getBoundingClientRect;
    function rawRect(el) { return RAW_RECT.call(el); }
    (function () {
      if (Element.prototype.getBoundingClientRect.__slRaw) return;
      var patched = function () {
        var r = RAW_RECT.call(this), h = TZ.host, z = TZ.z;
        if (z === 1 || !h || (this !== h && !h.contains(this))) return r;
        var o = RAW_RECT.call(h);
        return new DOMRect(o.left + (r.left - o.left) / z, o.top + (r.top - o.top) / z, r.width / z, r.height / z);
      };
      patched.__slRaw = RAW_RECT;
      Element.prototype.getBoundingClientRect = patched;
    })();
    SL.rawRect = rawRect; SL._tz = TZ; TZ.log = [];   /* _tz: the rigs read the zoom and the fit log */
    function tzFrame(fn) { var ran = false; function go() { if (!ran) { ran = true; fn(); } } requestAnimationFrame(go); setTimeout(go, 60); }
    function tzKey(it) { return it.skill.id + '|' + it.level + '|' + (it.q.key || it.q.text || '') + '|' + JSON.stringify(S.teach.opts || {}); }
    function tzSet(host, z) {
      z = Math.round(z * 1000) / 1000;
      host.style.setProperty('--tz', String(z));
      var on = Math.abs(z - 1) > 0.001;
      host.classList.toggle('is-tz', on);
      TZ.host = host; TZ.z = on ? z : 1;
    }
    /* a laptop-sized board or bigger; phones and short landscape screens keep their own layouts */
    function tzOn(host) {
      if (narrow() || S.teach.chorus) return false;
      var r = rawRect(host);
      return r.width >= 640 && r.height >= 300;
    }
    /* how much of the model fits, part by part (1 or more = all of it). 'box': everything drawn,
       against the board's inside. Each scroller (a chart or a number line that pans) by how far it
       would have to scroll, and '#clip': anything drawn past a scroller's or an svg's edge that no
       scrolling reaches (the end labels of a long number line). parts: path -> the smallest ratio
       seen, so one map can collect every step of a probe. */
    function tzRoom(host, parts, ext) {
      var z = TZ.host === host ? TZ.z : 1, hr = rawRect(host), cs = getComputedStyle(host);
      var bl = (parseFloat(cs.borderLeftWidth) || 0) + (parseFloat(cs.paddingLeft) || 0), br = (parseFloat(cs.borderRightWidth) || 0) + (parseFloat(cs.paddingRight) || 0);
      var bt = (parseFloat(cs.borderTopWidth) || 0) + (parseFloat(cs.paddingTop) || 0), bb = (parseFloat(cs.borderBottomWidth) || 0) + (parseFloat(cs.paddingBottom) || 0);
      var aw = hr.width - (bl + br) * z, ah = hr.height - (bt + bb) * z;
      var L = 1e9, T = 1e9, R = -1e9, B = -1e9, boxes = [], iT = 1e9, iB = -1e9;
      /* TEACH CENTRED: what is DRAWN (text, a picture, a box with a fill or a border), not the layout boxes
         round it, which run the board's full height */
      function inked(k, st) {
        if (k.namespaceURI !== 'http://www.w3.org/1999/xhtml' || /^(IMG|CANVAS|INPUT)$/.test(k.tagName)) return true;
        if (!k.children.length && (k.textContent || '').trim()) return true;
        if (st.backgroundImage !== 'none' || (st.backgroundColor && !/rgba\(.*,\s*0\)$|transparent/.test(st.backgroundColor))) return true;
        return (parseFloat(st.borderTopWidth) > 0 && st.borderTopStyle !== 'none') || (parseFloat(st.borderBottomWidth) > 0 && st.borderBottomStyle !== 'none');
      }
      function put(p, v) { if (!(v < 1)) v = 1; if (!(p in parts) || v < parts[p]) parts[p] = v; }
      if (host.scrollHeight > host.clientHeight + 1) put('host', host.clientHeight / host.scrollHeight);
      if (host.scrollWidth > host.clientWidth + 1) put('host', host.clientWidth / host.scrollWidth);
      (function walk(el, path, clip) {
        var kids = el.children, i, k, r, st, p, html, sx, svg, box;
        for (i = 0; i < kids.length; i++) {
          k = kids[i]; p = path + '.' + i;
          st = getComputedStyle(k);
          if (st.display === 'none') continue;
          r = rawRect(k);
          if (r.width > 0.5 || r.height > 0.5) {
            if (!clip) { if (r.left < L) L = r.left; if (r.top < T) T = r.top; if (r.right > R) R = r.right; if (r.bottom > B) B = r.bottom; }
            else { if (r.left < clip.L) clip.L = r.left; if (r.right > clip.R) clip.R = r.right; }
            if (ext && !clip && inked(k, st)) { if (r.top < iT) iT = r.top; if (r.bottom > iB) iB = r.bottom; }
          }
          html = k.namespaceURI === 'http://www.w3.org/1999/xhtml';
          sx = html && (st.overflowX !== 'visible' || st.overflowY !== 'visible');
          svg = !html && k.tagName.toLowerCase() === 'svg' && st.overflow !== 'visible';
          if (sx) {
            if (st.overflowX !== 'visible' && k.scrollWidth > k.clientWidth + 2 && k.clientWidth > 0) put(p, k.clientWidth / k.scrollWidth);
            if (st.overflowY !== 'visible' && k.scrollHeight > k.clientHeight + 2 && k.clientHeight > 0) put(p, k.clientHeight / k.scrollHeight);
          }
          if (sx || svg) {
            box = { p: p, r: r, L: 1e9, R: -1e9, x: sx && st.overflowX !== 'visible', el: k };
            boxes.push(box);
            if (k.children.length) walk(k, p, box);
          } else if (k.children.length) walk(k, p, clip);
        }
      })(host, 'b', null);
      boxes.forEach(function (b) {
        if (!(b.R > b.L) || b.r.width < 1) return;
        var zz = TZ.host === host ? TZ.z : 1, reachL = b.r.left, reachR = b.r.right;
        if (b.x) { reachL -= b.el.scrollLeft * zz; reachR += Math.max(0, b.el.scrollWidth - b.el.clientWidth - b.el.scrollLeft) * zz; }
        var cut = Math.max(0, reachL - b.L) + Math.max(0, b.R - reachR);
        if (cut > 1.5) put(b.p + '#clip', b.r.width / (b.r.width + cut));
      });
      /* TEACH CENTRED (2026-09-25): the probe also keeps how high and how low anything is drawn, as a
         share of the board's inside, over every press of the walk */
      if (ext && iB > iT && ah > 0) { var it0 = hr.top + bt * z; ext.t = Math.min(ext.t, (iT - it0) / ah); ext.b = Math.max(ext.b, (iB - it0) / ah); }
      if (R > L && aw > 0) put('box', aw / (R - L));
      if (B > T && ah > 0) put('box', ah / (B - T));
      return parts;
    }
    function tzRho(parts, ign) { var m = 1, p; for (p in parts) if (!(ign && ign[p]) && parts[p] < m) m = parts[p]; return m; }
    /* wait until the model has stopped changing: a few frames with the same size, or give up */
    function tzSettle(host, token, fn) {
      var last = '', same = 0, n = 0;
      function sig() { var r = 0; each(host.querySelectorAll('*'), function (e) { var b = rawRect(e); r += b.width * 3 + b.height * 7 + b.left; }); return Math.round(r) + ':' + host.scrollHeight + ':' + host.children.length; }
      (function tick() {
        if (token !== TZ.token) return;
        var s = sig(); n++;
        same = (s === last) ? same + 1 : 0; last = s;
        if ((same >= 2 && n >= 3) || n > 24) { fn(); return; }
        tzFrame(function () { setTimeout(tick, 0); });
      })();
    }
    function tzProbe(host, it, api, token, cb) {
      tzSet(host, 1);
      var box = rawRect(host), key = tzKey(it);
      var zmax = Math.max(1, Math.min(TZ.zmax, box.height / 250, box.width / 420));
      /* first guess: what this level needed last time (the questions of a level share a shape) */
      var lkey = it.skill.id + '|' + it.level + '|' + JSON.stringify(S.teach.opts || {});
      var z = TZ.lz[lkey] ? Math.min(zmax, TZ.lz[lkey] / 0.98) : zmax, t0 = Date.now(), ZMIN = 0.8;
      var atts = [], ign = TZ.ign[key] = {};
      var papi = { hint: function () {}, cta: function () {}, steps: function () {}, step: function () {}, done: function () {}, replace: function () {}, opt: api.opt, reduceMotion: true };
      /* 2% spare: the live model settles a hair bigger than the still one (a graph, a late badge) */
      function done(zz) {
        var a0 = null; atts.forEach(function (a) { if (a.ext && Math.abs(a.z - zz) < 1e-6) a0 = a; });
        TZ.lz[lkey] = zz; zz = Math.max(ZMIN, zz * 0.98); TZ.qz[key] = zz;
        /* TEACH CENTRED (2026-09-25, Aadam: "yes centre the teach working"): the walk that fitted, scaled to
           the zoom it will show at, is set down so the FINISHED model sits in the middle of the board. It
           grows into that space press by press, so nothing moves; a model that centres itself comes out
           at about 0 and is left alone. */
        var ty = 0;
        if (a0 && a0.ext.b > a0.ext.t) { var s = zz / a0.z, tt = a0.ext.t * s, hh = (a0.ext.b - a0.ext.t) * s; ty = (1 - hh) / 2 - tt; if (!(ty > 0.03) || hh > 0.97) ty = 0; }
        TZ.qy[key] = ty;
        TZ.log.push('fit ' + zz.toFixed(3) + (ty ? ' down ' + (ty * 100).toFixed(0) + '%' : '') + ' in ' + (Date.now() - t0) + 'ms' + (Object.keys(ign).length ? ' ignoring ' + Object.keys(ign).join(' ') : '')); cb(zz);
      }
      /* after every look: a scroller that is just as squeezed at a much smaller zoom is squeezed by
         design (a note that never fits its column), so it stops counting; then lo = the biggest
         zoom that fitted, hi = the smallest that did not. A model that simply scales jumps straight
         to its size; one whose columns widen as the zoom comes down is halved towards lo instead.
         Below 1 is allowed down to ZMIN: a short laptop screen used to scroll the board and cut the
         caption off; a little smaller and whole is clearer. */
      function next(parts, ext) {
        var cur = { z: z, parts: parts, ext: ext }, p;
        /* built in: it barely got better although the zoom came down (a real squeeze eases by far
           more than 0.05 for each 1 of zoom) */
        atts.forEach(function (a) {
          var dz = a.z - z; if (dz < 0.05) return;
          for (p in parts) if (p !== 'box' && p !== 'host' && parts[p] < 0.995 && a.parts[p] !== undefined && parts[p] - a.parts[p] < 0.05 * dz + 0.003) ign[p] = 1;
        });
        atts.push(cur);
        var lo = null, hi = null, hiRho = 1, hiBox = false;
        atts.forEach(function (a) {
          var r = tzRho(a.parts, ign), w = '', q;
          for (q in a.parts) if (!ign[q] && (!w || a.parts[q] < a.parts[w])) w = q;
          if (r >= 0.995) { if (lo === null || a.z > lo) lo = a.z; } else if (hi === null || a.z < hi) { hi = a.z; hiRho = r; hiBox = w === 'box' || w === 'host'; }
        });
        if (lo !== null && hi !== null && hi <= lo) hi = null;
        if (TZ.log.length > 40) TZ.log.shift();
        var worst = ''; for (p in parts) if (!ign[p] && (!worst || parts[p] < parts[worst])) worst = p;
        TZ.log.push(it.skill.id + ' L' + it.level + ' z=' + z.toFixed(2) + ' rho=' + tzRho(parts, ign).toFixed(3) + ' ' + worst);
        if (hi === null) { done(lo); return; }
        /* nothing fitted yet: the model's own size (1) is what the page always showed */
        var fallback = lo !== null ? lo : (hi > 1 ? 1 : ZMIN);
        if (hi <= ZMIN + 0.01 || atts.length >= 6) { done(fallback); return; }
        if (lo !== null && hi - lo < 0.12) { done(lo); return; }
        /* the plain box scales straight with the zoom, so its estimate was already the answer */
        if (lo !== null && hiBox && lo >= hi * hiRho * 0.97) { done(lo); return; }
        var est = hi * hiRho * 0.985, floor = lo === null ? ZMIN : lo;
        z = (hiRho < 0.6 && !hiBox) ? Math.max(est, (floor + hi) / 2) : est;
        if (lo !== null && z <= lo + 0.03) z = (lo + hi) / 2;
        z = Math.max(ZMIN, Math.min(z, hi - 0.04));
        if (atts.some(function (a) { return Math.abs(a.z - z) < 0.02; })) { done(fallback); return; }
        attempt();
      }
      function attempt() {
        if (token !== TZ.token) return;
        tzSet(host, z); tzDown(host, 0); host.innerHTML = '';
        var saved = SL.reduceMotion, pr = null, fin = false, k = 0, parts = {}, ext = { t: 1e9, b: -1e9 };
        papi.done = function () { fin = true; };
        SL.reduceMotion = true;
        try { pr = it.skill.teach(host, it.q, papi); } catch (e) { pr = null; TZ.log.push('probe threw: ' + (e && e.message)); }
        SL.reduceMotion = saved;
        if (!pr) { host.innerHTML = ''; done(1); return; }
        /* every step, not only the finished model: some models are widest half way (a grid
           beside the working), then tidy up at the end */
        function end() {
          try { if (pr.all) pr.all(); } catch (e) {}
          tzSettle(host, token, function () {
            try { tzRoom(host, parts, ext); } catch (e) { TZ.log.push('probe room threw: ' + (e && e.message)); }
            try { if (pr.destroy) pr.destroy(); } catch (e) {}
            host.innerHTML = '';
            if (token !== TZ.token) return;
            next(parts, ext);
          });
        }
        (function step() {
          if (token !== TZ.token) { try { pr.destroy(); } catch (e) {} return; }
          if (fin || k >= 40 || !pr.next) { end(); return; }
          var saved2 = SL.reduceMotion; SL.reduceMotion = true;
          try { pr.next(); } catch (e) { fin = true; }
          SL.reduceMotion = saved2; k++;
          /* a measure that throws must never leave the board blank (the walk would stop here for good) */
          setTimeout(function () { setTimeout(function () { if (token === TZ.token) { try { tzRoom(host, parts, ext); } catch (e) { TZ.log.push('probe room threw: ' + (e && e.message)); } } step(); }, 0); }, 0);
        })();
      }
      attempt();
    }
    /* a model that grows past the board later on: the zoom comes down to fit it, never up */
    function tzWatch(host, it) {
      if (TZ.mo) { TZ.mo.disconnect(); TZ.mo = null; }
      /* phones and short landscape screens keep their own layout, as before: no zoom, no guard */
      if (!window.MutationObserver || TZ.host !== host || !tzOn(host)) return;
      var key = tzKey(it);
      /* two looks, 450ms apart, must both find it too big: a pop or a slide in the middle of its
         animation is bigger for a moment and must not shrink the board for good */
      function over() { return (TZ.host !== host || !host.isConnected || TZ.z <= 0.801) ? 1 : tzRho(tzRoom(host, {}), TZ.ign[key]); }
      function check() {
        var a = over(); if (a >= 0.99) return;
        setTimeout(function () {
          var b = over(); if (b >= 0.99) return;
          /* at most 15% at a time: a squeezed column widens again as the zoom comes down */
          tzSet(host, Math.max(0.8, TZ.z * Math.max(a, b, 0.85) * 0.985)); TZ.qz[key] = TZ.z;
        }, 450);
      }
      TZ.mo = new MutationObserver(function () { if (TZ.moT) return; TZ.moT = setTimeout(function () { TZ.moT = null; check(); }, 300); });
      TZ.mo.observe(host, { subtree: true, childList: true, attributes: true, characterData: true });
    }
    /* full screen (F) or a resized window: a model nobody has stepped yet is fitted again */
    var tzResizeT = null;
    window.addEventListener('resize', function () {
      clearTimeout(tzResizeT);
      tzResizeT = setTimeout(function () {
        if (S.screen !== 'teach' || S.teach.chorus || S.teach.fitting) return;
        var it = S.set[S.teach.i]; if (!it) return;
        var hb = $('slTBoard'); if (hb && !tzOn(hb)) { if (TZ.z !== 1) { delete TZ.qz[tzKey(it)]; mountTeach(); } return; }
        if (!S.teach.moved) { delete TZ.qz[tzKey(it)]; mountTeach(); return; }
        if (TZ.host && TZ.z > 0.801) { var rho = tzRho(tzRoom(TZ.host, {}), TZ.ign[tzKey(it)]); if (rho < 0.99) tzSet(TZ.host, Math.max(0.8, TZ.z * rho * 0.985)); }
      }, 260);
    });
    /* TEACH STRIP FITS (2026-09-22): the level strip and Step by step | Answer only share one row on a laptop
       or board, but at 1024 wide the chips ran on under the switch (levels 3 to 5 of three brackets could not
       be pressed). The one-row strip is kept wherever every level box clears the switch and the row is no
       taller than the switch on a row of its own would make it. Otherwise the shortest of these that fits:
         'n'   one row, without the skill's name beside its icon (the top bar names it, as on a phone);
         '2'   the switch on its own row under the strip;
         'n2'  both (a narrow window: the name would wrap onto three lines beside the chips).
       The name only goes when one skill is being taught (a mixed strip needs its names). Classes on the teach
       main: is-tbn, is-tb2; hunks/tb2.css does the rest. */
    var TB_MQ = null; try { TB_MQ = window.matchMedia('(min-width: 861px) and (min-height: 621px)'); } catch (e) {}
    function fitTeachBar() {
      var m = elTe && elTe.querySelector('.sl-teach-main'); if (!m) return false;
      var was = (m.classList.contains('is-tbn') ? 'n' : '') + (m.classList.contains('is-tb2') ? '2' : '');
      var bar = m.querySelector(':scope > .sl-prbar'), tb = m.querySelector(':scope > .sl-teach-bar');
      function set(c) { m.classList.toggle('is-tbn', c.indexOf('n') >= 0); m.classList.toggle('is-tb2', c.indexOf('2') >= 0); }
      /* over: on one row, a level box runs within 8px of the switch; on two, past the strip's own edge */
      function lay(c) {
        set(c);
        var t = rawRect(tb), b = rawRect(bar), lim = c.indexOf('2') >= 0 ? b.right + 1 : t.left - 8, over = false;
        each(bar.children, function (k) { var r = rawRect(k); if (r.width && r.right > Math.min(lim, window.innerWidth)) over = true; });
        return { c: c, over: over, h: Math.max(b.bottom, t.bottom) - Math.min(b.top, t.top) };
      }
      set('');
      if (!(TB_MQ && TB_MQ.matches && bar && tb && bar.offsetWidth && tb.offsetWidth)) return was !== '';
      var one = bar.querySelectorAll('.sl-topic').length === 1;
      var A = lay(''), T = lay('2'), best = null;
      if (!A.over && A.h <= T.h + 2) best = A;
      else [one && lay('n'), T, one && lay('n2')].forEach(function (L) { if (L && !L.over && (!best || L.h < best.h - 2)) best = L; });
      var pick = best ? best.c : (one ? 'n2' : '2');
      set(pick);
      return pick !== was;
    }
    /* the fonts landed after the mount: a model nobody has stepped yet is fitted again, as on a resize */
    function refitTeachBar() {
      if (!fitTeachBar() || S.screen !== 'teach' || S.teach.chorus) return;
      var it = S.set[S.teach.i]; if (!it) return;
      if (S.teach.fitting || !S.teach.moved) { delete TZ.qz[tzKey(it)]; mountTeach(); return; }
      if (TZ.host && TZ.z > 0.801) { var rho = tzRho(tzRoom(TZ.host, {}), TZ.ign[tzKey(it)]); if (rho < 0.99) tzSet(TZ.host, Math.max(0.8, TZ.z * rho * 0.985)); }
    }
    var tbResizeT = null;
    window.addEventListener('resize', function () { clearTimeout(tbResizeT); tbResizeT = setTimeout(function () { if (S.screen === 'teach') fitTeachBar(); }, 90); });
    try { document.fonts.ready.then(refitTeachBar); document.fonts.addEventListener('loadingdone', refitTeachBar); } catch (err) {}
    function mountTeach() {
      destroyTeach();
      fitTeachBar();
      /* PHONE ROUND 3: TEACH + BOARD ON A PHONE (2026-09-23): the model is built after the zoom fit, so the floor is applied
         once when the step settles and again when the model has finished arriving */
      floorSoon(elTe); setTimeout(function () { if (S.screen === 'teach') floorType(elTe); }, 900);
      var it = S.set[S.teach.i]; if (!it) return;
      teachHost = $('slTBoard'); teachHost.innerHTML = '';
      S.teach.done = false;
      var api = {
        hint: function (html) { var h = $('slTHint'); if (!h) return; h.innerHTML = html || ''; refresh(h); },
        cta: function (label) { var c = $('slTCta'); if (!c) return; c.innerHTML = label + ICON.arrowR; refresh(c); },
        /* no step chips in Teach, for any skill (Aadam, 2026-09-15: "remove these explanation
           pills everywhere not needed", then "all should lose their chips"). Skills still call
           steps() and step(); both do nothing now. */
        steps: function () { var s = $('slTSteps'); if (s) s.innerHTML = ''; },
        step: function (i, label) { var s = $('slTSteps'); if (!s) return; Array.prototype.forEach.call(s.querySelectorAll('.sl-step'), function (c, n) { c.classList.toggle('is-done', n < i); c.classList.toggle('is-now', n === i); if (n === i && label) c.innerHTML = label; }); },
        done: function () {
          S.teach.done = true;
          it.state = (it.state === 'ok' || it.state === 'miss') ? it.state : 'shown';
          var ord = teachOrder(); var c = $('slTCta'); if (c) c.innerHTML = (teachPos(ord) >= ord.length - 1 ? 'New set' : 'Next in this set') + ICON.arrowR;
          var a = $('slTAll'); if (a) a.disabled = true;
          var s = $('slTSteps'); if (s) Array.prototype.forEach.call(s.querySelectorAll('.sl-step'), function (c) { c.classList.add('is-done'); c.classList.remove('is-now'); });
        },
        replace: function (q) { it.q = q; it.state = 'hid'; var row = elTe.querySelector('[data-tq="' + S.teach.i + '"] .rq'); if (row) row.innerHTML = q.html; },
        opt: function (id) { return !!S.teach.opts[id]; },
        reduceMotion: reduceMotion
      };
      var a = $('slTAll'); if (a) a.disabled = false;
      /* SMARTBOARD TEACH ZOOM (2026-09-21): fit first, then the real model at that zoom */
      var host = teachHost, token = ++TZ.token, tkey = tzKey(it);
      if (TZ.mo) { TZ.mo.disconnect(); TZ.mo = null; }
      S.teach.moved = false;
      function realMount(z) {
        tzSet(host, z); tzDown(host, TZ.qy[tkey] || 0);
        S.teach.r = it.skill.teach(host, it.q, api);
        if (S.teach.mode === 'answer') S.teach.r.all();
        tzWatch(host, it);
      }
      function finishMount(z) {
        S.teach.fitting = false;
        realMount(z);
        host.classList.remove('is-tzwait', 'is-tzprobe');
        var fn = S.teach.afterMount; S.teach.afterMount = null; if (fn) fn();
      }
      var waits = 0;
      function begin() {
        if (token !== TZ.token || host !== $('slTBoard')) return;
        fitTeachBar();
        if (!tzOn(host)) { finishMount(1); return; }
        if (TZ.qz[tkey]) { finishMount(TZ.qz[tkey]); return; }
        host.classList.add('is-tzprobe');
        tzProbe(host, it, api, token, function (z) { if (token === TZ.token && host === $('slTBoard')) finishMount(z); });
      }
      var r0 = rawRect(host);
      if (r0.width > 0 && r0.height > 0 && (!tzOn(host) || TZ.qz[tkey])) { S.teach.fitting = false; realMount(tzOn(host) ? TZ.qz[tkey] : 1); }
      else {
        /* the screen is not laid out yet the first time (or the zoom has to be found): wait for a sized board */
        S.teach.fitting = true; host.classList.add('is-tzwait');
        (function wait() {
          if (token !== TZ.token) return;
          var r = rawRect(host);
          if ((r.width > 0 && r.height > 0) || ++waits > 20) begin(); else tzFrame(wait);
        })();
      }
      /* on a phone the level chips are one sideways row: bring the level in use
         into view, or level 12 of 12 sits off the right edge */
      if (narrow()) {
        var chipRow = elTe.querySelector('.sl-prbar .sl-lvlchips'), nowChip = chipRow && chipRow.querySelector('.sl-chip--now');
        if (chipRow && nowChip) chipRow.scrollLeft = Math.max(0, nowChip.offsetLeft - chipRow.clientWidth / 2 + nowChip.offsetWidth / 2);
      }
    }
    /* Forward and back through the MODEL. Stepping back un-finishes the
       question: the CTA and the step chips are repainted by the renderer, but
       the finished flag and Show it all live out here. */
    function teachAnim(d, held) {
      var r = S.teach.r; if (!r) return;
      S.teach.moved = true;
      /* PHONE ROUND 3: TEACH + BOARD ON A PHONE (2026-09-23): a model re-sizes its rows on every press, so the floor is
         re-applied once the step has settled */
      floorSoon(elTe);
      /* Right always carries on (Aadam, 2026-09-15: "should be able to continue with the right key -
         without having to press using the mouse"): the next step; once the question is done, whatever
         the model offers past it (Keep counting); and when there is nothing more, the next question */
      if (d > 0) {
        if (!S.teach.done) { r.next(); return; }
        /* a HELD key (key repeat) runs the model to its answer and stops there; only a fresh press
           moves on (Aadam, 2026-09-16: "if you hold down right to go fast through the animation it
           shouldn't go to the next question - everywhere") */
        if (held) return;
        if (r.more && r.more()) return;
        /* Aadam, 2026-09-21: "pressing right on the keyboard should never go to
           the next question. should always stop at the final animation. they
           need to press down for next question - fix everywhere". Down
           (teachStep) and the Next button still move on; Right stops here. */
        return;
      }
      if (!r.back) return;
      /* un-finish BEFORE stepping back: a walk back that is still at or past the answer marks it done again */
      if (S.teach.done) { S.teach.done = false; var a = $('slTAll'); if (a) a.disabled = false; }
      r.back();
    }
    /* step by POSITION in the teaching order, not by index into the set */
    function teachStep(d) {
      var order = teachOrder(), pos = teachPos(order) + d;
      if (pos >= order.length) { buildSet(); S.teach.i = teachOrder()[0] || 0; renderTeach(); renderTop(); return; }
      if (pos < 0) pos = 0;
      teachGo(order[pos]);
    }
    function teachGo(i) {
      if (i === undefined || i >= S.set.length) { buildSet(); i = teachOrder()[0] || 0; }
      S.teach.i = Math.max(0, i);
      renderTeach(); renderTop();
    }
    /* swap one question for a fresh one at the same skill and level, avoiding
       anything already in the set */
    function freshTeachQuestion(i) {
      i = (i === undefined) ? S.teach.i : i;
      var it = S.set[i]; if (!it) return;
      var ctx = { seen: {}, shapeSeen: {}, last: null };
      S.set.forEach(function (x, k) { if (k !== i && x.skill === it.skill) ctx.seen[x.q.key] = 1; });
      ctx.slot = slotIn(S.set, i);
      S.set[i] = makeItem(it.skill, it.level, ctx);
      renderTeach(); renderTop();
    }
    function freshTeachSet() {
      if (partlyMarked() && !window.confirm('Refresh every question? The marks on this set will go.')) return;
      buildSet();
      S.teach.i = Math.min(S.teach.i, S.set.length - 1);
      renderTeach(); renderTop();
    }
    elTe.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('button') : null;
      if (!t) return;
      var tTopic = t.closest('.sl-topic');
      if (tTopic) {
        var tsk = SL.get(tTopic.getAttribute('data-topic'));
        if (tsk && levelClick(t, tsk)) { redealSkill(tsk); S.teach.i = 0; renderTeach(); renderTop(); }
        return;
      }
      if (t.id === 'slTCta') { if (S.teach.fitting) return; if (S.teach.done || !S.teach.r) { teachStep(1); return; } S.teach.moved = true; S.teach.r.next(); return; }
      if (t.id === 'slTAll') { if (S.teach.r) { S.teach.moved = true; S.teach.r.all(); } return; }
      if (t.id === 'slTPrev') { teachStep(-1); return; }
      if (t.id === 'slTNext') { teachStep(1); return; }
      if (t.id === 'slTeachNewAll') { freshTeachSet(); return; }
      if (t.hasAttribute('data-refresh')) { freshTeachQuestion(Number(t.getAttribute('data-refresh'))); return; }
      if (t.id === 'slListToggle') { S.teach.listOpen = !S.teach.listOpen; renderTeach(); return; }
      if (t.id === 'slChangeT') { changeSkill(); return; }
      if (t.id === 'slBackPr') { show('practise'); return; }
      if (t.hasAttribute('data-topt')) { toggleTeachOpt(t); return; }
      if (t.getAttribute('data-tmode')) { S.teach.mode = t.getAttribute('data-tmode'); renderTeach(); return; }
      if (t.hasAttribute('data-tq')) { if (narrow()) S.teach.listOpen = false; teachGo(Number(t.getAttribute('data-tq'))); return; }
    });


    /* ============================================================
       YOUR TURN
       Practise asks for the answer. This asks for the DECISIONS that
       reach it, one at a time, on the model itself, and reports each
       on its first try. Ten questions where every step was right the
       first time is not the same as ten right answers, and the
       difference is the whole point: the results say WHICH decision
       is the one going wrong.
       ============================================================ */
    var elTu = $('slTurn'), turnHost = null, turnTick = null;

    function turnSkill() { var it = S.set[S.turn.i]; return it ? it.skill : curSkill(); }
    function startTurn() {
      destroyTurn();
      buildSet();
      S.turn.i = 0; S.turn.phase = 'play'; S.turn.log = []; S.turn.cp = []; S.turn.marks = [];
      S.turn.at = 0; S.turn.t0 = Date.now(); S.turn.ms = 0; S.turn.ended = false;
    }
    function turnElapsed() { return S.turn.phase === 'play' ? (Date.now() - S.turn.t0) : S.turn.ms; }
    function saidTime(ms) {
      var t = Math.max(0, Math.round(ms / 1000));
      if (t < 60) return t + ' seconds';
      var m = Math.floor(t / 60), sec = t % 60;
      return m + ' minute' + (m === 1 ? '' : 's') + (sec ? ' ' + sec + ' seconds' : '');
    }

    /* ---------- the parts that repaint on their own ---------- */
    function paintUSteps() {
      var b = $('slUSteps'); if (!b) return;
      b.innerHTML = S.turn.cp.map(function (c, i) {
        var m = S.turn.marks[i];
        var cls = 'sl-step' + (i === S.turn.at ? ' is-now' : '') + (m ? (m.ok ? ' is-done' : ' is-missed') : '');
        return (i ? '<span class="arr">' + ICON.chevR + '</span>' : '') + '<span class="' + cls + '">' + esc(c.name) + '</span>';
      }).join('');
    }
    function paintURail() {
      var r = $('slUCps'); if (!r) return;
      r.innerHTML = S.turn.cp.map(function (c, i) {
        var m = S.turn.marks[i];
        var icon = m ? (m.ok ? '<span class="rtick">' + ICON.tick + '</span>' : '<span class="rtick miss">' + ICON.cross + '</span>') : '<span class="rtick pend"></span>';
        return '<div class="sl-ucp' + (i === S.turn.at ? ' is-now' : '') + (m && !m.ok ? ' is-miss' : '') + '">' + icon + '<span>' + esc(c.diag || c.name) + '</span></div>';
      }).join('');
      var sc = $('slUScore');
      if (sc) {
        var got = S.turn.log.filter(function (x) { return x && x.ok; }).length, seen = S.turn.log.filter(Boolean).length;
        sc.innerHTML = seen ? '<b class="num">' + got + '</b><span>right first time, of ' + seen + '</span>'
          : '<span>Nothing marked yet</span>';
      }
      var p = $('slUPips');
      if (p) p.innerHTML = pipsHTML();
    }
    function pipsHTML() {
      var out = [], i;
      for (i = 0; i < S.set.length; i++) {
        var g = S.turn.log[i];
        out.push('<span class="sl-upip' + (g ? (g.ok ? ' is-ok' : ' is-miss') : (i === S.turn.i ? ' is-now' : '')) + '"></span>');
      }
      return out.join('');
    }

    /* ---------- one question ---------- */
    function mountTurn() {
      destroyTurn();
      var it = S.set[S.turn.i]; if (!it || !it.skill.turn) return;
      turnHost = $('slUBoard'); if (!turnHost) return;
      turnHost.innerHTML = '';
      S.turn.cp = []; S.turn.marks = []; S.turn.at = 0; S.turn.ended = false;
      var nx = $('slUNext'); if (nx) nx.hidden = true;
      var sh = $('slUShow'); if (sh) sh.disabled = false;
      var api = {
        steps: function (list) { S.turn.cp = list || []; S.turn.marks = []; paintUSteps(); paintURail(); },
        step: function (i) { S.turn.at = i; paintUSteps(); paintURail(); },
        prompt: function (html) { var e = $('slUPrompt'); if (!e) return; e.innerHTML = html || ''; refresh(e); },
        hint: function (html) { var e = $('slUHint'); if (!e) return; e.innerHTML = html || ''; if (html) refresh(e); },
        mark: function (i, ok, c) {
          S.turn.marks[i] = { name: (c && c.name) || '', diag: (c && c.diag) || (c && c.name) || '', ok: !!ok };
          paintUSteps(); paintURail();
        },
        done: function (ok) { finishTurnQ(!!ok); },
        reduceMotion: reduceMotion
      };
      S.turn.r = it.skill.turn(turnHost, it.q, api);
    }
    function finishTurnQ(ok) {
      if (S.turn.ended) return;
      S.turn.ended = true;
      /* the same progress a marked set feeds: a level is secure at 80% of ten,
         and a question answered right first time counts once, here or there */
      var it = S.set[S.turn.i];
      mark(it, ok);
      /* the run's own record: the results screen adds these up, so it keeps
         every checkpoint, not just the ones that went wrong */
      S.turn.log[S.turn.i] = {
        html: it.q.html, level: it.level, skill: it.skill.name, ok: ok,
        cps: S.turn.cp.map(function (c, i) { var m = S.turn.marks[i]; return { diag: (c && c.diag) || (c && c.name) || '', name: (c && c.name) || '', ok: !!(m && m.ok) }; }),
        missed: S.turn.cp.map(function (c, i) { var m = S.turn.marks[i]; return (m && !m.ok) ? ((c && c.name) || c.diag) : null; }).filter(Boolean)
      };
      paintURail(); renderTop();
      var last = S.turn.i >= S.set.length - 1;
      var nx = $('slUNext');
      if (nx) { nx.hidden = false; nx.innerHTML = (last ? 'See how you did' : 'Next question') + ICON.arrowR; refresh(nx); nx.focus(); }
      var sh = $('slUShow'); if (sh) sh.disabled = true;
    }
    function nextTurnQ() {
      if (S.turn.i >= S.set.length - 1) {
        S.turn.ms = Date.now() - S.turn.t0; S.turn.phase = 'done';
        destroyTurn(); renderTurn(); renderTop(); return;
      }
      S.turn.i++;
      renderTurn(); renderTop();
    }

    /* ---------- the screen ---------- */
    function renderTurn() {
      var sk = curSkill(); if (!sk || !sk.turn) { show('skill'); return; }
      if (!S.set.length) startTurn();
      if (!S.set.length) buildSet();
      if (S.turn.phase === 'done') { renderTurnResults(sk); return; }
      S.turn.i = Math.max(0, Math.min(S.set.length - 1, S.turn.i));
      var it = S.set[S.turn.i];
      var rail = '<div class="sl-rail-title">Question ' + (S.turn.i + 1) + ' of ' + S.set.length + '</div>' +
        '<div class="sl-upips" id="slUPips">' + pipsHTML() + '</div>' +
        '<div class="sl-ucps" id="slUCps"></div>' +
        '<div class="sl-uscore" id="slUScore"></div>';
      var main = '<div class="sl-teach-main sl-turn-main">' +
        lvlStripHTML() +
        '<div class="sl-teach-bar"><div class="sl-steps" id="slUSteps"></div></div>' +
        '<div class="sl-teach-q' + (entering ? '' : ' is-fresh') + '"><span class="tqn num">' + (S.turn.i + 1) + ' of ' + S.set.length + '</span>' +
          '<span class="sl-expr tqx">' + it.q.html + '</span></div>' +
        '<div class="sl-teach-board is-enter" id="slUBoard"></div>' +
        '<div class="sl-teach-actions sl-turn-foot">' +
          '<div class="sl-uprompt" id="slUPrompt"></div>' +
          '<div class="row"><button type="button" class="sl-btn sl-btn--cta" id="slUNext" hidden>Next question</button>' +
          '<button type="button" class="sl-btn sl-btn--ghost" id="slUShow" data-tip="Show me" data-tipsub="Stuck? The rest of this one counts as missed and the answer is drawn.">' + ICON.eye + 'Show me</button></div>' +
          '<div class="sl-hint" id="slUHint"></div>' +
        '</div></div>';
      paint(elTu, '<div class="sl-rail sl-turn-rail">' + rail + '</div><div class="sl-main">' + main + '</div>', function () { paintURail(); mountTurn(); });
    }

    /* ---------- the results, which are the reason this mode exists ---------- */
    function renderTurnResults(sk) {
      var n = S.turn.log.filter(function (x) { return x; }).length;
      var ok = S.turn.log.filter(function (x) { return x && x.ok; }).length;
      var order = [], by = {};
      S.turn.log.forEach(function (g) {
        if (!g || !g.cps) return;
        g.cps.forEach(function (c) {
          if (!by[c.diag]) { by[c.diag] = { n: 0, ok: 0 }; order.push(c.diag); }
          by[c.diag].n++; if (c.ok) by[c.diag].ok++;
        });
      });
      var bars = order.map(function (d) {
        var r = by[d], pc = r.n ? Math.round(r.ok / r.n * 100) : 0;
        return '<div class="sl-ubar' + (pc < 70 ? ' is-low' : '') + '"><span class="ubname">' + esc(d) + '</span>' +
          '<span class="ubtrack"><i style="width:' + pc + '%"></i></span>' +
          '<span class="ubnum num">' + r.ok + ' of ' + r.n + '</span></div>';
      }).join('');
      var rates = order.filter(function (d) { return by[d].n >= 2; })
        .map(function (d) { return { d: d, pc: by[d].ok / by[d].n, r: by[d] }; })
        .sort(function (x, y) { return x.pc - y.pc; });
      var low = rates.length ? rates[0] : null;
      var tied = low ? rates.filter(function (x) { return x.pc === low.pc; }) : [];
      var say = function (x) { return '<b>' + esc(x.d.charAt(0).toLowerCase() + x.d.slice(1)) + '</b>'; };
      var lead;
      if (!low) lead = '';
      else if (low.pc >= 0.8) lead = '<p class="sl-ulead">No single decision stands out as the weak one. Move up a level.</p>';
      else if (tied.length >= rates.length) lead = '<p class="sl-ulead">Every decision is going wrong at the moment, not one of them. Work through Teach at this level, then come back.</p>';
      else if (tied.length > 1) lead = '<p class="sl-ulead">' + tied.map(say).join(' and ') + ' are the ones to work on, ' + low.r.ok + ' of ' + low.r.n + ' right first time each.</p>';
      else lead = '<p class="sl-ulead">' + say(low) + ' is the one to work on: ' + low.r.ok + ' of ' + low.r.n + ' right first time. The rest came out better than that.</p>';
      var list = S.turn.log.map(function (g, i) {
        if (!g) return '';
        return '<li><span class="unum num">' + (i + 1) + '</span><span class="sl-expr uq">' + g.html + '</span>' +
          (g.ok ? '<span class="rtick">' + ICON.tick + '</span>'
                : '<span class="umiss">' + esc(g.missed.length >= (g.cps || []).length ? 'all ' + g.missed.length : g.missed.join(' · ')) + '</span>') + '</li>';
      }).join('');
      paint(elTu, '<div class="sl-main"><div class="sl-scroll"><div class="sl-ures' + (entering ? ' is-enter' : '') + '">' +
        '<h2>' + esc(sk.turnName || 'Your turn') + ': ' + esc(sk.name) + '</h2>' +
        '<div class="sl-uhead"><div class="uscore"><b class="num">' + ok + '</b><span>of ' + n + ' right first time</span></div>' +
          '<div class="utime"><b class="num">' + saidTime(S.turn.ms) + '</b><span>' + esc(levelWord(sk)) + '</span></div></div>' +
        '<div class="sl-sect">Every decision, on the first try</div>' + '<div class="sl-ubars">' + bars + '</div>' + lead +
        '<div class="sl-sect">The ten questions</div><ol class="sl-ulist">' + list + '</ol>' +
        '<div class="sl-urow">' +
          '<button type="button" class="sl-btn sl-btn--cta" id="slUAgain2">' + ICON.refresh + 'Ten more</button>' +
          '<button type="button" class="sl-btn" id="slUTeach">' + ICON.steps + 'Teach this level</button>' +
          '<button type="button" class="sl-btn" id="slUPractise">' + ICON.list + 'Practise</button>' +
          '<button type="button" class="sl-btn sl-btn--ghost" id="slUSkill">' + ICON.chevL + 'Back to the skill</button>' +
        '</div></div></div></div>');
    }

    elTu.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('button') : null; if (!t) return;
      var tTopic = t.closest('.sl-topic');
      if (tTopic) {
        var sk2 = SL.get(tTopic.getAttribute('data-topic'));
        if (sk2 && levelClick(t, sk2)) { startTurn(); renderTurn(); renderTop(); return; }
      }
      if (t.id === 'slUNext') { nextTurnQ(); return; }
      if (t.id === 'slUShow') { if (S.turn.r && S.turn.r.reveal) S.turn.r.reveal(); return; }
      if (t.id === 'slUAgain2') { startTurn(); renderTurn(); renderTop(); return; }
      if (t.id === 'slUTeach') { S.teach.i = 0; S.teach.back = null; show('teach'); return; }
      if (t.id === 'slUPractise') { show('practise'); return; }
      if (t.id === 'slUSkill') { show('skill'); return; }
    });

    /* ============================================================
       BOARD
       ============================================================ */
    var elBo = $('slBoard');

    /* ---------- board timer ----------
       Typed in words or in clock form: "4 mins", "3 min 30", "90s", "2:30", or a
       bare number meaning minutes. It counts down, turns red near the end and
       holds at TIME UP rather than running on into negatives. */
    var TM = { left: 300, set: 300, running: false, tick: null, editing: false };
    function parseTime(txt) {
      txt = String(txt == null ? '' : txt).trim().toLowerCase().replace(/\s+/g, ' ');
      if (!txt) return null;
      var m;
      if ((m = txt.match(/^(\d{1,3})\s*[:.]\s*(\d{1,2})$/))) return (+m[1]) * 60 + (+m[2]);
      if ((m = txt.match(/^(\d+)\s*(?:m|min|mins|minute|minutes)\s*(\d{1,2})\s*(?:s|sec|secs|second|seconds)?$/))) return (+m[1]) * 60 + (+m[2]);
      if ((m = txt.match(/^(\d+(?:\.\d+)?)\s*(?:s|sec|secs|second|seconds)$/))) return Math.round(+m[1]);
      if ((m = txt.match(/^(\d+(?:\.\d+)?)\s*(?:m|min|mins|minute|minutes)?$/))) return Math.round(+m[1] * 60);
      return null;
    }
    function clock(sec) {
      sec = Math.max(0, Math.round(sec));
      var m = Math.floor(sec / 60), r = sec % 60;
      return m + ':' + (r < 10 ? '0' : '') + r;
    }
    function stopTimer() { TM.running = false; if (TM.tick) { clearInterval(TM.tick); TM.tick = null; } }
    function startTimer() {
      if (TM.left <= 0) TM.left = TM.set;
      stopTimer(); TM.running = true;
      /* a deadline, not a countdown: a throttled background tab must not make five minutes run long */
      var endAt = Date.now() + TM.left * 1000;
      TM.tick = setInterval(function () {
        TM.left = Math.max(0, Math.round((endAt - Date.now()) / 1000));
        if (TM.left <= 0) { TM.left = 0; stopTimer(); }
        paintTimer();
      }, 250);
      paintTimer();
    }
    function toggleTimer() { if (TM.running) { stopTimer(); paintTimer(); } else startTimer(); }
    function resetTimer() { stopTimer(); TM.left = TM.set; paintTimer(); }
    function timerHTML() {
      return '<div class="' + timerClasses() + '" id="slTimer">' +
        (TM.editing
          ? '<input type="text" id="slTimerIn" class="tmin" value="' + clock(TM.left) + '" aria-label="Set the timer, for example 4 mins or 3 min 30" spellcheck="false" autocomplete="off">'
          : '<button type="button" class="tmface num" id="slTimerFace" data-tip="Set the time" data-tipsub="Click and type: 4 mins, 3 min 30, 90s or 2:30. It takes a new time while it is running.">' + (TM.left <= 0 ? "TIME UP" : clock(TM.left)) + '</button>') +
        '<button type="button" class="sl-iconbtn sl-iconbtn--sq" id="slTimerGo" aria-label="' + (TM.running ? 'Pause' : 'Start') + '" data-tip="' + (TM.running ? 'Pause' : 'Start') + '" data-tipsub="Key: T">' + (TM.running ? ICON.pause : ICON.play) + '</button>' +
        '<button type="button" class="sl-iconbtn sl-iconbtn--sq" id="slTimerRe" aria-label="Reset the timer" data-tip="Reset" data-tipsub="Back to the time you set.">' + ICON.refresh + '</button></div>';
    }
    /* The clock repaints every second. Rebuilding the whole strip each tick
       destroyed the input you were typing into - a second in, the caret went and
       the box reverted to the face - so a running timer could not be re-set.
       The full rebuild now happens only when the shape changes (face <-> input);
       every other paint just patches the text and the button states. */
    function timerClasses() {
      return 'sl-timer' + (TM.running ? ' is-run' : '') + (TM.left <= 0 ? ' is-up' : (TM.left <= 30 ? ' is-low' : ''));
    }
    function paintTimer() {
      var host = $('slTimerWrap'); if (!host) return;
      var box = host.querySelector('.sl-timer');
      var shaped = !!(box && (!!box.querySelector('#slTimerIn') === TM.editing));
      if (!shaped) {
        host.innerHTML = timerHTML();
        if (TM.editing) { var inp = $('slTimerIn'); if (inp) { inp.focus(); inp.select(); } }
        return;
      }
      box.className = timerClasses();
      if (!TM.editing) { var f = $('slTimerFace'); if (f) f.textContent = TM.left <= 0 ? 'TIME UP' : clock(TM.left); }
      var go = $('slTimerGo');
      if (go) {
        var lab = TM.running ? 'Pause' : 'Start';
        go.innerHTML = TM.running ? ICON.pause : ICON.play;
        go.setAttribute('aria-label', lab); go.removeAttribute('title');
        go.setAttribute('data-tip', lab); go.setAttribute('data-tipsub', 'Key: T');
      }
    }
    /* A running clock counts down to a DEADLINE fixed when it started, so
       writing a new time into the box changed TM.left and the next tick, a
       quarter of a second later, put the old time straight back - the box
       looked dead. A new time while it is running restarts it, which is the
       only way the deadline gets recomputed. */
    function commitTimer(txt) {
      var v = parseTime(txt), fresh = v !== null && v > 0;
      if (fresh) { TM.set = v; TM.left = v; }
      TM.editing = false;
      if (fresh && TM.running) { startTimer(); return; }
      paintTimer();
    }

    /* A skill whose questions carry a picture needs the room: half a column each.
       And past three columns the screen splits two rows deep, so each takes six
       questions rather than eight - otherwise the type drops below what reads
       from the back of a room. */
    function perCol(skills, ncol) {
      if (skills.some(function (sk) { return sk && sk.diagram; })) return 4;
      return (ncol >= 4) ? 6 : 8;
    }
    function buildBoard() {
      var cols = [];
      if (S.from === 'mixed') {
        var mix = mixSkills().slice(0, 6);
        if (S.board.mixLayout === 'mixed') {
          /* every column draws from all the skills in turn, so a column is a
             mixed set rather than one topic */
          var ncm = Math.max(1, Math.round(S.board.n / 8)), pcm = perCol(mix, ncm);
          for (var m = 0; m < ncm; m++) {
            var mitems = [], queues = mix.map(function (sk) { return dealFor(sk, pcm); });
            for (var z = 0; mitems.length < pcm; z++) { var qq = queues[z % queues.length]; if (qq.length) mitems.push(qq.shift()); else if (queues.every(function (x) { return !x.length; })) break; }
            cols.push({ skill: mix[0], mixed: mix, items: mitems, title: ncm > 1 ? 'Questions ' + (m * pcm + 1) + ' to ' + (m * pcm + pcm) : 'Mixed questions',
                        sub: mix.length + ' skills mixed', tab: (m * pcm + 1) + ' to ' + (m * pcm + pcm), offset: m * pcm });
          }
        } else {
          var per = perCol(mix, mix.length);
          mix.forEach(function (sk) { cols.push({ skill: sk, items: dealFor(sk, per), title: sk.name, sub: levelWord(sk), tab: sk.short || sk.name, level: skillLevel(sk) }); });
        }
      } else {
        var sk = curSkill(); if (!sk) { S.board.cols = []; return; }
        var pc = perCol([sk], S.board.layout === 'diff' ? 3 : Math.max(1, Math.round(S.board.n / 8)));
        if (S.board.layout === 'diff') {
          diffLevels(sk).forEach(function (L) { var ctx = { seen: {}, shapeSeen: {}, last: null }, items = []; for (var k = 0; k < pc; k++) items.push(makeItem(sk, L, ctx)); cols.push({ skill: sk, level: L, fixedLevel: L, items: items, title: 'Level ' + L, sub: levelName(sk, L), tab: 'Level ' + L }); });
        } else {
          var ncol = Math.max(1, Math.round(S.board.n / 8)), all = dealFor(sk, ncol * pc), sel = selLevels(sk);
          for (var c = 0; c < ncol; c++) cols.push({ skill: sk, level: sel[0], items: all.slice(c * pc, c * pc + pc), title: ncol > 1 ? 'Questions ' + (c * pc + 1) + ' to ' + (c * pc + pc) : sk.name, sub: levelWord(sk), tab: (c * pc + 1) + ' to ' + (c * pc + pc), offset: c * pc });
        }
      }
      S.board.cols = cols; S.board.tab = 0; S.board.ans = false;
      if (S.from !== 'mixed' && curSkill()) cols.bsSig = boardSigFor(curSkill());
    }
    /* one question again, same skill and level, nothing else on the board moves
       (Aadam, 2026-09-15: "on board can refresh individual questions") */
    function freshBoardQ(ci, k) {
      var c = S.board.cols[ci], it = c && c.items[k]; if (!it || !it.skill) return;
      var ctx = { seen: {}, shapeSeen: {}, last: null };
      S.board.cols.forEach(function (col) { col.items.forEach(function (x) { if (x.skill === it.skill && x.q) ctx.seen[x.q.key] = 1; }); });
      ctx.slot = slotIn(c.items, k);
      c.items[k] = makeItem(it.skill, it.level, ctx);
      FX.col = -1; bFresh = ci + '.' + k;
      renderBoard();
    }
    /* deal one column again, at whatever it was set to, leaving the rest alone */
    function redealCol(i) {
      var c = S.board.cols[i]; if (!c || !c.skill) return;
      var n = c.items.length, ctx = { seen: {}, shapeSeen: {}, last: null }, items = [], k;
      if (c.mixed) {
        var qs = c.mixed.map(function (sk) { return dealFor(sk, n); });
        for (k = 0; items.length < n; k++) { var q1 = qs[k % qs.length]; if (q1.length) items.push(q1.shift()); else if (qs.every(function (x) { return !x.length; })) break; }
      } else if (c.fixedLevel) { for (k = 0; k < n; k++) items.push(makeItem(c.skill, c.fixedLevel, ctx)); }
      else items = dealFor(c.skill, n, ctx);
      c.items = items; FX.col = i;
      renderBoard();
    }
    /* A skill can offer a whole-class count for the board - the projector doing
       the counting so the room chants along. Only when one skill is on: a mix
       has no single step to count in. */
    function chorusOK() { var sk = curSkill(); return S.from !== 'mixed' && !!(sk && sk.chorus); }
    var chorusR = null;
    function destroyChorus() { if (chorusR && chorusR.destroy) { try { chorusR.destroy(); } catch (err) {} } chorusR = null; }
    function mountChorus() {
      var sk = curSkill(), h = $('slChorusHost');
      if (!h || !sk || !sk.chorus) return;
      chorusR = sk.chorus(h, {
        state: (S.chorus && S.chorus[sk.id]) || {},
        save: function (st) { S.chorus = S.chorus || {}; S.chorus[sk.id] = st; save(); }
      });
    }
    /* the board's columns and foot, shared by the board and the setup preview (2026-09-16) */
    function boardColsHTML(cols, colFx, headChips) {
      return cols.map(function (c, i) {
        var col = colourOf(c.skill), off = c.offset || 0;
        /* the head carries a short title too, for fitHeads to swap in when the
           column is narrow: the skill's short name, or the range the tabs show */
        var short = c.title === c.skill.name ? (c.skill.short || c.title) : (c.tab || c.title);
        return '<div class="sl-card sl-bcol' + (i === S.board.tab ? ' is-tab' : '') + (colFx === i ? ' is-enter' : '') + '" style="--i:' + i + '"><div class="sl-bhead" style="background:' + col.tint + '"><span class="bname" style="color:' + col.col + '">' + skIcon(c.skill) +
          '<span class="btitle"><span class="bt-full">' + esc(c.title) + '</span><span class="bt-short">' + esc(short) + '</span></span></span>' +
          (headChips ? '<span class="blvl">' + esc(c.sub) + '</span>' + headChipsHTML(c.skill)
            : '<span class="sl-chip num" style="color:' + col.col + ';border-color:' + col.col + ';background:var(--surface);cursor:default">' + esc(c.sub) + '</span>') +
          '<button type="button" class="sl-bnew" data-bnew="' + i + '" aria-label="New questions for ' + esc(c.title) + '" data-tip="New questions" data-tipsub="Deals this column again. The other columns stay as they are.">' + ICON.refresh + '</button></div>' +
          c.items.map(function (it, k) { return '<button type="button" class="sl-brow' + (it.ans ? ' is-ans' : '') + '" data-brow="' + i + '.' + k + '" style="--i:' + k + ';--ci:' + i + '" aria-pressed="' + (it.ans ? 'true' : 'false') + '"><span class="bn">' + (off + k + 1) + '<span class="bfresh" data-bfresh="' + i + '.' + k + '" role="button" aria-label="A new question ' + (off + k + 1) + '" data-tip="New question">' + ICON.refresh + '</span></span>' + (c.mixed ? '<span class="bdot" style="background:' + colourOf(it.skill).col + '" title="' + esc(it.skill.name) + '"></span>' : '') + '<span class="sl-expr">' + it.q.html + (it.q.choice ? '<span class="sl-bopts">' + it.q.choice.options.map(function (o, k) { return '<i><b>' + 'ABCDEF'.charAt(k) + '</b>' + o + '</i>'; }).join('') + '</span>' : '') + '</span><span class="sl-expr sl-ans">' + it.q.ansHTML + '</span></button>'; }).join('') + '</div>';
      }).join('');
    }
    function boardFootHTML(cols) {
      return '<div class="sl-bfoot">' + logoHTML('sl-logo--foot') + '<span>shlc-tutor.co.uk/pages/skills-lab</span><span>' + (S.from === 'mixed' ? (cols[0] && cols[0].mixed ? cols[0].mixed : cols.map(function (c) { return c.skill; })).map(function (sk) { return esc(sk.short || sk.name) + ' L' + selLevels(sk).join(','); }).join(' · ') : esc(curSkill() ? curSkill().name : '') + ' · ' + (S.board.layout === 'diff' ? 'levels ' + cols.map(function (c) { return c.level; }).join(', ') : esc(levelWord(curSkill()).toLowerCase()))) + '</span></div>';
    }
    function renderBoard() {
      if (!S.board.cols.length) buildBoard();
      var cols = S.board.cols;
      /* a new set deals every column in; one refreshed column deals itself in;
         a tab change or the answers toggle leaves the board where it is */
      var colFx = FX.col; FX.col = undefined;
      var sig = cols.map(function (c) { return c.items.map(function (it) { return it.q && it.q.key; }).join(','); }).join('|');
      var enter = entering || (colFx === undefined && sig !== boardSig);
      boardSig = sig;
      var tabs = cols.length > 1 ? '<div class="sl-btabs show-sm" role="tablist">' + cols.map(function (c, i) { return '<button type="button" role="tab" class="sl-chip' + (i === S.board.tab ? ' sl-chip--now' : '') + '" data-btab="' + i + '" aria-selected="' + (i === S.board.tab ? 'true' : 'false') + '">' + esc(c.tab) + '</button>'; }).join('') + '</div>' : '';
      var diffBoard = S.from !== 'mixed' && S.board.layout === 'diff';
      var headChips = !diffBoard && !cols.some(function (c) { return c.mixed; });
      var html = boardColsHTML(cols, colFx, headChips);
      var foot = boardFootHTML(cols);
      var sk0 = curSkill();
      var pTitle = S.from === 'mixed' ? 'Mixed practice' : esc(sk0 ? sk0.name : 'Skills Lab');
      var pSub = S.from === 'mixed' ? cols.map(function (c) { return esc(c.skill.short || c.skill.name); }).join(' · ')
        : (S.board.layout === 'diff' ? 'Levels ' + cols.map(function (c) { return c.level; }).join(', ') : esc(levelWord(sk0)));
      var head = '<div class="sl-print-head">' + logoHTML('sl-logo--sheet') + '<div class="ph-l"><b>' + pTitle + '</b><span>' + pSub + (S.board.ans ? ' · answers' : '') + '</span></div>' +
        '<div class="ph-r"><span>Name</span><i></i><span>Date</span><i class="sm"></i></div></div>';
      var strip = headChips ? '' : lvlStripHTML('', diffBoard ? 3 : 0);
      paint(elBo, '<div class="sl-main">' + strip + '<div class="sl-board-main' + (S.board.ans ? ' show-ans' : '') + '">' + head + tabs + '<div class="sl-board-cols n' + Math.min(6, cols.length) + (enter ? ' is-enter' : '') + '">' + (html || '<div class="sl-empty">Pick a skill first.</div>') + '</div>' + foot + '</div></div>');
      fitBoard(); watchBoard();
      if (bFresh) { var fr = elBo.querySelector('[data-brow="' + bFresh + '"]'); if (fr) fr.classList.add('is-fresh'); bFresh = null; }
    }
    var boardSig = '', bFresh = null;
    /* A long answer ran off the end of its column: the question would not give
       way and the answer would not shrink, so the last terms were simply cut off.
       Each row now measures what it needs against the width it has, and a row
       that is too long shrinks its question AND its answer by the same factor,
       so a crowded row keeps the proportions every other row has. (It used to
       shrink the question to its floor first and the answer only after that,
       which left "Write the value of the 4 in 0.090034" at about 13px beside a
       24px answer; Aadam asked for the two to come down together, 2026-09-11.)
       Measured in one pass, written in the next, then checked once, because
       scaling type does not scale the row number or the gaps with it. */
    /* SMARTBOARD BOARD ROWS (2026-09-21). Aadam: "NEEDS TO BE MUCH LARGER TO BE ABLE TO SEE THEM".
       Rows were ~112px tall and ~620px wide on a 1920x1080 board of 24, yet the type sat at 18px:
       each skill's CSS caps its size with a vh clamp, and the fit below only ever shrank a row.
       growBoard finds, for every row, the biggest scale of its question AND answer (together, so
       the two keep their proportions) that keeps the ink inside the row's width and 96% of its
       height; a hidden answer keeps its room, so showing the answers moves nothing. Then a column
       takes one size so it reads tidy (the whole board, when one skill fills every column in the
       mixed layout): the biggest size that half the rows can take. The rest, the long ones, keep
       the biggest size they can take, which is smaller. No row is held below the size its skill's
       CSS gives it, so nothing reads smaller than it did before. A bisection over every row at once, so it
       costs about a dozen layouts. Rows that grow to fit their type (a phone board scrolls) are
       left to the shrink-only fit. */
    var GROW_LO = 0.3, GROW_HI = 8, GROW_H = 0.96, GROW_TIDY = 0.5, GROW_GAP = 0.5;
    function growBoard(rows) {
      var list = [];
      Array.prototype.forEach.call(rows, function (r) {
        var cs = window.getComputedStyle(r);
        if (!(parseFloat(cs.flexGrow) > 0) || cs.flexBasis === 'auto' || !r.offsetHeight) return;
        var q = r.querySelector('.sl-expr:not(.sl-ans)'); if (!q) return;
        list.push({ r: r, q: q, a: r.querySelector('.sl-ans'), col: r.parentNode, lo: GROW_LO, hi: GROW_HI,
          base: parseFloat(window.getComputedStyle(q).fontSize) || 16, ra: 1,
          pad: [(parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.borderLeftWidth) || 0), (parseFloat(cs.paddingRight) || 0) + (parseFloat(cs.borderRightWidth) || 0),
                (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.borderTopWidth) || 0), (parseFloat(cs.paddingBottom) || 0) + (parseFloat(cs.borderBottomWidth) || 0)] });
      });
      if (!list.length) return false;
      /* an answer never outgrows its question: a few skills cut the question's size for their long
         rows and left the answer's, so "51" stood half as big again as "Write LI in figures" */
      list.forEach(function (t) { var fa = t.a ? parseFloat(window.getComputedStyle(t.a).fontSize) : 0; t.fa = fa; if (fa > t.base) t.ra = t.base / fa; });
      /* the ink of a question or answer: its text, pictures and small inline pieces (a chip, a gap
         box), never a block box, which spans the whole row whatever the type (a two-line question's
         halves are blocks). Listed once per row. A hidden answer sits 6px to the right (it slides
         in), so its slide is taken off to measure where it will show. */
      function parts(el) {
        var out = [];
        (function walk(n) {
          for (var c = n.firstChild; c; c = c.nextSibling) {
            if (c.nodeType === 3) { if (/\S/.test(c.nodeValue)) out.push(c); continue; }
            if (c.nodeType !== 1) continue;
            var d = window.getComputedStyle(c).display, tag = c.tagName.toLowerCase();
            if (d === 'none') continue;
            if (tag === 'svg' || tag === 'img' || tag === 'canvas' || (!c.firstElementChild && d.indexOf('inline') === 0)) out.push(c);
            if (tag !== 'svg') walk(c);
          }
        })(el);
        return out;
      }
      var g = document.createRange();
      function ink(el, bits, slid) {
        if (!el || !el.offsetHeight || !bits.length) return null;
        var l = 1e9, r = -1e9, tp = 1e9, bt = -1e9;
        bits.forEach(function (n) {
          var b;
          if (n.nodeType === 3) { g.selectNodeContents(n); b = g.getBoundingClientRect(); } else b = n.getBoundingClientRect();
          if (!b.width && !b.height) return;
          l = Math.min(l, b.left); r = Math.max(r, b.right); tp = Math.min(tp, b.top); bt = Math.max(bt, b.bottom);
        });
        if (l > r) return null;
        var tx = 0;
        if (slid) { var m = /matrix\(([^)]+)\)/.exec(window.getComputedStyle(el).transform || ''); if (m) tx = parseFloat(m[1].split(',')[4]) || 0; }
        return { l: l - tx, r: r - tx, t: tp, b: bt };
      }
      list.forEach(function (t) { t.qb = parts(t.q); t.ab = t.a ? parts(t.a) : []; });
      function fits(t) {
        var rr = t.r.getBoundingClientRect();
        var L = rr.left + t.pad[0], R = rr.right - t.pad[1], T = rr.top + t.pad[2], B = rr.bottom - t.pad[3];
        var qi = ink(t.q, t.qb, false), ai = ink(t.a, t.ab, true);
        if (!qi) return true;
        var top = ai ? Math.min(qi.t, ai.t) : qi.t, bot = ai ? Math.max(qi.b, ai.b) : qi.b, mid = (T + B) / 2;
        if (Math.max(mid - top, bot - mid) > (B - T) * GROW_H / 2) return false;
        if (qi.l < L - 0.5 || qi.r > R + 0.5) return false;
        /* half the answer's size clear of the question, or at 60px "0.82 ÷ 1000 0.00082" reads as one sum */
        if (ai && (ai.r > R + 0.5 || qi.r > ai.l - Math.max(12, GROW_GAP * t.fa * t.k * t.ra))) return false;
        return true;
      }
      function put(t, k) { t.r.style.setProperty('--fitq', k.toFixed(3)); t.r.style.setProperty('--fita', (k * t.ra).toFixed(3)); }
      var i;
      for (i = 0; i < 9; i++) {
        list.forEach(function (t) { t.k = Math.sqrt(t.lo * t.hi); put(t, t.k); });
        list.forEach(function (t) { if (fits(t)) t.lo = t.k; else t.hi = t.k; });
      }
      /* one size per column (per board for a single skill laid out in turn), in real pixels,
         because two skills in a mixed column start from different sizes */
      var whole = S.from !== 'mixed' && S.board.layout !== 'diff', groups = [], keyOf = [];
      list.forEach(function (t) {
        var key = whole ? 0 : keyOf.indexOf(t.col);
        if (key < 0) { keyOf.push(t.col); key = keyOf.length - 1; }
        (groups[key] = groups[key] || []).push(t);
      });
      groups.forEach(function (g) {
        var px = g.map(function (t) { return t.lo * t.base; }).sort(function (x, y) { return x - y; });
        var P = px[Math.floor((px.length - 1) * GROW_TIDY)];
        g.forEach(function (t) { t.k = Math.min(t.lo, Math.max(1, P / t.base)); put(t, t.k); });
      });
      /* type does not always scale in step (a wrapped line can break differently), so check once
         more and take a little off any row that ended up over */
      for (i = 0; i < 3; i++) {
        var over = list.filter(function (t) { return t.k > GROW_LO && !fits(t); });
        if (!over.length) break;
        over.forEach(function (t) { t.k = Math.max(GROW_LO, t.k * 0.94); put(t, t.k); });
      }
      return true;
    }
    var FITQ_MIN = 0.6, FITA_MIN = 0.62;
    /* PHONE ROUND 3: TEACH + BOARD ON A PHONE (2026-09-23). The app sizes a model by shrinking its root, and every label inside
       it is em of that root, so a label can end up at 7px with nothing in its own rule to stop it.
       Under 861px every leaf of text still under PW_LEAF after a fit is pinned to PW_LEAF. Pins are
       cleared first, so a screen that grows gets its em sizes back. Never runs above 860px. */
    function floorType(root) {
      if (!root || !flowWall()) return;
      each(root.querySelectorAll('[data-slfloor]'), function (e) { e.style.removeProperty('font-size'); e.removeAttribute('data-slfloor'); });
      each(root.querySelectorAll('*'), function (e) {
        if (e.children.length || !(e.textContent || '').trim()) return;
        if (!e.offsetWidth && !e.offsetHeight) return;
        var cs = window.getComputedStyle(e), f;
        if (cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return;
        if (isMark(e) || (e.parentNode && e.parentNode.nodeType === 1 && isMark(e.parentNode))) return;
        f = parseFloat(cs.fontSize);
        if (f && f < PW_LEAF) { e.style.fontSize = PW_LEAF + 'px'; e.setAttribute('data-slfloor', '1'); }
      });
    }
    var floorT = null;
    function floorSoon(root) { clearTimeout(floorT); floorT = setTimeout(function () { floorType(root); }, 260); }
    function fitBoard(root) {
      root = root && root.querySelectorAll ? root : elBo;
      fitHeads(root);
      var rows = root.querySelectorAll('.sl-brow'); if (!rows.length) return;
      var plan = [];
      Array.prototype.forEach.call(rows, function (r) {
        r.style.removeProperty('--fitq'); r.style.removeProperty('--fita'); r.classList.remove('is-wrapq');
      });
      /* PHONE ROUND 3: TEACH + BOARD ON A PHONE (2026-09-23): a board row is ONE line that never wraps, which is right on a
         board and wrong on a phone - under 861px a question that would have to shrink past the fit's
         floor is allowed to wrap onto a second line instead of being cut off. The rows there are a
         scrolling column, so the height is free. */
      if (flowWall()) Array.prototype.forEach.call(rows, function (r) {
        var q = r.querySelector('.sl-expr:not(.sl-ans)'), a = r.querySelector('.sl-ans'), cs, avail, room, k, fixed = 0;
        if (!q) return;
        cs = window.getComputedStyle(r);
        avail = r.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
        for (k = 0; k < r.children.length; k++) if (r.children[k] !== q) fixed += r.children[k].offsetWidth + 8;
        room = avail - fixed;
        /* the CONTENT width, not the box: a flex row squeezes the question's box, so a question whose choice
           options run past it measured 322px of box against 492px of content and was never marked, and the
           options sat 142px outside the card (rearranging formulae at 430, 2026-09-25) */
        /* 2026-09-25 (polish round): and a phone row that would have to come down past 85% wraps instead of
           waiting for the fit's 0.6 floor (a row that landed between the two ran off its card at the floor) */
        if (room > 0 && Math.max(q.offsetWidth, q.scrollWidth) > room / 0.85) r.classList.add('is-wrapq');
      });
      if (growBoard(rows)) return;  /* SMARTBOARD BOARD ROWS (2026-09-21): a board that fills the screen grows its type */
      Array.prototype.forEach.call(rows, function (r) {
        var q = r.querySelector('.sl-expr:not(.sl-ans)'), a = r.querySelector('.sl-ans');
        if (!q) return;
        var cs = window.getComputedStyle(r);
        var avail = r.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
        var gap = parseFloat(cs.columnGap) || parseFloat(cs.gap) || 0;
        var fixed = gap * Math.max(0, r.children.length - 1), k;
        /* margins too: a mixed column's colour dot has a 2px margin, and leaving it out put
           every fitted answer on those boards 2px into the row's padding */
        for (k = 0; k < r.children.length; k++) if (r.children[k] !== q && r.children[k] !== a) {
          var ck = window.getComputedStyle(r.children[k]);
          fixed += r.children[k].offsetWidth + (parseFloat(ck.marginLeft) || 0) + (parseFloat(ck.marginRight) || 0);
        }
        var room = avail - fixed, qw = q.offsetWidth, aw = a ? a.offsetWidth : 0;
        if (room <= 0 || qw + aw <= room) return;
        var s = room / (qw + aw), fq = Math.max(FITQ_MIN, s), fa = aw ? Math.max(FITA_MIN, s) : 1;
        plan.push({ r: r, q: q, a: a, room: room, fq: fq, fa: fa });
      });
      plan.forEach(function (p) {
        p.r.style.setProperty('--fitq', p.fq.toFixed(3));
        if (p.fa < 1) p.r.style.setProperty('--fita', p.fa.toFixed(3));
      });
      /* one check: type does not scale perfectly linearly, so trim what is left over */
      plan.forEach(function (p) {
        var got = p.q.offsetWidth + (p.a ? p.a.offsetWidth : 0);
        if (got <= p.room || !got) return;
        var k = p.room / got;
        p.r.style.setProperty('--fitq', Math.max(FITQ_MIN * 0.85, p.fq * k).toFixed(3));
        p.r.style.setProperty('--fita', Math.max(FITA_MIN * 0.85, p.fa * k).toFixed(3));
      });
      fitHeight(rows);
      floorType(root);
    }
    /* HEIGHT. The fit above is width only, so a question taller than its row (two lines, a
       list that wraps, a clock face) ran into the row below wherever rows are short: four to
       six skills sit two deep, six to a column, which leaves a row about 0.6 of the height
       every skill's face was sized for (measured 2026-09-11 on mixed boards: roman clocks
       27-66px over, place value's two-sentence rows 9-21px, comparing's lists and reading-
       writing's words up to 23px). Each row now measures the ink of its question and of its
       answer (a Range, which stands a little proud of the line boxes) around the middle of its
       own content box, and a row that stands too tall brings the two down together, as the
       width fit does, to the biggest type that fits. Rows that grow to fit (a phone board
       scrolls) are left alone. */
    var FITH_MIN = 0.35;
    function fitHeight(rows) {
      function reach(el, mid) {
        if (!el || !el.offsetHeight) return 0;
        var g = document.createRange(); g.selectNodeContents(el);
        var ink = g.getBoundingClientRect(), box = el.getBoundingClientRect();
        return Math.max(mid - Math.min(ink.top, box.top), Math.max(ink.bottom, box.bottom) - mid);
      }
      /* how far past its room a row stands: over 1 is too tall. `edge` keeps a row that is being
         fitted just inside its box; a row that fits as it is is never touched. */
      function over(r, edge) {
        var cs = window.getComputedStyle(r), rr = r.getBoundingClientRect();
        var top = rr.top + (parseFloat(cs.borderTopWidth) || 0) + (parseFloat(cs.paddingTop) || 0);
        var bot = rr.bottom - (parseFloat(cs.borderBottomWidth) || 0) - (parseFloat(cs.paddingBottom) || 0);
        var mid = (top + bot) / 2, half = (bot - top) / 2 - edge;
        if (half <= 0) return 0;
        return Math.max(reach(r.querySelector('.sl-expr:not(.sl-ans)'), mid), reach(r.querySelector('.sl-ans'), mid)) / half;
      }
      var todo = [];
      Array.prototype.forEach.call(rows, function (r) {
        var cs = window.getComputedStyle(r);
        if (!(parseFloat(cs.flexGrow) > 0) || cs.flexBasis === 'auto' || !r.offsetHeight) return;
        if (over(r, 0) > 1) todo.push({ r: r, fq: parseFloat(r.style.getPropertyValue('--fitq')) || 1, fa: parseFloat(r.style.getPropertyValue('--fita')) || 1, lo: 0, hi: 1 });
      });
      if (!todo.length) return;
      /* a wrapped list or sentence loses lines as its type comes down, so its height does not
         follow the type in step (one straight scale shrank "Largest first: 21,913, 448, ..." to
         7px on one line where two lines at 60% fitted). Each tall row finds the biggest type
         that fits by halving the gap seven times, every row at once, so it costs seven layouts. */
      function put(t, k) {
        t.r.style.setProperty('--fitq', Math.max(FITH_MIN, t.fq * k).toFixed(3));
        t.r.style.setProperty('--fita', Math.max(FITH_MIN, t.fa * k).toFixed(3));
      }
      for (var i = 0; i < 7; i++) {
        todo.forEach(function (t) { t.k = (t.lo + t.hi) / 2; put(t, t.k); });
        todo.forEach(function (t) { if (over(t.r, 0.3) > 1) t.hi = t.k; else t.lo = t.k; });
      }
      todo.forEach(function (t) { put(t, t.lo); });
    }
    var fitWait = null;
    function refitBoard() {
      if (S.screen !== 'board' || !shell.classList.contains('is-on')) return;
      clearTimeout(fitWait); fitWait = setTimeout(fitBoard, 120);
    }
    window.addEventListener('resize', refitBoard);
    window.addEventListener('resize', refitCards);
    try { if (document.fonts && document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', refitCards); } catch (err) {}
    /* The FIRST fit measured the rows in the fallback font (the board's heavy weights of the
       web font load the moment the board first uses them), or measured a board still 0 wide
       while the shell animated in and skipped every row. Nothing measured again until the
       window was resized, so on the live page a few answers ran off their column on every
       first load. The board now fits again when a web font finishes loading and whenever
       the columns' own width really moves. */
    try {
      if (document.fonts) {
        if (document.fonts.ready) document.fonts.ready.then(refitBoard);
        if (document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', refitBoard);
      }
    } catch (err) {}
    /* ...and when their HEIGHT moves: the height fit measured rows before the top bar had
       settled (it wraps to a second line once its font lands, or when a toggle re-renders it),
       the rows got shorter, and nothing fitted again, so a few stayed a pixel over. On a phone
       the columns scroll, so their height does not follow the rows and this cannot loop. */
    var stopBoardW = null, stopBoardH = null;
    function watchBoard() {
      if (stopBoardW) stopBoardW();
      if (stopBoardH) stopBoardH();
      var box = elBo.querySelector('.sl-board-cols');
      stopBoardW = box ? watchWidth(box, refitBoard) : null;
      stopBoardH = null;
      if (box && window.ResizeObserver) {
        var lastH = box.clientHeight, ro = new ResizeObserver(function () {
          var h = box.clientHeight;
          if (!h || Math.abs(h - lastH) < 2) return;
          lastH = h; refitBoard();
        });
        ro.observe(box);
        stopBoardH = function () { ro.disconnect(); };
      }
    }
    /* A column head is one row: the title, the level chips, the refresh. Three
       columns of a nine-level skill at 1280 wide asked the head for 80px more
       than it had, and the refresh - the one control every column keeps - was
       the part the column's edge cut off. The heads are measured like the rows,
       and the whole board steps down together so every head matches: first the
       short title (.hd-short), then smaller chips (.hd-small). Past that the
       CSS lets the title end in an ellipsis and the chips scroll under a fade,
       with the level being worked scrolled into view. Nothing pushes the
       refresh out. */
    function fitHeads(root) {
      var box = (root && root.querySelector ? root : elBo).querySelector('.sl-board-cols'); if (!box) return;
      var titles = box.querySelectorAll('.sl-bhead .btitle'), strips = box.querySelectorAll('.sl-bhead .sl-lvlchips');
      /* the title's own text against its box, in real (sub-pixel) widths: "Questions 1 to 8" ran 0.06px
         over a 125.75px box, scrollWidth rounded both to 126, and the head kept the long title with an
         ellipsis instead of stepping down to "1 to 8" (2026-09-25) */
      function over(el) { var r = document.createRange(); r.selectNodeContents(el); return r.getBoundingClientRect().width > el.getBoundingClientRect().width + 0.01; }
      function squeezed() {
        var k;
        for (k = 0; k < titles.length; k++) if (titles[k].scrollWidth > titles[k].clientWidth + 1 || over(titles[k])) return true;
        for (k = 0; k < strips.length; k++) if (strips[k].scrollWidth > strips[k].clientWidth + 1) return true;
        return false;
      }
      box.classList.remove('hd-short', 'hd-small');
      if (squeezed()) { box.classList.add('hd-short'); if (squeezed()) box.classList.add('hd-small'); }
      each(strips, function (s) {
        var on = s.querySelectorAll('.sl-chip--now'), first = s.firstElementChild;
        if (on.length && first && s.scrollWidth > s.clientWidth + 1) {
          var a = on[0], b = on[on.length - 1];
          s.scrollLeft = (a.offsetLeft + b.offsetLeft + b.offsetWidth) / 2 - first.offsetLeft - s.clientWidth / 2;
        } else s.scrollLeft = 0;
        chipFade(s);
      });
    }
    function chipFade(s) {
      var over = s.scrollWidth > s.clientWidth + 1;
      s.classList.toggle('is-fl', over && s.scrollLeft > 1);
      s.classList.toggle('is-fr', over && s.scrollLeft + s.clientWidth < s.scrollWidth - 1);
    }
    elBo.addEventListener('scroll', function (e) {
      var s = e.target; if (s.classList && s.classList.contains('sl-lvlchips')) chipFade(s);
    }, true);
    /* a mouse wheel turns up and down: over a strip that scrolls sideways it moves the chips */
    elBo.addEventListener('wheel', function (e) {
      var s = e.target.closest ? e.target.closest('.sl-bhead .sl-lvlchips') : null;
      if (!s || s.scrollWidth <= s.clientWidth + 1 || Math.abs(e.deltaX) >= Math.abs(e.deltaY)) return;
      s.scrollLeft += e.deltaY * (e.deltaMode === 1 ? 16 : 1); e.preventDefault();
    }, { passive: false });
    /* the toolbar toggle sets every row at once; a row click sets just that one */
    function setAllAns(v) {
      S.board.ans = v; syncHash(false);
      S.board.cols.forEach(function (c) { c.items.forEach(function (it) { it.ans = v; }); });
    }
    /* The answers toggle used to rebuild the board, which threw away the rows
       the answers would have faded in on. Now it patches the rows in place, so
       they fade up one after another (is-cascade adds the row's own delay), and
       the class comes off once the cascade has run so a single row click is
       not delayed by it. */
    var cascadeT = null;
    function paintAns() {
      var cols = elBo.querySelector('.sl-board-cols'), main = elBo.querySelector('.sl-board-main');
      if (!cols) { renderBoard(); return; }
      if (main) main.classList.toggle('show-ans', S.board.ans);
      cols.classList.add('is-cascade');
      each(cols.querySelectorAll('.sl-brow'), function (r) {
        var p = r.getAttribute('data-brow').split('.'), col = S.board.cols[Number(p[0])], it = col && col.items[Number(p[1])], on = !!(it && it.ans);
        r.classList.toggle('is-ans', on); r.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      clearTimeout(cascadeT); cascadeT = setTimeout(function () { cols.classList.remove('is-cascade'); }, 1000);
    }
    elBo.addEventListener('click', function (e) {
      var fq = e.target.closest ? e.target.closest('[data-bfresh]') : null;
      if (fq) { var fp = fq.getAttribute('data-bfresh').split('.'); freshBoardQ(Number(fp[0]), Number(fp[1])); return; }
      var t = e.target.closest ? e.target.closest('button') : null; if (!t) return;
      var bTopic = t.closest('.sl-topic');
      if (bTopic) {
        var bsk = SL.get(bTopic.getAttribute('data-topic'));
        if (bsk && levelClick(t, bsk, (S.from !== 'mixed' && S.board.layout === 'diff') ? 3 : 0)) { buildBoard(); renderBoard(); renderTop(); }
        return;
      }
      if (t.hasAttribute('data-btab')) { S.board.tab = Number(t.getAttribute('data-btab')); renderBoard(); return; }
      if (t.hasAttribute('data-bnew')) { redealCol(Number(t.getAttribute('data-bnew'))); return; }
      if (t.hasAttribute('data-brow')) {
        var p = t.getAttribute('data-brow').split('.'), col = S.board.cols[Number(p[0])];
        if (!col) return;
        var it = col.items[Number(p[1])]; if (!it) return;
        it.ans = !it.ans;
        t.classList.toggle('is-ans', it.ans);
        t.setAttribute('aria-pressed', it.ans ? 'true' : 'false');
        return;
      }
    });

    /* ============================================================
       SPEED
       The fourth thing you can do with a skill. Practise is ten questions
       with the marking left to you; Speed is the same questions against a
       clock, typed on a keypad, with every answer TIMED so the results can
       say where the time actually went and which level is costing it.

       Two shapes, named the way the rest of the site names them:
         Race           - 10 to 50 questions, stopwatch, score is the time.
         Beat the clock - 1 to 10 minutes, endless questions, score is the
                          number right.

       Questions come from the SAME dealer as everything else. `dealFor` keeps
       its quota plan on the ctx it is handed (see counting.js `stateFor`), and
       a plan refills itself when it empties, so one long-lived ctx per skill
       keeps a level's mix right for a four-minute run. `ctx.seen` is the part
       that cannot run forever - after a hundred questions everything is seen
       and the generator falls back to a repeat - so each skill's ctx is
       replaced every ten questions. That is the rolling block: the quota is
       calibrated on ten, so it is dealt in tens.
       ============================================================ */
    var elSpS = $('slSpeedSetup'), elSp = $('slSpeed');
    var KSP = 'shlc_sl_speed_v1';
    /* SPEED SLIDERS (2026-09-21, Aadam: "change both to sliders, min 10 questions max 50, min 1 minute,
       max 10 minutes"). A Race is 10 to 50 questions in fives; Beat the clock is 1 to 10 whole minutes,
       kept in SECONDS so the runs and bests saved before still match. Anything else, from an old save or
       an old link, snaps to the nearest stop in range. Declarations, so load() can use them early. */
    function spRange(shape) { return shape === 'race' ? { lo: 10, hi: 50, step: 5, unit: 1 } : { lo: 60, hi: 600, step: 60, unit: 60 }; }
    function spSnap(shape, v) {
      var r = spRange(shape); v = Number(v);
      if (!isFinite(v) || v <= 0) return 0;
      return Math.min(r.hi, Math.max(r.lo, Math.round(v / r.step) * r.step));
    }
    function spStops(shape) { var r = spRange(shape), a = []; for (var v = r.lo; v <= r.hi; v += r.step) a.push(v); return a; }
    function spShapeName(shape) { return shape === 'race' ? 'Race' : 'Beat the clock'; }
    function spLenParts(shape, v) {
      if (shape === 'race') return { n: String(v), u: 'questions' };
      var m = v / 60;
      if (v < 60) return { n: String(v), u: 'seconds' };
      return { n: m % 1 ? Math.floor(m) + '½' : String(m), u: m === 1 ? 'minute' : 'minutes' };
    }

    /* ---------- what a run is while it is running ---------- */
    var SP = {
      on: false, phase: 'play', shape: 'race', len: 10,
      i: 0, item: null, log: [], deal: {}, turn: 0,
      t0: 0, paused: 0, pauseAt: 0, qAt: 0, tick: null,
      cd: 0, cdT: null, lock: null, entry: [], bi: 0, picked: null,
      stopped: false, run: null, prev: null, bestBefore: null, isBest: false
    };

    /* ---------- storage: runs and personal bests, on this device ---------- */
    function spStore() {
      var d = lsGet(KSP, null);
      if (!d || typeof d !== 'object') return { runs: [], best: {} };
      return { runs: Array.isArray(d.runs) ? d.runs : [], best: (d.best && typeof d.best === 'object') ? d.best : {} };
    }
    /* forty runs is a couple of months of use and about 8 KB */
    function spPut(st) { lsSet(KSP, { runs: st.runs.slice(0, 40), best: st.best }); }
    /* Two runs are comparable only when the shape, the length AND the exact
       skills and levels match - the Quick Maths rule. Ordering five numbers and
       typing "-7" are not the same job, so a mix never compares to one skill. */
    function spSig(shape, len, skills) {
      var parts = skills.map(function (sk) { return sk.id + ':' + selLevels(sk).join('.'); }).sort();
      return shape + '|' + len + '|' + parts.join(',');
    }
    function spCurSig() { return spSig(S.speed.shape, spLen(), raceSkills()); }
    function spLen() { return S.speed.shape === 'race' ? S.speed.n : S.speed.secs; }
    function spRunsFor(sig) { return spStore().runs.filter(function (r) { return r.sig === sig; }); }
    function spBestFor(sig) { var b = spStore().best[sig]; return b || null; }
    /* A Race is won on ACCURACY first and time second, and a Beat the clock on
       how many are right. Ranking a race on time alone makes guessing fast the
       winning move: 9 of 10 in 20s would beat 10 of 10 in 24s. */
    function spBetter(shape, run, best) {
      if (!best) return true;
      if (shape !== 'race') return run.ok > best.ok;
      if (run.ok !== best.ok) return run.ok > best.ok;
      return run.ms < best.ms;
    }

    /* ---------- sound: made in the browser, no files to ship ----------
       push.py only carries text assets, so every sound here is an oscillator.
       The context is created on the first press inside a gesture and resumed
       there too, because iOS starts it suspended. */
    var AC = null;
    function audio() {
      if (!S.sound) return null;
      try {
        if (!AC) { var C = window.AudioContext || window.webkitAudioContext; if (!C) return null; AC = new C(); }
        if (AC.state === 'suspended' && AC.resume) AC.resume();
        return AC;
      } catch (err) { return null; }
    }
    function tone(freq, at, dur, vol, type) {
      var a = audio(); if (!a) return;
      try {
        var o = a.createOscillator(), g = a.createGain(), t = a.currentTime + at;
        o.type = type || 'sine'; o.frequency.setValueAtTime(freq, t);
        g.gain.setValueAtTime(0.0001, t);
        g.gain.exponentialRampToValueAtTime(vol, t + 0.012);
        g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
        o.connect(g); g.connect(a.destination); o.start(t); o.stop(t + dur + 0.02);
      } catch (err) {}
    }
    var SOUND = {
      ok: function () { tone(660, 0, 0.09, 0.16); tone(990, 0.07, 0.11, 0.13); },
      bad: function () { tone(196, 0, 0.16, 0.13, 'square'); },
      tick: function () { tone(520, 0, 0.07, 0.09); },
      go: function () { tone(880, 0, 0.16, 0.15); },
      low: function () { tone(440, 0, 0.06, 0.08); },
      end: function () { tone(587, 0, 0.13, 0.14); tone(740, 0.11, 0.13, 0.14); tone(988, 0.22, 0.26, 0.14); }
    };
    function sfx(k) { if (S.sound && SOUND[k]) SOUND[k](); }
    function toggleSound() { S.sound = !S.sound; save(); if (S.sound) sfx('go'); }

    /* ---------- dealing, one question at a time ---------- */
    function freshCtx() { return { seen: {}, shapeSeen: {}, last: null }; }
    function spNext() {
      var sks = raceSkills(); if (!sks.length) return null;
      var sk = sks[SP.turn % sks.length]; SP.turn++;
      var d = SP.deal[sk.id] || (SP.deal[sk.id] = { ctx: freshCtx(), n: 0, k: 0 });
      if (d.n >= 10) { d.ctx = freshCtx(); d.n = 0; }
      d.n++;
      var levels = selLevels(sk);
      return makeItem(sk, levels[d.k++ % levels.length], d.ctx);
    }

    /* ---------- how a question is answered ----------
       Three kinds, and every question is one of them:
         choice - the options ARE the answer box, one tap
         pad    - numbers, so the keypad drives it
         text   - words (writing a number out), so a real input and the
                  device's own keyboard
       A skill with none of these cannot be raced, and the Speed card is not
       offered for it - see `canRace`. (There used to be a `spSkillOK` here that
       sampled make() to decide the same thing; it was never called, it could not
       work on a manifest stub, and the comment claiming it gated the card was
       wrong for as long as it sat there. Removed 2026-09-24.) */
    function spNumeric(f) { return f.type !== 'text' && /^[£$]?\s*[-−]?[\d.,\s]+p?$/.test(String(f.ans)); }
    function spInput(it) {
      if (!it) return null;
      if (it.q.choice) return { kind: 'choice', ch: it.q.choice };
      var fs = typeFields(it); if (!fs) return null;
      return { kind: fs.every(spNumeric) ? 'pad' : 'text', fs: fs };
    }

    /* ---------- the clock ----------
       A deadline, never a sum of intervals: a tab that sleeps stops firing and
       an accumulating clock loses whatever it slept through. */
    /* SP.t0 is only set when the 3, 2, 1 clears: before that nothing has been timed, so the
       clock reads 0:00 on a Race and the full length on Beat the clock, never Date.now() - 0 */
    function spElapsed() { if (!SP.on || SP.cd || !SP.t0) return 0; return (SP.pauseAt ? SP.pauseAt : Date.now()) - SP.t0 - SP.paused; }
    function spLeft() { return Math.max(0, SP.len * 1000 - spElapsed()); }
    function spClock(ms) {
      var t = Math.max(0, Math.round(ms / 1000));
      return Math.floor(t / 60) + ':' + ('0' + (t % 60)).slice(-2);
    }
    function spSecs(ms) { return (ms / 1000).toFixed(1) + 's'; }
    function spStopTick() { if (SP.tick) { clearInterval(SP.tick); SP.tick = null; } }
    function spStartTick() {
      spStopTick();
      var lowAt = -1;
      SP.tick = setInterval(function () {
        if (!SP.on || SP.phase !== 'play' || SP.pauseAt) return;
        if (SP.shape === 'clock') {
          var left = spLeft(), s = Math.ceil(left / 1000);
          if (s <= 5 && s !== lowAt) { lowAt = s; if (s > 0) sfx('low'); }
          if (left <= 0) { spFinish(false); return; }
        }
        spPaintClock();
      }, 100);
    }
    /* how far through: questions done in a Race, time used on the clock */
    function spProgress() {
      if (SP.shape === 'clock') return SP.t0 ? Math.min(100, spElapsed() / (SP.len * 1000) * 100) : 0;
      return SP.len ? Math.min(100, SP.i / SP.len * 100) : 0;
    }
    function spPaintClock() {
      var f = $('slSpFace'); if (!f) return;
      var ms = SP.shape === 'clock' ? spLeft() : spElapsed();
      f.textContent = spClock(ms);
      f.parentNode.classList.toggle('is-low', SP.shape === 'clock' && ms <= 10000);
      var pr = $('slSpProg');
      if (pr && SP.shape === 'clock') { pr.style.width = spProgress().toFixed(1) + '%'; pr.parentNode.classList.toggle('is-low', ms <= 10000); }
    }
    /* fit a sum on one line: shrink it to the width it has, down to half size,
       and only then let it wrap (centred). Words are left to wrap naturally. */
    function spFitQ() {
      var ex = elSp.querySelector('.sl-spexpr'); if (!ex || ex.classList.contains('is-words')) return;
      ex.style.fontSize = ''; ex.classList.remove('is-wrap');
      var room = ex.parentNode.clientWidth - 6, need = ex.scrollWidth;
      if (!room || need <= room) return;
      var base = parseFloat(getComputedStyle(ex).fontSize) || 40, f = Math.max(0.5, room / need);
      ex.style.fontSize = (base * f).toFixed(1) + 'px';
      if (ex.scrollWidth > room + 1) ex.classList.add('is-wrap');
    }
    window.addEventListener('resize', function () { if (S.screen === 'speed' && SP.phase === 'play') spFitQ(); });

    /* ---------- a run ---------- */
    function spReset() {
      spStopTick(); clearTimeout(SP.cdT); clearTimeout(SP.lock);
      SP.on = false; SP.phase = 'play'; SP.i = 0; SP.item = null; SP.log = [];
      SP.deal = {}; SP.turn = 0; SP.t0 = 0; SP.paused = 0; SP.pauseAt = 0; SP.qAt = 0;
      SP.cd = 0; SP.entry = []; SP.bi = 0; SP.picked = null; SP.stopped = false;
      SP.run = null; SP.prev = null; SP.bestBefore = null; SP.isBest = false;
    }
    /* The minus and point keys are decided once for the whole run, from a sample
       of what these levels deal - never per question. A minus key that turned
       up only when the answer was negative told the child the sign before they
       had worked anything out, and the pad changed shape between questions. */
    function spKeySet() {
      var neg = false, dot = false;
      raceSkills().forEach(function (sk) {
        selLevels(sk).forEach(function (lv) {
          var ctx = freshCtx();
          for (var t = 0; t < 14 && !(neg && dot); t++) {
            var it; try { it = makeItem(sk, lv, ctx); } catch (err) { continue; }
            var inp = spInput(it); if (!inp || inp.kind !== 'pad') continue;
            var all = inp.fs.map(function (f) { return String(f.ans); }).join(' ');
            if (/[-\u2212]/.test(all)) neg = true;
            if (/[.\u00a3]/.test(all)) dot = true;
          }
        });
      });
      return { neg: neg, dot: dot };
    }
    function spStart() {
      spReset();
      SP.keys = spKeySet();
      SP.on = true; SP.shape = S.speed.shape; SP.len = spLen();
      SP.sig = spCurSig(); SP.bestBefore = spBestFor(SP.sig);
      SP.skills = raceSkills().map(function (sk) { return { id: sk.id, levels: selLevels(sk) }; });
      SP.item = spNext();
      /* 3, 2, 1 - and nothing is timed or accepted until it clears */
      SP.cd = 3; spRender();
      (function step() {
        SP.cdT = setTimeout(function () {
          SP.cd--;
          if (SP.cd > 0) { sfx('tick'); spRender(); step(); return; }
          sfx('go');
          SP.cd = 0; SP.t0 = Date.now(); SP.qAt = SP.t0;
          spRender(); spStartTick();
        }, 850);
      })();
      sfx('tick');
    }
    function spArm() { SP.qAt = Date.now(); SP.entry = []; SP.bi = 0; SP.picked = null; }
    /* the answer is in: log it with its time, flash it, then move on */
    function spAnswer(got, typed, typedHTML) {
      if (!SP.on || SP.phase !== 'play' || SP.cd || SP.lock || SP.pauseAt) return;
      var it = SP.item, ms = Date.now() - SP.qAt;
      it.state = got ? 'ok' : 'miss'; it.typed = typed || ''; it.typedHTML = typedHTML || '';
      SP.log.push({ sk: it.skill.id, name: it.skill.short || it.skill.name, lv: it.level, ms: ms, ok: got, q: it.q.html, t: spPlain(it.q), a: it.q.ansHTML, typedHTML: typedHTML || '' });
      spProg(it, got);
      SP.i++;
      sfx(got ? 'ok' : 'bad');
      spRender();
      /* the flash is not thinking time: the next question's clock starts when
         the next question is on the screen, not when this one was answered */
      SP.lock = setTimeout(function () {
        SP.lock = null;
        if (SP.shape === 'race' && SP.i >= SP.len) { spFinish(false); return; }
        if (SP.shape === 'clock' && spLeft() <= 0) { spFinish(false); return; }
        SP.item = spNext(); spArm(); spRender();
      }, got ? 340 : 800);
    }
    /* q.text is written for machines: "(x - 3)^2", "-9(x + 7)", Write "nineteen". The results screen
       shows it to the child (the chart's tips, the three that took longest), so it gets the page's minus
       sign, squares and curly quotes. A hyphen only becomes a minus after a space or a bracket, so
       forty-six and 10-digit keep theirs. */
    var SP_SUP = { 0: '⁰', 1: '¹', 2: '²', 3: '³', 4: '⁴', 5: '⁵', 6: '⁶', 7: '⁷', 8: '⁸', 9: '⁹' };
    function spTidy(t) {
      return t.replace(/\^(\d+)/g, function (m, d) { return d.replace(/\d/g, function (c) { return SP_SUP[c]; }); })
        .replace(/(^|[\s(\[])-/g, '$1−')
        .replace(/"([^"]*)"/g, '“$1”');
    }
    function spPlain(q) {
      var t = String(q.text || '').trim();
      if (t) return spTidy(t);
      return el('div', null, q.html || '').textContent.replace(/\s+/g, ' ').trim();
    }
    /* Speed marks count towards a level the same way Practise does */
    function spProg(it, got) {
      var p = S.prog[it.skill.id] = S.prog[it.skill.id] || {};
      var r = p[it.level] = p[it.level] || { n: 0, ok: 0 };
      r.n++; if (got) r.ok++;
      trackSecure(it.skill, it.level, r);
      save();
    }
    function spPause(on) {
      if (!SP.on || SP.phase !== 'play' || SP.cd) return;
      if (on && !SP.pauseAt) { SP.pauseAt = Date.now(); spRender(); return; }
      if (!on && SP.pauseAt) { SP.paused += Date.now() - SP.pauseAt; SP.pauseAt = 0; spArm(); spRender(); }
    }
    function spFinish(stopped) {
      spStopTick(); clearTimeout(SP.lock); SP.lock = null;
      if (SP.pauseAt) { SP.paused += Date.now() - SP.pauseAt; SP.pauseAt = 0; }
      SP.stopped = !!stopped; SP.phase = 'done';
      var ok = SP.log.filter(function (r) { return r.ok; }).length;
      var run = {
        t: Date.now(), sig: SP.sig, shape: SP.shape, len: SP.len,
        n: SP.log.length, ok: ok, ms: spElapsed(), med: spMedian(SP.log.map(function (r) { return r.ms; })),
        x: stopped ? 1 : 0, from: S.from,
        skills: SP.skills, rows: SP.log.map(function (r) { return { sk: r.sk, lv: r.lv, ms: r.ms, ok: r.ok }; })
      };
      SP.run = run;
      var st = spStore();
      /* only a finished run compares, and only a finished run can be a best:
         quitting a 25 after 3 must not read as a personal best */
      SP.prev = st.runs.filter(function (r) { return r.sig === run.sig && !r.x; })[0] || null;
      if (!stopped && run.n) {
        SP.isBest = spBetter(SP.shape, run, st.best[run.sig]);
        if (SP.isBest) st.best[run.sig] = { ms: run.ms, ok: run.ok, n: run.n, t: run.t };
      }
      st.runs.unshift(run); spPut(st);
      sfx('end');
      spRender();
    }
    function spMedian(a) {
      if (!a.length) return 0;
      var b = a.slice().sort(function (x, y) { return x - y; }), m = b.length >> 1;
      return b.length % 2 ? b[m] : Math.round((b[m - 1] + b[m]) / 2);
    }

    /* ============================================================
       SPEED SETUP
       ============================================================ */
    function spHistHTML(sig) {
      var runs = spRunsFor(sig).slice(0, 5);
      if (!runs.length) return '<div class="sl-lvlnote">No runs at these levels yet.</div>';
      return '<div class="sl-splist">' + runs.map(function (r) {
        return '<div class="sl-sprow' + (r.x ? ' is-part' : '') + '"><b>' + (r.shape === 'race' ? spClock(r.ms) : r.ok + ' right') + '</b>' +
          '<span>' + (r.shape === 'race' ? r.ok + ' of ' + r.n + ' right' : 'in ' + spClock(r.len * 1000)) + (r.x ? ' · stopped early' : '') + '</span>' +
          '<i>' + spWhen(r.t) + '</i></div>';
      }).join('') + '</div>';
    }
    function spWhen(t) {
      var d = Date.now() - t, day = 86400000;
      if (d < 3600000) return Math.max(1, Math.round(d / 60000)) + ' min ago';
      if (d < day) return Math.round(d / 3600000) + 'h ago';
      if (d < 7 * day) return Math.round(d / day) + 'd ago';
      try { return new Date(t).toLocaleDateString(); } catch (e) { return ''; }
    }
    function spBestHTML(sig, shape) {
      var b = spBestFor(sig);
      if (!b) return '';
      return '<div class="sl-spbest">' + ICON.trophy + '<b>Your best</b><span>' +
        (shape === 'race' ? spClock(b.ms) + ' · ' + b.ok + ' of ' + b.n + ' right' : b.ok + ' right') + '</span></div>';
    }
    /* the level list starts open on a laptop and CLOSED on a phone: the levels
       were picked on the skill screen already, and twelve rows of them pushed
       the run's own settings 1,100px down */
    var spLvOpen = null;
    function renderSpeedSetup() {
      var sk = curSkill(), mixed = S.from === 'mixed';
      if (!mixed && !sk) { show('library'); return; }
      /* reached by a stale deep link or a back button after the card went: a skill that cannot
         be raced has no Speed screen to set up */
      if (!mixed && !canRace(sk)) { show('skill'); return; }
      var mixRace = mixSkills().filter(canRace), mixOut = mixSkills().filter(function (x) { return !canRace(x); });
      if (mixed && !mixRace.length) { show('library'); return; }
      if (spLvOpen === null) spLvOpen = !narrow();
      var who = mixed
        /* a basket may hold a skill that cannot be raced; say so in the same line rather than
           quietly dropping it, or the run looks like it lost questions. No new class: the
           stylesheet is shared and this needs nothing the span has not got. */
        ? '<div class="sl-spwho"><div><b>Mixed practice</b><span>' + mixRace.map(function (x) { return esc(x.short || x.name); }).join(' · ') +
            (mixOut.length ? '. Not in a race: ' + esc(mixOut.map(function (x) { return x.short || x.name; }).join(' · ')) + ', because their answers are revealed rather than typed' : '') +
            '</span></div></div>'
        : '<div class="sl-spwho"><div><b>' + esc(sk.name) + '</b><span>' + esc(levelWord(sk)) + '</span></div>' +
            '<button type="button" class="sl-btn sl-btn--sm sl-btn--ghost" id="slSpLv" aria-expanded="' + (spLvOpen ? 'true' : 'false') + '">' + (spLvOpen ? ICON.chevD + 'Hide levels' : ICON.sliders + 'Change levels') + '</button></div>';
      var lvList = !mixed && spLvOpen ? '<div class="sl-splvlist">' + levelListHTML(sk, true) + '</div>' : '';
      /* SPEED SLIDERS (2026-09-21): each card is one big slider, a big readout and one Start button.
         Moving a slider keeps that length at once (so it is there next time) and makes that card the
         one Your best and Recent runs below are for; the card used last carries the ring. */
      var opts = '<div class="sl-spgo">' + spCardHTML('race') + spCardHTML('clock') + '</div>' +
        '<div class="sl-spfoot"><span>Slide to set the length, then press Start</span>' +
          '<button type="button" class="sl-iconbtn' + (S.sound ? '' : ' is-off') + '" id="slSpSound" aria-pressed="' + (S.sound ? 'true' : 'false') + '" aria-label="Sound" data-tip="' + (S.sound ? 'Sound on' : 'Sound off') + '">' + (S.sound ? ICON.sound : ICON.mute) + '</button>' +
        '</div>';
      paint(elSpS, '<div class="sl-main"><div class="sl-scroll"><div class="sl-setup sl-spsetup' + (entering ? ' is-enter' : '') + '">' +
        '<h2>Speed</h2>' + who + opts + lvList +
        '<div class="sl-sphistwrap" id="slSpHist">' + spSetupHistHTML() + '</div>' +
        '</div></div></div>');
    }
    /* Your best and Recent runs for the length on the card being set */
    function spSetupHistHTML() {
      var sig = spCurSig(), hist = spRunsFor(sig).length, lw = spLenParts(S.speed.shape, spLen());
      return spBestHTML(sig, S.speed.shape) +
        (hist ? '<section class="sl-spsec"><span class="sl-sect">Recent runs: ' + spShapeName(S.speed.shape) + ', ' + lw.n + ' ' + lw.u + '</span>' + spHistHTML(sig) + '</section>' : '');
    }
    /* one card: the name, the readout, the slider with every stop named under it, and Start.
       The slider counts questions, or whole minutes; the state keeps seconds. */
    function spCardHTML(shape) {
      var race = shape === 'race', r = spRange(shape), v = spSnap(shape, race ? S.speed.n : S.speed.secs) || r.lo;
      var w = spLenParts(shape, v), span = r.hi - r.lo, name = spShapeName(shape);
      return '<div class="sl-sptapcol sl-spcard is-' + shape + (S.speed.shape === shape ? ' is-last' : '') + '" data-spcard="' + shape + '">' +
        '<div class="sl-sptaphead"><span class="sl-sptapicon">' + (race ? ICON.flag : ICON.clock) + '</span>' +
          '<div><b>' + name + '</b><span>' + (race ? 'Answer them all, fast' : 'Most right in the time') + '</span></div></div>' +
        '<div class="sl-slider sl-spslide" style="--p:' + ((v - r.lo) / span).toFixed(4) + '">' +
          '<output class="sl-spval" for="slSpRange-' + shape + '" aria-hidden="true"><b class="num">' + w.n + '</b><i>' + w.u + '</i></output>' +
          '<input type="range" class="sl-range" id="slSpRange-' + shape + '" min="' + r.lo / r.unit + '" max="' + r.hi / r.unit + '" step="' + r.step / r.unit + '" value="' + v / r.unit + '"' +
            ' data-spslide="' + shape + '" aria-label="' + name + ' length" aria-valuetext="' + w.n + ' ' + w.u + '">' +
          '<div class="sl-slticks">' + spStops(shape).map(function (s) {
            return '<button type="button" class="sl-slstop num' + (s === v ? ' is-on' : '') + '" style="--k:' + ((s - r.lo) / span).toFixed(4) + '" data-spstop="' + shape + ':' + s + '" tabindex="-1" aria-label="' + spLenParts(shape, s).n + ' ' + spLenParts(shape, s).u + '">' + s / r.unit + '</button>';
          }).join('') + '</div>' +
        '</div>' +
        '<button type="button" class="sl-btn sl-btn--cta sl-spstart" data-spgo="' + shape + '" aria-label="Start ' + name + ', ' + w.n + ' ' + w.u + '">' + ICON.play + '<span>Start</span></button>' +
      '</div>';
    }
    /* a slider moved (or a stop under it pressed): the readout, the fill and the stop names follow in
       place, so the focused slider keeps the focus and the arrow keys keep working */
    function spSlideSet(shape, v) {
      v = spSnap(shape, v); if (!v) return;
      var r = spRange(shape), w = spLenParts(shape, v), words = w.n + ' ' + w.u;
      if (shape === 'race') S.speed.n = v; else S.speed.secs = v;
      S.speed.shape = shape;
      var card = elSpS.querySelector('[data-spcard="' + shape + '"]');
      if (card) {
        var inp = card.querySelector('.sl-range'), wrap = card.querySelector('.sl-spslide'), o = card.querySelector('.sl-spval'), go = card.querySelector('[data-spgo]');
        if (inp) { if (Number(inp.value) !== v / r.unit) inp.value = String(v / r.unit); inp.setAttribute('aria-valuetext', words); }
        if (wrap) wrap.style.setProperty('--p', ((v - r.lo) / (r.hi - r.lo)).toFixed(4));
        if (o) o.innerHTML = '<b class="num">' + w.n + '</b><i>' + w.u + '</i>';
        each(card.querySelectorAll('.sl-slstop'), function (b) { b.classList.toggle('is-on', b.getAttribute('data-spstop') === shape + ':' + v); });
        if (go) go.setAttribute('aria-label', 'Start ' + spShapeName(shape) + ', ' + words);
      }
      each(elSpS.querySelectorAll('[data-spcard]'), function (c) { c.classList.toggle('is-last', c.getAttribute('data-spcard') === shape); });
      var h = $('slSpHist'); if (h) h.innerHTML = spSetupHistHTML();
      save();
    }
    elSpS.addEventListener('input', function (e) {
      var t = e.target, shape = t && t.getAttribute ? t.getAttribute('data-spslide') : null; if (!shape) return;
      spSlideSet(shape, Number(t.value) * spRange(shape).unit);
    });
    /* the arrow keys move a focused slider (the browser does that); Enter on it starts that card */
    elSpS.addEventListener('keydown', function (e) {
      var t = e.target, shape = t && t.getAttribute ? t.getAttribute('data-spslide') : null; if (!shape) return;
      if (e.key !== 'Enter' || e.repeat || e.metaKey || e.ctrlKey || e.altKey) return;
      e.preventDefault();
      var b = elSpS.querySelector('[data-spgo="' + shape + '"]'); if (b && !b.disabled) b.click();
    });
    elSpS.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('button') : null; if (!t) return;
      var sk = curSkill();
      var go = t.getAttribute('data-spgo');
      if (go) {
        /* the length on that card's slider, read back from the slider itself */
        var gshape = go === 'clock' ? 'clock' : 'race', gin = $('slSpRange-' + gshape);
        var gv = spSnap(gshape, gin ? Number(gin.value) * spRange(gshape).unit : (gshape === 'race' ? S.speed.n : S.speed.secs));
        S.speed.shape = gshape;
        if (gv) { if (gshape === 'race') S.speed.n = gv; else S.speed.secs = gv; }
        save();
        var race = raceSkills(); if (!race.length) return;
        withSkills(race.map(function (x) { return x.id; }), t, function () { spStart(); show('speed'); }, true);
        return;
      }
      var stop = t.getAttribute('data-spstop');
      if (stop) {
        var sp = stop.split(':'), sshape = sp[0] === 'clock' ? 'clock' : 'race';
        spSlideSet(sshape, Number(sp[1]));
        var sin = $('slSpRange-' + sshape); if (sin) { try { sin.focus({ preventScroll: true }); } catch (err) {} }
        return;
      }
      if (t.id === 'slSpSound') { toggleSound(); renderSpeedSetup(); return; }
      if (t.id === 'slSpLv') { spLvOpen = !spLvOpen; renderSpeedSetup(); return; }
      if (sk && levelClick(t, sk)) { renderSpeedSetup(); return; }
    });

    /* ============================================================
       THE RUN
       ============================================================ */
    /* what the entry looks like: one box per field, the live one lit */
    /* vals and state are for the moment after an answer: a right answer stays
       in its boxes lit green, and a miss puts the RIGHT answer in the boxes
       (the typed one is struck through on the line above), so the last thing
       the child sees at full size is the correct number, not their mistake */
    function spBoxesHTML(fs, vals, state) {
      return '<div class="sl-spboxes' + (fs.length > 1 ? ' is-many' : '') + '">' + stackFields(fs, function (f, j, vw) {
        var v = vals ? String(vals[j] == null ? '' : vals[j]) : (SP.entry[j] || '');
        return { lead: j ? '<span class="af-op">' + (f.sign ? ' ' : (f.op || '+')) + '</span>' : '', body: (vw.pre ? '<span class="af-t af-pre">' + vw.pre + '</span>' : '') +
          '<span class="sl-spbox' + (!state && j === SP.bi ? ' is-now' : '') + (v ? ' has-v' : '') + (state ? ' is-' + state : '') + '" data-spbox="' + j + '" style="min-width:' + ((f.w || 4) + 1) + 'ch">' +
          (v ? esc(v) : '<i>?</i>') + '</span>' + (vw.after ? '<span class="af-t">' + vw.after + '</span>' : '') };
      }, function (h) { return '<span class="af-t af-pre">' + h + '</span>'; }) + '</div>';
    }
    /* the keypad: 123 on top, the way a phone is, not a calculator. No submit
       key - a full answer checks itself, which is what makes a run fast. */
    function spPadHTML(fs, off) {
      var all = fs.map(function (f) { return String(f.ans); }).join(' '), K = SP.keys || {};
      /* the run's key set, plus this question's needs in case the sample missed
         one - a question the pad cannot type is worse than a rare hint */
      var neg = !!K.neg || /[-−]/.test(all), dot = !!K.dot || /[.]/.test(all), pound = /£/.test(all);
      var keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
      var last = [];
      if (neg) last.push(['-', '−']);
      if (dot || pound) last.push(['.', '.']);
      last.push(['0', '0']);
      last.push(['back', ICON.del]);
      return '<div class="sl-pad' + (off ? ' is-off' : '') + '">' +
        keys.map(function (k) { return '<button type="button" class="sl-key num" data-key="' + k + '">' + k + '</button>'; }).join('') +
        '<div class="sl-padlast" style="grid-template-columns:repeat(' + last.length + ',1fr)">' +
        last.map(function (k) { return '<button type="button" class="sl-key' + (k[0] === 'back' ? ' sl-key--fn' : ' num') + '" data-key="' + k[0] + '" aria-label="' + (k[0] === 'back' ? 'Delete' : k[0]) + '">' + k[1] + '</button>'; }).join('') +
        '</div></div>';
    }
    function spStageHTML() {
      var it = SP.item, inp = spInput(it), done = it.state === 'ok' || it.state === 'miss';
      var body;
      if (!inp) body = '<div class="sl-empty">This question cannot be raced.</div>';
      else if (inp.kind === 'choice') {
        var optText = inp.ch.options.map(function (o) { return el('div', null, String(o)).textContent.trim(); });
        var longOpt = optText.some(function (t) { return t.length > 12; });
        /* < > = are x-height glyphs: at a button's text size they read as specks */
        var symOpt = optText.every(function (t) { return t.length <= 2; });
        body = '<div class="sl-spchoices' + (done ? ' is-done' : '') + (longOpt ? ' is-long' : '') + (symOpt ? ' is-sym' : '') + (inp.ch.options.length > 2 && !longOpt ? ' is-3' : '') + '">' + inp.ch.options.map(function (o, k) {
          var cls = 'sl-choice' + (done && k === inp.ch.answer ? ' is-right' : '') + (done && SP.picked === k && k !== inp.ch.answer ? ' is-wrong' : '');
          return '<button type="button" class="' + cls + '" data-spopt="' + k + '"' + (done ? ' disabled' : '') + '><b>' + 'ABCDEF'.charAt(k) + '</b><span>' + o + '</span></button>';
        }).join('') + '</div>';
      } else if (inp.kind === 'text') {
        body = '<div class="sl-sptext">' +
          '<input type="text" id="slSpText" class="sl-ansin" autocomplete="off" spellcheck="false" placeholder="Type it, then Enter" aria-label="Your answer"' +
          (done ? ' disabled value="' + esc(String(it.typed || '')) + '"' : '') + '>' +
          '<button type="button" class="sl-btn sl-btn--cta" id="slSpCheck"' + (done ? ' disabled' : '') + '>' + ICON.tick + 'Check</button></div>';
      } else {
        var shown = !done ? null : (it.state === 'ok' ? SP.entry.slice() : inp.fs.map(function (f) { return String(f.ans).replace(/^\u2212/, '-'); }));
        body = spBoxesHTML(inp.fs, shown, done ? (it.state === 'ok' ? 'ok' : 'fix') : null) + spPadHTML(inp.fs, done);
      }
      var mark;
      if (!done) mark = '<div class="sl-spmark is-idle" aria-hidden="true"><span></span></div>';
      else if (it.state === 'ok') mark = '<div class="sl-spmark ok">' + ICON.tick + '<b>Right</b></div>';
      else if (inp && inp.kind === 'pad') mark = '<div class="sl-spmark miss">' + ICON.cross + '<b>You put <span class="sl-yours">' + (it.typedHTML || esc(it.typed || '')) + '</span></b></div>';
      else mark = '<div class="sl-spmark miss">' + ICON.cross + '<b>It was <span class="sl-spans">' + it.q.ansHTML + '</span></b></div>';
      /* a sentence wraps at a reading size; a sum stays on one line and is
         shrunk to fit (spFitQ), because a chain broken with a "+" at the start
         of the next line is harder to add up than a smaller one */
      var words = /[a-z]{3,}/i.test(spPlain(it.q).replace(/\b(?:sqrt|surd)\b/gi, ''));
      return '<div class="sl-spq' + (done ? ' is-' + it.state : '') + '" style="--c:' + colourOf(it.skill).col + '">' +
        (S.from === 'mixed' ? tagHTML(it.skill) : '') +
        '<div class="sl-spexpr sl-expr' + (words ? ' is-words' : '') + '">' + it.q.html + '</div>' + mark + '</div>' +
        '<div class="sl-spentry">' + body + '</div>';
    }
    function spRunTopHTML() {
      var right = SP.log.filter(function (r) { return r.ok; }).length;
      var ms = SP.shape === 'clock' ? spLeft() : spElapsed();
      return '' +
        '<div class="sl-sptimer' + (SP.shape === 'clock' && ms <= 10000 ? ' is-low' : '') + '">' + ICON.clock + '<b class="num" id="slSpFace">' + spClock(ms) + '</b></div>' +
        '<div class="sl-spstat"><b class="num">' + right + '</b><span>right</span></div>' +
        '<div class="sl-spstat sp-done"><b class="num">' + (SP.shape === 'race' ? SP.i + ' / ' + SP.len : String(SP.log.length)) + '</b><span>' + (SP.shape === 'race' ? 'done' : 'answered') + '</span></div>' +
        '<button type="button" class="sl-iconbtn" id="slSpSnd" aria-label="Sound on or off" data-tip="' + (S.sound ? 'Sound on' : 'Sound off') + '" data-tipsub="A blip for right, a buzz for wrong. Key: M">' + (S.sound ? ICON.sound : ICON.mute) + '</button>' +
        '<button type="button" class="sl-iconbtn" id="slSpPause" aria-label="Pause" data-tip="Pause" data-tipsub="The clock stops. Key: Esc">' + ICON.pause + '</button>';
    }
    function spPlayHTML() {
      var cd = SP.cd > 0;
      return '<div class="sl-main sl-run">' +
        '<div class="sl-spprog' + (SP.shape === 'clock' ? ' is-clock' : '') + '" aria-hidden="true"><i id="slSpProg" style="width:' + spProgress().toFixed(1) + '%"></i></div>' +
        '<div class="sl-runstage">' + spStageHTML() + '</div>' +
        (cd ? '<div class="sl-spover sl-spcd"><b class="num">' + SP.cd + '</b><span>Get ready</span></div>' : '') +
        (SP.pauseAt ? '<div class="sl-spover sl-sppause"><b>Paused</b><span>The clock has stopped.</span>' +
          '<div class="sl-sprow2"><button type="button" class="sl-btn sl-btn--cta" id="slSpResume">' + ICON.play + 'Carry on</button>' +
          '<button type="button" class="sl-btn sl-btn--ghost" id="slSpEnd">' + ICON.flag + 'End the run</button></div></div>' : '') +
        '</div>';
    }

    /* ============================================================
       RESULTS
       The point of the whole thing: not the score, the seconds.
       ============================================================ */
    /* WHERE THE TIME WENT. One column per question, height = seconds.
       Built to the dataviz rules: bars capped at 24px with the rest of the
       band left as air, 4px rounded tips square at the baseline, a real y-axis
       on clean seconds with solid hairline gridlines, the typical time as the
       one dashed line (it is a threshold, not a grid), a legend, and the
       slowest bar labelled with its value. Colour carries right or missed
       ONLY - height already says slow, and a third "slow" colour said it twice.
       Missed bars also carry a cross, so the state is never colour alone.
       Every mark is an <i>, never an empty <div>: Dawn hides div:empty. */
    function spTickLabel(ms) { var v = ms / 1000; return (v % 1 ? v.toFixed(1) : String(v)) + 's'; }
    function spChartHTML() {
      var n = SP.log.length, times = SP.log.map(function (r) { return r.ms; });
      var med = spMedian(times), real = Math.max.apply(null, times.concat([1]));
      /* one ten-second question flattened every other bar to a stub, so the
         scale stops at 3.5x the typical answer and anything past it is drawn
         full height with a break on top and its real time over it */
      var cap = Math.max(1, Math.min(real, Math.round(med * 3.5) || real));
      var STEPS = [200, 500, 1000, 2000, 5000, 10000, 15000, 30000, 60000], step = STEPS[STEPS.length - 1];
      for (var k = 0; k < STEPS.length; k++) if (cap / STEPS[k] <= 4) { step = STEPS[k]; break; }
      var top = Math.max(step, Math.ceil(cap / step) * step);
      /* a slowest bar only just past the top tick (4.1s on a 4s scale) is not an
         outlier worth a break mark, and the break read as a glitch: stretch the
         scale one tick instead */
      if (real > top && real <= top * 1.15) top += step;
      var pct = function (ms) { return Math.max(0, Math.min(100, ms / top * 100)); };
      var ticks = []; for (var t = 0; t <= top + 1; t += step) ticks.push(t);
      var slowI = times.indexOf(real), anyMiss = SP.log.some(function (r) { return !r.ok; });
      var every = n <= 12 ? 1 : (n <= 30 ? 5 : (n <= 100 ? 10 : (n <= 250 ? 25 : 50)));
      var cols = SP.log.map(function (r, i) {
        var h = pct(r.ms), over = r.ms > top, isTop = i === slowI;
        var edge = i === 0 ? ' is-first' : (i === n - 1 ? ' is-last' : '');
        return '<div class="sl-spcol' + (r.ok ? '' : ' is-bad') + (over ? ' is-over' : '') + (isTop ? ' is-top' : '') + edge + '" style="--h:' + h.toFixed(1) + '%"' +
          /* Aadam, 2026-09-23: the tip shows the question itself, not "Question 3 · Surds, level 2";
             the no-break spaces keep "· missed" on the line with the question's last word */
          ' data-tipkeep="1" data-tip="' + spSecs(r.ms) + '" data-tipsub="' + esc((r.t || 'Question ' + (i + 1)) + '\u00a0·\u00a0' + (r.ok ? 'right' : 'missed')) + '">' +
          (isTop ? '<b class="sl-spcap num">' + spSecs(r.ms) + '</b>' : '') +
          (r.ok ? '' : '<span class="sl-spx" aria-hidden="true">' + ICON.cross + '</span>') +
          '<i class="sl-spbar"></i>' +
          '<span class="sl-sr">Question ' + (i + 1) + ', ' + spSecs(r.ms) + ', ' + (r.ok ? 'right' : 'missed') + '</span></div>';
      }).join('');
      var xs = SP.log.map(function (r, i) {
        var q = i + 1, show = every === 1 || q === 1 || q % every === 0;
        return '<span>' + (show ? q : '') + '</span>';
      }).join('');
      return '<div class="sl-spchart' + (n > 60 ? ' is-dense' : '') + '">' +
        '<div class="sl-spyax" aria-hidden="true">' + ticks.map(function (v) { return '<span style="--y:' + pct(v).toFixed(1) + '%">' + spTickLabel(v) + '</span>'; }).join('') + '</div>' +
        '<div class="sl-spplot">' +
          ticks.map(function (v) { return '<i class="sl-spgl" style="--y:' + pct(v).toFixed(1) + '%"></i>'; }).join('') +
          '<i class="sl-spmed" style="--y:' + pct(med).toFixed(1) + '%"></i>' +
          '<div class="sl-spcols">' + cols + '</div>' +
        '</div>' +
        '<div class="sl-spxax" aria-hidden="true">' + xs + '</div>' +
        '<div class="sl-splegend">' +
          '<span><i class="sw sw-ok"></i>Right</span>' +
          (anyMiss ? '<span><i class="sw sw-bad"></i>Missed</span>' : '') +
          '<span><i class="sw sw-med"></i>Typical ' + spSecs(med) + '</span>' +
        '</div></div>';
    }
    function spByLevel() {
      var map = {}, out = [];
      SP.log.forEach(function (r) {
        var k = r.sk + '/' + r.lv;
        var e = map[k] || (map[k] = { sk: r.sk, name: r.name, lv: r.lv, n: 0, ok: 0, ms: [] });
        e.n++; if (r.ok) e.ok++; e.ms.push(r.ms);
      });
      Object.keys(map).forEach(function (k) { var e = map[k]; e.med = spMedian(e.ms); out.push(e); });
      return out.sort(function (a, b) { return b.med - a.med; });
    }
    /* What to do next: one short line and the button that does it. They are
       decided together, so the message never says "practise" over a Teach
       button. Short on purpose: it is read once, at the end of a run. */
    function spNextStep(worst) {
      var med = spMedian(SP.log.map(function (r) { return r.ms; }));
      var slowMiss = SP.log.filter(function (r) { return !r.ok && r.ms > med * 1.6; }).length;
      var slowRight = SP.log.filter(function (r) { return r.ok && r.ms > med * 1.6; }).length;
      var missed = SP.log.some(function (r) { return !r.ok; });
      var one = SP.skills && SP.skills.length === 1 ? SL.get(SP.skills[0].id) : null;
      var lvName = function (sk, n) { var nm = sk ? levelName(sk, n) : ''; return nm ? ': ' + nm : ''; };
      var teach = worst ? { kind: 'teach', sk: worst.sk, lv: worst.lv, label: (one ? 'Teach level ' + worst.lv + lvName(one, worst.lv) : 'Teach ' + worst.name + ', level ' + worst.lv) } : null;
      var prac = { kind: 'practise', label: 'Practise these levels' };
      if (!SP.log.length) return { msg: '', btn: null };
      if (slowMiss >= 2) return { msg: 'The ones you missed took longest. Watch the model first.', btn: teach };
      if (!missed && slowRight >= 3) return { msg: 'Every one right, but a few were slow. Race it again.', btn: null };
      if (!missed) {
        if (one) {
          var top = Math.max.apply(null, SP.skills[0].levels);
          if (top < one.levels.length) return { msg: 'Every one right. Try the next level up.', btn: { kind: 'up', sk: one.id, lv: top + 1, label: 'Race level ' + (top + 1) + lvName(one, top + 1) } };
        }
        return { msg: 'Every one right. Race it again to beat your time.', btn: null };
      }
      return { msg: 'You missed a few. Practise without the clock, then race again.', btn: prac };
    }
    function spDeltaHTML() {
      if (SP.stopped || !SP.prev || !SP.run.n) return '';
      var d, txt;
      if (SP.shape === 'race') {
        /* accuracy first, the same order a best is judged in: the score change
           leads and sets the colour, and the time only decides when the score
           is the same. "2.1s slower, and 1 more right" in red under a gold
           Personal best badge told the child two opposite things. */
        d = SP.prev.ms - SP.run.ms;
        var dk = SP.run.ok - SP.prev.ok, tpart = Math.abs(d) < 700 ? '' : (d > 0 ? spSecs(d) + ' faster' : spSecs(-d) + ' slower');
        if (dk !== 0) {
          txt = (dk > 0 ? dk + ' more right' : (-dk) + ' fewer right') + ' than last time' + (tpart ? ', ' + tpart + '.' : '.');
          return '<div class="sl-spdelta' + (dk > 0 ? ' is-up' : ' is-down') + '">' + txt + '</div>';
        }
        txt = tpart ? tpart + ' than last time.' : 'The same pace as last time.';
        return '<div class="sl-spdelta' + (d > 700 ? ' is-up' : (d < -700 ? ' is-down' : '')) + '">' + txt + '</div>';
      }
      d = SP.run.ok - SP.prev.ok;
      txt = d === 0 ? 'The same as last time.' : (d > 0 ? d + ' more right than last time.' : (-d) + ' fewer than last time.');
      return '<div class="sl-spdelta' + (d > 0 ? ' is-up' : (d < 0 ? ' is-down' : '')) + '">' + txt + '</div>';
    }
    function spResultHTML() {
      var r = SP.run, ok = r.ok, n = r.n, med = r.med, mixed = SP.skills && SP.skills.length > 1;
      var times = SP.log.map(function (x) { return x.ms; });
      var fast = Math.min.apply(null, times.concat([Infinity])), slowest = Math.max.apply(null, times.concat([0]));
      var half = Math.ceil(SP.log.length / 2);
      var pace = SP.log.length >= 6
        ? (spMedian(times.slice(half)) < spMedian(times.slice(0, half)) ? 'You sped up as you went.' : 'You slowed down as you went.')
        : '';
      var lv = spByLevel(), worst = lv[0];
      var hero = SP.shape === 'race' ? spClock(r.ms) : String(ok);
      var heroSub = SP.shape === 'race' ? ok + ' of ' + n + ' right' : 'right in ' + spClock(r.len * 1000);
      /* one line under the number, and only when it says something the badge
         and the number do not: "Your best yet" under a Personal best badge said
         the same thing twice, and "Run finished" said nothing */
      var title = SP.stopped ? 'Stopped early' : (!SP.isBest && ok === n && n ? 'Every one right' : '');
      var slow3 = SP.log.slice().sort(function (a, b) { return b.ms - a.ms; }).slice(0, 3);
      var lvName = function (e) { var sk = SL.get(e.sk), nm = sk ? levelName(sk, e.lv) : ''; return nm; };
      var step = spNextStep(worst);
      var body = !n ? '<div class="sl-empty">No questions answered.</div>' :
        '<div class="sl-spstats">' +
          '<div class="sl-spcell"><b class="num">' + spSecs(med) + '</b><span>typical</span></div>' +
          '<div class="sl-spcell"><b class="num">' + spSecs(fast) + '</b><span>fastest</span></div>' +
          '<div class="sl-spcell"><b class="num">' + spSecs(slowest) + '</b><span>slowest</span></div>' +
          '<div class="sl-spcell"><b class="num">' + Math.round(ok / n * 100) + '%</b><span>right</span></div>' +
        '</div>' +
        '<section class="sl-spsec"><div class="sl-sphead"><span class="sl-sect">Where the time went</span>' + (pace ? '<span class="sl-sppace">' + pace + '</span>' : '') + '</div>' + spChartHTML() + '</section>' +
        /* the recommendation sits under the chart, before the detail: it is the
           reason the screen exists, and on a phone the detail is a long scroll */
        (step.msg ? '<section class="sl-spnext"><span class="sl-sect">What to do next</span><p>' + esc(step.msg) + '</p>' +
          (step.btn ? '<button type="button" class="sl-btn sl-btn--ghost" id="' + ({ teach: 'slSpTeach', up: 'slSpUp', practise: 'slSpPrac' })[step.btn.kind] + '"' +
            (step.btn.sk ? ' data-sk="' + step.btn.sk + '" data-lv="' + step.btn.lv + '"' : '') + '>' +
            ({ teach: ICON.steps, up: ICON.arrowR, practise: ICON.list })[step.btn.kind] + '<span>' + esc(step.btn.label) + '</span></button>' : '') +
        '</section>' : '') +
        '<section class="sl-spsec"><span class="sl-sect">The three that took longest</span><div class="sl-splist">' + slow3.map(function (x) {
          return '<div class="sl-spslow' + (x.ok ? '' : ' is-miss') + '"><b class="num">' + spSecs(x.ms) + '</b>' +
            '<span class="sq">' + esc(x.t || '') + (mixed ? '<i>' + esc(x.name) + ' · level ' + x.lv + '</i>' : '') + '</span>' +
            '<span class="sv" aria-label="' + (x.ok ? 'Right' : 'Missed') + '">' + (x.ok ? ICON.tick : ICON.cross) + '</span></div>';
        }).join('') + '</div></section>' +
        '<section class="sl-spsec"><span class="sl-sect">How each level went</span><div class="sl-splist">' + lv.map(function (e) {
          var nm = lvName(e);
          return '<div class="sl-splv"><span class="ln num">' + e.lv + '</span>' +
            '<span class="lt"><b>' + esc(nm || ('Level ' + e.lv)) + '</b>' + (mixed ? '<i>' + esc(e.name) + '</i>' : '') + '</span>' +
            '<span class="ls num' + (e.ok === e.n ? ' is-all' : '') + '">' + e.ok + '/' + e.n + '</span>' +
            '<span class="lm num">' + spSecs(e.med) + '</span></div>';
        }).join('') + '</div></section>';
      return '<div class="sl-main sl-spres-wrap"><div class="sl-scroll"><div class="sl-spres' + (entering ? ' is-enter' : '') + '">' +
        '<div class="sl-sphero' + (SP.isBest ? ' is-best' : '') + '">' +
          (SP.isBest ? '<span class="sl-spbadge">' + ICON.trophy + 'Personal best</span>' : '') +
          '<b class="num">' + hero + '</b><span class="hs">' + esc(heroSub) + '</span>' +
          (title ? '<i>' + esc(title) + '</i>' : '') + spDeltaHTML() + '</div>' +
        body +
        '<section class="sl-spsec"><span class="sl-sect">Recent runs</span>' + spHistHTML(r.sig) + '</section>' +
        '</div></div>' +
        /* the two ways on stay in reach at the foot of the screen, outside the
           scroll: on a phone they sat 1,700px down under the detail */
        '<div class="sl-spacts">' +
          '<button type="button" class="sl-btn sl-btn--cta" id="slSpAgain">' + ICON.refresh + 'Go again</button>' +
          '<button type="button" class="sl-btn sl-btn--ghost" id="slSpBack">' + ICON.sliders + 'Change the run</button>' +
        '</div></div>';
    }
    function spRender() {
      if (SP.phase === 'done') { paint(elSp, spResultHTML()); renderTop(); return; }
      paint(elSp, spPlayHTML());
      spFitQ();
      var tx = $('slSpText'); if (tx && !SP.cd && !SP.pauseAt) { try { tx.focus(); } catch (e) {} }
      renderTop();
    }
    function renderSpeed() {
      if (!SP.on) { show(S.from === 'mixed' ? 'mixed' : 'skill'); return; }
      spRender();
    }

    /* ---------- pressing things ---------- */
    function spPad(k) {
      var it = SP.item, inp = it && spInput(it);
      if (!inp || inp.kind !== 'pad' || SP.cd || SP.lock || SP.pauseAt) return;
      var v = SP.entry[SP.bi] || '';
      if (k === 'back') {
        if (v) SP.entry[SP.bi] = v.slice(0, -1);
        else if (SP.bi > 0) { SP.bi--; SP.entry[SP.bi] = String(SP.entry[SP.bi] || '').slice(0, -1); }
        spPaintEntry(inp); return;
      }
      /* a minus only leads, a point only appears once */
      if (k === '-' && v) return;
      if (k === '.' && v.indexOf('.') >= 0) return;
      SP.entry[SP.bi] = v + k;
      spPaintEntry(inp);
      spTry(inp);
    }
    /* Auto-check, the Quick Maths rule: a right answer goes through the moment
       it is right, and a wrong one is only registered once the entry is as long
       as the answer - so a digit at a time cannot be brute-forced. */
    function spTry(inp) {
      var fs = inp.fs, j = SP.bi, f = fs[j], v = String(SP.entry[j] || '');
      var acc = fs.length === 1 && SP.item.q.data && SP.item.q.data.accepted;
      var right = sameAnswer(v, f.ans, f.accepted || acc || null, f.norm);
      if (right) {
        if (j < fs.length - 1) { SP.bi = j + 1; spPaintEntry(inp); return; }
        spDone(inp, true); return;
      }
      var want = String(f.ans).replace(/[^0-9]/g, '').length, got = v.replace(/[^0-9]/g, '').length;
      if (got >= want) {
        /* the box is full and wrong. With one box that ends the question; with
           several, the whole answer is judged once the last box is full. */
        if (j < fs.length - 1) { SP.bi = j + 1; spPaintEntry(inp); return; }
        spDone(inp, false);
      }
    }
    function spDone(inp, right) {
      var fs = inp.fs;
      var acc = fs.length === 1 && SP.item.q.data && SP.item.q.data.accepted;
      var got = fieldsRight(SP.item, fs, fs.map(function (f, j) { return SP.entry[j]; }), acc);
      var html = stackFields(fs, function (f, j, vw) {
        return { lead: j ? '<span class="eb-op">' + (f.sign ? ' ' : (f.op || '+')) + '</span>' : '', body: '<span class="eb-tm">' + esc(String(SP.entry[j] || '').trim()) + vw.after + '</span>' };
      }, function (h) { return '<span class="eb-op">' + h + '</span>'; });
      spAnswer(!!got, fs.map(function (f, j) { return SP.entry[j] || ''; }).join(', '), html);
    }
    /* only the boxes are repainted while typing: rebuilding the screen would
       take the keypad out from under the finger mid-press, and on a text
       question it would destroy the input the child is typing into */
    function spPaintEntry(inp) {
      var host = elSp.querySelector('.sl-spboxes'); if (!host) { spRender(); return; }
      var fresh = el('div', null, spBoxesHTML(inp.fs)).firstChild;
      host.parentNode.replaceChild(fresh, host);
    }
    elSp.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('button') : null; if (!t) return;
      if (t.id === 'slSpResume') { spPause(false); return; }
      if (t.id === 'slSpEnd') { spFinish(true); return; }
      if (t.hasAttribute('data-key')) { spPad(t.getAttribute('data-key')); return; }
      if (t.hasAttribute('data-spopt')) {
        var inp = spInput(SP.item); if (!inp || inp.kind !== 'choice' || SP.cd || SP.lock || SP.pauseAt) return;
        var k = Number(t.getAttribute('data-spopt'));
        SP.picked = k;
        spAnswer(k === inp.ch.answer, inp.ch.options[k], esc(String(inp.ch.options[k])));
        return;
      }
      if (t.id === 'slSpCheck') { spText(); return; }
      if (t.id === 'slSpAgain') { spStart(); return; }
      if (t.id === 'slSpBack') { spReset(); show('speedsetup'); return; }
      if (t.id === 'slSpPrac') {
        var runSk = (SP.skills || []).slice(), wasMixed = S.from === 'mixed';
        if (!runSk.length) return;
        spReset();
        withSkills(runSk.map(function (x) { return x.id; }), t, function () {
          runSk.forEach(function (x) { var k = SL.get(x.id); if (k) setSel(k, x.levels); });
          if (!wasMixed) { S.skill = runSk[0].id; S.from = 'skills'; }
          buildSet(); show('practise');
        }, true);
        return;
      }
      if (t.id === 'slSpUp') {
        var skU = SL.get(t.getAttribute('data-sk')), lvU = Number(t.getAttribute('data-lv'));
        if (!skU) return;
        spReset(); S.skill = skU.id; S.from = 'skills'; setSel(skU, [lvU]); show('speedsetup');
        return;
      }
      if (t.id === 'slSpTeach') {
        var sk2 = SL.get(t.getAttribute('data-sk')), lv = Number(t.getAttribute('data-lv'));
        if (!sk2) return;
        spReset();
        withSkills([sk2.id], t, function () {
          S.skill = sk2.id; S.from = 'skills'; setSel(sk2, [lv]);
          buildSet(); S.teach.i = 0; S.teach.back = null; show('teach');
        }, true);
      }
    });
    function spText() {
      var box = $('slSpText'); if (!box) return;
      var inp = spInput(SP.item); if (!inp || inp.kind !== 'text' || SP.cd || SP.lock || SP.pauseAt) return;
      var v = String(box.value || '').trim(); if (!v) return;
      SP.entry = [v];
      var f = inp.fs[0], acc = SP.item.q.data && SP.item.q.data.accepted;
      var got = sameAnswer(v, f.ans, f.accepted || acc || null, f.norm);
      spAnswer(got, v, '<span class="eb-tm">' + esc(v) + '</span>');
    }
    elSp.addEventListener('keydown', function (e) {
      if (e.target && e.target.id === 'slSpText' && e.key === 'Enter') { e.preventDefault(); spText(); }
    });

    /* ============================================================
       PAGE (launcher), keys, focus trap, deep links
       ============================================================ */
    /* The launcher shows one of three panels: Teach, Practise or Board.
       Class, never the hidden attribute: a display: rule out-specifies it. */
    function setLauncherAct(name) {
      each(root.querySelectorAll('[data-sl-act]'), function (b) {
        var on = b.getAttribute('data-sl-act') === name;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      each(root.querySelectorAll('[data-sl-demo]'), function (d) {
        d.classList.toggle('is-on', d.getAttribute('data-sl-demo') === name);
      });
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('button') : null;
      if (!t || shell.contains(t)) return;
      if (t.hasAttribute('data-sl-theme')) { toggleTheme(); return; }
      if (t.hasAttribute('data-sl-act')) { setLauncherAct(t.getAttribute('data-sl-act')); return; }
      if (t.id === 'slOpen') { openShell('library'); return; }
    });
    document.addEventListener('keydown', function (e) {
      if (!shell.classList.contains('is-on') || closing) return;
      if (e.key === 'Tab') {
        var f = Array.prototype.filter.call(shell.querySelectorAll('button:not([disabled]), input, [tabindex="0"]'), function (x) { return x.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && (document.activeElement === first || !shell.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        return;
      }
      if (e.key === 'Escape') {
        e.preventDefault();
        if (keysOpen) { toggleKeys(false); return; }
        if (S.screen === 'welcome') { welDone(false); return; }
        if (S.screen === 'practise' && S.prOne >= 0) { toWall(); return; }
        if (S.screen === 'speed' && SP.phase !== 'done' && !SP.cd) { spPause(!SP.pauseAt); return; }
        if (S.screen === 'library' || S.screen === 'mixed') closeShell();
        else show(S.screen === 'skill' ? 'library' : (S.screen === 'teach' ? backFromTeach() : backTarget()));
        return;
      }
      if (e.metaKey || e.ctrlKey || e.altKey) return;
      var tgt = e.target || {}, tag = tgt.tagName, typing = tag === 'INPUT' || tag === 'TEXTAREA' || tgt.isContentEditable;
      if ((e.key === '?' || e.key === '/') && !typing) { e.preventDefault(); toggleKeys(); return; }
      if (keysOpen) return;
      if (typing) return;
      var k = (e.key || '').toLowerCase();
      if (k === 'f') { e.preventDefault(); toggleFull(); return; }
      if (k === 'l') { e.preventDefault(); copyLink(); return; }
      var onButton = tag === 'BUTTON';
      if (S.screen === 'teach') {
        if (S.teach.chorus && chorusOK()) {
          if ((e.key === 'Enter' || e.key === ' ') && !onButton) { e.preventDefault(); var cg = elTe.querySelector('[data-cgo]'); if (cg) cg.click(); }
          /* the arrows rewind and step the count as well (Aadam: "so you can always rewind") */
          if ((e.key === 'ArrowRight' || e.key === 'ArrowLeft') && chorusR && chorusR.step) { e.preventDefault(); chorusR.step(e.key === 'ArrowRight' ? 1 : -1); }
          return;
        }
        if ((e.key === 'Enter' || e.key === ' ') && !(onButton && tgt.id !== 'slTCta')) { e.preventDefault(); if (e.repeat && S.teach.done) return; var c = $('slTCta'); if (c) c.click(); return; }
        /* left and right walk the model - the arrows point along the working,
           so they move the working - and up and down change the question.
           These come BEFORE the button guard: pressing the CTA leaves it
           focused, and the arrows have to keep working after a press. */
        if (e.key === 'ArrowRight') { e.preventDefault(); teachAnim(1, e.repeat); return; }
        if (e.key === 'ArrowLeft') { e.preventDefault(); teachAnim(-1); return; }
        if (e.key === 'ArrowDown') { e.preventDefault(); teachStep(1); return; }
        if (e.key === 'ArrowUp') { e.preventDefault(); teachStep(-1); return; }
        /* A and R come before the button guard as well: pressing Next leaves it focused, and every
           later A or R was swallowed */
        if (k === 'a') { e.preventDefault(); if (S.teach.r) { S.teach.moved = true; S.teach.r.all(); } return; }
        if (k === 'r') { e.preventDefault(); freshTeachQuestion(); return; }
        if (k === 'n') { e.preventDefault(); freshTeachSet(); return; }
        return;
      }
      if (S.screen === 'turn') {
        var nb = $('slUNext');
        /* the CTA keeps focus after a press, so Space has to keep working on it */
        if ((e.key === 'Enter' || e.key === ' ') && nb && !nb.hidden) { e.preventDefault(); if (!e.repeat) nb.click(); return; }
        if (onButton) return;
        if (S.turn.phase === 'play' && (k === '1' || k === '2')) {
          var cb = elTu.querySelectorAll('.nl-cbtn');
          if (cb.length === 2) { e.preventDefault(); cb[k === '1' ? 0 : 1].click(); return; }
        }
        if (k === 'a') { e.preventDefault(); var sb = $('slUShow'); if (sb && !sb.disabled) sb.click(); return; }
        if (k === 'r' || k === 'n') { e.preventDefault(); startTurn(); renderTurn(); renderTop(); return; }
        return;
      }
      if (onButton && (e.key === ' ' || e.key === 'Enter')) return;
      if (S.screen === 'practise') {
        /* one card open: the arrows move along the ten, Space shows its answer and, once it is
           marked, moves on; on the wall Space opens the next card that has not been looked at */
        var one = S.prOne >= 0 ? S.set[S.prOne] : null;
        if (one && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) { e.preventDefault(); openCard(S.prOne + (e.key === 'ArrowRight' ? 1 : -1)); return; }
        if (one && (e.key === ' ' || e.key === 'Enter')) {
          e.preventDefault();
          if (one.state === 'hid') {
            if (one.q.choice) return;
            if (S.typed && canType(one)) { var obox = elPr.querySelector('[data-ans="' + S.prOne + '"]'); if (obox) obox.focus(); return; }
            revealOne(S.prOne); return;
          }
          if (one.state !== 'shown') openCard(S.prOne + 1);
          return;
        }
        if (one && (k === 'c' || k === '1' || k === 'x' || k === '2')) {
          if (one.state !== 'shown') return;
          e.preventDefault(); mark(one, k === 'c' || k === '1'); renderPractise(); renderTop(); return;
        }
        if (one && k === 's') { e.preventDefault(); S.teach.i = S.prOne; S.teach.back = 'practise'; show('teach'); return; }
        if (e.key === ' ' || e.key === 'Enter') {
          var nx = nextHidden(); if (nx < 0) return;
          e.preventDefault(); openCard(nx); return;
        }
        if (k === 'c' || k === '1' || k === 'x' || k === '2') {
          var li = lastLive(); if (li < 0 || S.set[li].state !== 'shown') return;
          e.preventDefault(); mark(S.set[li], k === 'c' || k === '1'); renderPractise(); renderTop(); return;
        }
        if (k === 'a') { e.preventDefault(); revealAll(); return; }
        if (k === 'h') { e.preventDefault(); hideAll(); return; }
        if (k === 'r' || k === 'n') { e.preventDefault(); var b = $('slNewSet'); if (b) b.click(); return; }
        if (k === 's') { var si = lastLive(); if (si < 0) si = 0; e.preventDefault(); S.teach.i = si; S.teach.back = 'practise'; show('teach'); return; }
        return;
      }
      /* a run is driven from the number row as well as the pad, so the keys
         come BEFORE the button guard: pressing a key leaves it focused and the
         next digit would otherwise be swallowed as a button press */
      if (S.screen === 'speed') {
        if (SP.phase === 'done') return;
        if (k === 'm') { e.preventDefault(); toggleSound(); spRender(); return; }
        if (e.key === 'Escape') { e.preventDefault(); spPause(!SP.pauseAt); return; }
        if (SP.pauseAt || SP.cd) return;
        var sIn = spInput(SP.item);
        if (!sIn) return;
        if (sIn.kind === 'choice') {
          var oi = '123456'.indexOf(e.key);
          if (oi >= 0 && oi < sIn.ch.options.length) { e.preventDefault(); SP.picked = oi; spAnswer(oi === sIn.ch.answer, sIn.ch.options[oi], esc(String(sIn.ch.options[oi]))); }
          return;
        }
        if (sIn.kind !== 'pad') return;
        if (/^[0-9]$/.test(e.key)) { e.preventDefault(); spPad(e.key); return; }
        if (e.key === '.') { e.preventDefault(); spPad('.'); return; }
        if (e.key === '-') { e.preventDefault(); spPad('-'); return; }
        if (e.key === 'Backspace') { e.preventDefault(); spPad('back'); return; }
        return;
      }
      if (S.screen === 'board') {
        if (e.key === ' ' || k === 'a') { e.preventDefault(); setAllAns(!S.board.ans); paintAns(); renderTop(); return; }
        if (k === 'n' || k === 'r') { e.preventDefault(); buildBoard(); renderBoard(); renderTop(); return; }
        if (k === 't') { e.preventDefault(); toggleTimer(); return; }
      }
    });
    /* ============================================================
       THE ADDRESS BAR
       The link names the screen, the skill and the LEVELS that are ticked, and
       carries the settings that change what you get, so a copied link opens
       exactly what the person copying it was looking at. Screen changes push a
       history entry (Back walks the screens); a setting change replaces one, or
       every level chip would be a step in the back button.
       ============================================================ */
    var routing = false, hashT = null;
    function levelsParam(sk) { return selLevels(sk).join(','); }
    function hashFor() {
      if (!shell.classList.contains('is-on')) return '';
      var sk = curSkill(), P = [], screen = S.screen;
      if (screen === 'welcome') return '';
      if (screen === 'papers') return '#papers' + (S.papersQ ? '/' + S.papersQ : '');
      if (screen === 'library') screen = 'skills';
      if (screen === 'boardsetup') screen = 'skill';
      if (screen === 'speedsetup') screen = 'speed';
      var h = '#' + screen;
      if (S.from === 'mixed') {
        var ids = mixSkills().map(function (x) { return x.id; });
        if (ids.length) P.push('mix=' + ids.join(','));
        mixSkills().forEach(function (x) { P.push('l.' + x.id + '=' + levelsParam(x)); });
        if (S.board.mixLayout !== 'mixed') P.push('mixlay=' + S.board.mixLayout);
      } else if (sk && screen !== 'skills' && screen !== 'mixed') {
        h += '/' + sk.id + '/' + levelsParam(sk);
      } else if (sk && screen === 'skills') {
        P.push('sk=' + sk.id);
      }
      if (screen === 'practise' && S.typed) P.push('type=1');
      if (screen === 'speed') {
        P.push('shape=' + S.speed.shape);
        P.push('len=' + spLen());
      }
      if (screen === 'board') {
        if (S.board.layout !== 'mix') P.push('lay=' + S.board.layout);
        if (S.board.n !== 24) P.push('n=' + S.board.n);
        if (S.board.ans) P.push('ans=1');
      }
      if (screen === 'teach' && S.teach.chorus) {
        P.push('count=1');
        var C = (S.chorus && sk && S.chorus[sk.id]) || {};
        if (C.step) P.push('cs=' + C.step);
        if (C.start != null) P.push('cf=' + C.start);
        if (C.up === false) P.push('cd=back');
        if (C.tempo && C.tempo !== 'steady') P.push('ct=' + C.tempo);
      }
      if (S.theme !== 'dark') P.push('theme=' + S.theme);
      return h + (P.length ? '?' + P.join('&') : '');
    }
    function syncHash(push) {
      if (routing || !window.history || !history.replaceState) return;
      clearTimeout(hashT);
      hashT = setTimeout(function () {
        var h = hashFor(), url = location.pathname + location.search + h;
        if (h === (location.hash || '') && h !== '') return;
        try { history[push && h ? 'pushState' : 'replaceState'](null, '', url); } catch (e) {}
      }, push ? 0 : 140);
    }
    function copyLink() {
      var url = location.origin + location.pathname + location.search + hashFor();
      function ok() { toast('Link copied. It opens this skill at these levels.'); }
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(url).then(ok, function () { prompt('Copy this link', url); }); return; }
      } catch (e) {}
      try { window.prompt('Copy this link', url); } catch (e) {}
    }
    /* ---------- reading one back ---------- */
    function paramsOf(hash) {
      var out = {}, i = hash.indexOf('?');
      if (i < 0) return out;
      hash.slice(i + 1).split('&').forEach(function (kv) {
        var j = kv.indexOf('='); if (j < 0) return;
        out[decodeURIComponent(kv.slice(0, j))] = decodeURIComponent(kv.slice(j + 1));
      });
      return out;
    }
    function levelsFrom(str, sk) {
      var a = String(str || '').split(',').map(Number).filter(function (n) { return n >= 1 && n <= sk.levels.length; });
      return a.length ? a : null;
    }
    function fromHash() {
      var hash = location.hash || '';
      var m = /^#(play|library|skills|mixed|skill|practise|teach|turn|board|speed|papers)(?:\/([a-z0-9-]+))?(?:\/([\d,]+))?/.exec(hash);
      if (!m) return false;
      var P = paramsOf(hash);
      routing = true;
      try {
        if (P.theme === 'light' || P.theme === 'dark') { S.theme = P.theme; applyTheme(); }
        var sk = SL.get(m[2] || P.sk || '');
        if (sk) {
          S.skill = sk.id; S.from = 'skills';
          var lv = levelsFrom(m[3], sk); if (lv) setSel(sk, lv);
        }
        /* a mixed link carries the tray and a level list per skill in it */
        if (P.mix) {
          var ids = P.mix.split(',').filter(function (id) { return SL.get(id); }).slice(0, 6);
          if (ids.length) { S.mix = ids.map(function (id) { return { id: id }; }); S.from = 'mixed'; }
          ids.forEach(function (id) {
            var x = SL.get(id), a2 = P['l.' + id] && levelsFrom(P['l.' + id], x);
            if (a2) setSel(x, a2);
          });
          if (P.mixlay === 'skill' || P.mixlay === 'mixed') S.board.mixLayout = P.mixlay;
        }
        if (P.type === '1') S.typed = true;
        if (P.shape === 'race' || P.shape === 'clock') S.speed.shape = P.shape;
        if (P.len) {
          /* SPEED SLIDERS (2026-09-21): a length from an old link (5 questions, 90 seconds) snaps into range */
          var pl = spSnap(S.speed.shape, P.len);
          if (pl && S.speed.shape === 'race') S.speed.n = pl;
          if (pl && S.speed.shape === 'clock') S.speed.secs = pl;
        }
        if (P.lay === 'diff' || P.lay === 'mix') S.board.layout = P.lay;
        if (P.n && [8, 16, 24].indexOf(Number(P.n)) >= 0) S.board.n = Number(P.n);
        S.teach.chorus = P.count === '1';
        if (S.teach.chorus && sk) {
          S.chorus = S.chorus || {};
          var C = S.chorus[sk.id] = S.chorus[sk.id] || {};
          if (P.cs) C.step = Number(P.cs);
          if (P.cf) C.start = Number(P.cf);
          if (P.cd) C.up = P.cd !== 'back';
          if (P.ct) C.tempo = P.ct;
        }
        save();
      } finally { routing = false; }
      if (m[1] === 'mixed' || (P.mix && m[1] === 'skills')) { openShell('mixed'); return true; }
      if (m[1] === 'skill' && sk) { openShell('skill'); return true; }
      /* a deep link into an activity: the skill screen opens at once from the
         manifest and the activity follows as soon as its engine has loaded */
      var into = function (go) { if (SL.ready(sk.id)) { go(true); return; } openShell('skill'); withSkills([sk.id], elSk.querySelector('.sl-act'), function () { go(false); }); };
      if (m[1] === 'practise' && sk) { into(function (direct) { buildSet(); if (direct) openShell('practise'); else show('practise'); }); return true; }
      if (m[1] === 'teach' && sk) { into(function (direct) { buildSet(); S.teach.i = 0; S.teach.back = null; if (direct) openShell('teach'); else show('teach'); }); return true; }
      /* a skill with no answerable model has no Your turn: the link lands on the skill */
      /* a stub is replaced IN PLACE when its engine registers, so the skill
         captured before the load is stale: read it back from the registry */
      if (m[1] === 'turn' && sk) { into(function (direct) { var s2 = SL.get(sk.id); if (!s2 || !s2.turn) { show('skill'); return; } startTurn(); if (direct) openShell('turn'); else show('turn'); }); return true; }
      if (m[1] === 'board' && sk) { into(function (direct) { buildBoard(); if (P.ans === '1') setAllAns(true); if (direct) openShell('board'); else show('board'); }); return true; }
      /* a skill whose answer is only revealed has no Speed: the link lands on the skill */
      if (m[1] === 'speed' && sk && !canRace(sk)) { openShell('skill'); return true; }
      if (m[1] === 'speed' && (sk || P.mix)) { openShell('speedsetup'); return true; }
      if (m[1] === 'papers') { S.papersQ = (m[2] && /^[a-z0-9-]+$/.test(m[2])) ? m[2] : ''; save(); openShell('papers'); return true; }
      openShell('library'); return true;
    }

    applyTheme();
    fromHash();
    window.addEventListener('hashchange', fromHash);
    /* pushState and replaceState do not fire hashchange, so Back and Forward
       come through popstate instead */
    window.addEventListener('popstate', function () { if (!location.hash) { if (shell.classList.contains('is-on')) closeShell(); return; } fromHash(); });
    if (window.__SL_DEBUG) window.__sl = { S: S, SP: SP, spStart: spStart, spInput: spInput, spAnswer: spAnswer, buildSet: buildSet, buildBoard: buildBoard, show: show, openShell: openShell, closeShell: closeShell, mark: mark, setLevel: setLevel, setSel: setSel, selLevels: selLevels, skillLevel: skillLevel, teachGo: teachGo, withSkills: withSkills, lastPaint: function () { return lastPaint; } };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
